webpackJsonp([1],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var DiccionarioCookiesAGuardar = ['usuariosexo', 'usuarioemail', 'usuarioanio', 'usuarioDetalleClubNacion', 'UsuarioDetalleGuid', 'UsuarioDetalleNick', 'UsuarioId', 'UsuarioUsuario', 'usuario%5Fusuario', 'usuarioLogTkn', 'cookieLogin', 'syncLfLN', 'Provinciaid', 'Paisid', 'LNPreferencias', 'Crm_id', 'ProductoPremiumId', 'token', 'xvalue', 'TokenJWT'];

var LeerCookie = exports.LeerCookie = function LeerCookie(nombrecookie) {
    return leer(nombrecookie);
};

var CreateCookie = exports.CreateCookie = function CreateCookie(name, value) {
    var seconds = parseInt(window.config.Statics.CookieExpiration);
    var expires;
    if (seconds) {
        var date = new Date();
        date.setTime(date.getTime() + seconds);
        expires = "; expires=" + date.toGMTString();
    } else {
        expires = "";
    }

    if (document.domain === 'localhost') {
        document.cookie = name + "=" + value + expires + "; path=/";
    } else {
        document.cookie = name + "=" + value + expires + ";domain=" + window.config.Statics.DominioCookie + "; path=/";
    }
};

var SetToken = exports.SetToken = function SetToken(token) {
    if (IsEmpty(token)) return;
    CreateCookie('token', token);
};

var SetXValue = exports.SetXValue = function SetXValue(xvalue) {
    if (IsEmpty(xvalue)) return;
    CreateCookie('xvalue', xvalue);
};

var IsEmpty = exports.IsEmpty = function IsEmpty(obj) {
    if (obj == null) return true;
    if (obj.length > 0) return false;
    if (obj.length === 0) return true;
    for (var key in obj) {
        if (hasOwnProperty.call(obj, key)) return false;
    }
    return true;
};

var SetupCookies = exports.SetupCookies = function SetupCookies(obj) {
    for (var key in obj) {
        var aux;
        var cookie;
        // Busco si la key se encuentra en el diccionario de cookies para ver si la grabo o no . 
        if (DiccionarioCookiesAGuardar.indexOf(key) > -1 && typeof obj[key] == "string") {
            switch (key) {
                case 'UsuarioDetalleGuid':
                    aux = "usuario%5Fdetalle%5Fguid";
                    cookie = '{' + leer("token") + '}';
                    break;
                case 'UsuarioDetalleNick':
                    aux = "usuario%5Fdetalle%5Fnick";
                    cookie = obj[key];
                    break;
                case 'UsuarioId':
                    aux = "usuario%5Fid";
                    cookie = obj[key];
                    break;
                case 'UsuarioUsuario':
                    aux = "usuario%5Fusuario";
                    cookie = obj[key];
                    break;
                case 'usuarioLogTkn':
                    aux = "usuario%5Flogtkn";
                    cookie = obj[key];
                    break;
                case 'TokenJWT':
                    aux = "PersoTKN";
                    cookie = obj[key];
                    break;
                default:
                    aux = key;
                    cookie = obj[key];
            }

            CreateCookie(aux, cookie);
        }
    }
};

function leer(nombrecookie) {
    var laCookie = '' + document.cookie;
    var indice = laCookie.indexOf(nombrecookie);

    if (indice == -1 || nombrecookie == '') {
        return '';
    }

    var indiceUno = laCookie.indexOf(';', indice);
    var indiceDos = laCookie.indexOf('&', indice);

    if (indiceUno > indiceDos && indiceDos != -1 || indiceUno == -1 && indiceDos != -1) {
        indiceUno = indiceDos;
    }

    if (indiceUno == -1) {
        indiceUno = laCookie.length;
    }

    return unescape(laCookie.substring(indice + nombrecookie.length + 1, indiceUno));
}

function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1, c.length);
        }if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// @ts-check

/**
 * Request - Generic method
 * @param {string} method
 * @param {string} url
 * @param {any} params
 * @param {any} headers
 * @return {Promise<string>}
 */
var ajax = exports.ajax = function ajax(method, url, params) {
    var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    return new Promise(function (resolve, reject) {
        var request = new XMLHttpRequest();

        request.open(method, url, true);
        if (headers) {
            var names = Object.keys(headers);
            names.forEach(function (name) {
                var value = headers[name];

                request.setRequestHeader(name, value);
            });
        }

        request.onload = function () {
            if (request.status >= 200 && request.status < 400) {
                var resp = request.responseText;
                resolve(resp);
            } else {
                reject();
            }
        };
        request.onerror = function () {
            return reject();
        };
        request.send(JSON.stringify(params));
    });
};

/**
 * Request - Post
 * @param {string} url
 * @param {any} params
 * @param {any} headers
 * @return {Promise<string>}
 */
var post = exports.post = function post(url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return ajax('POST', url, params, headers);
};

/**
 * Request - Get
 * @param {string} url
 * @param {any} params
 * @param {any} headers
 * @return {Promise<string>}
 */
var get = exports.get = function get(url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return ajax('GET', url, params, headers);
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//todo: refactorizar.
var urlBucketBalance = exports.urlBucketBalance = function urlBucketBalance(bucketUrl, pathImage) {
    var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    var width = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
    var extension = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "png";

    var id = "";
    var ext = "";
    if (pathImage.toString().indexOf("fotos") !== -1) {
        var startIndex = pathImage.indexOf("fotos") + 9; // (fotos/23/) = 9
        var finalIndex = pathImage.length - 4;
        id = pathImage.substr(startIndex, finalIndex - startIndex);
        ext = pathImage.substr(pathImage.length - 3);
    } else {
        id = pathImage.toString();
        ext = extension;
    }
    var bucketSrv = "1";
    height = height === "" ? "" : "h" + height;
    width = width === "" ? "" : "w" + width;
    var ultdos = id.substr(id.length - 2);
    var ultdig = ultdos.substr(ultdos.length - 1);
    switch (ultdig) {
        case "0":
        case "1":
        case "2":
            bucketSrv = "1";
            break;
        case "3":
        case "4":
        case "5":
            bucketSrv = "2";
            break;
        default:
            bucketSrv = "3";
            break;
    }

    var url = bucketUrl.replace("{nro}", bucketSrv) + "/anexos/fotos/" + ultdos + "/" + id + width + height + "." + ext;

    return url;
};

var urlBucketClubLn = exports.urlBucketClubLn = function urlBucketClubLn(bucketUrl, pathImage) {
    var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    var width = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
    var extension = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "png";

    var id = "";
    var ext = "";
    if (pathImage.toString().indexOf("fotos") !== -1) {
        var startIndex = pathImage.indexOf("fotos") + 9; // (fotos/23/) = 9
        var finalIndex = pathImage.length - 4;
        id = pathImage.substr(startIndex, finalIndex - startIndex);
        ext = pathImage.substr(pathImage.length - 3);
    } else {
        id = pathImage.toString();
        ext = extension;
    }

    height = height === "" ? "" : "h" + height;
    width = width === "" ? "" : "w" + width;
    var ultdos = id.substr(id.length - 2);

    var url = bucketUrl + "/" + ultdos + "/I" + id + width + height + "." + ext;

    return url;
};

// type, classSize
var getImageSrcPath = exports.getImageSrcPath = function getImageSrcPath(img, type, classSize) {
    var classFinal = classSize.substr(0, 2).trim();
    var height = "";

    //Se define la resolución depende del tipo(img, galeria, etc..) y class(L, XL).
    type === "galeria" ? classFinal === "L" ? //si no es L..  es XL
    height = "484" : height = "688" : type === "imagen" ? classFinal === "L" ? //si no es L..  es XL 
    height = "640" : height = "540" : type === "Encolumnada" ? height = "280" : type === "modal" ? height = "765" : "";

    //const carpeta = "\\anexos\\fotos\\" + img.id.toString().slice(-2);
    return height;
};

var changeSizeWithFullPath = exports.changeSizeWithFullPath = function changeSizeWithFullPath(srcImage, size) {
    srcImage.substr(srcImage.length - 1) === "/" ? srcImage = srcImage.slice(0, -1) : "";
    var startIndex = srcImage.indexOf("fotos/") + 9;
    var finalIndex = srcImage.length - 4;

    var ext = srcImage.substr(srcImage.length - 3);
    var bucketUrl = srcImage.substr(0, startIndex);
    var imageWithSize = srcImage.substr(startIndex, finalIndex - startIndex);
    var imageHeight = imageWithSize.indexOf("h");
    var imageWidth = imageWithSize.indexOf("w");

    var imageFinal = "";
    imageHeight > imageWidth ? imageFinal = imageWithSize.slice(0, imageHeight) : imageFinal = imageWithSize.slice(0, imageWidth);

    return "" + bucketUrl + imageFinal + size + "." + ext;
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sortArrayByObjProperty = exports.getTagPrioritario = exports.getUrlSitios = exports.metaRefresh = exports.scrolledIntoView = exports.getRandom = exports.getRandomInteger = exports.formatoUrlAcuAutor = exports.formatoUrlAcuFotoTag = exports.formatoUrlAcuTag = exports.FormatearUrl = undefined;

var _cookie = __webpack_require__(0);

var Cookie = _interopRequireWildcard(_cookie);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var FormatearUrl = exports.FormatearUrl = function FormatearUrl(nombre) {
    if (nombre == undefined) {
        return "";
    }
    var res = nombre.trim().toLowerCase().replace(/,/g, '').replace(/\./g, '').replace(/:/g, '-').replace(/ /g, '-').replace(/\)/g, '').replace(/\(/g, '').replace(/´/g, '').replace(/"/g, '').replace(/#/g, '').replace(/&/g, '').replace(/\//g, '').replace(/\\/g, '').replace(/\?/g, '').replace(/!/g, '').replace(/\*/g, '').replace(/\[/g, '').replace(/\]/g, '').replace(/\{/g, '').replace(/\}/g, '').replace(/~/g, '').replace(/'/g, '').replace(/¨/g, '').replace(/`/g, '').replace(/\^/g, '').replace(/_/g, '').replace(/\+/g, '').replace(/“/g, '').replace(/%/g, '').replace(/”/g, '');

    var replacement = ['a', 'a', 'a', 'a', 'a', 'a', 'c', 'e', 'e', 'e', 'e', 'i', 'i', 'i', 'i', 'n', 'o', 'o', 'o', 'o', 'o', 'u', 'u', 'u', 'u', 'y', 'y'];
    var accents = ['à', 'á', 'â', 'ã', 'ä', 'å', 'ç', 'é', 'è', 'ê', 'ë', 'ì', 'í', 'î', 'ï', 'ñ', 'ò', 'ó', 'ô', 'ö', 'õ', 'ù', 'ú', 'û', 'ü', 'ý', 'ÿ'];

    for (var i = 0; i < accents.length; i++) {
        res = res.replace(accents[i], replacement[i]);
    }

    return res;
};

var formatoUrlAcuTag = exports.formatoUrlAcuTag = function formatoUrlAcuTag(descripcion, id) {

    return '/' + FormatearUrl(descripcion) + '-t' + id;
};

var formatoUrlAcuFotoTag = exports.formatoUrlAcuFotoTag = function formatoUrlAcuFotoTag(descripcion, id) {

    return '/fotos-de-' + FormatearUrl(descripcion) + '-f' + id;
};

var formatoUrlAcuAutor = exports.formatoUrlAcuAutor = function formatoUrlAcuAutor(nombre, id) {

    return '/autor/' + FormatearUrl(nombre) + '-' + id;
};

var getRandomInteger = exports.getRandomInteger = function getRandomInteger(min, max) {
    var _min = Math.ceil(min);
    var _max = Math.floor(max + 1);
    return Math.floor(Math.random() * (_max - _min)) + _min;
};

var getRandom = exports.getRandom = function getRandom(data, hasta) {
    {
        var arrayNotasRandom = [];
        var arraycount = data.length;
        var startIndex = 0;
        var endIndex = arraycount - 1;
        var loopTo = hasta;
        var dataRandom = [];

        if (endIndex < loopTo) loopTo = arraycount;

        for (var i = startIndex; i < loopTo; i++) {
            //Obtenego el primer numero random
            var _randomNumIndex = getRandomInteger(0, endIndex);

            //Cargo el numero random en el array
            arrayNotasRandom.push(_randomNumIndex);

            //Si no es el 1er numero y si esta en el array buscar otro numero
            if (arrayNotasRandom.length > 1 && jQuery.inArray(_randomNumIndex, arrayNotasRandom) > -1) {
                var exitwhile = 0;
                _randomNumIndex = getRandomInteger(0, endIndex);
                while (jQuery.inArray(_randomNumIndex, arrayNotasRandom) > -1 && exitwhile < 400) {
                    exitwhile++;
                    _randomNumIndex = getRandomInteger(0, endIndex);
                }
                arrayNotasRandom[i] = _randomNumIndex;
            }
        }

        for (var ir = 0; ir < arrayNotasRandom.length; ir++) {
            dataRandom.push(data[arrayNotasRandom[ir]]);
        }

        return dataRandom;
    }
};

var scrolledIntoView = exports.scrolledIntoView = function scrolledIntoView(elem) {
    var element = $(elem);

    if (element.length > 0) {
        var docViewTop = $(window).scrollTop();
        var docViewBottom = docViewTop + $(window).height();

        var elemTop = element.offset().top;
        var elemBottom = elemTop + element.height();

        return elemBottom <= docViewBottom && elemTop >= docViewTop;
    }
    return false;
};

var metaRefresh = exports.metaRefresh = function metaRefresh(time, pagina) {
    var productoPremiumId = Cookie.LeerCookie("ProductoPremiumId");
    if (productoPremiumId !== "") {
        productoPremiumId = productoPremiumId.replace(/ /g, "").split(",");
    }
    var objPlayers = document.getElementsByClassName("jwplayer");
    var objAudioPlayers = document.querySelectorAll("div.externo.audioboom");

    if (productoPremiumId.indexOf("5") < 0 || pagina === "home") {
        setInterval(function () {
            if (objPlayers.length > 0 || objAudioPlayers.length > 0) {
                var isPlaying = false;
                for (var i = 0; i < objPlayers.length; i++) {
                    if (jwplayer(i).getState() === "playing") {
                        isPlaying = true;
                        break;
                    }
                }

                if (objAudioPlayers.length > 0) isPlaying = true;

                if (!isPlaying) {
                    localStorage.setItem("CDmetaRefresh", true);
                    window.location.reload();
                }
            } else {
                localStorage.setItem("CDmetaRefresh", true);
                window.location.reload();
            }
        }, time);
    }
};

var getUrlSitios = exports.getUrlSitios = function getUrlSitios(sitioId) {

    switch (sitioId) {
        case 21:
            return "https://www.lanacion.com.ar/revista-ohlala-t50784";
        case 9:
            return "http://www.rollingstone.com.ar/";
        case 32:
            return "http://www.revistasusana.com/";
        default:
            return "https://www.lanacion.com.ar/";
    }
};

var getTagPrioritario = exports.getTagPrioritario = function getTagPrioritario(tagsNota, tagsConfigHome) {

    if (tagsNota.length === 0) {
        return undefined;
    }
    //0 - Filtro notas con tags ocultos formatoId = 2
    tagsNota = tagsNota.filter(function (t) {
        return t.formatoId !== 2;
    });
    //1 - Ordeno el array de tags prioritarios para la Home
    tagsConfigHome = tagsConfigHome.sort(sortArrayByObjProperty("prioridad"));
    //2 - Filtro los tags de la ESTA nota en base a los de la Home.
    tagsNota.filter(function (t) {
        return t.tipoId === tagsConfigHome.tagtipo;
    });
    //3 - Si no hay ningun tag que conincida, retorno undefined para poder evitar la escritura del <a>
    if (tagsNota.length === 0) {
        return undefined;
    }
    //4 - Si hay mas de un tag de nota del mimso tipo, se discrimina por la prioridad DEL TAG DE LA NOTA y tomar el primero.
    var maxPrioridad = Math.min.apply(Math, tagsNota.map(function (tag) {
        return tag.prioridad;
    }));
    return tagsNota.filter(function (tag) {
        return tag.prioridad === maxPrioridad;
    })[0];
};

var sortArrayByObjProperty = exports.sortArrayByObjProperty = function sortArrayByObjProperty(key) {
    var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "asc";

    return function (a, b) {
        if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
            return 0;
        }

        var varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
        var varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

        var comparison = 0;
        if (varA > varB) {
            comparison = 1;
        } else if (varA < varB) {
            comparison = -1;
        }

        return order === "desc" ? comparison * -1 : comparison;
    };
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // @ts-check


var _ajax = __webpack_require__(25);

var _ajax2 = _interopRequireDefault(_ajax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DEFAULT_HEADERS = {
  'Content-Type': 'application/json; charset=UTF-8'
};

var ApiBase = function () {
  function ApiBase(name, config) {
    var _this = this;

    var apiTarget = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

    _classCallCheck(this, ApiBase);

    var settings = typeof config === 'function' ? config() : config;

    this.target = apiTarget || {};
    this.reset();
    this.name = name;
    this.version = settings.version || 'v1';
    this.domain = settings.domain;
    this.defaultHeaders = DEFAULT_HEADERS;
    this.session = settings.session;
    var headers = settings.headers || {};
    if (!settings.token) throw new Error('config.token is undefined');else this.getToken = function () {
      return settings.token;
    };

    if (!settings.session) throw new Error('config.session is undefined');

    Object.keys(headers).forEach(function (header) {
      if (headers[header] === undefined) delete headers[header];else _this.defaultHeaders[header] = headers[header];
    });
  }

  _createClass(ApiBase, [{
    key: 'init',
    value: function init() {
      this.reset();
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.tasks = { urls: [] };
    }
  }, {
    key: 'getURL',
    value: function getURL() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.name;
      var chunk = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var url = '' + this.domain;
      if (name) url += '/' + name;
      if (chunk) url += '/' + chunk;

      return url;
    }
  }, {
    key: 'getHeaders',
    value: function getHeaders() {
      var _this2 = this;

      var headersBase = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.defaultHeaders;

      var headers = headersBase || {};

      return new Promise(function (resolve, reject) {
        try {
          headers['x-ln-token'] = _this2.getToken();
          headers['x-ln-session'] = _this2.session;
          headers['x-ln-api-version'] = _this2.version;

          resolve(headers);
        } catch (errorGetHeaders) {
          reject(errorGetHeaders);
        }
      });
    }
  }, {
    key: 'addTask',
    value: function addTask(name, chunkUrl, parameters) {
      var _tasks$url$params,
          _this3 = this;

      var params = parameters === undefined ? chunkUrl : parameters;
      var chunk = parameters === undefined ? undefined : chunkUrl;

      var url = this.getURL(name, chunk);
      if (!this.tasks[url]) this.tasks.urls.push(url);
      this.tasks[url] = this.tasks[url] || { url: url, params: [], promise: [] };
      this.tasks[url].length = (_tasks$url$params = this.tasks[url].params).push.apply(_tasks$url$params, _toConsumableArray(params));

      var p = new Promise(function (resolve, reject) {
        return _this3.tasks[url].promise.push({ resolve: resolve, reject: reject });
      });

      return p;
    }
  }, {
    key: 'execute',
    value: function execute() {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        _this4.getHeaders().then(function (headers) {
          var tasksToRun = _this4.tasks;
          _this4.reset();

          if (tasksToRun.urls.length > 0) {
            tasksToRun.urls.forEach(function (url) {
              var info = tasksToRun[url];
              _ajax2.default.post(info.url, info.params, headers).then(function (textResult) {
                try {
                  var result = JSON.parse(textResult);

                  if (result instanceof Array) {
                    result.forEach(function (r, i) {
                      return info.promise[i].resolve(r);
                    });

                    resolve(result);
                  } else if ((typeof result === 'undefined' ? 'undefined' : _typeof(result)) === 'object') {
                    reject(result ? result.errorMessage : textResult);
                  } else {
                    reject(result);
                  }
                } catch (err) {
                  reject(err);
                }
              }).catch(reject);
            });
          } else {
            resolve(null);
          }
        }).catch(reject);
      });
    }
  }, {
    key: 'tasks',
    get: function get() {
      return this.target.tasks;
    },
    set: function set(value) {
      this.target.tasks = value;
    }
  }]);

  return ApiBase;
}();

exports.default = ApiBase;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initPerso = exports.init = undefined;

var _cookie = __webpack_require__(0);

var Cookie = _interopRequireWildcard(_cookie);

var _api = __webpack_require__(27);

var _api2 = _interopRequireDefault(_api);

var _laNacionProvider = __webpack_require__(29);

var _laNacionProvider2 = _interopRequireDefault(_laNacionProvider);

var _ClearLoQueSigo = __webpack_require__(11);

var ClearLoQueSigo = _interopRequireWildcard(_ClearLoQueSigo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var init = exports.init = function init() {
    var cookieToken = Cookie.LeerCookie("token");

    if (cookieToken !== "") {
        var lsToken = localStorage.getItem("token");
        if (cookieToken === lsToken) {
            //Pregunta si la cookie tiene el mismo token que el localstorage
            if (!isSessionDateExpired()) {
                //Devuelve si la sesion sigue siendo valida
                return true;
            } else {
                clearLocalstorage();
                localStorage.setItem("token", cookieToken);
                localStorage.setItem("sessionCreated", Date.now());
                localStorage.setItem("CDusuarioLogeado", "yes");
                return true;
            }
        } else {
            clearLocalstorage();
            //Se llama al clearCustomDImension porque unicamente se limpia al cambiarse el token y no al deslogearse
            clearCustomDimension();
            localStorage.setItem("token", cookieToken);
            localStorage.setItem("sessionCreated", Date.now());
            localStorage.setItem("CDusuarioLogeado", "yes");
            return true;
        }
    } else {
        clearLocalstorage();
        return false;
    }
};
var isSessionDateExpired = function isSessionDateExpired() {
    var sessionCreatedDate = localStorage.getItem("sessionCreated");
    var sessionCacheMiliseconds = 900000; ///TODO:pasar a configuracion
    var dif = 0;

    if (sessionCreatedDate === null) {
        return true;
    } else {
        dif = Date.now() - sessionCreatedDate;
        if (dif < sessionCacheMiliseconds) {
            return false;
        } else {
            return true;
        }
    }
};

var clearLocalstorage = function clearLocalstorage() {

    localStorage.removeItem("token");
    localStorage.removeItem("sugerenciasTitulares");
    localStorage.removeItem("fechaSugerenciaTitulares");
    localStorage.removeItem("CDusuarioLogeado");
    ClearLoQueSigo.clearLS();
    //remove items
};

var clearCustomDimension = function clearCustomDimension() {
    //Solo tiene que llamarse al clearCustomDimension cuando cambio el token y no cuando se deslogeo
    localStorage.removeItem("CDcacheCommon");
    localStorage.removeItem("CDusuarioLogeado");
    localStorage.removeItem("CDusuarioRegistrado");
    localStorage.removeItem("CDpayUser");
    localStorage.removeItem("CDsuscriptorType");
    localStorage.removeItem("CDcredentialType");
    localStorage.removeItem("CDuserId");
};

var initPerso = exports.initPerso = function initPerso() {
    var configProvider = _laNacionProvider2.default.ConfigProvider;
    return (0, _api2.default)(configProvider());

    //FOR TEST ONLY
    //******************************
    //const usuario = {
    //    token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiMDYyNjY1MzkyRkVENDRBNjg3Mzc3NENFMUQ5NDcwM0EiLCJpZF92ZXJpZmllciI6IkY4Nzc4M0YxIiwiZXhwIjoxNTE0MjExNjUyfQ.WbMh_4ZmPlWLXmECoRfZWtOyCtVNAtVOIe0Frg-qIyM",
    //    //token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiODA2RDM5QjFCRDUwNERBOUFFN0Y3RjYwRTExMjEzRUQiLCJpZF92ZXJpZmllciI6IkFFQUQxMDhBIiwiZXhwIjoxNTEyODQ1NzIwfQ.3apuiTeTkcnRsJ7P_JgInnVN2kpAv3kSrgSJ2kEUYCk",
    //    //session: "AEAD108A"
    //    session: "F87783F1"
    //}
    //const APIDOMAIN = "https://personalizacion.lanacion.com.ar/v3";
    //return ApiBuilder(configProvider(APIDOMAIN, usuario));  
};

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = {"metaTitle":"{title}","metaDescription":"{title} - {bajada} - {arrayTags} - LA NACION","metaKeywords":"{title} - {bajada} - {arrayTags} - LA NACION","LiveFyre":{"activo":true,"mensaje":"Debido a la veda electoral estas notas estar�n cerradas a comentarios hasta el domingo a las 18hs. Muchas gracias.","token":""},"sitiosPermitidos":[1,37],"categoriasEliminadas":[7195],"prioridadTag":[{"descripcion":"content-lab","tagtipo":10,"prioridad":1},{"descripcion":"espacio-patrocinado","tagtipo":9,"prioridad":2},{"descripcion":"topico","tagtipo":1,"prioridad":3},{"descripcion":"show","tagtipo":8,"prioridad":4},{"descripcion":"seccion","tagtipo":6,"prioridad":5}],"Template":[{"Nombre":"Htmllibre","Apertura":["Titulo"],"Destacado":["Encuentro","Video","Galeria","Imagen","Infografia","ImagenEmbebida"]},{"Nombre":"Historia","Apertura":["Historia"],"Destacado":["Encuentro","Galeria","Video","Imagen","Infografia","ImagenEmbebida"]},{"Nombre":"Opinion","Apertura":["Titulo"],"Destacado":["Encuentro","Video","Galeria","Imagen","Infografia","ImagenEmbebida"]},{"Nombre":"Infografia","Apertura":["Infografia","Titulo"],"Destacado":["ImagenEmbebida"]},{"Nombre":"Noticia","Apertura":["Titulo"],"Destacado":["Encuentro","Video","Galeria","Imagen","Infografia","ImagenEmbebida"]},{"Nombre":"LiveBlog","Apertura":["Titulo"],"Destacado":["Encuentro","Video","Galeria","Imagen","Infografia","ImagenEmbebida"]}],"tercera":["BannerCaja1","BannerCaja2","ListadoTemasBloque2","PromoContent","Ranking","PromoClub"],"site":[{"categoriaId":1,"nombre":"LA NACION"},{"categoriaId":9,"nombre":"ROLLING STONE"},{"categoriaId":19,"nombre":"LIVING"},{"categoriaId":20,"nombre":"Club LANACION"},{"categoriaId":21,"nombre":"REVISTA OHLALA"},{"categoriaId":22,"nombre":"Revista BRANDO"},{"categoriaId":28,"nombre":"Revista HOLA"},{"categoriaId":32,"nombre":"Revista Susana"},{"categoriaId":35,"nombre":"Recetas"},{"categoriaId":37,"nombre":"Master LN"},{"categoriaId":40,"nombre":"Revista Lugares"}],"class":{"bloque1":[{"nombre":"Noticia","descripcion":"normal"},{"nombre":"Historia","descripcion":"storytelling"},{"nombre":"Infografia","descripcion":"normal infografia"},{"nombre":"Opinion","descripcion":"opinion"},{"nombre":"LiveBlog","descripcion":"normal liveblog"}],"bloque2":[{"descripcion":"revista brando","id":7993,"ignoradoId":61735,"tagUrlDescripcion":"revista brando","tipo":1},{"descripcion":"revista living","id":7998,"ignoradoId":50022,"tagUrlDescripcion":"revista living","tipo":1},{"descripcion":"revista ohlala","id":8000,"ignoradoId":50784,"tagUrlDescripcion":"revista ohlala","tipo":1},{"descripcion":"revista rolling","id":7048,"ignoradoId":99999,"tagUrlDescripcion":"revista rolling","tipo":1},{"descripcion":"revista lugares","id":7994,"ignoradoId":62072,"tagUrlDescripcion":"revista lugares","tipo":1},{"descripcion":"revista jardin","id":7995,"ignoradoId":61799,"tagUrlDescripcion":"revista jardin","tipo":1},{"descripcion":"revista hola","id":7996,"ignoradoId":62132,"tagUrlDescripcion":"revista hola","tipo":1},{"descripcion":"revista living","id":7998,"ignoradoId":50022,"tagUrlDescripcion":"revista living","tipo":1},{"descripcion":"revista lnmas","id":58215,"ignoradoId":58215,"tagUrlDescripcion":"ln mas","tipo":2}],"bloque3":[{"descripcion":"ovrik","tipo":"tag","id":59142,"url":"http://www.ovrik.com/"},{"descripcion":"bbc","tipo":"categoria","id":6250,"url":"http://www.bbc.co.uk/mundo/"},{"descripcion":"bbc","tipo":"tag","id":6250,"url":"http://www.bbc.co.uk/mundo/"},{"descripcion":"wall-street","tipo":"tag","id":53649,"url":"http://www.wsj.com/"},{"descripcion":"wall-street","tipo":"categoria","id":6373,"url":"http://www.wsj.com/"}],"bloque4":[{"descripcion":"content-lab","tagTipo":10},{"descripcion":"espacio-patrocinado","tagTipo":9}]},"autoresMostrarEnCabecera":3,"reglaNodoContenidoExtendido":[{"nodoType":"NodoBanner","template":["Noticia","Opinion","Infografia"],"espacio":"Middle 1","cssClass":"middle-1","bannerId":"middle","bannerType":"middle","dispositivo":"desktop","dibujarEnPosicionInicial":3,"dibujarSiElementosEnNotaAlMenos":3,"nombre":"Regla[Template:{0}|NodoType:{1}|Espacio:{2}|Posicion:{3}|dibujarSiElementosEnNotaAlMenos:{4}|Prioridad:{5}|ElementosEnLaNota:{6}]","prioridad":1,"nodoNoContabilizar":["Subtitulo","Subtitulo2"]},{"nodoType":"NodoBanner","template":["Noticia","Opinion","Infografia"],"espacio":"Middle 2","cssClass":"middle-2","bannerId":"middle_2","bannerType":"middle","dispositivo":"desktop","dibujarEnPosicionInicial":6,"dibujarSiElementosEnNotaAlMenos":9,"nombre":"Regla[Template:{0}|NodoType:{1}|Espacio:{2}|Posicion:{3}|dibujarSiElementosEnNotaAlMenos:{4}|Prioridad:{5}|ElementosEnLaNota:{6}]","prioridad":3,"nodoNoContabilizar":["Subtitulo","Subtitulo2"]},{"nodoType":"NodoBanner","template":["Noticia","Opinion","Infografia","Historia"],"espacio":"Caja 1","cssClass":"caja","bannerId":"caja_1","bannerType":"bigbox","dispositivo":"mobile","dibujarEnPosicionInicial":1,"dibujarSiElementosEnNotaAlMenos":1,"nombre":"Regla[Template:{0}|NodoType:{1}|Espacio:{2}|Posicion:{3}|dibujarSiElementosEnNotaAlMenos:{4}|Prioridad:{5}|ElementosEnLaNota:{6}]","prioridad":4,"nodoNoContabilizar":["Subtitulo","Subtitulo2"]},{"nodoType":"NodoBanner","template":["Noticia","Opinion","Infografia","Historia"],"espacio":"Middle","cssClass":"middle-1","bannerId":"middle","bannerType":"middle","dispositivo":"mobile","dibujarEnPosicionInicial":4,"dibujarSiElementosEnNotaAlMenos":4,"nombre":"Regla[Template:{0}|NodoType:{1}|Espacio:{2}|Posicion:{3}|dibujarSiElementosEnNotaAlMenos:{4}|Prioridad:{5}|ElementosEnLaNota:{6}]","prioridad":5,"nodoNoContabilizar":["Subtitulo","Subtitulo2"]},{"nodoType":"NodoBanner","template":["Noticia","Opinion","Infografia","Historia"],"espacio":"Caja 2","cssClass":"caja","bannerId":"caja_2","bannerType":"caja2","dispositivo":"mobile","dibujarEnPosicionInicial":7,"dibujarSiElementosEnNotaAlMenos":7,"nombre":"Regla[Template:{0}|NodoType:{1}|Espacio:{2}|Posicion:{3}|dibujarSiElementosEnNotaAlMenos:{4}|Prioridad:{5}|ElementosEnLaNota:{6}]","prioridad":6,"nodoNoContabilizar":["Subtitulo","Subtitulo2"]},{"nodoType":"NodoBanner","template":["Noticia","Opinion","Infografia","Historia"],"espacio":"Caja 3","cssClass":"caja","bannerId":"caja_3","bannerType":"caja3","dispositivo":"mobile","dibujarEnPosicionInicial":9,"dibujarSiElementosEnNotaAlMenos":9,"nombre":"Regla[Template:{0}|NodoType:{1}|Espacio:{2}|Posicion:{3}|dibujarSiElementosEnNotaAlMenos:{4}|Prioridad:{5}|ElementosEnLaNota:{6}]","prioridad":7,"nodoNoContabilizar":["Subtitulo","Subtitulo2"]},{"nodoType":"NodoBanner","template":["Noticia","Opinion","Infografia","Historia"],"espacio":"Caja 1","cssClass":"caja","bannerId":"caja_1","bannerType":"bigbox","dispositivo":"tablet","dibujarEnPosicionInicial":1,"dibujarSiElementosEnNotaAlMenos":1,"nombre":"Regla[Template:{0}|NodoType:{1}|Espacio:{2}|Posicion:{3}|dibujarSiElementosEnNotaAlMenos:{4}|Prioridad:{5}|ElementosEnLaNota:{6}]","prioridad":8,"nodoNoContabilizar":["Subtitulo","Subtitulo2"]},{"nodoType":"NodoBanner","template":["Noticia","Opinion","Infografia","Historia"],"espacio":"Caja 2","cssClass":"caja","bannerId":"caja_2","bannerType":"caja2","dispositivo":"tablet","dibujarEnPosicionInicial":4,"dibujarSiElementosEnNotaAlMenos":4,"nombre":"Regla[Template:{0}|NodoType:{1}|Espacio:{2}|Posicion:{3}|dibujarSiElementosEnNotaAlMenos:{4}|Prioridad:{5}|ElementosEnLaNota:{6}]","prioridad":9,"nodoNoContabilizar":["Subtitulo","Subtitulo2"]},{"nodoType":"NodoNotaDinamica","template":["Noticia","Opinion","Infografia"],"espacio":"Listado Ademas Notas Automaticas Dinamicas","cssClass":"ademas","bannerId":"","bannerType":"","dispositivo":"","dibujarEnPosicionInicial":2,"dibujarSiElementosEnNotaAlMenos":3,"nombre":"Regla[Template:{0}|NodoType:{1}|Espacio:{2}|Posicion:{3}|dibujarSiElementosEnNotaAlMenos:{4}|Prioridad:{5}|ElementosEnLaNota:{6}]","prioridad":2,"nodoNoContabilizar":["Subtitulo","Subtitulo2"]}],"reglaColumnaTercera":[{"prioridad":1,"viewName":"BannersNota/BannerCaja1","template":["Noticia","Opinion","Infografia","Historia","LiveBlog"],"dibujarSiElementosEnNotaAlMenos":0},{"prioridad":2,"viewName":"ListadoTemasBloque2","template":["Noticia","Opinion","Infografia","Historia","LiveBlog"],"dibujarSiElementosEnNotaAlMenos":3},{"prioridad":3,"viewName":"BannersNota/BannerCaja2","template":["Noticia","Opinion","Infografia","Historia","LiveBlog"],"dibujarSiElementosEnNotaAlMenos":6},{"prioridad":4,"viewName":"PromoContent","template":["Noticia","Opinion","Infografia","Historia","LiveBlog"],"dibujarSiElementosEnNotaAlMenos":6},{"prioridad":5,"viewName":"Ranking","template":["Noticia","Opinion","Infografia","Historia","LiveBlog"],"dibujarSiElementosEnNotaAlMenos":9},{"prioridad":6,"viewName":"PromoClub","template":["Noticia","Opinion","Infografia","Historia","LiveBlog"],"dibujarSiElementosEnNotaAlMenos":10}],"sugerenciasPie":[{"categoriasPosibles":[30,131,120,272,7773,7353,7994,7998,1312],"tagsPosibles":[63583],"cantidad":4,"providers":["categoria","ranking"]}],"HeaderVarnish":[{"key":"X-APW-ACCESS-CONTROL","value":"anonymous,subscribers"},{"key":"X-APW-AAC-PIDS","value":"0"},{"key":"X-APW-SAC-PIDS","value":"PAYWALL"},{"key":"X-APW-AUTHENTICATION-FAILED","value":"https://ingresar.lanacion.com.ar/suscripcion/V/1/1/?{url}"},{"key":"X-APW-AUTHORIZATION-DENIED","value":"https://ingresar.lanacion.com.ar/suscripcion/V/1/1/?{url}"},{"key":"X-APW-CID","value":"n_{notaId}"},{"key":"X-APW-SOCIAL","value":"{social}"}],"sugerenciasPerso":{"providers":["ApiPerso","Liftigniter"],"horasCorteSugerencias":24,"opcionesCorte":["usuario","usuarioDias","usuarioCategorias","usuarioHoras","usuarioDiaHorario"],"rangosDiscretizacion":["00,01,02,03,04,05,06,07","08,09,10","11,12,13,14","15,16,17,18","18,19,20","20,21,22,23"]},"ampInvalids":{"nodosExterno":["streamable"],"nodosTexto":["object","param","embed","script"]},"newsletter":[{"servicioId":2,"titulo":"Pol�tica","categoriaId":30},{"servicioId":3,"titulo":"Econom�a","categoriaId":272},{"servicioId":21,"titulo":"Turismo","categoriaId":504},{"servicioId":23,"titulo":"Campo","categoriaId":337},{"servicioId":43,"titulo":"Columnistas del d�a","categoriaId":0},{"servicioId":85,"titulo":"Moda y belleza","categoriaId":1312},{"servicioId":90,"titulo":"Comunidad","categoriaId":1344},{"servicioId":135,"titulo":"Lo que hay que saber hoy","categoriaId":0},{"servicioId":154,"titulo":"Titulos de Tapa","categoriaId":0},{"servicioId":194,"titulo":"Men� semanal","categoriaId":0},{"servicioId":196,"titulo":"Revista Hola!","categoriaId":7996},{"servicioId":107,"titulo":"Revista OHLAL�!","categoriaId":8000},{"servicioId":115,"titulo":"Revista Brando","categoriaId":7993},{"servicioId":15,"titulo":"Tecnolog�a","categoriaId":432},{"servicioId":129,"titulo":"Deportes","categoriaId":131},{"servicioId":202,"titulo":"Lifestyle","categoriaId":7353}],"rankingPorCategoria":[{"id":7994,"descripcion":"Lugares"},{"id":7993,"descripcion":"Brando"},{"id":7995,"descripcion":"Jardin"},{"id":7996,"descripcion":"Hola"},{"id":7998,"descripcion":"Living"},{"id":7353,"descripcion":"Lifestyle"},{"id":8000,"descripcion":"Ohlala"}],"rankingPorTag":[{"id":58215,"descripcion":"LN+"}]}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Logout = exports.Initialize = undefined;

var _usuario = __webpack_require__(8);

var Usuario = _interopRequireWildcard(_usuario);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var Initialize = exports.Initialize = function Initialize() {
    $('.salir').click(function () {
        return Logout();
    });
};

var Logout = exports.Logout = function Logout() {
    return Usuario.Salir();
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Salir = exports.VerificarUsuario = undefined;

var _cookie = __webpack_require__(0);

var Cookie = _interopRequireWildcard(_cookie);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var VerificarUsuario = exports.VerificarUsuario = function VerificarUsuario() {
    if (Cookie.LeerCookie('cookieLogin') != undefined && Cookie.LeerCookie('cookieLogin') != '') {
        MostrarUsuario();
    } else {
        $('#cabezal').removeClass('no-btn');
    }
};

var Salir = exports.Salir = function Salir() {
    $('#cabezal').removeClass('logueado');
    $('#cabezal').removeClass('suscripto');
    $('#pie').removeClass('suscripto');
    return OcultarUsuario();
};

function MostrarUsuario() {

    var nick = Cookie.LeerCookie('usuario%5Fdetalle%5Fnick');

    $('.usuario').text(nick + ' ' + $('.usuario').text());

    $('.ingresar').css('display', 'none');
    //$('.usuario').css('display', 'initial');

    if (Cookie.LeerCookie('ProductoPremiumId') != "") {
        $('#cabezal').removeClass('no-btn');
        $('#cabezal').addClass('suscripto');
        $('#pie').addClass('suscripto');
    } else {
        $('#cabezal').removeClass('no-btn');
        $('#cabezal').addClass('logueado');
    }
}

function OcultarUsuario() {
    $('.ingresar').css('display', 'initial');
    $('.usuario').css('display', 'none');

    $('.usuario').text('&#9660;');

    localStorage.removeItem("token");

    window.top.frames['iLogout'].location.href = window.config.Statics.SitioSeguroRegistracion + '/logout/logout.html?pagina=' + window.location.origin + window.config.Statics.LogoutUrl;

    if (typeof fyre != "undefined") {
        fyre.conv.logout();
    }

    return false;
}

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Login = exports.Initialize = undefined;

var _usuario = __webpack_require__(8);

var Usuario = _interopRequireWildcard(_usuario);

var _cookie = __webpack_require__(0);

var Cookie = _interopRequireWildcard(_cookie);

var _logout = __webpack_require__(7);

var Logout = _interopRequireWildcard(_logout);

var _logger = __webpack_require__(19);

var Logger = _interopRequireWildcard(_logger);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var Initialize = exports.Initialize = function Initialize() {
    $('.ingresar').click(function () {
        Login();
    });

    //Logger.Muestreo();

    if (Cookie.LeerCookie('cookieLogin') != "") {
        Relogin();
    }

    Usuario.VerificarUsuario();
};

var Login = exports.Login = function Login() {
    location.href = window.config.Statics.LoginUrl + window.btoa(location.href);
};

function Relogin() {
    var toRelogin = mustRelogin();
    console.log(toRelogin);

    if (toRelogin) {
        var tokenCookie = Cookie.LeerCookie("token");
        var xvalueCookie = Cookie.LeerCookie("xvalue");
        if (tokenCookie == null || !tokenCookie) {
            tokenCookie == "";
        }
        if (xvalueCookie == null || !xvalueCookie) {
            xvalueCookie = "";
        }
        /*if (tokenCookie != null && tokenCookie && xvalueCookie!= null && xvalueCookie)
        {*/

        var headers = { 'X-Token': tokenCookie || '', 'X-Value': xvalueCookie || '' };
        var data = {
            OrigenLoginTipoId: 1,
            AutenticacionTipoId: 1,
            IsRelogin: 1
        };
        jQuery.ajax({
            url: window.config.Statics.APILoginUrl + "/Usuario/ReLogin",
            type: 'post',
            dataType: "json",
            data: data,
            headers: headers,
            async: true,
            success: function success(res, status, xhr) {
                reloginHandler(res, status, xhr);
            },
            error: function error(e) {
                console.log("error: " + e.toString());
                Logger.Error("Relogin | API Error ", e);
            }
        });

        /*}
          else
          {
              if ((tokenCookie == null && xvalueCookie == null) || (!tokenCookie && !xvalueCookie))
              {
                  Logger.Error("Relogin | sin token ni xvalue" );
              }
              else
              {
                  if (tokenCookie == null || !tokenCookie)
                  {
                      Logger.Error("Relogin | sin token ",{"xvalue": xvalueCookie});
                  }
                  if (xvalueCookie == null || !xvalueCookie)
                  {
                      Logger.Warn("Relogin | sin xvalue ", {"token": tokenCookie});
                  }
              }
            }*/
    }
}

function mustRelogin() {

    var syncValue = Cookie.LeerCookie('syncLfLN');

    var cookieSalt = Cookie.LeerCookie('token');

    try {
        var result = true;
        var millisecBeforeRelogin = window.config.Statics.ReloginValidation;

        // Parseo cookie syncLfLN para que no tenga am/pm . 
        // Tengo que convertir la hora en formato de 24hrs y no de 12hrs . 
        // Cookie de ejemplo : 09/06/2017 06:52:46 p.m.
        if (syncValue.indexOf("/") > -1 && (syncValue.indexOf('a.m.') > -1 || syncValue.indexOf('p.m.') > -1)) {
            var arr_full_date = syncValue.split(" "); // [0] : 09/06/2017 - [1] : 06:52:46 - [2] : p.m.

            // La fecha está en DD/MM/YYYY . La convierto a MM/DD/YYYY ; 
            var daysDate = arr_full_date[0];
            var arr_days = daysDate.split('/');
            var daysDate = arr_days[1] + '/' + arr_days[0] + "/" + arr_days[2];

            var time = convertTo24Hour(arr_full_date[1] + arr_full_date[2]);
            arr_full_date[1] = time;
            syncValue = daysDate + " " + arr_full_date[1]; // Vuelvo a armar la cookie con el date actualizado. 
        }
        // Fin 

        if (cookieSalt == '') {
            return false;
        }

        if (syncValue != '') {
            var syncDate = new Date(syncValue);
            if (isNaN(syncDate)) Logger.Error("Relogin | SyncDate Invalid Date => " + syncValue, e);
            if (new Date() < new Date(syncDate.getTime() - millisecBeforeRelogin)) {
                result = false;
            }
        }

        return result;
    } catch (e) {

        Logger.Error("Relogin | MustRelogin - Error restando fechas", { 'syncValue': syncValue, 'Date': new Date() });

        return false;
    }
}

function convertTo24Hour(time) {
    var hours = time.substr(0, 2);
    if (time.indexOf('a.m.') != -1 && hours == 12) {
        time = time.replace('12', '00');
    }
    if (time.indexOf('p.m.') != -1 && hours < 12) {
        time = time.replace(hours, parseInt(hours) + 12);
    }
    return time.replace(/(a.m.|p.m.)/, '');
}

function reMe(token, xvalue) {
    //var headers = { 'X-Token': Cookie.LeerCookie("token") || '', 'X-Value': Cookie.LeerCookie("xvalue") || '' };
    var headers = { 'X-Token': token, 'X-Value': xvalue };
    jQuery.ajax({
        url: window.config.Statics.APILoginUrl + "/Usuario/Me",
        type: 'post',
        dataType: "json",
        headers: headers,
        async: true,
        success: function success(res, status, xhr) {
            reMeHandler(res, token, xvalue);
        },
        error: function error(e) {
            console.log("error: " + e.toString());
            Logger.Error("ReMe | Error ", e);
        }
    });
}

function reloginHandler(res, status, xhr) {
    switch (res.code) {
        case "0000":
            var token = xhr.getResponseHeader("X-Token") || getTokenBodyHelper(res.response, 1);
            var xvalue = xhr.getResponseHeader("X-Value") || getTokenBodyHelper(res.response, 2);

            if (res.code == "0000" && (token == null || xvalue == null || !token || !xvalue)) {
                Logger.Error("Relogin | Headers en null", 'Headers | ' + xhr.getAllResponseHeaders() + ' || ' + ' Response | ' + JSON.stringify(res));
            } else {
                // Solo hace ReMe si el servicio trajo Token y xValue.
                reMe(token, xvalue);
                top.frames['iLogout'].location.href = "https://passport.lanacion.com.ar/cifrador.aspx?pagina=" + window.location.origin + window.config.Statics.ReloginUrl;
            }
            break;

        case "0220":
            Logger.Warn("Relogin | Token o xvalue Expirado", res);
            Logout.Logout();
            break;

        case "0221":
            Logger.Error("Relogin | Relogin 0221", res);
            break;

        default:
            Logger.Error("Relogin | Error ", res);
    }
};

function reMeHandler(res, token, xvalue) {
    switch (res.code) {
        case "0000":
            var usuario = JSON.parse(res.response);
            Cookie.SetXValue(xvalue);
            Cookie.SetToken(token);
            Cookie.SetupCookies(usuario.Usuario);
            break;
        case "0001":
            Logger.Error("ReMe | Error Controlado ", JSON.stringify(res));
            Logout.Logout();
            break;
        case "0002":
            Logger.Error("ReMe | Token inválido ", JSON.stringify(res)); //{ 'response' : res ,  'tokens': { 'X-Token': Cookie.LeerCookie("token") || '', 'X-Value': Cookie.LeerCookie("xvalue") || '' }});
            Logout.Logout();
            break;
        default:
            Logger.Error("ReMe | Error (Handler) ", JSON.stringify(res));
            Logout.Logout();
    }
};

function getTokenBodyHelper(res, position) {
    try {
        return res.split("|")[position];
    } catch (ex) {
        return null;
    }
}

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.registrarAccesosAcumulados = exports.preferenciasCambioBotonSiguiendo = exports.initPreferencias = exports.dejarSeguirLoQueSigo = exports.preferenciasPendientes = exports.seguirDejarSeguir = undefined;

var _ajax = __webpack_require__(1);

var _bucket = __webpack_require__(2);

var BucketTools = _interopRequireWildcard(_bucket);

var _utilities = __webpack_require__(3);

var Utilities = _interopRequireWildcard(_utilities);

var _session = __webpack_require__(5);

var SessionLogin = _interopRequireWildcard(_session);

var _ClearLoQueSigo = __webpack_require__(11);

var ClearLoQueSigo = _interopRequireWildcard(_ClearLoQueSigo);

var _loQueSigo = __webpack_require__(23);

var _preferencias = __webpack_require__(24);

var _sugerencias = __webpack_require__(21);

var Sugerencias = _interopRequireWildcard(_sugerencias);

var _login = __webpack_require__(9);

var Login = _interopRequireWildcard(_login);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var urlBucket = window.config.Statics.BucketUrl;
var urlNavAnonimo = window.config.Statics.ApiNavAnonimaHome;
var urlNavAnonimoExt = window.config.Statics.ApiNavAnonimaExt;

var showErr = console.error.bind(console, "perso ");
var showLog = console.log.bind(console, "perso ");

//TODO: HACER REFACTOR DE ESTE JS, QUEDANDO EN EL MISMO TODO LO DE APIPERSO Y LO DE LOCALSTORAGE, SACAR LO DE PERSO DE LOS OTROS ARCHIVOS, LOQUESIGO, HOME, NOTA, ETC....
//TODO: PODEMOS HACER QUE DESDE SESSION.JS SE LLAME A PERSONALIZACION Y EN EL INICIO YA TENER TODO CARGADO

var seguirDejarSeguir = exports.seguirDejarSeguir = function seguirDejarSeguir(element) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = Array.from(element)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var btn = _step.value;

            btn.addEventListener('click', function (event) {

                if (!SessionLogin.init()) {
                    var dataPreferible = "{dataPreferibleId}|{dataPreferibleTipoId}".replace("{dataPreferibleId}", event.currentTarget.getAttribute('data-preferibleId')).replace("{dataPreferibleTipoId}", event.currentTarget.getAttribute('data-preferibleTipoId'));

                    localStorage.setItem("apiPerso.Pendientes.Preferencias", dataPreferible);

                    location.href = window.config.Statics.LoginUrl + window.btoa(location.href);
                    return;
                }

                var apiPerso = SessionLogin.initPerso();

                if (event.currentTarget.classList.contains("activo")) {
                    event.currentTarget.classList.remove("activo");
                    event.currentTarget.innerText = "SEGUIR";
                    apiPerso.preferencias.dejarDeSeguirPreferible(event.currentTarget.getAttribute('data-preferibleId'), event.currentTarget.getAttribute('data-preferibleTipoId'));
                    apiPerso.execute().then(function (resp) {
                        dejarSeguirOrSeguir();
                    }).catch(console.log.bind(console, 'error'));
                } else {
                    event.currentTarget.classList.add("activo");
                    event.currentTarget.innerText = "SIGUIENDO";
                    apiPerso.preferencias.seguirPreferible(event.currentTarget.getAttribute('data-preferibleId'), event.currentTarget.getAttribute('data-preferibleTipoId'));
                    apiPerso.execute().then(function (resp) {
                        dejarSeguirOrSeguir();
                    }).catch(console.log.bind(console, 'error'));
                }
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};

var dejarSeguirOrSeguir = function dejarSeguirOrSeguir() {

    var apiPerso = SessionLogin.initPerso();

    if (!SessionLogin.init()) {
        location.href = window.config.Statics.LoginUrl + window.btoa(location.href);
        return;
    }

    apiPerso.execute().then(function (resp) {
        ClearLoQueSigo.clearLS();
    }).catch(console.log.bind(console, 'error'));
};

var preferenciasPendientes = exports.preferenciasPendientes = function preferenciasPendientes() {
    var preferenciasPendientes = localStorage.getItem("apiPerso.Pendientes.Preferencias");

    if (preferenciasPendientes != null) {
        var apiPerso = SessionLogin.initPerso();
        var datosPreferencias = preferenciasPendientes.split("|");

        apiPerso.preferencias.seguirPreferible(parseInt(datosPreferencias[0]), parseInt(datosPreferencias[1]));

        apiPerso.execute().then(function (resp) {
            localStorage.removeItem("apiPerso.Pendientes.Preferencias");
        }).catch(showErr.bind(console, "execute"));
    }
};

var dejarSeguirLoQueSigo = exports.dejarSeguirLoQueSigo = function dejarSeguirLoQueSigo(element) {

    var apiPerso = SessionLogin.initPerso();

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = Array.from(element)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var btn = _step2.value;

            btn.addEventListener('click', function (event) {

                if (!SessionLogin.init()) {
                    location.href = window.config.Statics.LoginUrl + window.btoa(location.href);
                    return;
                }

                apiPerso.preferencias.dejarDeSeguirPreferible(event.currentTarget.getAttribute('data-preferibleId'), event.currentTarget.getAttribute('data-preferibleTipoId'));
                apiPerso.execute().then(function (resp) {
                    ClearLoQueSigo.clearLS();
                }).catch(console.log.bind(console, 'error'));

                event.currentTarget.parentNode.remove();
            });
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
};

//////////////////
//  LO QUE SIGO //
//////////////////
var initPreferencias = exports.initPreferencias = function initPreferencias() {
    var section = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

    var fechaGeneracionHomeMilliseconds = "";
    var fechaGeneracionHomeLs = "";

    var ctx = null;
    if (SessionLogin.init()) {
        //let obtenerSugerencias = localStorage.getItem("obtenerSugerencias");
        var obtenerHashSuscripciones = localStorage.getItem("obtenerHashSuscripciones");
        var obtenerPreferibles = localStorage.getItem("obtenerPreferibles");
        var obtenerPorPrioridad = localStorage.getItem("obtenerPorPrioridad");
        var _recomendarTemas = localStorage.getItem("recomendarTemas");

        if (section === "home") {
            fechaGeneracionHomeMilliseconds = new Date(document.querySelector("#fechaGeneracionHome").getAttribute("value")).getTime();
            var fechaGeneracionLs = localStorage.getItem("fechaGeneracionHome");
            fechaGeneracionHomeLs = fechaGeneracionLs === null ? 0 : parseInt(fechaGeneracionLs);

            if (fechaGeneracionHomeMilliseconds > fechaGeneracionHomeLs) {
                localStorage.setItem("fechaGeneracionHome", fechaGeneracionHomeMilliseconds);
                obtenerHashSuscripciones = null;
                obtenerPreferibles = null;
                obtenerPorPrioridad = null;
                _recomendarTemas = null;
            }
        }

        var apiPerso = SessionLogin.initPerso();
        preferenciasPendientes();

        if (section === "nota") {
            var obtenerNotaId = document.querySelector("div[data-notaId]").getAttribute("data-notaId");
            var obtenerTemas = document.querySelector("div[data-preferibles]").getAttribute("data-preferibles").split(",");
            apiPerso.sugerencias.lecturaNota(obtenerNotaId).then(function (resp) {
                showLog.bind(console, 'lecturaNota');
            }).catch(showErr.bind(console, 'lecturaNota'));

            apiPerso.sugerencias.registrarTemas(obtenerTemas, ctx).then(showLog.bind(console, 'registrarTemas')).catch(showErr.bind(console, 'registrarTemas'));

            apiPerso.preferencias.obtenerNovedades().then(function (resp) {
                localStorage.setItem("obtenerNovedades", resp[0].cantidad);
            });

            if (localStorage.getItem("obtenerNovedades") !== null && parseInt(localStorage.getItem("obtenerNovedades")) > 0) {
                //Obtener las Preferencias y competando con sugerencias llegado el caso.
                apiPerso.comunes.obtenerPorPrioridad(true, 32, "Preferencia", [], [], [], true, [], ["home-instanciada"]).then(function (resp) {
                    localStorage.setItem("obtenerPorPrioridad", JSON.stringify(resp));
                    obtenerPorPrioridad = localStorage.getItem("obtenerPorPrioridad");
                });
            }
        }

        if (obtenerHashSuscripciones === null) {
            apiPerso.preferencias.obtenerHashSuscripciones().then(function (resp) {
                localStorage.setItem("obtenerHashSuscripciones", resp);
                obtenerHashSuscripciones = localStorage.getItem("obtenerHashSuscripciones");
            }).catch(showErr.bind(console, "Obtener hash suscripciones"));
        }

        if (obtenerPorPrioridad === null) {
            //const idsExcluidos = localStorage.getItem("notasUltimasNoticias").split(",").map(n => parseInt(n));
            apiPerso.comunes.obtenerPorPrioridad(true, 32, "Preferencia", [], [], [], true, [], ["home-instanciada"]).then(function (resp) {
                if (section === "home") {
                    var notasLimpias = limpiarPerferenciasDeUltimasNoticias(localStorage.getItem("notasUltimasNoticias"), resp);
                    localStorage.setItem("obtenerPorPrioridad", JSON.stringify(notasLimpias));
                    return;
                }
                localStorage.setItem("obtenerPorPrioridad", JSON.stringify(resp));
                obtenerPorPrioridad = localStorage.getItem("obtenerPorPrioridad");
            });
        }

        if (obtenerPreferibles === null) {
            apiPerso.preferencias.obtenerPreferibles().then(function (resp) {
                localStorage.setItem("obtenerPreferibles", JSON.stringify(resp));
                obtenerPreferibles = localStorage.getItem("obtenerPreferibles");
            }).catch(showErr.bind(console, "Obtener preferibles"));
        }

        if (_recomendarTemas === null) {
            //Para temas y autores mas sugeridos
            apiPerso.sugerencias.recomendarTemas(5).then(function (resp) {
                localStorage.setItem("recomendarTemas", JSON.stringify(resp));
                _recomendarTemas = localStorage.getItem("recomendarTemas");
            });
        }

        apiPerso.execute().then(function (resp) {
            cargarLsPreferenciasTemasYSugerencias(section);
        }).catch(showErr.bind(console, "execute"));
    } else {
        if (section === "home") {
            (0, _loQueSigo.preferencias)();
        } else {
            //NO LOGUEADO 
            getDataNoLogueado();
            if (isSessionDateExpired()) {
                reLoadSugerenciasAnonimas();
            }
        }
    }
};

var limpiarPerferenciasDeUltimasNoticias = function limpiarPerferenciasDeUltimasNoticias(notasUltimasNoticias, notasPreferencias) {
    if (!notasUltimasNoticias) return limpiarPreferenciasDeColumnistas(notasPreferencias);

    notasUltimasNoticias = notasUltimasNoticias.split(",");
    var arrayIdsUltimasNoticias = notasUltimasNoticias.map(function (i) {
        return parseInt(i);
    });
    var arrayIdsPreferencias = notasPreferencias.map(function (n) {
        return n.contenido_id;
    });
    var arrayIdsParaBorrar = arrayIdsPreferencias.filter(function (val) {
        return arrayIdsUltimasNoticias.includes(val);
    });

    //retorna un nuevo array con los valores que NO ESTEN EN AMBOS (o sea los que no coinciden en ambos arrays)
    var preferencias = notasPreferencias.filter(function (x) {
        return arrayIdsParaBorrar.indexOf(x.contenido_id) === -1;
    });

    return limpiarPreferenciasDeColumnistas(preferencias);
};

var limpiarPreferenciasDeColumnistas = function limpiarPreferenciasDeColumnistas(preferencias) {
    var notasIdsTotal = [];
    //Editoriales
    var notasEditoriales = document.querySelectorAll("section#autores > section.editoriales > article");
    //Columnistas
    var notasColumnistas = document.querySelectorAll("section#autores > article.autor");

    notasEditoriales.forEach(function (item) {
        notasIdsTotal.push(parseInt(item.getAttribute("data-notaid")));
    });

    notasColumnistas.forEach(function (item) {
        notasIdsTotal.push(parseInt(item.getAttribute("data-notaid")));
    });

    return preferencias.filter(function (x) {
        return notasIdsTotal.indexOf(x.contenido_id) === -1;
    });
};

var cargarLsPreferenciasTemasYSugerencias = function cargarLsPreferenciasTemasYSugerencias(section) {
    var apiPerso = SessionLogin.initPerso();
    var obtenerNovedades = localStorage.getItem("obtenerNovedades");
    var obtenerSugerencias = localStorage.getItem("obtenerSugerencias");

    if (localStorage.getItem("obtenerHashSuscripciones") !== null) {
        //Obtener las Preferencias y competando con sugerencias llegado el caso.
        if (section === "nota") {

            /*Fuerzo a que sea ApiPerso */
            localStorage.setItem("randomCorteSugerencias", "ApiPerso");
            /****************************/

            var objResult = Sugerencias.getValoresDeCorte();
            if (obtenerSugerencias === null) {
                //const jsonCategoria = JSON.parse(localStorage.getItem("obtenerPreferibles"));
                if (objResult !== undefined) {

                    /*Despues de ejecutar Fuerzo a que sea Liftigniter */
                    localStorage.setItem("randomCorteSugerencias", "Liftigniter");

                    apiPerso.sugerencias.obtener([], 25, objResult.horas, objResult.dias, objResult.usuario, objResult.categorias).then(function (resp) {
                        localStorage.setItem("obtenerSugerencias", JSON.stringify(resp));
                        obtenerSugerencias = localStorage.getItem("obtenerSugerencias");
                    }).catch(showErr.bind(console, "obtener sugerencias"));
                }
            }
        }

        if (obtenerNovedades === null) {
            apiPerso.preferencias.obtenerNovedades().then(function (resp) {
                localStorage.setItem("obtenerNovedades", resp[0].cantidad);
                obtenerNovedades = localStorage.getItem("obtenerNovedades");
            });
        }
    } else {
        //SIN PREFERENCIAS
        if (recomendarTemas === null) {
            //Para temas y autores mas sugeridos
            apiPerso.sugerencias.recomendarTemas(5).then(function (resp) {
                localStorage.setItem("recomendarTemas", JSON.stringify(resp));
                recomendarTemas = localStorage.getItem("recomendarTemas");
            });
        }
    }

    apiPerso.execute().then(function (resp) {
        if (section === "home") {
            (0, _loQueSigo.preferencias)();
        } else {
            if (localStorage.getItem("obtenerHashSuscripciones") !== null) {
                (0, _preferencias.renderPreferencias)();
                Sugerencias.sugerencias();
            } else {
                //SIN PREFERENCIAS
                (0, _preferencias.sugerenciasNoSigoNada)();
            }
        }
        preferenciasCambioBotonSiguiendo();
    }).catch(showErr.bind(console, "execute"));
};

var isSessionDateExpired = function isSessionDateExpired() {
    var createdDate = localStorage.getItem("sugerenciasNoLoginCreated");
    var cacheMiliseconds = 300000; ///TODO:pasar a configuracion
    var dif = 0;

    if (createdDate === null) {
        return true;
    } else {
        dif = Date.now() - createdDate;
        if (dif < cacheMiliseconds) {
            return false;
        } else {
            return true;
        }
    }
};

var reLoadSugerenciasAnonimas = function reLoadSugerenciasAnonimas() {

    localStorage.removeItem("sugerenciasNoLogin");
    getDataNoLogueado();
};

var preferenciasCambioBotonSiguiendo = exports.preferenciasCambioBotonSiguiendo = function preferenciasCambioBotonSiguiendo() {
    //TODO: Refactor ver donde se puede hacer esta llamada una sola vez para reutilizacion inicial de todas las pag
    var LSPreferible = localStorage.getItem("obtenerPreferibles");

    if (!SessionLogin.init()) {
        return;
    }

    if (LSPreferible === null) {

        var apiPerso = SessionLogin.initPerso();

        apiPerso.preferencias.obtenerPreferibles().then(function (resp) {
            localStorage.setItem("obtenerPreferibles", JSON.stringify(resp));
        }).catch(showErr.bind(console, "Obtener preferibles"));

        apiPerso.execute().then(function (resp) {
            cambioBotonSiguiendo();
        }).catch(showErr.bind(console, "execute"));
    } else {
        cambioBotonSiguiendo();
    }
};

var cambioBotonSiguiendo = function cambioBotonSiguiendo() {
    var LSPreferible = localStorage.getItem("obtenerPreferibles");
    if (LSPreferible == null) return;

    var dataPreferibles = JSON.parse(LSPreferible);
    var idsPreferibles = [];
    document.querySelectorAll('button.seguir').forEach(function (elem) {
        idsPreferibles.push(elem.getAttribute('data-preferibleid'));
    });

    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
        for (var _iterator3 = dataPreferibles[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var preferible = _step3.value;

            if (idsPreferibles.indexOf(preferible.id.toString()) != -1) {
                var nodo = document.querySelectorAll('button.seguir[data-preferibleid="' + preferible.id + '"]');

                nodo.forEach(function (element, index) {
                    element.textContent = 'SIGUIENDO';
                    element.classList.add('activo');
                });
            }
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
            }
        } finally {
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }
};

var getDataNoLogueado = function getDataNoLogueado() {
    var resp = void 0;
    var sugerenciasNoLoginLS = localStorage.getItem("sugerenciasNoLogin");

    if (sugerenciasNoLoginLS != null) {
        renderNoLogueado(JSON.parse(sugerenciasNoLoginLS));
        sugerenciasNoLoginLS = purgarNotaDeSugerenciasNoLogueado(JSON.parse(sugerenciasNoLoginLS));
        sugerenciasNoLogin(sugerenciasNoLoginLS);
    } else {
        if (randomFn() > 5) {
            (0, _ajax.get)(urlNavAnonimo).then(function (rs) {
                localStorage.setItem("sugerenciasNoLogin", rs);
                localStorage.setItem("sugerenciasOrigen", "home");
                localStorage.setItem("sugerenciasNoLoginCreated", Date.now());
                renderNoLogueado(JSON.parse(rs));
                resp = purgarNotaDeSugerenciasNoLogueado(JSON.parse(rs));
                sugerenciasNoLogin(resp);
            });
        } else {
            (0, _ajax.get)(urlNavAnonimoExt).then(function (rs) {
                localStorage.setItem("sugerenciasNoLogin", rs);
                localStorage.setItem("sugerenciasOrigen", "nohome");
                localStorage.setItem("sugerenciasNoLoginCreated", Date.now());
                renderNoLogueado(JSON.parse(rs));
                resp = purgarNotaDeSugerenciasNoLogueado(JSON.parse(rs));
                sugerenciasNoLogin(resp);
            });
        }
    }
};

var purgarNotaDeSugerenciasNoLogueado = function purgarNotaDeSugerenciasNoLogueado(notas) {
    var notaId = document.querySelector("div[data-notaId]").getAttribute("data-notaId");
    var notasSugerencias = notas.items;

    if (notasSugerencias !== null && notasSugerencias !== undefined && notasSugerencias.length > 0) {
        notasSugerencias.forEach(function (laNota, index) {
            if (laNota.id === parseInt(notaId)) {
                notasSugerencias.splice(index, 1);
            }
        });
    }
    return notasSugerencias;
};

var randomFn = function randomFn() {
    return Math.floor(Math.random() * 10 + 1);
};

var renderNoLogueado = function renderNoLogueado(notas) {
    if (document.querySelector("#bloque-2")) {
        var notasTemasRecomendados = notas.items.filter(function (nota) {
            return nota.tagDestacado;
        });
        var css = "sin-loguear";
        var html = "";

        if (notasTemasRecomendados !== null && notasTemasRecomendados !== undefined && notasTemasRecomendados.length > 0) {
            var valueToSlice = notasTemasRecomendados.length < 3 ? notasTemasRecomendados.length : 3;

            html += "<div class=\"techo floatFix\">\n                    <h4>REGISTRATE EN LA NACION Y </h4>\n                    <h4><b>MEJOR\xC1 TU EXPERIENCIA</b></h4>\n                    <button class=\"ingresar\"> INGRES\xC1 </button>\n                </div>\n                <p>Segu\xED los temas y autores que m\xE1s te interesan y enterate, al instante, cada vez que haya nuevas notas</p>\n                <section class=\"mas-seguidos\">";

            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = notasTemasRecomendados.slice(0, valueToSlice)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var nota = _step4.value;

                    var id = nota.tagDestacado.id;

                    html += "<div class=\"tema floatFix\"><p>" + nota.tagDestacado.valor + "</p>\n                     <button class=\"seguir\" data-preferibleId=\"" + id + "\" data-preferibleTipoId=\"7\">SEGUIR</button></div>";
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }

            html += "</section>";
        }

        var asideBloque2 = document.querySelector("#bloque-2");
        asideBloque2.classList.add(css);
        asideBloque2.innerHTML = html;

        Login.Initialize();
    }
    seguirDejarSeguir(document.querySelectorAll('button[class="seguir"]'));
};

var sugerenciasNoLogin = function sugerenciasNoLogin(notas) {
    if (notas != null && notas.length > 0) {

        notas = notas.filter(function (item) {
            return item != null && item.imagenes !== null && item.imagenes !== undefined && item.imagenes.length > 0;
        });

        var notasBloque1 = notas.slice(0, 7);
        var notasBloque2 = notas.slice(7, 15);
        var notasBloque3 = notas.slice(15, 20);
        var contador = 0;
        var toi = 101;

        var html = "<section class=\"puede-interesar\" id=\"bloque-3\" data-is-block=\"true\" data-block-name=\"n_sugerencias\" data-diagramacion-id=\"0\">\n                    <div class=\"fila-1 floatFix\" id=\"sugeridasBloque3F1\">\n                    <h4>Te puede interesar</h4>\n                    <div class=\"columna-doble\">" + getArticleSugeridoSinLogin(notas[0], 514, 137, toi) + "</div>";

        var article = "";
        notasBloque1.shift();
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
            for (var _iterator5 = notasBloque1[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                var nota = _step5.value;

                toi++;
                article += getArticleSugeridoSinLogin(nota, 216, 137, toi);
                contador++;

                if (contador % 2 === 0) {
                    html += "<div class=\"columna\">" + article + "</div>";
                    article = "";
                }
            }
        } catch (err) {
            _didIteratorError5 = true;
            _iteratorError5 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                    _iterator5.return();
                }
            } finally {
                if (_didIteratorError5) {
                    throw _iteratorError5;
                }
            }
        }

        html += "</div>";

        if (notasBloque2.length == 8) {
            html += "<div class=\"fila-2 floatFix\" id=\"sugeridasBloque3F2\">";
            article = "";
            contador = 0;
            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
                for (var _iterator6 = notasBloque2[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                    var nota = _step6.value;

                    toi++;
                    article += getArticleSugeridoSinLogin(nota, 216, 137, toi);
                    contador++;
                    if (contador % 2 === 0) {
                        html += "<div class=\"columna\">" + article + "</div>";
                        article = "";
                    }
                    if (contador === 5) {
                        toi++;
                        article = getArticleSugeridoSinLogin(nota, 514, 137, toi);
                        html += "<div class=\"columna-doble\">" + article + "</div>";
                        article = "";
                        contador++;
                    }
                }
            } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion6 && _iterator6.return) {
                        _iterator6.return();
                    }
                } finally {
                    if (_didIteratorError6) {
                        throw _iteratorError6;
                    }
                }
            }

            html += "</div>";
        }

        if (notasBloque3.length == 5) {
            html += "<div class=\"fila-3 floatFix\" id=\"sugeridasBloque3F3\">";
            var _iteratorNormalCompletion7 = true;
            var _didIteratorError7 = false;
            var _iteratorError7 = undefined;

            try {
                for (var _iterator7 = notasBloque3[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                    var nota = _step7.value;

                    toi++;
                    html += getArticleSugeridoSinLogin(nota, 216, 137, toi);
                }
            } catch (err) {
                _didIteratorError7 = true;
                _iteratorError7 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion7 && _iterator7.return) {
                        _iterator7.return();
                    }
                } finally {
                    if (_didIteratorError7) {
                        throw _iteratorError7;
                    }
                }
            }

            html += "</div></section>";
        }

        html += "</aside>";

        //Se agrega el "-ln" para diferenciarlo del de Liftigniter
        document.querySelector('div[data-module="nota-sugeridas-ln"]').innerHTML = html;
    }
};

var getArticleSugeridoSinLogin = function getArticleSugeridoSinLogin(nota, width, widthTablet, toi) {
    var imgHtml = "";
    var toiPos = "toi".concat(toi.toString());
    var sugerenciasOrigen = localStorage.getItem("sugerenciasOrigen");
    if (nota.imagenes instanceof Array && nota.imagenes[0].src != null && nota.imagenes[0].src != "") {
        imgHtml += "<source media=\"(min-width: 768px)\" srcset=\"" + BucketTools.urlBucketBalance(urlBucket, nota.imagenes[0].src, "", width) + "\">";
        imgHtml += "<img src=\"" + BucketTools.urlBucketBalance(urlBucket, nota.imagenes[0].src, "", widthTablet) + "\"/>";
    }
    var html = "<article title=\"\" class=\"nota\" data-id=\"" + nota.id + "\" data-notaid=\"" + nota.id + "\" data-source=\"ranking-ref-" + sugerenciasOrigen + "\" data-pos=\"" + toiPos + "\">\n                  <a class=\"figure\" href=\"" + Utilities.FormatearUrl(nota.url) + "\">\n                      <picture>\n                        " + imgHtml + "\n                      </picture>\n                  </a>\n                  <h2><a href=\"" + Utilities.FormatearUrl(nota.url) + "\">" + nota.titulo + "</a></h2>\n                </article>";
    return html;
};

var registrarAccesosAcumulados = exports.registrarAccesosAcumulados = function registrarAccesosAcumulados() {
    if (SessionLogin.init()) {
        var apiPerso = SessionLogin.initPerso();

        var preferibleAcumulado = document.querySelector('div[data-preferibles]').getAttribute('data-preferibles');
        var ctx = null;
        apiPerso.sugerencias.registrarAccesos(preferibleAcumulado, ctx).then(console.log.bind(console, 'registrarAccesos')).catch(console.log.bind(console, 'registrarAccesos'));
        apiPerso.execute().then(console.log.bind(console, 'execute ')).catch(console.log.bind(console, 'error'));
    }
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var clearLS = exports.clearLS = function clearLS() {

    localStorage.removeItem("apiPerso.preferencias.obtener");
    localStorage.removeItem("apiPerso.preferencias.obtenerNovedades");
    localStorage.removeItem("apiPerso.preferencias.obtenerPreferibles");

    localStorage.removeItem("apiPerso.ranking.obtenerMasSeguidos");

    localStorage.removeItem("obtenerPorPrioridad");
    localStorage.removeItem("obtenerNovedades");
    localStorage.removeItem("recomendarTemas");
    localStorage.removeItem("obtenerAccesos");
    localStorage.removeItem("obtenerSugerencias");
    localStorage.removeItem("obtenerHashSuscripciones");
    localStorage.removeItem("obtenerPreferibles");
    localStorage.removeItem("notasUltimasNoticias");
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.functions = undefined;
exports.stylesNotaLiveBlog = stylesNotaLiveBlog;
exports.buscador = buscador;
exports.bannerHeaderLogo = bannerHeaderLogo;
exports.share = share;

__webpack_require__(18);

var _bucket = __webpack_require__(2);

var BucketTools = _interopRequireWildcard(_bucket);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/*$(document).ready(function() {
    
    $('#cuerpo aside.listado.ademas').each(function() {
        let $this = $(this);
        if ($this.find('article').length = 1) {
            $this.addClass('uno');
        }
    });
    

});*/

function stylesNotaLiveBlog() {

    $(document).ready(function () {

        if ($(window).width() >= 1450) {
            var indice = $('<div>', {
                'class': 'indice'
            });
            $('.noticias').append(indice);

            $(window).scroll(function () {
                var inicioContPrincipal = $('.cont-principal').offset().top;
                var documento = $(document).scrollTop();
                var pantalla = $(window).height();
                var pantallaBottom = documento + pantalla;
                var delay = 1;

                /*agregamos clase para mostrar menu fixed y  hacemos efecto cascada*/
                if (documento + 400 > inicioContPrincipal) {
                    $('.menu-fixed li').addClass('visible');
                    $(".menu-fixed li").each(function () {
                        $(this).css({ "transition-delay": "0." + delay + "s" });
                        delay += 1;
                    });
                } else {
                    $('.menu-fixed li').removeClass('visible');
                    $(".menu-fixed li").each(function () {
                        $(this).css({ "transition-delay": "0s" });
                        delay += 1;
                    });
                }
            });

            /*EFECTO MENU FIXED, AGREGADO CLASE ACTIVE, EFECTO INDICE Y ANIM NUMERO*/
            $(".menu-fixed li").on("click", function () {
                var inicioContPrincipal = $('.cont-principal').offset().top;
                var seccion = $(this).attr("name");
                var seccionId = $("#" + seccion);
                var posicion = $(seccionId).offset().top;

                if ($(this).hasClass('active') > 0) {
                    return false;
                } else {
                    $(".menu-fixed li").removeClass("active");
                    $(this).addClass('active');

                    $("html, body").animate({
                        scrollTop: posicion - 200
                    }, 1500);
                    $(".indice").animate({
                        top: posicion + 109 - inicioContPrincipal
                    }, 1500);
                    //setTimeout(function () {
                    //    /*funcion de efecto numeros en la hora*/
                    //    $('#' + seccion + ' .count').each(function () {
                    //        $(this).prop('Counter', 99).animate({
                    //            Counter: $(this).html()
                    //        }, {
                    //            duration: 400,
                    //            step: function (now) {
                    //                $(this).html(Math.ceil(now));
                    //            },
                    //            complete: function () {
                    //                let data = $(this).data('value');
                    //                $(this).html(data);
                    //            }
                    //        })
                    //    });
                    //}, 1400);
                }
            });
        }
    });
}

function buscador() {

    $('button[data-id="btnBuscador"]').on('click', function () {
        window.location.href = window.config.Statics.BuscadorUrl + $('input[data-id="buscador"]').val();
    });
    $('input[data-id="buscador"]').on('keypress', function (e) {
        if (e.keyCode == 13) {
            $('button[data-id="btnBuscador"]').click();
        }
    });
}

function bannerHeaderLogo() {
    setTimeout(function () {
        $('.banner-header-logo div').fadeIn();
    }, 3000);

    if ($(window).width() <= 769) {
        // Link usuario mobile
        var link = $('body header#cabezal .usuario');
        link.click(function () {
            window.open('http://micuenta.lanacion.com.ar/', '_blank');
        });
    }
}

function share() {
    if ($(window).width() <= 769) {
        var shareHover = $('#item-nota #nota .barra .datos-nota .herramientas .share-hover');
        shareHover.click(function () {
            shareHover.toggleClass('visible');
        });

        var shareHeader = $('header .herramientas .share-hover');
        shareHeader.click(function () {
            shareHeader.toggleClass('visible');
            $('header').toggleClass('shareVisible');
        });
    } else {}

    //$(window).on('load resize', function() {
    if ($(window).width() >= 769) $('.icon-whatsapp').attr('id', 'whatsAppShareDesktop');else $('.icon-whatsapp').attr('id', 'whatsAppShareMobile');
    //  });

}

var functions = exports.functions = function functions() {

    var $window = $(window);
    modal();
    encuesta();
    //colorMobile();
    headerFijo();
    arriba();
    menu();
    menuBusqueda();
    modalOut();
    fotoXL();
    audioPlayer();
    //slider(); //TODO: esto solo se usa para HTMLs de integracion
    headerFijoHome();
    comentarioScroll();
    videoFixed();
    //animaciones();
    obtenerLink();
    scrollLiveblog();

    function scrollLiveblog() {
        if ($(".menu-fixed").length > 0 && $(".puede-interesar").length > 0) {
            $(window).scroll(function () {
                if (checkVisible($('.puede-interesar'))) {
                    $(".menu-fixed").fadeOut();
                } else {
                    $(".menu-fixed").fadeIn();
                }
            });
        }

        function checkVisible(elm, evalparam) {
            var evalparam = evalparam || "visible";
            var vpH = $(window).height(),
                // Viewport Height
            st = $(window).scrollTop(),
                // Scroll Top
            y = $(elm).offset().top,
                elementHeight = $(elm).height();

            if (evalparam === "visible") return y < vpH + st && y > st - elementHeight;
            if (evalparam === "above") return y < vpH + st;
        }
    }

    function obtenerLink() {
        var link = $('.herramientas .icon-001-internet span');
        link.click(function () {
            link.text('Link copiado');
        });
    };

    function encuesta() {
        var opcion = $('#item-nota #nota #cuerpo .encuesta button');
        var encuesta = $('#item-nota #nota #cuerpo .encuesta');

        opcion.click(function () {

            if (encuesta.hasClass('resultados')) {} else {
                $(this).addClass('elegido');
                encuesta.addClass('resultados');

                opcion.each(function () {
                    var opcionAfter = $(this).find('span');
                    var porcentaje = opcionAfter.html();
                    opcionAfter.css('width', porcentaje);
                });
            }
        });
    }

    function headerFijo() {
        if ($(window).width() > 767) {
            if ($('h1.titulo') && $('h1.titulo').length > 0) {
                var titulo = $('h1.titulo')[0].textContent;
                document.querySelector('.titulo-fijo').innerHTML = titulo;
            }
        } else {
            if (document.querySelector('.titulo-fijo')) {
                document.querySelector('.titulo-fijo').innerHTML = '';
            }
        }

        $(window).scroll(function () {
            if (checkVisible($('.titulo'))) {
                $("header").removeClass("headerFijo");
            } else {
                $("header").addClass("headerFijo");
            }
        });

        function checkVisible(elm, evalparam) {
            var evalparam = evalparam || "visible";
            var vpH = $(window).height(),
                // Viewport Height
            st = $(window).scrollTop(),
                // Scroll Top
            y = $(elm).offset().top,
                elementHeight = $(elm).height();

            if (evalparam === "visible") return y < vpH + st && y > st - elementHeight;
            if (evalparam === "above") return y < vpH + st;
        }
    }

    function headerFijoHome() {
        // Oculta header cuando el usuario scrollea hacia abajo y lo muestra cuando scrollea hacia arriba
        var didScroll = void 0;
        var lastScrollTop = 0;
        var delta = 5;
        var navbarHeight = $('header').outerHeight();

        $(window).scroll(function (event) {
            didScroll = true;
        });

        setInterval(function () {
            if (didScroll) {
                hasScrolled();
                didScroll = false;
            }
        }, 250);

        function hasScrolled() {
            var st = $(window).scrollTop();

            // Make sure they scroll more than delta
            if (Math.abs(lastScrollTop - st) <= delta) return;

            // If they scrolled down and are past the navbar, add class .nav-up.
            // This is necessary so you never see what is "behind" the navbar.
            if (st > lastScrollTop && st > navbarHeight) {
                // Scroll Down
                $('header').removeClass('nav-down').addClass('nav-up');
            } else {
                // Scroll Up
                if (st + $(window).height() < $(document).height()) {
                    $('header').removeClass('nav-up').addClass('nav-down');
                }
            }

            if ($(window).width() < 1024 && $("#nota").length) {
                var cuerpo = $('#nota').offset().top + 70;
                if (st > lastScrollTop || $(window).scrollTop() < cuerpo) {
                    $('.scroll-links').slideUp(200);
                } else {
                    // Scroll Up
                    if (st + $(window).height() < $(document).height()) {
                        $('.scroll-links').slideDown(200);
                    }
                }
            }
            if (st > 180) {

                if ($('header').hasClass('nav-down')) {
                    $('.banner-mobile.sticky2, .banner.sticky2').removeClass('up');
                } else {
                    $('.banner-mobile.sticky2, .banner.sticky2').addClass('up');
                }
            }

            lastScrollTop = st;
        }

        /*$(".scroll-links a").on('click', function(event) {
            if (this.hash !== "") {
                event.preventDefault();
                let hash = this.hash;
                $('html, body').animate({
                    scrollTop: $(hash).offset().top
                }, 800, function() {
                    window.location.hash = hash;
                });
            }
        });*/
    }

    function arriba() {
        $(".volver").click(function (event) {
            event.preventDefault();
            $("html, body").animate({ scrollTop: 0 }, 600);
            return false;
        });
    };

    function comentarioScroll() {
        if ($("#livefyre").length > 0) {
            $('[data-id="comentarios"]').click(function (event) {
                event.preventDefault();
                $("html, body").animate({ scrollTop: $("#livefyre").offset().top }, 600);
                return false;
            });
        }
    }

    function modal() {
        var modal = $('#modalImagen');
        var ampliar = $('.galeria img, figure img');
        var cerrar = $('#cuerpo .icon-cerrar');

        //Abre Modal
        ampliar.click(function () {
            var sliderContainer = $('body').find('#sliderContainer');

            if ($(this).parent().parent().parent().is('#sliderContainer')) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = sliderContainer.find('ul li img')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var img = _step.value;


                        var alturaImagen = window.screen.height;
                        $(this).parent().find("img").css('display', 'none');
                        img.src = BucketTools.changeSizeWithFullPath(img.src, 'h' + alturaImagen);
                        $('#sliderContainer').find('ul').addClass('elementoModal');
                        $('#slider').addClass('top');
                        $(this).parent().find("img").fadeIn();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                ;
            } else {
                var parentReal = $(this).parent().parent();

                parentReal.find("img").addClass('previa');
                parentReal.find('img.previa').clone().attr('class', 'nueva').appendTo(parentReal);
                parentReal.find("img.nueva").attr("src", "");
                var alturaImagen = window.screen.height;
                parentReal.find("img.nueva").attr("src", BucketTools.changeSizeWithFullPath(parentReal.find("img.previa").attr("src"), 'h' + alturaImagen));
                parentReal.addClass('elementoModal');
                parentReal.find("img").fadeIn();
            }

            if ($("body").hasClass('modal-on')) {} else {
                setTimeout(function () {
                    var elem = document.body; // Make the body go full screen.
                    requestFullScreen(elem);
                }, 0);
                modal.fadeIn(500);
                $('body').addClass('modal-on');
                $('.modal-on figcaption').fadeOut(0);
                $('.modal-on .elementoModal + figcaption, .modal-on .elementoModal > figcaption').fadeIn(500);
            }
        });

        cerrar.click(function () {
            if ($("body").hasClass('modal-on')) {
                exitFullScreen(elem);
                setTimeout(function () {
                    modal.fadeOut();
                    $('img').removeClass('previa');
                    $('img.nueva').remove();
                    $('body').removeClass('modal-on');
                    $('body').find('.elementoModal').removeClass('elementoModal');
                    $('#slider').removeClass('top');
                }, 0);
                var elem = document.body; // Make the body go full screen.

                $('.modal-on figcaption').fadeIn(0);
            } else {}
        });
    }

    // Fullscreen on
    function requestFullScreen(element) {
        // Supports most browsers and their versions.
        var requestMethod = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullScreen;

        if (requestMethod) {
            // Native full screen.
            requestMethod.call(element);
        } else if (typeof window.ActiveXObject !== "undefined") {
            // Older IE.
            var wscript = new ActiveXObject("WScript.Shell");
            if (wscript !== null) {
                wscript.SendKeys("{F11}");
            }
        }
    }

    // Fullscreen off
    function exitFullScreen(element) {
        if (document.exitFullscreen) {
            document.exitFullscreen();
            setTimeout(function () {
                modal.fadeOut();
                $('img').removeClass('previa');
                $('img.nueva').remove();
                $('body').removeClass('modal-on');
                $('body').find('.elementoModal').removeClass('elementoModal');
                $('#slider').removeClass('top');
            }, 300);
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        }
    }

    function modalOut() {

        var modal = $('#modalImagen');

        $(document).keyup(function (e) {
            if (e.which == 27) setTimeout(function () {
                modal.fadeOut();
                $('img').removeClass('previa');
                $('img.nueva').remove();
                $('body').removeClass('modal-on');
                $('body').find('.elementoModal').removeClass('elementoModal');
                $('#slider').removeClass('top');
            }, 300);
        });

        //Mousewheel abajo
        $(window).on('mousewheel', function (turn, delta) {

            if ($("figure").hasClass('elementoModal')) {
                if (delta == 1) ;else setTimeout(function () {
                    modal.fadeOut();
                    $('img').removeClass('previa');
                    $('img.nueva').remove();
                    $('body').removeClass('modal-on');
                    $('body').find('.elementoModal').removeClass('elementoModal');
                    $('#slider').removeClass('top');
                }, 300);

                var elem = document.body; // Make the body go full screen.
                exitFullScreen(elem);

                return true;
            } else {}
        });
    }

    function menu() {
        $(".icon-menu-desktop").unbind().click(function (event) {
            if ($('header').hasClass('desplegado')) {
                $('.icon-menu-desktop').html('MENÚ');
                $('header').removeClass('desplegado-busqueda');
                $('header').removeClass('desplegado');
            } else {
                $('header').addClass('desplegado');
                $('.icon-menu-desktop').html('CERRAR');
            }
            if ($('header').hasClass('desplegado-busqueda') && $('.icon-menu-desktop').html('CERRAR')) {
                $('.icon-menu-desktop').html('MENÚ');
                $('header').removeClass('desplegado-busqueda');
                $('header').removeClass('desplegado');
            }

            if ($(window).width() < 1024) {
                if ($('body').hasClass('sinScroll')) {
                    $('body').removeClass('sinScroll');
                } else {
                    $('body').addClass('sinScroll');
                }
            }
        });

        //Cierre del menú

        $('html').click(function (e) {
            if (e.target.id != 'header' && $(e.target).parents('header').length == 0) {
                $('.icon-menu-desktop').html('MENÚ');
                $('header').removeClass('desplegado-busqueda');
                $('header').removeClass('desplegado');
            }
        });
    }

    function menuBusqueda() {
        $('.busqueda input').focus(function () {
            /*$('header').addClass('desplegado-busqueda');
            $('header').removeClass('desplegado');
            $('.icon-menu-desktop').html('CERRAR');*/
        });
    }

    function fotoXL() {
        if ($(window).width() < 768) {
            $(".scroll").each(function () {
                var contenedor = $(this).children("img").width();
                var scroll = $(this).width();
                var diferencia = (contenedor - scroll) / 2;
                if ($(this).hasClass("centrado")) {
                    $(this).scrollLeft(diferencia);
                }
                /*if ($(this).hasClass("derecha")) {
                    $(this).scrollLeft(0);
                }
                if ($(this).hasClass("izquierda")) {
                    $(this).scrollLeft(scroll);
                }*/
            });
        }
    }

    function audioPlayer() {
        $('.audio-player').mediaPlayer();
    }

    function colorNotaMobile(hex) {
        //Paso de HEX a RGB
        var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, function (m, r, g, b) {
            return r + r + g + g + b + b;
        });

        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        var r = parseInt(result[1], 16);
        var g = parseInt(result[2], 16);
        var b = parseInt(result[3], 16);

        //Convierto de RGB a YIQ 
        var yiq = (r * 299 + g * 587 + b * 114) / 1000;
        var colorRGB = "rgb(" + r + "," + g + "," + b + ")";
        var foto = $("#cuerpo figure.XL img");
        var extra = 200;

        var alto = foto.offset().top + foto.height() + extra; //hardcode: por el banner sticky

        //Si el color es muy claro lo dejo blanco
        if (yiq < 190) {
            $("body").addClass("predomina-oscuro");
            if (!$(".background").length) {
                $("body").prepend("<div class='background'></div>");
            }
            $(".background").css({ "height": alto });
            $(".background").css({ "margin-top": "-" + extra + "px" });
            $(".background").css({ backgroundColor: colorRGB });
            $(".predomina-oscuro #cabezal").css({ backgroundColor: colorRGB });
        };
    }

    function borrarColorNotaMobile() {
        $("body").removeClass("predomina-oscuro");
        $(".background").remove();
        $("#cabezal").removeAttr("style");
    }

    //ESTO SOLO VA EN NOTA
    //COLORES EJEMPLOS oscuro 878E9A y claro D9D1CE:
    var colorPredominante = document.querySelector("div[data-colorPredominante]");
    colorPredominante = colorPredominante != null ? colorPredominante.getAttribute("data-colorPredominante") : null;

    $(document).ready(function () {
        if (!$('.storytelling').length && colorPredominante != null && colorPredominante != "") {
            if (window.innerWidth < 767) {
                colorNotaMobile(colorPredominante);
            }
        }
    });

    $(window).resize(function () {
        if (!$('.storytelling').length && colorPredominante != null && colorPredominante != "") {
            if (window.innerWidth < 767) {
                colorNotaMobile(colorPredominante);
            } else {
                borrarColorNotaMobile();
            }
        }
    });

    //Start - INHABILITA :HOVER en MOBILE
    function hasTouch() {
        return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    }

    if (hasTouch()) {
        // remove all :hover stylesheets
        try {
            // prevent exception on browsers not supporting DOM styleSheets properly
            for (var si in document.styleSheets) {
                var styleSheet = document.styleSheets[si];
                if (!styleSheet.rules) continue;

                for (var ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
                    if (!styleSheet.rules[ri].selectorText) continue;

                    if (styleSheet.rules[ri].selectorText.match(':hover')) {
                        styleSheet.deleteRule(ri);
                    }
                }
            }
        } catch (ex) {}
    }
    //End - INHABILITA :HOVER en MOBILE
};

function animaciones() {

    (function ($, win) {
        $.fn.inViewport = function (cb) {
            return this.each(function (i, el) {
                function visPx() {
                    var H = $(this).height(),
                        r = el.getBoundingClientRect(),
                        t = r.top,
                        b = r.bottom;
                    return cb.call(el, Math.max(0, t > 0 ? H - t : b < H ? b : H));
                }
                visPx();
                $(win).on("load resize scroll", visPx);
            });
        };
    })(jQuery, window);

    setTimeout(function () {
        $("#item-nota #nota #cuerpo .textual, #item-nota #nota #cuerpo .destacado, #item-nota.storytelling #nota .encabezado>div>div, #item-nota #mas-notas .puede-interesar div div .nota, #item-nota #mas-notas .puede-interesar div.fila-3 .nota, #item-nota #nota .link-boton a").inViewport(function (px) {
            if (px) $(this).addClass("animated");
            if (px) $(this).addClass("fadeInUp");
        });
        $("#item-nota #nota #cuerpo .XL img,#item-nota #nota #cuerpo .L img, #item-nota.storytelling .encabezado figure img").inViewport(function (px) {
            if (px) $(this).addClass("animated");
            if (px) $(this).addClass("fadeIn");
        });

        $("#item-nota #nota #cuerpo .S div, .XL.caja-destacada.epigrafe, #item-nota #nota #cuerpo .ademas .nota").inViewport(function (px) {
            if (px) $(this).addClass("animated");
            if (px) $(this).addClass("fadeInLeftShort");
        });

        $(".deportes .encabezado .techo-1 h3 a, #acumulado .encabezado h1").inViewport(function (px) {
            if (px) $(this).addClass("animated");
            if (px) $(this).addClass("underline");

            setTimeout(function () {
                $('.deportes .encabezado .techo-1 h3 a, #acumulado .encabezado h1').addClass('now');
            }, 1500);
        });
    }, 1);
}

function videoFixed() {
    if ($(window).width() >= 1024) {
        var videoid = 0;
        $(document).on('mouseup', 'aside', function () {
            if (videoid == 0) {
                videoid = $(this).children("div.jwplayer").attr("id");
                return false;
            } else if (videoid != $(this).children("div.jwplayer").attr("id")) {
                jwplayer(videoid).pause();
                $("#" + videoid).removeClass("fixedVideo");
                $(".contenedor-video-fixed").css("display", "none");
                $("#" + videoid).addClass("defaultVideo");
                videoid = $(this).children("div.jwplayer").attr("id");
                return false;
            } else if ($('#' + videoid + '.jw-state-paused.fixedVideo').length > 0 || $('#' + videoid + '.jw-state-playing.fixedVideo').length > 0) {
                jwplayer(videoid).pause();
            }
        });
        //animacion con el scroll ya tomado el id
        $(window).scroll(function () {
            function VideoDefault() {
                $("#" + videoid).removeClass("fixedVideo");
                $(".contenedor-video-fixed").css("display", "none");
                $("#" + videoid).addClass("defaultVideo");
            };

            function VideoFixed() {
                $("#" + videoid).addClass("fixedVideo");
                $(".contenedor-video-fixed").css("display", "block");
                $("#" + videoid).removeClass("defaultVideo");
            };

            //segun estado del video
            if ($("#" + videoid + ".jw-state-playing").length > 0 || $("#" + videoid + ".jw-state-paused").length > 0 || $("#" + videoid + ".jw-flag-ads.jw-state-playing").length > 0 || $(".jw-state-buffering").length > 0) {

                var limiteTop = $("#" + videoid).parent().offset().top;
                var limiteBottom = limiteTop + $("#" + videoid).height();
                var documento = $(document).scrollTop();
                var pantalla = $(window).height();
                var altoAside = $("#" + videoid).parent().height();
                $("#" + videoid).parent().css({ "min-height": altoAside, "background-color": "#ddd" });

                //Si se visualiza o no en el WindowsScreen
                if (documento + pantalla < limiteTop || documento > limiteBottom) {
                    VideoFixed();
                } else {
                    VideoDefault();
                }

                //Termina el video y finaliza la funcion Fixed
                jwplayer(videoid).on('complete', function () {
                    VideoDefault();
                    videoid = 0;
                });
            }

            //Boton cerrar FixedVideo
            $(".contenedor-video-fixed span:last-child").on("click", function () {
                var cerrarVideo = $(".jwplayer.fixedVideo").attr("id");
                if ($(".jwplayer.jw-flag-ads").length > 0) {
                    jwplayer(cerrarVideo).pause();
                } else {
                    jwplayer(cerrarVideo).stop();
                }
                $("#" + cerrarVideo + " .jw-skip").removeClass("omitirShow");
                $("#" + cerrarVideo + " .jw-skip").addClass("omitirHide");
                $("#" + cerrarVideo).addClass("animated slideOutDown");
                $(".contenedor-video-fixed").addClass("animated slideOutDown");

                function slideCerrar() {
                    $("#" + cerrarVideo).removeClass("fixedVideo");
                    $("#" + cerrarVideo).removeClass("animated slideOutDown");
                    $(".contenedor-video-fixed").removeClass("animated slideOutDown");
                    $(".contenedor-video-fixed").css("display", "none");
                    $("#" + cerrarVideo).addClass("defaultVideo");
                    cerrarVideo = 0;
                }
                setTimeout(slideCerrar, 500);
                videoid = 0;
            });
        }); /*fin de scroll*/
    }
}

/***/ }),
/* 13 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function() {

/*!
 * jQuery JavaScript Library v3.3.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2018-01-20T17:24Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

      // Support: Chrome <=57, Firefox <=52
      // In some browsers, typeof returns "function" for HTML <object> elements
      // (i.e., `typeof document.createElement( "object" ) === "function"`).
      // We don't want to classify *any* DOM node as a function.
      return typeof obj === "function" && typeof obj.nodeType !== "number";
  };


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};




	var preservedScriptAttributes = {
		type: true,
		src: true,
		noModule: true
	};

	function DOMEval( code, doc, node ) {
		doc = doc || document;

		var i,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {
				if ( node[ i ] ) {
					script[ i ] = node[ i ];
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.3.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && Array.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {

		/* eslint-disable no-unused-vars */
		// See https://github.com/eslint/eslint/issues/6125
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		DOMEval( code );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	disabledAncestor = addCombinator(
		function( elem ) {
			return elem.disabled === true && ("form" in elem || "label" in elem);
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						disabledAncestor( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
        if ( nodeName( elem, "iframe" ) ) {
            return elem.contentDocument;
        }

        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
        // Treat the template element as a regular one in browsers that
        // don't support it.
        if ( nodeName( elem, "template" ) ) {
            elem = elem.content || elem;
        }

        return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			jQuery.contains( elem.ownerDocument, elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();
var documentElement = document.documentElement;



var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 only
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), doc, node );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		div.style.position = "absolute";
		scrollboxSizeVal = div.offsetWidth === 36 || "absolute";

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a property mapped along what jQuery.cssProps suggests or to
// a vendor prefixed property.
function finalPropName( name ) {
	var ret = jQuery.cssProps[ name ];
	if ( !ret ) {
		ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
	}
	return ret;
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5
		) );
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),
		val = curCSS( elem, dimension, styles ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox;

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}

	// Check for style in case a browser which returns unreliable values
	// for getComputedStyle silently falls back to the reliable elem.style
	valueIsBorderBox = valueIsBorderBox &&
		( support.boxSizingReliable() || val === elem.style[ dimension ] );

	// Fall back to offsetWidth/offsetHeight when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	// Support: Android <=4.1 - 4.3 only
	// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
	if ( val === "auto" ||
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) {

		val = elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ];

		// offsetWidth/offsetHeight provide border-box values
		valueIsBorderBox = true;
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),
				isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra && boxModelAdjustment(
					elem,
					dimension,
					extra,
					isBorderBox,
					styles
				);

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && support.scrollboxSize() === styles.position ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = Date.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( typeof define === "function" && define.amd ) {
	define( "jquery", [], function() {
		return jQuery;
	} );
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );

}.call(window));

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadData = loadData;
exports.signwall = signwall;
exports.paywall = paywall;

var _ajax = __webpack_require__(1);

var _nota = __webpack_require__(6);

function getDefaultDataUrl() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    if (url.indexOf('?') >= 0) {
        return url + '&utm_source=navigation';
    }
    return url + '?utm_source=navigation';
}

function loadData(url) {
    var getDataUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getDefaultDataUrl;

    var dataUrl = getDataUrl(url);
    return new Promise(function (resolve, reject) {
        (0, _ajax.get)(dataUrl).then(function (rs) {
            var data = JSON.parse(rs);
            var elements = [];
            for (var i = 0; i < data.Modules.length; i++) {
                var m = data.Modules[i];
                var el = document.querySelector('[data-module="' + m.Key + '"]');
                el.innerHTML = m.Value;
                elements.push(el);
            }
            document.title = data.Title;
            resolve(elements);
        }).catch(function () {
            return reject();
        });
    });
}

function signwall() {
    var signwall = _nota.HeaderVarnish.filter(function (x) {
        return x.key == "X-APW-AUTHENTICATION-FAILED";
    });
    return signwall.value.replace("{url}", "");
}

function paywall() {
    var signwall = _nota.HeaderVarnish.filter(function (x) {
        return x.key == "X-APW-AUTHORIZATION-DENIED";
    });
    return signwall.value.replace("{url}", "");
}

window.prueba11 = function () {
    console.log("entre a PRUEBA11111111");
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Request - Service worker register method
 * @param {string} method
 * @param {string} url
 * @param {any} params
 * @param {any} headers
 * @return {Promise<string>}
 */
exports.default = ServiceWorker = {
    addToHome: function addToHome() {
        return new Promise(function (resolve, reject) {
            reject(new Error('Lo sentimos, se produjo algún error al inicializar el app'));
        });
    },
    verify: function verify() {
        //if (document.location.hash === "#pwa=on") {
        //    Cookie.CreateCookie('LNpwaStatus', 'true');
        //    console.log('PWA Activo');
        //    document.location.hash = '';
        //}
        //else if(document.location.hash === "#pwa=off") {
        //    Cookie.CreateCookie('LNpwaStatus', 'false')
        //}            
        //const cookie = Cookie.LeerCookie('LNpwaStatus') === 'true';
        //console.log('SW: cookie ', cookie);
        //esto se puede comentar.
        //if (localStorage.getItem("pwaa") !== null && localStorage.getItem("pwaa") === "on") {
        //    console.log('SW: PWA Activo');
        //    return localStorage.getItem("pwaa") === "on" && ("serviceWorker" in navigator);
        //}
        //else if(localStorage.getItem("pwaa") !== null && localStorage.getItem("pwaa") === "off") {
        //    //Cookie.CreateCookie('LNpwaStatus', 'false')
        //    console.log('SW: PWA DESACTIVADOOOOOOOOOOOOOOOOOOOO');
        //    return false;
        //}          

        return true && "serviceWorker" in navigator;
    },
    unregister: function unregister() {
        return new Promise(function (resolve, reject) {
            if ("serviceWorker" in navigator) {
                navigator.serviceWorker.getRegistrations().then(function (registrations) {
                    var length = (registrations || []).length;

                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = registrations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var registration = _step.value;

                            console.log('SW: unreg', registration);
                            registration.unregister();
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }

                    resolve(length);
                }).catch(function (err) {
                    console.log('SW: unreg ERROR', arguments);

                    reject(err);
                });
            } else {
                reject(new Error("serviceWorker == undefined"));
            }
        });
    },
    register: function register() {
        console.log('SW: xxx', ServiceWorker);

        return new Promise(function (resolve, reject) {

            //window.addEventListener('load', function() {

            //    if(navigator.standalone || window.matchMedia('(display-mode: standalone)').matches) {
            //        document.querySelector('body').classList.add('pwa-mode-standalone');
            //    }

            //    const styleMedia = (window.styleMedia || {}).type || false;
            //    if(styleMedia) {
            //        document.querySelector('body').classList.add('pwa-media-' + styleMedia);
            //    }

            //    function updateOnlineStatus(event) {
            //        document.querySelector('body').classList.add('pwa-' + (navigator.onLine ? 'online' : 'offline'));
            //        document.querySelector('body').classList.remove('pwa-' + (navigator.onLine ? 'offline' : 'online'));
            //    }

            //    window.addEventListener('online',  updateOnlineStatus);
            //    window.addEventListener('offline', updateOnlineStatus);
            //});

            //window.addEventListener('beforeinstallprompt', e => {
            //    console.log('SW: app beforeinstallprompt Event fired', e);
            //    e.preventDefault();

            //    ServiceWorker.addToHome = () => {
            //        e.prompt();

            //        return e.userChoice;
            //    };

            //    const btn = document.createElement('button'); 
            //    btn.innerText = "Agregar a inicio";
            //    btn.onclick = () => { 
            //        ServiceWorker.addToHome();
            //    };
            //    document.querySelector('#cabezal > section > div.desplegable > div.tematicas > div.derecha > ul').appendChild(btn);

            //    return false;
            //});

            window.addEventListener('beforeinstallprompt', function (e) {
                // beforeinstallprompt Event fired
                dataLayer.push({
                    'event': 'notificationPrompt'
                });
                // e.userChoice will return a Promise. 
                // For more details read: https://developers.google.com/web/fundamentals/getting-started/primers/promises
                e.userChoice.then(function (choiceResult) {

                    console.log(choiceResult.outcome);

                    if (choiceResult.outcome == 'dismissed') {
                        console.log('User cancelled home screen install');
                    } else {
                        dataLayer.push({
                            'event': 'notificationConsent'
                        });
                    }
                });
            });

            if ('serviceWorker' in navigator) {
                console.log("Will the service worker register?");
                navigator.serviceWorker.register('/sw.js').then(function (reg) {
                    console.log("Yes, it did.");
                }).catch(function (err) {
                    console.log("No it didn't. This happened: ", err);
                });
            }

            //    try {    
            //        navigator.serviceWorker.register("/sw.js")
            //            .then(function (reg) {
            //                var status = reg.installing ? 1 : reg.waiting ? 2 : reg.active ? 3 : 0;
            //                console.log('SW: reg ', reg);
            //                console.log('SW: status', status == 1 ? 'installing' : status == 2 ? 'waiting' : status == 3 ? 'active' : 'none' );

            //                var sw = reg.active;

            //                reg.addEventListener('updatefound', () => {
            //                    var newSW = reg.installing;
            //                    document.querySelector('body').classList.add('pwa-updating');

            //                    console.log('SW: newSW', newSW);
            //                    if(!!newSW) newSW.onstatechange = function (e) {
            //                        var o = e.target;
            //                        console.log('SW: status change new', o.state);

            //                        if ("activated" === o.state && sw) {
            //                            window.location.reload();
            //                        }
            //                    };
            //                });

            //                reg.onstatechange = function (e) {
            //                    var o = e.target;
            //                    console.log('SW: status change', o.state);

            //                    document.querySelector('body').classList.add('pwa-state-' + o.state);
            //                };

            //                resolve({ ok:true, sw: sw, reg: reg });
            //            })
            //            .catch(function (e) {
            //                reject({error: e, ok: false});
            //            });
            //    } catch(err) {
            //        reject({ok:false, message:"Service workers are not supported.", error: err});
            //    }
            //});
        });
    }
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.start = start;

var _jquery = __webpack_require__(13);

var _jquery2 = _interopRequireDefault(_jquery);

var _page = __webpack_require__(14);

var page = _interopRequireWildcard(_page);

var _register = __webpack_require__(15);

var _register2 = _interopRequireDefault(_register);

var _spinner = __webpack_require__(20);

var Spinner = _interopRequireWildcard(_spinner);

var _EplAd = __webpack_require__(17);

var _EplAd2 = _interopRequireDefault(_EplAd);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.spinner = Spinner;

window.jQuery = _jquery2.default;
window.$ = _jquery2.default;

//window.eplArgs = window.eplArgs || {};
//window.eplArgs.callback = (arg) => {
//    if (arg.k === "megaLateral") {
//        const div = document.getElementById('eplAdDivmegaLateral');
//        if (div.childNodes.length) {
//            document.body.classList.remove('con-mega');
//            document.body.classList.add('con-mega');    
//        }
//    }
//}

function start() {
    if (_register2.default.verify()) {
        _register2.default.register().then(function (r) {
            console.log('SW: start', r, _register2.default);
        }).catch(function (err) {
            console.error('SW: error', err);
        });
    } else {
        _register2.default.unregister().then(function (r) {
            return console.log('SW: unreg ', r);
        }).catch(function (err) {
            return console.error('SW: unreg', err);
        });
    }

    return new Promise(function (resolve, reject) {
        (0, _jquery2.default)(function () {
            if (window.banner && window.banner.sites) {
                var ad = new _EplAd2.default(window.banner.sites, window.keywords);
                ad.initSpaces();
            }
            if (!window.render) {
                resolve();
            } else {
                Spinner.show();
                page.loadData(window.location.href).then(function (rs) {
                    Spinner.hide();
                    resolve(rs);
                }).catch(function (err) {
                    Spinner.hide();
                    reject(err);
                });
            }
        });
    });
}

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GLOBAL_URL = 'us.img.e-planning.net';
var DATA_ATTR = 'data-adpos';

var createIframe = function createIframe() {
    var el = document.createElement('IFRAME');
    el.src = 'about:blank';
    el.id = 'epl4iframe';
    el.name = 'epl4iframe';
    el.width = 0;
    el.height = 0;
    el.style.width = '0px';
    el.style.height = '0px';
    el.style.display = 'none';
    return el;
};

var findSite = function findSite(sites) {
    var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.body.offsetWidth;

    var selectedSites = sites.filter(function (s) {
        return s.maxWidth >= width;
    }).sort(function (a, b) {
        return a.maxWidth - b.maxWidth;
    });

    if (selectedSites.length < 1) throw new Error('No se encuentra un sitio para el ancho: ' + width);

    return selectedSites[0];
};

var EplAd = function () {
    function EplAd(sites) {
        var keywords = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        _classCallCheck(this, EplAd);

        var protocol = document.location.protocol || window.top.location.protocol;
        this.scheme = protocol.substr(0, protocol.length - 1);
        this.sites = sites;
        this.args = args;
        this.keywords = keywords;

        this.site = findSite(sites);
        this.eplArgs = this._getArgs(this.site, args);

        this._loaded = false;
    }

    _createClass(EplAd, [{
        key: 'updateAds',
        value: function updateAds() {
            var forced = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (!document.epl) return;
            var site = findSite(this.sites);
            if (forced || site !== this.site) {
                this.site = site;
                this.eplArgs = this._getArgs(this.site, this.args);
                this.removeSpaces();
                document.epl.eplInit(this.eplArgs);
                this.initSpaces();
            }
        }
    }, {
        key: '_getArgs',
        value: function _getArgs(site) {
            var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            return Object.assign({
                iIF: 1,
                sV: this.scheme + '://ads.e-planning.net/',
                vV: "4",
                sOpts: {},
                sI: site.id,
                sec: site.section,
                eIs: site.positions,
                kVs: { busqueda: this.keywords }
            }, args);
        }
    }, {
        key: 'initSpace',
        value: function initSpace(id) {
            var container = document.querySelector('[' + DATA_ATTR + '="' + id + '"]');
            this._initSpace(container);
        }
    }, {
        key: 'initSpaces',
        value: function initSpaces() {
            var ads = document.querySelectorAll('[' + DATA_ATTR + ']');
            for (var i = 0; i < ads.length; i++) {
                var container = ads[i];
                this._initSpace(container);
            }
        }
    }, {
        key: 'removeSpace',
        value: function removeSpace(id) {
            if (!document.epl) return;

            id = this._findPosition(id);
            var space = document.epl.getSpace(id);
            try {
                space.clearAds();
                space.getDiv().remove();
            } catch (_) {}
        }
    }, {
        key: 'removeSpaces',
        value: function removeSpaces() {
            if (!document.epl) return;

            for (var name in document.epl.spaces) {
                var space = document.epl.spaces[name];
                try {
                    space.clearAds();
                    space.getDiv().remove();
                } catch (_) {}
            }
            var ads = document.querySelectorAll('[' + DATA_ATTR + ']');
            for (var i = 0; i < ads.length; i++) {
                var container = ads[i];
                container.childNodes.forEach(function (n) {
                    return n.remove();
                });
            }
        }
    }, {
        key: 'reloadSpaces',
        value: function reloadSpaces() {
            document.epl.refreshAds();
        }
    }, {
        key: '_findPosition',
        value: function _findPosition(pos) {
            if (this.site.rename) {
                for (var i = 0; i < this.site.rename.length; i++) {
                    var rn = this.site.rename[i];
                    if (rn.from === pos) {
                        return rn.to;
                    }
                }
            }
            return pos;
        }
    }, {
        key: '_initialized',
        value: function _initialized() {
            if (document.epl) return this._setupAd();
            if (this._loaded) return false;
            this._loaded = true;

            var cookie = document.cookie;
            var cookieName = ('https' === this.scheme ? 'EPLSERVER_S' : 'EPLSERVER') + '=';
            var regex = new RegExp(cookieName + '[\\w.-]+');

            var baseUrl = null;
            var res = regex.exec(cookie);
            if (res) {
                baseUrl = res[0].substr(cookieName.length);
            }

            var iframe = createIframe();
            document.body.appendChild(iframe);
            var iframeDoc = iframe.contentDocument ? iframe.contentDocument : iframe.document;

            iframeDoc.open();
            iframeDoc.write('<html><head><title>e-planning</title></head><body></body></html>');
            iframeDoc.close();

            var script = iframeDoc.createElement('SCRIPT');
            script.src = this.scheme + '://' + (baseUrl ? baseUrl : GLOBAL_URL) + '/layers/epl-41.min.js';
            iframeDoc.body.appendChild(script);

            if (!baseUrl) {
                script = iframeDoc.createElement('SCRIPT');
                script.src = this.scheme + '://ads.e-planning.net/egc/4/39a8';
                iframeDoc.body.appendChild(script);
            }

            return false;
        }
    }, {
        key: '_initSpace',
        value: function _initSpace(container) {
            var idAttr = container.getAttribute(DATA_ATTR);
            var id = this._findPosition(idAttr);
            this._createSpace(container, id);
        }
    }, {
        key: '_createSpace',
        value: function _createSpace(container, id) {
            var eplId = 'eplAdDiv' + id;
            if (container.querySelector('#' + eplId) == null) {
                var el = document.createElement('div');
                el.id = eplId;
                container.appendChild(el);
                var opts = { t: 1 };
                this.eplArgs.sOpts[id] = opts;
                this._showSpace(id);
            }
        }
    }, {
        key: '_showSpace',
        value: function _showSpace(id, custom) {
            var _this = this;

            if (this._initialized()) {
                var epl = document.epl;
                if (custom) {
                    epl.setCustomAdShow(id, this.eplArgs.custom[id]);
                }
                epl.showSpace(id);
            } else {
                setTimeout(function () {
                    _this._showSpace(id, custom);
                }, 250);
            }
        }
    }, {
        key: '_setupAd',
        value: function _setupAd() {
            if (document.epl.eplReady()) return true;
            document.epl.eplInit(this.eplArgs);
            if (this.eplArgs.custom) {
                for (var s in this.eplArgs.custom) {
                    document.epl.setCustomAdShow(s, this.eplArgs.custom[s]);
                }
            }
            return document.epl.eplReady();
        }
    }]);

    return EplAd;
}();

exports.default = EplAd;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function (root, factory) {

    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
        module.exports = factory;
    } else {
        root.lunar = factory();
    }
})(undefined, function () {

    var lunar = {};

    lunar.hasClass = function (elem, name) {
        return new RegExp('(\\s|^)' + name + '(\\s|$)').test(elem.attr('class'));
    };

    lunar.addClass = function (elem, name) {
        !lunar.hasClass(elem, name) && elem.attr('class', (!!elem.getAttribute('class') ? elem.getAttribute('class') + ' ' : '') + name);
    };

    lunar.removeClass = function (elem, name) {
        var remove = elem.attr('class').replace(new RegExp('(\\s|^)' + name + '(\\s|$)', 'g'), '$2');
        lunar.hasClass(elem, name) && elem.attr('class', remove);
    };

    lunar.toggleClass = function (elem, name) {
        lunar[lunar.hasClass(elem, name) ? 'removeClass' : 'addClass'](elem, name);
    };

    lunar.className = function (elem, name) {
        elem.attr('class', name);
        console.log('className', elem);
    };

    return lunar;
});

(function ($) {

    var _ = {

        cursorPoint: function cursorPoint(evt, el) {
            _.settings.pt.x = evt.clientX;
            _.settings.pt.y = evt.clientY;
            var playObject = el.find('svg').attr('id');
            playObject = document.getElementById(playObject);
            return _.settings.pt.matrixTransform(playObject.getScreenCTM().inverse());
        },

        angle: function angle(ex, ey) {
            var dy = ey - 50; // 100;
            var dx = ex - 50; // 100;
            var theta = Math.atan2(dy, dx); // range (-PI, PI]
            theta *= 180 / Math.PI; // rads to degs, range (-180, 180]
            theta = theta + 90; // in our case we are animating from the top, so we offset by the rotation value;
            if (theta < 0) theta = 360 + theta; // range [0, 360)
            return theta;
        },

        setGraphValue: function setGraphValue(obj, val, el) {

            var audioObj = el.find(_.settings.audioObj),
                pc = _.settings.pc,
                dash = pc - parseFloat(val / audioObj[0].duration * pc, 10);

            $(obj).css('strokeDashoffset', dash);

            if (val === 0) {
                $(obj).addClass(obj, 'done');
                //if (obj === $(_.settings.progress)) {
                //$(obj).closest("svg").attr('class', 'ended');
                $(obj).closest("svg").attr('class', 'not-started playable');
                //}
            }
        },

        reportPosition: function reportPosition(el, audioId) {
            var progress = el.find(_.settings.progress),
                audio = el.find(_.settings.audioObj);
            if (audioId.currentTime == audio[0].duration) {
                audioId.currentTime = 0;
            }
            _.setGraphValue(progress, audioId.currentTime, el);
        },

        stopAllSounds: function stopAllSounds() {

            document.addEventListener('play', function (e) {
                var audios = document.getElementsByTagName('audio');
                for (var i = 0, len = audios.length; i < len; i++) {
                    if (audios[i] != e.target) {
                        audios[i].pause();
                    }
                    if (audios[i] != e.target) $(audios[i]).parent('div').find('.playing').attr('class', 'paused');
                }
            }, true);
        },

        settings: {},

        /**
         * Main Function for plugin
         * @param options
         */
        init: function init(options) {

            var template = ['<svg viewBox="0 0 100 100" id="playable" version="1.1" xmlns="http://www.w3.org/2000/svg" width="34" height="34" data-play="playable" class="not-started playable">', '<g class="shape">', '<circle class="progress-track" cx="50" cy="50" r="47.45" stroke="#ffffff" stroke-opacity="0.25" stroke-linecap="square" fill="none" stroke-width="4"/>', '<circle class="precache-bar" cx="50" cy="50" r="47.45" stroke="#cccccc" stroke-opacity="0.25" stroke-linecap="square" fill="none" stroke-width="4" transform="rotate(-90 50 50)"/>', '<circle class="progress-bar" cx="50" cy="50" r="47.45" stroke="#009EF8" stroke-opacity="1" stroke-linecap="square" fill="none" stroke-width="5" transform="rotate(-90 50 50)"/>', '</g>', '<circle class="controls" cx="50" cy="50" r="36" stroke="none" stroke-width="2" fill="#ffffff" opacity="0.0" pointer-events="all"/>', '<g class="control pause">', '<line x1="40" y1="35" x2="40" y2="65" stroke="#ffffff" fill="none" stroke-width="8" stroke-linecap="butt"/>', '<line x1="60" y1="35" x2="60" y2="65" stroke="#ffffff" fill="none" stroke-width="8" stroke-linecap="butt"/>', '</g>', '<g class="control play">', '<polygon points="45,35 65,50 45,65" fill="#000000" stroke-width="0"></polygon>', '</g>', '<g class="control stop">', '<rect x="35" y="35" width="30" height="30" stroke="#000000" fill="none" stroke-width="1"/>', '</g>', '</svg>'];

            template = template.join(' ');

            $.each(this, function (a, b) {

                var audio = $(this).find('audio');
                audio.attr('id', 'audio' + a);
                template = template.replace('width="34"', 'width="' + audio.data('size') + '"');
                template = template.replace('height="34"', 'height="' + audio.data('size') + '"');
                template = template.replace('id="playable"', 'id="playable' + a + '"');
                $(this).append(template);
            });

            var svgId = $(this).find('svg').attr('id');
            if (svgId == null) {
                return false;
            }
            svgId = document.getElementById(svgId);

            _.defaults = {
                this: this,
                thisSelector: $(this).parent(),
                playObj: 'playable',
                progress: '.progress-bar',
                precache: '.precache-bar',
                audioObj: 'audio',
                controlsObj: '.controls',
                pt: svgId.createSVGPoint(),
                pc: 298.1371428256714 // 2 pi r                                
            };

            var lunar = {};

            _.settings = $.extend({}, _.defaults, options);

            $(_.settings.controlsObj).on('click', function (e) {

                var el = $(e.currentTarget).closest($(_.settings.thisSelector));

                var obj = {
                    el: el,
                    activeAudio: el.find(_.settings.audioObj),
                    playObj: el.find('[data-play]'),
                    precache: el.find(_.settings.precache)
                };

                obj.class = obj.playObj.attr('class');
                switch (obj.class.replace('playable', '').trim()) {

                    case 'not-started':
                        _.stopAllSounds();
                        obj.activeAudio[0].play();
                        var audioId = document.getElementById(obj.activeAudio.attr('id'));
                        audioId.addEventListener('timeupdate', function (e) {
                            _.reportPosition(el, audioId);
                        });
                        obj.playObj.attr('class', 'playing');
                        break;
                    case 'playing':
                        obj.playObj.attr('class', 'playable paused');
                        obj.activeAudio[0].pause();
                        $(audioId).off('timeupdate');
                        break;
                    case 'paused':
                        obj.playObj.attr('class', 'playable playing');
                        obj.activeAudio[0].play();
                        break;
                    case 'ended':
                        obj.playObj.attr('class', 'not-started playable');
                        obj.activeAudio.off('timeupdate', _.reportPosition);
                        break;
                }
            });

            $(_.defaults.audioObj).on('progress', function (e) {
                if (this.buffered.length > 0) {
                    var end = this.buffered.end(this.buffered.length - 1);
                    var cache = $(e.currentTarget).parent().find(_.settings.precache),
                        el = $(this).closest($(_.settings.thisSelector));
                    _.setGraphValue(cache, end, el);
                }
            });
        }

    };

    // Add Plugin to Jquery
    $.fn.mediaPlayer = function (methodOrOptions) {
        if (_[methodOrOptions]) {
            return _[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if ((typeof methodOrOptions === 'undefined' ? 'undefined' : _typeof(methodOrOptions)) === 'object' || !methodOrOptions) {
            // Default to "init"
            return _.init.apply(this, arguments);
        } else {
            $.error('Method ' + methodOrOptions + ' does not exist on jQuery.mediaPlayer');
        }
    };
})(jQuery);

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Exception = exports.Fatal = exports.Debug = exports.Warn = exports.Trace = exports.Info = exports.Error = exports.Muestreo = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _cookie = __webpack_require__(0);

var Cookie = _interopRequireWildcard(_cookie);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var types = {
    info: { name: 'info', level: 2 },
    trace: { name: 'trace', level: 0 },
    warn: { name: 'warn', level: 3 },
    debug: { name: 'debug', level: 1 },
    error: { name: 'error', level: 4 },
    fatal: { name: 'fatal', level: 5 }
};
var elmahLevel = 'warn';

function post(data) {

    $.ajax({
        url: 'https://micuenta.lanacion.com.ar' + '/ln-log',
        type: 'POST',
        data: JSON.stringify(data),
        async: true,
        crossDomain: true,
        xhrFields: {
            withCredentials: true
        }

    });
}
var Muestreo = exports.Muestreo = function Muestreo() {
    try {
        var ytr_arrayUse = ["3785852", "3097523", "1682002"];
        //desa  ytr_arrayUse = ["3141092"];
        var ytr_userId = Cookie.LeerCookie('usuario%5Fid');
        if (ytr_userId != null && ytr_userId && ytr_arrayUse.indexOf(ytr_userId) > -1) {
            console.log('gsdsf5d34');
            Error("User - " + ytr_userId + " - Cookies:" + document.cookie.split(';').length + " size:" + document.cookie.length);
        }
    } catch (ex) {
        console.log(ex);
    }
};

function log(type, message, ex) {
    try {

        if (ex != null && (typeof ex === 'undefined' ? 'undefined' : _typeof(ex)) == "object") {
            ex = JSON.stringify(ex);
        }

        var values = {
            type: type,
            message: message,
            exception: ex
        };

        if (types[type].level >= types[elmahLevel].level) {
            post(values);
        }
    } catch (exp) {
        console.log('Error logueando');
    }

    return true;
};

var Error = exports.Error = function Error(message, ex) {
    return log(types.error.name, message, ex);
};

var Info = exports.Info = function Info(message, ex) {
    return log(types.info.name, message, ex);
};

var Trace = exports.Trace = function Trace(message, ex) {
    return log(types.trace.name, message, ex);
};

var Warn = exports.Warn = function Warn(message, ex) {
    return log(types.warn.name, message, ex);
};

var Debug = exports.Debug = function Debug(message, ex) {
    return log(types.debug.name, message, ex);
};

var Fatal = exports.Fatal = function Fatal(message, ex) {
    return log(types.fatal.name, message, ex);
};

var Exception = exports.Exception = function Exception(message, ex) {
    return log(types.fatal.name, message, ex);
};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var html = '<div class="load online">\n        <div class="bounce1"></div>\n        <div class="bounce2"></div>\n        <div class="bounce3"></div>\n    </div>';

var box = document.createElement('div');
box.className = 'spinner-box';
box.innerHTML = html;
document.querySelector('main').classList.add('cargando');

var show = exports.show = function show() {
    return document.querySelector('main').appendChild(box);
};
var hide = exports.hide = function hide() {
    box.remove();
    document.querySelector('main').classList.remove('cargando');
};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ohlalaNewsletterEspecial = exports.getNewsletter = exports.getSugerenciasPie = exports.getValoresDeCorte = exports.sugerencias = undefined;

var _ajax = __webpack_require__(1);

var Ajax = _interopRequireWildcard(_ajax);

var _bucket = __webpack_require__(2);

var BucketTools = _interopRequireWildcard(_bucket);

var _utilities = __webpack_require__(3);

var Utilities = _interopRequireWildcard(_utilities);

var _nota = __webpack_require__(6);

var _cookie = __webpack_require__(0);

var Cookie = _interopRequireWildcard(_cookie);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var urlRankingMultiplesCategoriaUrl = window.config.Statics.ApiContenidoUrlRaiz + window.config.Statics.ApiRankingMultiplesCategoriaUrl;
var urlApiCategorias = window.config.Statics.ApiContenidoUrlRoot + "categoriastags?categoriasId=";
var urlApiLogin = window.config.Statics.APILoginUrl;
var bucket = window.config.Statics.BucketUrl;
var urlApiNewsletter = urlApiLogin + window.config.Statics.ApiNewsletterSugerenciaUrl;
var urlApiSuscribirse = urlApiLogin + window.config.Statics.ApiUrlSuscribirse;
var urlBucket = window.config.Statics.BucketUrl;

/////////////////////////////////////TE PUEDE INTERESAR - NOTA///////////////////////////////////////////////////////////////////
var sugerencias = exports.sugerencias = function sugerencias() {
    var notas = JSON.parse(localStorage.getItem("obtenerSugerencias"));
    if (notas != null && notas.length > 0) {

        notas = notas.filter(function (item) {
            return item.datos != null && item.datos.imagen !== null && item.datos.imagen !== undefined;
        });

        //Purgar nota actual de listado de sugerencias.
        notas = purgarNotaDeSugerencias(notas);

        var notasBloque1 = notas.slice(0, 7);
        var notasBloque2 = notas.slice(7, 15);
        var notasBloque3 = notas.slice(15, 20);
        var contador = 0;
        var toi = 801;
        var html = "<aside class=\"puede-interesar\" id=\"bloque-3\" data-is-block=\"true\" data-block-name=\"n_sugerencias\" data-diagramacion-id=\"0\">\n                    <div class=\"fila-1 floatFix\" id=\"sugeridasBloque3F1\">\n                    <h4>Te puede interesar</h4>\n                    <div class=\"columna-doble\">" + getArticleSugerido(notas[0], 514, 137, toi) + "</div>";

        var article = "";
        notasBloque1.shift();
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = notasBloque1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var nota = _step.value;

                toi++;
                article += getArticleSugerido(nota, 216, 137, toi);
                contador++;

                if (contador % 2 === 0) {
                    html += "<div class=\"columna\">" + article + "</div>";
                    article = "";
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        html += "</div>";

        if (notasBloque2.length === 8) {
            html += "<div class=\"fila-2 floatFix\" id=\"sugeridasBloque3F2\">";
            article = "";
            contador = 0;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = notasBloque2[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var nota = _step2.value;

                    toi++;
                    article += getArticleSugerido(nota, 216, 137, toi);
                    contador++;
                    if (contador % 2 === 0) {
                        html += "<div class=\"columna\">" + article + "</div>";
                        article = "";
                    }
                    if (contador === 5) {
                        toi++;
                        article = getArticleSugerido(nota, 514, 137, toi);
                        html += "<div class=\"columna-doble\">" + article + "</div>";
                        article = "";
                        contador++;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            html += "</div>";
        }

        if (notasBloque3.length === 5) {
            html += "<div class=\"fila-3 floatFix\" id=\"sugeridasBloque3F3\">";
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = notasBloque3[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var nota = _step3.value;

                    toi++;
                    html += getArticleSugerido(nota, 216, 137, toi);
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            html += "</div></aside>";
        }

        document.querySelector('div[data-module="nota-sugeridas-ln"]').innerHTML = html;
    }
};

var purgarNotaDeSugerencias = function purgarNotaDeSugerencias(notas) {
    var notaId = document.querySelector("div[data-notaId]").getAttribute("data-notaId");

    notas.forEach(function (laNota, index) {
        if (laNota.contenido_id === parseInt(notaId)) notas.splice(index, 1);
    });
    return notas;
};

var isRandomDateDifMoreThanADay = function isRandomDateDifMoreThanADay() {
    var fechaOriginalRandom = localStorage.getItem("fechaOriginalRandom");
    if (fechaOriginalRandom === null) return false;

    var fechaLocal = new Date();
    var diferenciaMinutos = Math.abs(Math.round((fechaLocal.getTime() - Date.parse(localStorage.getItem("fechaOriginalRandom"))) / 1000 / 60));
    var diferenciaHoras = Math.abs(Math.round(diferenciaMinutos / 60));

    if (diferenciaHoras <= _nota.sugerenciasPerso.horasCorteSugerencias) //Default: 24
        return false;

    localStorage.removeItem("randomCorteSugerencias");
    localStorage.removeItem("fechaOriginalRandom");
    return true;
};

var getValoresDeCorte = exports.getValoresDeCorte = function getValoresDeCorte() {
    //Liftigniter
    var arrayOpcionesProviders = _nota.sugerenciasPerso.providers;
    var randomOptionProvider = arrayOpcionesProviders[Math.floor(Math.random() * arrayOpcionesProviders.length)];

    if (localStorage.getItem("randomCorteSugerencias") === null || isRandomDateDifMoreThanADay()) {
        localStorage.setItem("randomCorteSugerencias", randomOptionProvider);
        localStorage.setItem("fechaOriginalRandom", new Date());
    }

    if (localStorage.getItem("randomCorteSugerencias") === "Liftigniter") {
        var container = document.querySelector("div[data-module=\"nota-sugeridas\"]");
        if (container !== null && container !== undefined) {
            container.setAttribute("data-suggestion-engine", "liftigniter");

            return undefined;
            //return {};
        }
    } else {
        var cortes = _nota.sugerenciasPerso;
        var arrayOpciones = cortes.opcionesCorte;
        var randomOption = arrayOpciones[Math.floor(Math.random() * arrayOpciones.length)];

        var objResult = {
            usuario: true,
            dias: [],
            categorias: [],
            horas: [],
            diaYHorario: []
        };

        localStorage.removeItem("sugerenciasTipoCorte");

        switch (randomOption) {
            case "usuario":
                objResult.usuario = true;
                localStorage.setItem("sugerenciasTipoCorte", JSON.stringify("default"));
                break;
            case "usuarioDias":
                {
                    var date = new Date();
                    var diaDeSemana = date.getDay();
                    //TODO: que pasas si pedimos un numero de dia mayor al que estamos? lo validamos?
                    diaDeSemana = diaDeSemana === 0 ? 7 : diaDeSemana;
                    objResult.dias = [diaDeSemana];
                    localStorage.setItem("sugerenciasTipoCorte", JSON.stringify("dia"));
                }
                break;
            case "usuarioCategorias":
                {
                    var jsonCategoria = JSON.parse(localStorage.getItem("obtenerPreferibles"));
                    jsonCategoria = jsonCategoria.filter(function (x) {
                        return x.tipoId === 20;
                    });

                    var arrCategorias = [];
                    jsonCategoria.map(function (o) {
                        arrCategorias.push(o.id);
                    });
                    objResult.categorias = arrCategorias;
                    localStorage.setItem("sugerenciasTipoCorte", JSON.stringify("categoria"));
                }
                break;
            case "usuarioHoras":
                objResult.horas = getRangoHorario(cortes.rangosDiscretizacion);
                localStorage.setItem("sugerenciasTipoCorte", JSON.stringify("hora"));
                break;
            case "usuarioDiaHorario":
                {
                    var _date = new Date();
                    var _diaDeSemana = _date.getDay();
                    //TODO: que pasas si pedimos un numero de dia mayor al que estamos? lo validamos?
                    _diaDeSemana = _diaDeSemana === 0 ? 7 : _diaDeSemana;
                    objResult.dias = [_diaDeSemana];
                    objResult.horas = getRangoHorario(cortes.rangosDiscretizacion);
                    localStorage.setItem("sugerenciasTipoCorte", JSON.stringify("fechaYhora"));
                }
                break;
        }
        return objResult;
    }
};

var getRangoHorario = function getRangoHorario(arrayRangosHorarios) {
    //["00,01,02,03,04,05,06,07", "08,09,10", "11,12,13,14", "15,16,17,18", "18,19,20", "20,21,22,23"];

    var date = new Date(); //new Date("July 21, 1983 01:15:00")
    var hora = date.getHours();
    hora = ("0" + hora).slice(-2);

    var valor = void 0;
    arrayRangosHorarios.map(function (o, index) {
        o.split(",").find(function (h) {
            if (h === hora) valor = index;
        });
    });

    return arrayRangosHorarios[valor];
};

var getArticleSugerido = function getArticleSugerido(nota, width, widthTablet, toi) {
    var imgHtml = "";
    var toiPos = "toi".concat(toi.toString());
    var tipoCorte = JSON.parse(localStorage.getItem("sugerenciasTipoCorte"));

    if (nota.datos.imagen != null && nota.datos.imagen.id > 0 && nota.datos.imagen.extension != null && nota.datos.imagen.extension != "") {
        imgHtml += "<source media=\"(min-width: 768px)\" srcset=\"" + BucketTools.urlBucketBalance(urlBucket, nota.datos.imagen.id, "", width, nota.datos.imagen.extension) + "\">";
        imgHtml += "<img src=\"" + BucketTools.urlBucketBalance(urlBucket, nota.datos.imagen.id, "", widthTablet, nota.datos.imagen.extension) + "\"/>";
    }

    return "<article title=\"\" class=\"nota\"  data-id=\"" + nota.contenido_id + "\" data-notaid=\"" + nota.contenido_id + "\" data-source=\"sugerencia-" + tipoCorte + "\" data-pos=\"" + toiPos + "\">\n              <a class=\"figure\" href=\"" + nota.contenido_id + "-" + Utilities.FormatearUrl(nota.titulo) + "\">         \n                <picture>\n                     " + imgHtml + "\n                </picture>\n              </a>\n              <h2><a href=\"" + nota.contenido_id + "-" + Utilities.FormatearUrl(nota.titulo) + "\">" + nota.titulo + "</a></h2>\n          </article>";
};

var renderNotasPieCategoria = function renderNotasPieCategoria(data, categoriaRandom, idsCategoria, randomOptionProvider) {
    var container = document.getElementById("bloque-4");

    if (!container || data == null) return;
    container.setAttribute("data-source", randomOptionProvider);

    var heightBucket = void 0;
    var widthBucket = void 0;
    var conAutor = void 0;
    var categoria = void 0;
    var listado = void 0;
    var toi = 901;

    var _loop = function _loop(j) {
        var isCategoriaOTag = idsCategoria.indexOf(categoriaRandom[j]) > -1 ? "categorias" : "tags";

        if (data[isCategoriaOTag][categoriaRandom[j]].items.length > 0) {
            categoria = isCategoriaOTag === "categorias" ? data[isCategoriaOTag][categoriaRandom[j]].items[0].categoriaDescripcion : data[isCategoriaOTag][categoriaRandom[j]].items[0].tags.find(function (x) {
                return x.id === categoriaRandom[j];
            }).valor;
            var categoriaNormalizada = Utilities.FormatearUrl(categoria);
            listado = "<section data-is-block=\"true\" data-block-name=\"n_recomendacion-" + categoriaNormalizada + "\" data-diagramacion-id=\"0\">";
            var notas = data[isCategoriaOTag][categoriaRandom[j]].items.slice(0, 5);
            listado += "<h3>" + categoria + "</h3>";

            for (var i = 0; i < notas.length; i++) {
                var nota = notas[i];
                var conImagen = nota.imagenes instanceof Array && nota.imagenes.length > 0 && nota.imagenes[0].src != null && nota.imagenes[0].src !== "";
                i === 0 ? heightBucket = 183 : heightBucket = 80;
                i === 0 ? widthBucket = 282 : widthBucket = 107;
                nota.template_id !== null && nota.template_id === 3 ? conAutor = "autor" : conAutor = "";
                var toiPos = "toi".concat(toi.toString());
                listado += "<article class=\"nota " + conAutor + " floatFix\" data-id=\"" + nota.id + "\" data-notaid=\"" + nota.id + "\" data-source=\"" + randomOptionProvider + "\" data-pos=\"" + toiPos + "\">";

                if (i === 0) {
                    listado += "<a class=\"figure\" href=\"" + nota.url + "\" \"data-numero=\"" + i + "\" data-tipo=\"normal-primera\">";
                    listado += conImagen ? "<img src=\"" + BucketTools.urlBucketBalance(bucket, nota.imagenes[0].src, heightBucket) + "\"/>" : "";
                    listado += "</a>";
                } else {
                    if (conAutor === "") {
                        //conImagen && Si se lo saco qu eonda?
                        listado += "<a class=\"figure\"  href=\"" + nota.url + "\" data-numero=\"" + i + "\" data-tipo=\"normal\">";
                        listado += conImagen ? "<img src=\"" + BucketTools.urlBucketBalance(bucket, nota.imagenes[0].src, heightBucket) + "\"/>" : "";
                        listado += "</a>";
                    } else if (conAutor !== "" && nota.autores[0].hdImagenId !== null && nota.autores[0].hdImagenExtension) {
                        listado += "<a class=\"figure\"  href=\"" + nota.url + "\" data-numero=\"" + i + "\" data-tipo=\"autor\">";
                        listado += nota.autores instanceof Array && nota.autores.length > 0 && nota.autores[0].hdImagenId != null && nota.autores[0].hdImagenId != 0 && nota.autores[0].hdImagenExtension != null && nota.autores[0].hdImagenExtension != "" ? "<img src=\"" + BucketTools.urlBucketBalance(bucket, nota.autores[0].hdImagenId, heightBucket, "", nota.autores[0].hdImagenExtension) + "\"/>" : "";
                        listado += "</a>";
                    }
                }

                listado += "<h2><a href=\"" + nota.url + "\">" + nota.titulo + "</a></h2>";
                if (conAutor !== "" && nota.autores instanceof Array && nota.autores.length > 0) {
                    listado += "<a href=\"" + Utilities.formatoUrlAcuAutor(nota.autores[0].valor, nota.autores[0].id) + "\" class=\"autor\">" + nota.autores[0].valor + "</a>";
                }
                listado += "</article>";
                toi++;
            }
            listado += "</section>";
            container.insertAdjacentHTML("afterbegin", listado);
        }
    };

    for (var j = 0; j < categoriaRandom.length; j++) {
        _loop(j);
    }
};

var renderSugerenciaNewsletter = function renderSugerenciaNewsletter(data) {
    var suscripcionPendiente = localStorage.getItem("suscripcionPendiente");
    var fechaSuscripcionPendiente = localStorage.getItem("fechaSuscripcionPendiente");
    var token = Cookie.LeerCookie("token");
    var tiempoCacheMilisegundos = 300000; ///TODO:Cambiar a configuracion
    var dif = tiempoCacheMilisegundos;

    if (fechaSuscripcionPendiente !== null) {
        dif = Date.now() - fechaSuscripcionPendiente;
    }

    if (token !== "" && suscripcionPendiente !== null && dif < tiempoCacheMilisegundos) {
        var objPendiente = data.filter(function (p) {
            return p.servicioId === parseInt(suscripcionPendiente);
        });
        if (objPendiente.length > 0) {
            var tituloPendiente = objPendiente[0].titulo;
            renderCajaSuscribir(tituloPendiente);
        }

        suscribirNewsletterAjax(data, token, suscripcionPendiente);
        localStorage.removeItem("suscripcionPendiente");
        localStorage.removeItem("fechaSuscripcionPendiente");
    } else if (data.length > 0) {
        if (suscripcionPendiente !== null) {
            localStorage.removeItem("suscripcionPendiente");
            localStorage.removeItem("fechaSuscripcionPendiente");
        }

        var sinSuscripcion = data.filter(function (d) {
            return d.suscripto === 0;
        });
        if (sinSuscripcion.length === 0) {
            return;
        }

        var sugerenciasSuscripcion = [];
        for (var i = 0; sinSuscripcion.length > i; i++) {
            sugerenciasSuscripcion.push(sinSuscripcion[i].servicioId);
        }

        var categoria = document.querySelector('div[data-categoriaid]');
        var categoriaId = categoria != null ? categoria.getAttribute('data-categoriaid') : -1;
        var servicioIdPorCategoria = _nota.newsletter.find(function (x) {
            return x.categoriaId == categoriaId;
        });
        servicioIdPorCategoria = servicioIdPorCategoria != undefined ? servicioIdPorCategoria.servicioId : -1;
        //Me fijo si el diccionario de newsletter coincide con la categoria de la nota
        var matchNewsDictionary = sugerenciasSuscripcion.find(function (n) {
            return n == servicioIdPorCategoria;
        });

        var newsRandom = matchNewsDictionary != undefined ? [matchNewsDictionary] : Utilities.getRandom(sugerenciasSuscripcion, 1);

        var objSugerencia = newsRandom.length > 0 ? data.filter(function (x) {
            return x.servicioId === newsRandom[0];
        }) : [];

        if (objSugerencia.length > 0) {
            var tituloSugerencia = objSugerencia[0].titulo;
            renderCajaSuscribir(tituloSugerencia);
        }

        var btn = document.getElementById("suscribirse");
        if (btn == null) return;
        if (token !== "") {
            btn.addEventListener("click", function () {
                suscribirNewsletterAjax(data, token, newsRandom);
            });
        } else {
            btn.addEventListener("click", function () {
                loguearYSuscribir(newsRandom);
            });
        }
    }
};

var renderCajaSuscribir = function renderCajaSuscribir(tituloADibujar) {
    var boton = document.createElement("BUTTON");
    var textoBoton = document.createTextNode("SUSCRIBIRME");
    boton.setAttribute("id", "suscribirse");
    boton.appendChild(textoBoton);

    var containerFinCuerpo = document.getElementsByClassName("fin-cuerpo")[0];
    var containerSegunda = document.getElementsByClassName("segunda floatFix")[0];

    var container = containerFinCuerpo !== undefined ? containerFinCuerpo : containerSegunda !== undefined ? containerSegunda : false;

    if (!container) return;
    var recomendacion = "<div class='titulares-del-dia'>";
    recomendacion += "<span class='icon-mail-line'></span>";
    recomendacion += "<div><b>" + tituloADibujar + "</b>";
    recomendacion += "<p id='textSuscripcion'>Suscribite al newsletter</p>";
    recomendacion += "</div>";
    recomendacion += boton.outerHTML;
    recomendacion += "<span class='load' style='display:none;'></span>";
    recomendacion += "<span id='respuesta' style='display:none;'>¡Ya estás suscripto!</span>";

    recomendacion += "</div>";
    container.insertAdjacentHTML("beforeend", recomendacion);
};
var saveNewsletterLocalStorage = function saveNewsletterLocalStorage(data) {
    localStorage.setItem("fechaSugerenciaTitulares", Date.now().toString());
    localStorage.setItem("sugerenciasTitulares", JSON.stringify(data));
    renderSugerenciaNewsletter(data);
};
var saveNewsletterLocalStorageDefault = function saveNewsletterLocalStorageDefault(data) {
    localStorage.setItem("sugerenciasTitularesDefault", JSON.stringify(data));
    renderSugerenciaNewsletter(data);
};

var getSugerenciasPie = exports.getSugerenciasPie = function getSugerenciasPie() {
    var data = [];
    var idsRandoms = [];
    var idsCategorias = [];
    var idsTags = [];
    var orderCategorias = [];
    var orderTags = [];
    var pathCategorias = "";
    var urlRoot = "";

    var arrayProviders = _nota.sugerenciasPie[0].providers;
    var randomOptionProvider = arrayProviders[Math.floor(Math.random() * arrayProviders.length)];

    switch (randomOptionProvider) {
        case "categoria":
            data = _nota.sugerenciasPie[0].categoriasPosibles.concat(_nota.sugerenciasPie[0].tagsPosibles);
            idsRandoms = Utilities.getRandom(data, _nota.sugerenciasPie[0].cantidad);
            idsCategorias = _nota.sugerenciasPie[0].categoriasPosibles.filter(function (x) {
                return idsRandoms.indexOf(x) > -1;
            });
            idsTags = _nota.sugerenciasPie[0].tagsPosibles.filter(function (x) {
                return idsRandoms.indexOf(x) > -1;
            });

            orderCategorias = JSON.parse(JSON.stringify(idsCategorias)).sort(function (a, b) {
                return a - b;
            });
            orderTags = JSON.parse(JSON.stringify(idsTags)).sort(function (a, b) {
                return a - b;
            });
            pathCategorias = orderCategorias.join() + "&tagsId=" + orderTags.join() + "&c=5";
            urlRoot = urlApiCategorias;

            randomOptionProvider = "ultimas";
            break;
        case "ranking":
            data = _nota.sugerenciasPie[0].categoriasPosibles; //No se agrega el tag de videos.
            idsRandoms = Utilities.getRandom(data, _nota.sugerenciasPie[0].cantidad);
            idsCategorias = _nota.sugerenciasPie[0].categoriasPosibles.filter(function (x) {
                return idsRandoms.indexOf(x) > -1;
            });

            pathCategorias = JSON.parse(JSON.stringify(idsCategorias)).sort(function (a, b) {
                return a - b;
            });
            urlRoot = urlRankingMultiplesCategoriaUrl;
            break;
    }

    Ajax.get(urlRoot + pathCategorias).then(function (rs) {
        return renderNotasPieCategoria(normalizeSugerenciasPieObject(JSON.parse(rs)), idsRandoms, idsCategorias, randomOptionProvider);
    });
};

var normalizeSugerenciasPieObject = function normalizeSugerenciasPieObject(data) {
    var normalizedObject = {};

    if (data.categorias !== undefined && data.tags !== undefined) return data;

    normalizedObject.categorias = data;
    normalizedObject.tags = {};

    return normalizedObject;
};

var getNewsletter = exports.getNewsletter = function getNewsletter() {
    var fechaSugerencia = localStorage.getItem("fechaSugerenciaTitulares"),
        sugerenciasData = JSON.parse(localStorage.getItem("sugerenciasTitulares")),
        tokenStorage = localStorage.getItem("token"),
        sugerenciaDataDefault = JSON.parse(localStorage.getItem("sugerenciasTitularesDefault"));
    var tiempoCacheMilisegundos = 300000; ///TODO:Cambiar a configuracion
    var dif = 0;

    if (tokenStorage != null) {
        //se fija que el localstorage tenga datos y el token coincida con el guardado
        if (fechaSugerencia != null && sugerenciasData != null) {
            dif = Date.now() - fechaSugerencia;
            //se fija que no haya vencido el cache
            if (dif < tiempoCacheMilisegundos) {
                renderSugerenciaNewsletter(sugerenciasData);
            } else {
                //vencio el cache entonces va a buscar de nuevo la data actualiza el localstorage y renderea
                obtenerSuscripciones(tokenStorage);
            }
        } else {
            obtenerSuscripciones(tokenStorage);
        }
    } else {
        //Si no esta logueado, se fija que tenga informacion en el LocalStorage
        if (sugerenciaDataDefault != null) {
            // dibuja con la data ya existente
            renderSugerenciaNewsletter(sugerenciaDataDefault);
        } else {
            obtenerSuscripciones("default");
        }
    }
};

var obtenerSuscripciones = function obtenerSuscripciones(tipo) {
    if (tipo === "default") {
        Ajax.post(urlApiNewsletter).then(function (rs) {
            return JSON.parse(rs);
        }).then(saveNewsletterLocalStorageDefault).catch(function (err) {
            return console.log("***Error en obtenerSuscripciones - Default: " + err);
        });
    } else {
        var objHeaders = {
            "X-Token": tipo
        };
        Ajax.post(urlApiNewsletter + "PorUsuario", "", objHeaders).then(function (rs) {
            return JSON.parse(rs);
        }).then(saveNewsletterLocalStorage).catch(function (err) {
            return console.log("***Error en obtenerSuscripciones: " + err);
        });
    }
};

var suscribirNewsletterAjax = function suscribirNewsletterAjax(data, token, suscribirse) {
    var serviciosYaSuscripto = data.filter(function (s) {
        return s.suscripto === 1;
    });
    var urlSuscribirse = urlApiSuscribirse;
    var stringIds = "";
    if (serviciosYaSuscripto.length > 0) {
        for (var k = 0; serviciosYaSuscripto.length > k; k++) {
            stringIds += serviciosYaSuscripto[k].servicioId + ",";
        }
    }
    stringIds += suscribirse;
    var objParam = {
        "servicios_ids": stringIds,
        "acepta_novedades": null
    };
    var objHeaders = {
        "Content-Type": "application/json",
        "X-Token": token
    };
    suscribirNewsletterLogueado(urlSuscribirse, objParam, objHeaders);
};

var suscribirNewsletterLogueado = function suscribirNewsletterLogueado(url, objParam, objHeaders) {
    document.getElementById("suscribirse").style.display = "none";
    var load = document.querySelector(".titulares-del-dia .load");
    //  let respuesta =  document.querySelector(".titulares-del-dia #respuesta");
    load.style.display = "block";
    Ajax.post(urlApiSuscribirse, objParam, objHeaders).then(suscripcionCorrecta).catch(suscripcionError);
    localStorage.removeItem("sugerenciasTitulares");
};

var loguearYSuscribir = function loguearYSuscribir(newsRandom) {
    document.getElementById("suscribirse").style.display = "none";
    var load = document.querySelector(".titulares-del-dia .load");
    load.style.display = "block";
    localStorage.setItem("tareaPendiente", newsRandom);
    localStorage.setItem("fechaPendiente", Date.now().toString());
    localStorage.removeItem("sugerenciasTitulares");
    location.href = window.config.Statics.LoginUrl + window.btoa(location.href);
};

var suscripcionCorrecta = function suscripcionCorrecta() {
    //document.getElementById("textSuscripcion").innerText = "¡Ya estás suscripto!";
    var load = document.querySelector(".titulares-del-dia .load");
    var respuesta = document.querySelector(".titulares-del-dia #respuesta");
    load.style.display = "none";
    respuesta.style.display = "inline-block";
    setTimeout(function () {
        respuesta.classList.add("bg-letter");
    }, 200);
    localStorage.removeItem("tareaPendiente");
    localStorage.removeItem("fechaPendiente");
};

var suscripcionError = function suscripcionError() {
    var load = document.querySelector(".titulares-del-dia .load");
    var respuesta = document.querySelector(".titulares-del-dia #respuesta");
    load.style.display = "none";
    respuesta.innerHTML = "¡Ups volvé a intentarlo!";
    respuesta.style.display = "inline-block";

    //document.getElementById("textSuscripcion").innerText = "¡Ups volvé a intentarlo!";
    document.getElementById("suscribirse").style.display = "block";
};

var ohlalaNewsletterEspecial = exports.ohlalaNewsletterEspecial = function ohlalaNewsletterEspecial() {
    if (document.querySelector('div[data-type="newsletter-ohlala"]') != null) {
        var fechaSugerencia = localStorage.getItem("fechaSugerenciaTitulares"),
            sugerenciasData = JSON.parse(localStorage.getItem("sugerenciasTitulares")),
            tokenStorage = localStorage.getItem("token"),
            tokenCookie = Cookie.LeerCookie("token"),
            sugerenciaDataDefault = JSON.parse(localStorage.getItem("sugerenciasTitularesDefault"));
        var tiempoCacheMilisegundos = 300000; ///TODO:Cambiar a configuracion
        var dif = 0;

        if (tokenStorage != null && tokenStorage == tokenCookie) {
            if (fechaSugerencia != null && sugerenciasData != null) {
                dif = Date.now() - fechaSugerencia;
                //se fija que no haya vencido el cache
                if (dif < tiempoCacheMilisegundos) {
                    //vencio el cache entonces va a buscar de nuevo la data actualiza el localstorage y renderea
                    funcionesOhlalaNewsletter(sugerenciasData);
                } else {
                    obtenerSuscripcionesOhlala(tokenStorage);
                }
            } else {
                obtenerSuscripcionesOhlala(tokenStorage);
            }
        } else {
            var divNews = document.querySelector('div[data-type="newsletter-ohlala"]');
            var btnSuscribite = divNews.querySelector('button[data="iconOhlala"]');

            if (btnSuscribite != null) {
                btnSuscribite.addEventListener("click", function () {
                    location.href = window.config.Statics.LoginUrl + window.btoa(location.href);
                });
                divNews.style.display = "block";
            }
        }

        //    <button class="suscribite" data="suscribiteOhlala">Suscribite</button>
        //    <button class="icon-derecha" 5="" data="iconOhlala"></button>
        //    <span class="load" style="display:none;" data="loadOhlala"></span>
        //    <label id="respuesta" style="display:none;" data="rtaOhlala">¡Ya estás suscripto!</label>
    }
};

var obtenerSuscripcionesOhlala = function obtenerSuscripcionesOhlala(tipo) {

    if (tipo === "default") {
        Ajax.post(urlApiNewsletter).then(function (rs) {
            return JSON.parse(rs);
        }).then(saveNewsOhlalaDefault).catch(function (err) {
            return console.log("***Error en obtenerSuscripcionesOhlala - Default: " + err);
        });
    } else {
        var objHeaders = {
            "X-Token": tipo
        };
        Ajax.post(urlApiNewsletter + "PorUsuario", "", objHeaders).then(function (rs) {
            return JSON.parse(rs);
        }).then(saveNewsOhlala).catch(function (err) {
            return console.log("***Error en obtenerSuscripcionesOhlala: " + err);
        });
    }
};

var saveNewsOhlala = function saveNewsOhlala(data) {
    localStorage.setItem("fechaSugerenciaTitulares", Date.now().toString());
    localStorage.setItem("sugerenciasTitulares", JSON.stringify(data));
    funcionesOhlalaNewsletter(data);
};
var saveNewsOhlalaDefault = function saveNewsOhlalaDefault(data) {
    localStorage.setItem("sugerenciasTitularesDefault", JSON.stringify(data));
    funcionesOhlalaNewsletter(data);
};

var funcionesOhlalaNewsletter = function funcionesOhlalaNewsletter(data) {
    var divOhlala = document.querySelector('div[data-type="newsletter-ohlala"]');
    var btnSuscribite = divOhlala.querySelector('button[data="suscribiteOhlala"]');
    var btnIcon = divOhlala.querySelector('button[data="iconOhlala"]');
    var spanLoad = divOhlala.querySelector('span[data="loadOhlala"]');
    var yaSuscriptoOhlala = data.filter(function (s) {
        return s.servicioId == 107 && s.suscripto == 1;
    });

    if (yaSuscriptoOhlala.length == 0) {
        divOhlala.style.display = "block";
        btnSuscribite.addEventListener("click", function () {
            spanLoad.style.display = "block";
            btnIcon.style.display = "none";
            suscribirOhlala(data, divOhlala);
        });
    }
};

var suscribirOhlala = function suscribirOhlala(data, divNews) {
    var serviciosYaSuscripto = data.filter(function (s) {
        return s.suscripto == 1;
    });
    var urlSuscribirse = urlApiSuscribirse;
    var token = localStorage.getItem("token");
    var stringIds = "";
    if (serviciosYaSuscripto.length > 0) {
        for (var k = 0; serviciosYaSuscripto.length > k; k++) {
            stringIds += serviciosYaSuscripto[k].servicioId + ",";
        }
    }
    stringIds += 107;
    //stringIds += 2;
    var objParam = {
        "servicios_ids": stringIds,
        "acepta_novedades": null
    };
    var objHeaders = {
        "Content-Type": "application/json",
        "X-Token": token
    };
    suscribirOhlalaLogeado(urlSuscribirse, objParam, objHeaders, divNews);
};

var suscribirOhlalaLogeado = function suscribirOhlalaLogeado(url, objParam, objHeaders, divNews) {
    var btnSuscribite = divNews.querySelector('button[data="suscribiteOhlala"]');
    var spanLoad = divNews.querySelector('span[data="loadOhlala"]');
    spanLoad.style.display = "block";
    btnSuscribite.style.display = "none";

    Ajax.post(urlApiSuscribirse, objParam, objHeaders).then(ohlalaSuscripcionCorrecta(divNews)).catch(function (err) {
        console.log(err);
        ohlalaSuscripcionIncorrecta(divNews);
    });
    localStorage.removeItem("sugerenciasTitulares");
};

var ohlalaSuscripcionCorrecta = function ohlalaSuscripcionCorrecta(divNews) {
    var labelRta = divNews.querySelector('label[data="rtaOhlala"]');
    var spanLoad = divNews.querySelector('span[data="loadOhlala"]');

    spanLoad.style.display = "none";
    labelRta.style.display = "inline-block";
    setTimeout(function () {
        labelRta.classList.add("bg-letter");
    }, 200);
};

var ohlalaSuscripcionIncorrecta = function ohlalaSuscripcionIncorrecta(divNews) {
    var labelRta = divNews.querySelector('label[data="rtaOhlala"]');
    var spanLoad = divNews.querySelector('span[data="loadOhlala"]');
    var btnSuscribite = divNews.querySelector('button[data="suscribiteOhlala"]');

    setTimeout(function () {
        spanLoad.style.display = "none";
        btnSuscribite.style.display = "none";
        labelRta.innerHTML = "¡Ups volvé a intentarlo!";
        labelRta.style.display = "block";
    }, 200);
};

/***/ }),
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.preferencias = undefined;

var _ajax = __webpack_require__(1);

var _bucket = __webpack_require__(2);

var BucketTools = _interopRequireWildcard(_bucket);

var _utilities = __webpack_require__(3);

var Utilities = _interopRequireWildcard(_utilities);

var _session = __webpack_require__(5);

var Session = _interopRequireWildcard(_session);

var _home = __webpack_require__(33);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var urlBucket = window.config.Statics.BucketUrl;
var siteIdLF = window.config.Statics.SiteIdLF;
var loginUrl = window.config.Statics.LoginUrl;
var loginUrlCallback = loginUrl + window.btoa(location.href);
var liveFireUrlApi = window.config.Statics.ApiLiveFireUrl;
var urlNavAninima = window.config.Statics.ApiNavAnonimaHome;

var preferencias = exports.preferencias = function preferencias() {
    if (Session.init()) {
        preferenciasTrigger();
    } else {
        //NO LOGUEADO
        renderDataNoLogueado(5, getTemasYAutores);
    }
};

var preferenciasTrigger = function preferenciasTrigger() {
    //Personalizacion.initPreferencias().then(function(result) {
    if (localStorage.getItem("obtenerHashSuscripciones") != null) {
        obtenerDatosPreferencias(true, renderPreferencias); //Obtener las Preferencias y competando con sugerencias llegado el caso.
    } else {
        //SIN PREFERENCIAS
        obtenerDatosSugerencias(false, renderSugerencias); //Obtener sugerencias pero NO completar con preferencias llegado el caso.
    }
    //});
};

//Prefgerencias
var obtenerDatosPreferencias = function obtenerDatosPreferencias(rellenar, callback) {
    callback(JSON.parse(localStorage.getItem("obtenerPorPrioridad")), localStorage.getItem("obtenerNovedades"), JSON.parse(localStorage.getItem("recomendarTemas")));
};

//Sugerencias
var obtenerDatosSugerencias = function obtenerDatosSugerencias(rellenar, callback) {
    callback(JSON.parse(localStorage.getItem("obtenerPorPrioridad")), JSON.parse(localStorage.getItem("recomendarTemas")));
};

var renderPreferencias = function renderPreferencias(preferencias, cantNotasNoLeidas, temasRecomendados) {
    var html = "";

    //CON notas a leer. (si hay pocas, completa con Sugerencias)
    if (cantNotasNoLeidas > 0) {
        html += "<div class=\"logueado-solo\">\n                    <div class=\"techo-2 floatFix\">\n                    <span>Temas y autores que segu\xEDs:\n                            <b>\n                                <span>" + cantNotasNoLeidas + "</span> notas nuevas\n                            </b>\n                        </span>\n                    </div>";
        //Articles
        html += loopArticles(preferencias, 8);
        html += "<div class=\"botones\">\n                    <a href=\"/lo-que-sigo\">VER M\xC1S TEMAS <label class=\"desktop\"> Y AUTORES</label></a>\n                    <a class=\"desktop\" href=\"/lo-que-sigo\">CONFIGURAR</a>\n                </div>\n                </div>";
    } else if (preferencias.length === 0) {
        //SIN preferencias NI Sugerencias.
        html += "<div class=\"logueado-sin-preferencias\">\n                    <div class=\"techo-2 floatFix\">\n                        <span>\n                            Segu\xED los Temas y autores<b> que m\xE1s te interesan</b>\n                        </span>\n                    </div>\n                    <div class=\"instrucciones\">\n                        <div class=\"izquierda\">\n                            <article>\n                                <h2>\n                                    <span>Busc\xE1 el bot\xF3n </span>\n                                    <div class=\"seguir\">SEGUIR</div>\n                                    <span>para guardarlos y enterate al instante cada vez que haya notas nuevas.</span>\n                                </h2>\n                            </article>\n                            <article><h2><span>Encontr\xE1 este bot\xF3n en las notas y listados de temas y autores. </span></h2></article>\n                            <article><h2><span>Cada vez que publiquemos notas nuevas, podr\xE1s encontrarlas aqu\xED o en tu e-mail.</span></h2></article>\n                        </div>";

        html += renderTemasRecomendados(temasRecomendados);

        html += "<div class=\"botones\">\n                    <a href=\"/lo-que-sigo\">VER M\xC1S TEMAS Y AUTORES</a>\n                    <a href=\"/lo-que-sigo\">CONFIGURAR</a>\n                </div>\n                </div>\n                </div>";
    } else {
        //SIN nota a leer (Llenar con SUGERENCIAS)
        html += "<div class=\"logueado-con-preferencias-no-notas-nuevas\">\n                    <div class=\"techo-2 floatFix\">\n                        <span> Temas y autores <b>que segu\xEDs</b></span>\n                    </div>";
        //Articles
        html += loopArticles(preferencias, 8);
        html += "<div class=\"botones\">\n                    <a href=\"/lo-que-sigo\">VER MAS TEMAS Y AUTORES</a>\n                    <a href=\"/lo-que-sigo\">CONFIGURAR</a>\n                </div>\n                </div>";
    }
    document.querySelector("#que-sigo").innerHTML = html;
};

var renderSugerencias = function renderSugerencias(sugerencias, temasRecomendados) {
    var html = "";
    if (sugerencias != null && sugerencias.length > 0) {
        html += "<div class=\"logueado-sin-preferencias\">\n                    <div class=\"techo-2 floatFix\">\n                        <span>Segu\xED los Temas y autores<b> que m\xE1s te interesan</b></span>\n                    </div>\n                    <div class=\"instrucciones\">\n                        <div class=\"izquierda\">\n                            <article>\n                                <h2>\n                                    <span>Busc\xE1 el bot\xF3n </span>\n                                    <div class=\"seguir\">SEGUIR</div><span>para guardarlos y enterate al instante cada vez que haya notas nuevas.</span>\n                                </h2>\n                            </article>\n                            <article><h2><span>Encontr\xE1 este bot\xF3n en las notas y listados de temas y autores. </span></h2></article>\n                            <article><h2><span>Cada vez que publiquemos notas nuevas, podr\xE1s encontrarlas aqu\xED o en tu e-mail.</span></h2></article>\n                        </div>";

        html += renderTemasRecomendados(temasRecomendados);

        html += "</div>";
        html += loopArticles(sugerencias, 6);
        html += "</div>";
        document.querySelector("#que-sigo").innerHTML = html;
    }
};

var renderTemasRecomendados = function renderTemasRecomendados(temas) {
    var html = "";

    if (temas.length > 0) {
        html = "<div class=\"derecha\">\n                    <b>MIENTRAS TANTO, TE SUGERIMOS LOS SIGUIENTES TEMAS Y AUTORES</b>\n                    <div class=\"relacionados\">\n                        <div>";

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = temas[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var temaAutor = _step.value;

                html += "<a href=\"" + Utilities.formatoUrlAcuTag(temaAutor[5], temaAutor[0]) + "\">" + temaAutor[5] + "</a>";
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        html += "</div>\n                </div>\n                </div>";
    }
    return html;
};

var loopArticles = function loopArticles(notas, cantidadATomar) {
    var valueToSlice = notas.length < cantidadATomar ? notas.length : cantidadATomar;
    notas = notas.filter(function (n) {
        return n.datos != undefined;
    });

    var html = "";
    var toi = 301;
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = notas.slice(0, valueToSlice)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var nota = _step2.value;

            var notaDato = nota.datos;
            var esNotaOpinion = notaDato.template.id === 3;
            var imagenSrc = "";
            var autorUrl = "";

            if (esNotaOpinion) {
                if (notaDato.autores !== undefined && notaDato.autores !== null && notaDato.autores.length > 0 && notaDato.autores[0].imagen !== undefined && notaDato.autores[0].imagen != null && notaDato.autores[0].imagen.id > 0 && notaDato.autores[0].imagen.extension != null && notaDato.autores[0].imagen.extension != "") {
                    imagenSrc = "<img src=\"" + BucketTools.urlBucketBalance(urlBucket, notaDato.autores[0].imagen.id, "", 90, notaDato.autores[0].imagen.extension) + "\"/>";
                }

                if (notaDato.autores !== undefined && notaDato.autores !== null && notaDato.autores.length > 0) {
                    var url = Utilities.formatoUrlAcuAutor(notaDato.autores[0].nombre, notaDato.autores[0].id);
                    autorUrl = "<a href=\"" + url + "\" class=\"nombre\">" + notaDato.autores[0].nombre + "</a>";
                }
            } else {
                imagenSrc = notaDato.imagen && notaDato.imagen !== undefined && notaDato.imagen != null && notaDato.imagen.id > 0 && notaDato.imagen.extension != null && notaDato.imagen.extension != "" ? "<img src=\"" + BucketTools.urlBucketBalance(urlBucket, notaDato.imagen.id, 280, "", notaDato.imagen.extension) + "\"/>" : "";
            }

            var notaUrl = nota.contenido_id + "-" + Utilities.FormatearUrl(nota.titulo),
                tags = notaDato.temas;
            var tag = void 0;
            var tagHtml = "";

            if (tags && tags.length > 0) {
                //TODO: esto despues tiene que ser borrado ya que servicio tiene que enviar el primer objeto completo.
                var prioridaTagConfigHome = _home.prioridadTag;
                tag = tags[0].formatoId === undefined ? tags[0] : Utilities.getTagPrioritario(tags, prioridaTagConfigHome);

                if (tag !== undefined) {
                    //En el caso de que el unico tag sea formatoId = 2 o que no haya tags que conincidan con los tags de la config
                    tagHtml = "<h3 class=\"tag\"><a href=\"" + Utilities.formatoUrlAcuTag(tag.descripcion, tag.id) + "\">" + tag.descripcion + "</a></h3>";
                }
            }
            var toiPos = "toi".concat(toi.toString());
            var esSugerencia = nota.origen === "Sugerencia" ? esSugerencia = "recomendada" : esSugerencia = "";
            html += "<article title=\"\" class=\"m noticia tema" + (esNotaOpinion ? " autor" : " foto") + " floatFix " + esSugerencia + "\" data-id=\"" + nota.contenido_id + "\" data-notaid=\"" + nota.contenido_id + "\" data-source=\"" + nota.origen + "\" data-pos=\"" + toiPos + "\">\n                    <a href=\"" + notaUrl + "\" class=\"figure\">\n                        " + imagenSrc + "\n                    </a><div class=\"titulo\">";

            if (!esNotaOpinion) {
                html += "<h2>\n                        <a href=\"" + notaUrl + "\">" + nota.titulo + "</a>\n                        </h2>";
                html += tagHtml;
            } else {
                html += tagHtml;
                html += "<h2>\n                        <a href=\"" + notaUrl + "\">" + nota.titulo + "</a>\n                        </h2>\n                        " + autorUrl;
            }
            html += "</div></article>";
            toi++;
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    return html;
};

////TODO: Unificar con el mismo metodo de notasAdicionales.js, no se hizo ahora por tema de tiempo.
var renderDataNoLogueado = function renderDataNoLogueado(cantNotas, callback) {
    liveFireUrlApi = liveFireUrlApi.replace("{livefyre-domainName}", "la-nacion");
    liveFireUrlApi = liveFireUrlApi.replace("{SiteId_Livefyre}", siteIdLF);
    liveFireUrlApi = liveFireUrlApi.replace("{cantidad de notas}", cantNotas);

    (0, _ajax.get)(liveFireUrlApi).then(function (rs) {
        return JSON.parse(rs);
    }).then(callback);
};

var getTemasYAutores = function getTemasYAutores(notasMasComentadas) {
    var resp = void 0;
    (0, _ajax.get)(urlNavAninima).then(function (rs) {
        resp = JSON.parse(rs);
        renderNotasNoLogueado(notasMasComentadas, resp);
    });
};

var renderNotasNoLogueado = function renderNotasNoLogueado(notasMasComentadas, temasYAutoresAnonimos) {
    var notasTemasRecomendados = temasYAutoresAnonimos.items.filter(function (nota) {
        return nota.tagDestacado;
    });
    var notasAutoresRecomendados = temasYAutoresAnonimos.items.filter(function (nota) {
        return nota.autores.find(function (autor) {
            return autor !== null;
        });
    });

    var html = "<div class=\"no-logueado\">\n                    <div class=\"sin-loguear\">\n                        <div class=\"izquierda\">\n                            <div class=\"techo-2 floatFix\">\n                               <span>REGISTRATE EN LA NACION <br> Y <b>MEJOR\xC1 TU EXPERIENCIA</b></span>\n                            </div>\n                        </div>\n                        <a href=\"" + loginUrlCallback + "\" class=\"boton\">REGISTRATE</a>\n                        <b class=\"resgristate\">Al registrarte con tu red social o tu e-mail pod\xE9s:</b>\n                    </div>\n                    <div class=\"secciones\">\n                        <span class=\"icon-seguir-1 fondo-amarillo\"></span>\n                        <h4>\n                            Seguir los temas y autores que m\xE1s te interesan\n                            <span>y enterarte, al instante, cada vez que haya nuevas notas</span>\n                        </h4>\n                        <div class=\"relacionados izquierda\">\n                            <h5>AUTORES M\xC1S SEGUIDOS</h5>\n                            <div>";

    //AUTORES (3)
    if (notasAutoresRecomendados !== null && notasAutoresRecomendados !== undefined && notasAutoresRecomendados.length > 0) {
        var valueToSlice = notasAutoresRecomendados.length < 3 ? notasAutoresRecomendados.length : 3;
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
            for (var _iterator3 = notasAutoresRecomendados.slice(0, valueToSlice)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var nota = _step3.value;

                html += "<a href=\"" + Utilities.formatoUrlAcuAutor(nota.autores[0].valor, nota.autores[0].id) + "\">" + nota.autores[0].valor + "</a>";
            }
        } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                }
            } finally {
                if (_didIteratorError3) {
                    throw _iteratorError3;
                }
            }
        }
    }

    html += "</div>\n                </div>\n                <div class=\"relacionados derecha \">\n                    <h5>TEMAS M\xC1S SEGUIDOS</h5>\n                <div>";

    //TEMAS (3)
    if (notasTemasRecomendados !== null && notasTemasRecomendados !== undefined && notasTemasRecomendados.length > 0) {
        var _valueToSlice = notasTemasRecomendados.length < 3 ? notasTemasRecomendados.length : 3;
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
            for (var _iterator4 = notasTemasRecomendados.slice(0, _valueToSlice)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var _nota = _step4.value;

                html += "<a href=\"" + Utilities.formatoUrlAcuTag(_nota.tagDestacado.valor, _nota.tagDestacado.id) + "\">" + _nota.tagDestacado.valor + "</a>";
            }
        } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                    _iterator4.return();
                }
            } finally {
                if (_didIteratorError4) {
                    throw _iteratorError4;
                }
            }
        }
    }

    html += "</div>\n                </div>\n                    </div>\n                    <div class=\"secciones\">\n                        <span class=\"icon-mail2 fondo-amarillo fixLeft\"></span>\n                        <h4>Suscribirte y recibir nuestros newsletters </h4>\n                        <div class=\"list fixLeft\">\n                            <p>Alertas de noticias</p>\n                            <p>Lo que hay que saber hoy y muchos m\xE1s\u2026</p>\n                            <p>Lo que pas\xF3 en el d\xEDa</p>\n                            <p>Titulares de tapa</p>\n                        </div>\n                    </div>\n                    <div class=\"secciones\">\n                        <span class=\"icon-comentario fondo-amarillo\"></span>\n                        <h4>Participar activamente con tu comentario en el debate de nuestra comunidad</h4>";

    if (notasMasComentadas.data.length > 0) {
        html += "<section class=\"mas-leidas\" data-is-block=\"true\" data-block-name=\"h_mas-leidas-logout\" data-diagramacion-id=\"0\">\n                        <div class=\"techo-2 floatFix\">\n                            <span>NOTAS \n                                <b>M\xC1S COMENTADAS</b>\n                            </span>\n                        </div>";
        var toi = 351;
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
            for (var _iterator5 = notasMasComentadas.data[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                var _nota2 = _step5.value;

                var parts = _nota2.url.split("/");
                var url = parts.pop();
                var idNota = url.split("-")[0];
                var toiPos = "toi".concat(toi.toString());
                html += "<article class=\"noticia foto flo atFix\" data-id=\"" + idNota + "\" data-notaid=\"" + idNota + "\" data-source=\"livefyre\" data-pos=\"" + toiPos + "\">\n                            <h2>\n                                <a href=\"/" + url + "\">" + _nota2.title + "</a>\n                            </h2>\n                        </article>";
                toi++;
            }
        } catch (err) {
            _didIteratorError5 = true;
            _iteratorError5 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                    _iterator5.return();
                }
            } finally {
                if (_didIteratorError5) {
                    throw _iteratorError5;
                }
            }
        }

        html += "</section>\n                    </div>\n                        <div class=\"secciones\">\n                            <p>Disfrut\xE1 de los beneficios de navegar registrado, <br>mejor\xE1 tu experiencia y <b>\xA1mantenete siempre informado! </b></p>\n                            <a href=\"" + loginUrlCallback + "\" class=\"boton\">INGRESAR</a>\n                        </div>\n                    </div>";
    }
    document.querySelector("#que-sigo").innerHTML = html;
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sugerenciasNoSigoNada = exports.renderPreferencias = undefined;

var _personalizacion = __webpack_require__(10);

var Personalizacion = _interopRequireWildcard(_personalizacion);

var _bucket = __webpack_require__(2);

var BucketTools = _interopRequireWildcard(_bucket);

var _utilities = __webpack_require__(3);

var Utilities = _interopRequireWildcard(_utilities);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var urlBucket = window.config.Statics.BucketUrl;

var renderPreferencias = exports.renderPreferencias = function renderPreferencias() {
    var preferencias = JSON.parse(localStorage.getItem("obtenerPorPrioridad"));
    var cantNotasNoLeidas = localStorage.getItem("obtenerNovedades");
    var temasRecomendados = JSON.parse(localStorage.getItem("recomendarTemas"));
    var html = "";
    var css = void 0;

    //CON notas a leer. (si hay pocas, completa con Sugerencias)
    if (cantNotasNoLeidas > 0) {
        css = "nuevas";
        html = "<div class=\"techo floatFix\">\n                    <span class=\"subtitulo\">Tus temas y autores </span>\n                    <h4><span data-cantidadNota=\"\">" + cantNotasNoLeidas + "</span> nuevas notas </h4>\n                    <a href=\"/lo-que-sigo\"> Configurar </a>\n                </div>";

        //Articles (Por nueva regla de negocio en Nota solo se muestran las Preferencias sin completar con Sugerencias.)
        var soloPreferencias = preferencias.filter(function (p) {
            return p.origen === "Preferencia";
        });
        html += loopArticles(soloPreferencias, 8);

        //Botones
        html += "<div class=\"ver-mas\">\n                    <a href=\"/lo-que-sigo\">VER M\xC1S NOTAS</a>\n                 </div>";
    } else if (preferencias.length === 0) {
        //SIN Preferencias NI Sugerencias.
        css = "sin-seguir";
        html = "<div class=\"techo floatFix\">\n                    <h4>SEGU\xCD LOS TEMAS Y AUTORES QUE <b>M\xC1S TE INTERESAN</b></h4>\n                </div>\n                <p> Busc\xE1 el bot\xF3n: <span class=\"seguir\">SEGUIR</span> para guardarlos en tus favoritos y enterate, al instante, cada vez que haya nuevas notas.</p>\n                <section class=\"mas-seguidos\">\n                <h5> MIENTRAS PODES SEGUIR ESTOS TEMAS:</h5>";

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = temasRecomendados[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var tema = _step.value;

                var id = tema[0],
                    idTipo = tema[3];

                html += "<div class=\"tema floatFix\"><p>" + tema[5] + "</p>\n                 <button class=\"seguir\" data-preferibleId=\"" + id + "\" data-preferibleTipoId=\"" + idTipo + "\">SEGUIR</button></div>";
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        html += "</section>";
    } else {
        //SIN nota a leer (Llenar con sugerencias)
        css = "recomendadas";
        html += "<div class=\"techo floatFix\">\n                    <span class=\"subtitulo\">Tus temas y autores </span>\n                    <h4>RECOMENDADOS</h4>\n                    <a href=\"/lo-que-sigo\"> Configurar </a>\n                </div>";
        //Articles
        html += loopArticles(preferencias, 8);
        //Botones
        html += "<div class=\"ver-mas\">\n                    <a href=\"/lo-que-sigo\">VER M\xC1S NOTAS</a>\n                </div>";
    }

    var asideBloque2 = document.querySelector("#bloque-2");
    if (asideBloque2 != null) {
        asideBloque2.classList.add(css);
        asideBloque2.innerHTML = html;
    }
    Personalizacion.seguirDejarSeguir(document.querySelectorAll('button[class="seguir"]'));
};

var loopArticles = function loopArticles(notas, cantidadATomar) {
    var valueToSlice = notas.length < cantidadATomar ? notas.length : cantidadATomar;
    notas = notas.filter(function (n) {
        return n.datos != undefined;
    });

    //Para test de render nota opinion
    //notas = notas.filter(n => n.datos.template.id === 3);

    var html = "";
    var toi = 701;
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = notas.slice(0, valueToSlice)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var nota = _step2.value;

            var notaDato = nota.datos;
            var esNotaOpinion = notaDato.template.id === 3;

            var isNotaRecomendada = nota.origen === "Sugerencia" ? "recomendadas" : "";
            var tipoOrigenNotas = isNotaRecomendada === "" ? "preferencias" : "recomendadas";

            var imagenSrc = "";
            var autorUrl = "";

            if (esNotaOpinion) {
                if (notaDato.autores !== undefined && notaDato.autores !== null && notaDato.autores.length > 0 && notaDato.autores[0].imagen !== undefined && notaDato.autores[0].imagen != null && notaDato.autores[0].imagen.id > 0 && notaDato.autores[0].imagen.extension != null && notaDato.autores[0].imagen.extension != "") {
                    imagenSrc = "<img src=\"" + BucketTools.urlBucketBalance(urlBucket, notaDato.autores[0].imagen.id, "", 90, notaDato.autores[0].imagen.extension) + "\"/>";
                }
                if (notaDato.autores !== undefined && notaDato.autores !== null && notaDato.autores.length > 0 && notaDato.autores[0].nombre != null && notaDato.autores[0].id != null && notaDato.autores[0].id > 0) {
                    var url = Utilities.formatoUrlAcuAutor(notaDato.autores[0].nombre, notaDato.autores[0].id);

                    autorUrl = "<a href=\"" + url + "\" class=\"autor\">" + notaDato.autores[0].nombre + "</a>";
                }
            } else {
                imagenSrc = notaDato.imagen && notaDato.imagen !== undefined && notaDato.imagen != null && notaDato.imagen.id > 0 && notaDato.imagen.extension != null && notaDato.imagen.extension != "" ? "<img src=\"" + BucketTools.urlBucketBalance(urlBucket, notaDato.imagen.id, 80, "", notaDato.imagen.extension) + "\"/>" : "";
            }

            var notaUrl = nota.contenido_id + "-" + Utilities.FormatearUrl(nota.titulo),
                tags = notaDato.temas;
            var tag = void 0;
            var tagHtml = "";

            if (tags && tags.length > 0) {
                tag = tags[0];
                tagHtml = "<h3 class=\"tag\"><a href=\"" + Utilities.formatoUrlAcuTag(tag.descripcion, tag.id) + "\">" + tag.descripcion + "</a></h3>";
            }
            var toiPos = "toi".concat(toi.toString());
            html += "<article title=\"\" class=\"nota m " + (esNotaOpinion ? " autor" : " foto") + " floatFix " + isNotaRecomendada + "\" data-id=\"" + nota.contenido_id + "\" data-notaid=\"" + nota.contenido_id + "\" data-source=\"" + tipoOrigenNotas + "\" data-pos=\"" + toiPos + "\">\n                    <a href=\"" + notaUrl + "\" class=\"figure\">\n                        " + imagenSrc + "\n                    </a>";

            if (!esNotaOpinion) {
                html += tagHtml;
                html += "<h2>\n                        <a href=\"" + notaUrl + "\">" + nota.titulo + "</a>\n                        </h2>";
            } else {
                html += "<h2>\n                        <a href=\"" + notaUrl + "\">" + nota.titulo + "</a>\n                        </h2>\n                        " + autorUrl;
            }
            html += "</article>";
            toi++;
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    return html;
};

//CUANDO NO SIGO NADA se dibuja esto.
var sugerenciasNoSigoNada = exports.sugerenciasNoSigoNada = function sugerenciasNoSigoNada(temasRecomendados) {
    var css = "sin-seguir";
    var html = "<div class=\"techo floatFix\">\n                    <h4>SEGU\xCD LOS TEMAS Y AUTORES QUE <b>M\xC1S TE INTERESAN</b></h4>\n                </div>\n                <p> Busc\xE1 el bot\xF3n: <span class=\"seguir\">SEGUIR</span> para guardarlos en tus favoritos y enterate, al instante, cada vez que haya nuevas notas.</p>\n                <section class=\"mas-seguidos\">\n                <h5> MIENTRAS PODES SEGUIR ESTOS TEMAS:</h5>";

    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
        for (var _iterator3 = temasRecomendados[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var tema = _step3.value;

            var id = tema[0],
                idTipo = tema[3];

            html += "<p>" + tema[5] + "</p>\n                 <button class=\"seguir\" data-preferibleId=\"" + id + "\" data-preferibleTipoId=\"" + idTipo + "\">SEGUIR</button>";
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
            }
        } finally {
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }

    html += "</section>";

    var asideBloque2 = document.querySelector("#bloque-2");
    asideBloque2.classList.add(css);
    asideBloque2.innerHTML = html;
    Personalizacion.seguirDejarSeguir(document.querySelectorAll('button[class="seguir"]'));
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// @ts-check

/**
 * Request - Generic method
 * @param {string} method
 * @param {string} url
 * @param {any} params
 * @param {any} headers
 * @return {Promise<string>}
 */
var ajax = exports.ajax = function ajax(method, url, params) {
  var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return new Promise(function (resolve, reject) {
    var request = new XMLHttpRequest();

    request.open(method, url, true);
    if (headers) {
      var names = Object.keys(headers);
      names.forEach(function (name) {
        var value = headers[name];

        request.setRequestHeader(name, value);
      });
    }

    request.onload = function () {
      if (request.status >= 200 && request.status < 400) {
        var resp = request.responseText;
        resolve(resp);
      } else {
        reject();
      }
    };
    request.onerror = function () {
      return reject();
    };
    request.send(JSON.stringify(params));
  });
};

/**
 * Request - Post
 * @param {string} method
 * @param {string} url
 * @param {any} params
 * @param {any} headers
 * @return {Promise<string>}
 */
var post = exports.post = function post(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return ajax('POST', url, params, headers);
};

/**
 * Request - Get
 * @param {string} method
 * @param {string} url
 * @param {any} params
 * @param {any} headers
 * @return {Promise<string>}
 */
var get = exports.get = function get(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return ajax('GET', url, params, headers);
};

exports.default = { get: get, post: post };

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var builder = function builder(domain) {
  var document = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.document;

  var doc = document;

  var getValue = function getValue(name) {
    var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : doc.cookie;

    var indice = source.indexOf(name);

    if (indice === -1 || !name) return '';

    var idxTo = source.indexOf(';', indice);

    var idxAmp = source.indexOf('&', indice);
    if (idxTo > idxAmp && idxAmp !== -1 || idxTo === -1 && idxAmp !== -1) idxTo = idxAmp;
    if (idxTo === -1) idxTo = source.length;

    var idFrom = indice + name.length + 1;

    return unescape(source.substring(idFrom, idxTo));
  };

  var createCookieString = function createCookieString(name, value, seconds, path) {
    var strExpires = seconds ? 'expires=' + new Date(Date.now() + seconds * 1000).toGMTString() + '; ' : '';
    var strDomain = domain === 'localhost' ? '' : 'domain=' + domain + '; ';
    var strPath = path ? 'path=' + path + '; ' : '';

    return (name + '=' + value + '; ' + strExpires + strDomain + strPath).trim();
  };

  var setValue = function setValue(name, value) {
    var seconds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 853200;
    var path = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '/';
    doc.cookie = createCookieString(name, value, seconds, path);
  };

  return { getValue: getValue, setValue: setValue };
};

module.exports = builder(window.document.domain.split(':', 1).pop(), window.document);
module.exports.builder = builder;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApiBuilder = undefined;

var _preferencias = __webpack_require__(30);

var _preferencias2 = _interopRequireDefault(_preferencias);

var _sugerencias = __webpack_require__(32);

var _sugerencias2 = _interopRequireDefault(_sugerencias);

var _comunes = __webpack_require__(28);

var _comunes2 = _interopRequireDefault(_comunes);

var _ranking = __webpack_require__(31);

var _ranking2 = _interopRequireDefault(_ranking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ApiBuilder = exports.ApiBuilder = function ApiBuilder(config) {
  var api = { byBuilder: true };

  var preferencias = new _preferencias2.default(config.preferencias || config, api);
  var sugerencias = new _sugerencias2.default(config.sugerencias || config, api);
  var comunes = new _comunes2.default(config.comunes || config, api);
  var ranking = new _ranking2.default(config.ranking || config, api);

  return {
    preferencias: preferencias,
    sugerencias: sugerencias,
    comunes: comunes,
    ranking: ranking,
    execute: function execute() {
      return preferencias.execute();
    }
  };
};

exports.default = ApiBuilder;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _apibase = __webpack_require__(4);

var _apibase2 = _interopRequireDefault(_apibase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Comunes = function (_ApiBase) {
  _inherits(Comunes, _ApiBase);

  function Comunes(config) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

    _classCallCheck(this, Comunes);

    return _possibleConstructorReturn(this, (Comunes.__proto__ || Object.getPrototypeOf(Comunes)).call(this, 'personalizacion', config, target));
  }

  /**
   * Obtiene notas en base a la prioridad ('sugerencia' | 'preferencia')
   * @param {Bool} rellena - indica si rellena con la 2da prioridad si no alcanzan las notas con la prioridad indicada.
   * @param {Number} [cantidad] - hasta cuantos resultados devolver
   * @param {String} tipo - Tipo de prioridad ('sugerencia' o 'preferencia')
   * @param {Number[]} contenidosLeidos - array con los id's de notas que se quieren excluir de la busqueda
   * @param {Number[]} [hours] - en que horas buscar
   * @param {Number[]} [daysOfWeek] - en que dias de la semana buscar
   * @param {Bool} [user] - si busca solamente en el entrenamiento del usuario
   * @param {String[]} [tags]
   * @param {String[]} [contenidosExcluidos] - array con las keys de contenidos que se quieren excluir de la busqueda
   */


  _createClass(Comunes, [{
    key: 'obtenerPorPrioridad',
    value: function obtenerPorPrioridad(rellena) {
      var cantidad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
      var tipo = arguments[2];
      var contenidosLeidos = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
      var hours = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
      var daysOfWeek = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
      var user = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : true;
      var tags = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : [];
      var contenidosExcluidos = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];

      var params = {};

      params.quantity = cantidad <= 0 ? 10 : cantidad;
      params.contenidosLeidos = contenidosLeidos;
      params.priorityType = tipo;
      params.hours = hours;
      params.daysOfWeek = daysOfWeek;
      params.user = user;
      params.tags = tags;
      params.refill = rellena;
      params.contenidosExcluidos = contenidosExcluidos;

      return this.addTask('personalizacion', 'json', [{
        name: 'obtener_por_prioridad',
        params: params
      }]);
    }
  }]);

  return Comunes;
}(_apibase2.default);

exports.default = Comunes;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var TOKEN_COOKIE_NAME = 'PersoTKN';
var SESSION_COOKIE_NAME = 'token';
var DEFAULT_DOMAIN = 'https://personalizacion.lanacion.com.ar/v3';
var cookie = __webpack_require__(26);

var _window = window,
    LN = _window.LN;
var ConfigProvider = exports.ConfigProvider = function ConfigProvider() {
  var domain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_DOMAIN;
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var version = 2;
  var token = config.token || cookie.getValue(config.tokenCookieName || TOKEN_COOKIE_NAME);
  var session = config.session || (cookie.getValue(config.sessionCookieName || SESSION_COOKIE_NAME) || '').split('-', 1);

  return function () {
    return {
      domain: domain,
      token: token,
      session: session,
      version: version
    };
  };
};

var DataProvider = exports.DataProvider = function DataProvider() {
  return { obtenerTemas: function obtenerTemas() {
      return LN.Preferencias.Categories || [];
    }, obtenerNotaId: function obtenerNotaId() {
      return LN.current.notaId;
    } };
};

var Providers = exports.Providers = {
  ConfigProvider: ConfigProvider,
  DataProvider: DataProvider
};

exports.default = Providers;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _apibase = __webpack_require__(4);

var _apibase2 = _interopRequireDefault(_apibase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Preferencias = function (_ApiBase) {
  _inherits(Preferencias, _ApiBase);

  function Preferencias(config) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

    _classCallCheck(this, Preferencias);

    return _possibleConstructorReturn(this, (Preferencias.__proto__ || Object.getPrototypeOf(Preferencias)).call(this, 'personalizacion', config, target));
  }

  /**
   * Sigue un preferible
   * @param {Number} preferibleId - Id del preferible a seguir
   * @param {Number} preferibleTipoId - Id del tipo de preferible a seguir (6:autor, 7:tag, 20:categoria)
   */


  _createClass(Preferencias, [{
    key: 'seguirPreferible',
    value: function seguirPreferible(preferibleId, preferibleTipoId) {
      var params = {};
      params.preferibleId = preferibleId;
      params.preferibleTipoId = preferibleTipoId;
      return this.addTask('personalizacion', 'json', [{
        name: 'suscribir',
        params: params
      }]);
    }

    /**
     * Obtiene el hash de las suscripciones del usuario. devuelve null si el usuario no tiene suscripciones.
     */

  }, {
    key: 'obtenerHashSuscripciones',
    value: function obtenerHashSuscripciones() {
      var params = {};
      return this.addTask('personalizacion', 'json', [{
        name: 'obtener_hash_suscripciones',
        params: params
      }]);
    }

    /**
     * Deja de seguir un preferible
     * @param {Number} preferibleId - Id del preferible a dejar de seguir
     * @param {Number} preferibleTipoId - Id del tipo de preferible a seguir (6:autor, 7:tag, 20:categoria)
     */

  }, {
    key: 'dejarDeSeguirPreferible',
    value: function dejarDeSeguirPreferible(preferibleId, preferibleTipoId) {
      var params = {};
      params.preferibleId = preferibleId;
      params.preferibleTipoId = preferibleTipoId;
      return this.addTask('personalizacion', 'json', [{
        name: 'cancelar_suscripcion',
        params: params
      }]);
    }

    /**
     * Registrar accion sobre contenido
     * @param {Number} contenidoId - Id del contenido
     * @param {Number} contenidoTipoId - Id del tipo de contenido (1:nota)
     * @param {String} [accion] - acción a entrenar
     */

  }, {
    key: 'registrarAccion',
    value: function registrarAccion(contenidoId, contenidoTipoId) {
      var accion = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'lectura';

      return this.addTask('personalizacion', 'json', [{
        name: 'registrar_accion',
        params: [contenidoId, contenidoTipoId, accion]
      }]);
    }

    /**
     * Obtiene la cantidad de novedades del usuario
     */

  }, {
    key: 'obtenerNovedades',
    value: function obtenerNovedades() {
      return this.addTask('personalizacion', 'json', [{
        name: 'obtener_cantidad_novedades'
      }]);
    }

    /**
     * Obtiene los preferibles del usuario
     * @param {Number} [preferibleTipoId] - tipo de preferible (6:autor, 7:tag, 20:categoria)
     */

  }, {
    key: 'obtenerPreferibles',
    value: function obtenerPreferibles() {
      var preferibleTipoId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var params = {};
      params.preferibleTipoId = preferibleTipoId;
      return this.addTask('personalizacion', 'json', [{
        name: 'obtener_preferibles',
        params: params
      }]);
    }

    /**
    * Obtiene notas en base a las preferencias del usuario
    * @param {Number} [cantidad=10] - Cantidad máxima de Notas a devolver
    * @param {Number} [page=1] - Página
    */

  }, {
    key: 'obtener',
    value: function obtener(cantidad) {
      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      var params = {};

      params.quantity = cantidad <= 0 ? 10 : cantidad;
      params.page = page;

      return this.addTask('personalizacion', 'json', [{
        name: 'obtener_preferencias',
        params: params
      }]);
    }
  }]);

  return Preferencias;
}(_apibase2.default);

exports.default = Preferencias;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _apibase = __webpack_require__(4);

var _apibase2 = _interopRequireDefault(_apibase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Comunes = function (_ApiBase) {
  _inherits(Comunes, _ApiBase);

  function Comunes(config) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

    _classCallCheck(this, Comunes);

    return _possibleConstructorReturn(this, (Comunes.__proto__ || Object.getPrototypeOf(Comunes)).call(this, 'personalizacion', config, target));
  }

  /**
   * Obtiene los autores y tags mas seguidos
   */


  _createClass(Comunes, [{
    key: 'obtenerMasSeguidos',
    value: function obtenerMasSeguidos() {
      var params = '';

      return this.addTask('personalizacion', 'json', [{
        name: 'obtener_mas_seguidos',
        params: params
      }]);
    }
  }]);

  return Comunes;
}(_apibase2.default);

exports.default = Comunes;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _apibase = __webpack_require__(4);

var _apibase2 = _interopRequireDefault(_apibase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CATEGORY_MAX_WEIGHT = 1000;

/**
 * Api sugerencias
 */

var Sugerencias = function (_ApiBase) {
  _inherits(Sugerencias, _ApiBase);

  /**
   * @param {object} config
   */
  function Sugerencias(config) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

    _classCallCheck(this, Sugerencias);

    return _possibleConstructorReturn(this, (Sugerencias.__proto__ || Object.getPrototypeOf(Sugerencias)).call(this, 'personalizacion', config, target));
  }

  /**
   * Recomendar temas en base al entrenamiento del usuario
   * @param {Number} [quantity] - hasta cuantos resultados devolver
   * @param {Number[]} [hours] - en que horas buscar
   * @param {Number[]} [daysOfWeek] - en que dias de la semana buscar
   * @param {Bool} [user] - si busca solamente en el entrenamiento del usuario
   * @param {String[]} [tags]
   */


  _createClass(Sugerencias, [{
    key: 'recomendarTemas',
    value: function recomendarTemas() {
      var quantity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
      var hours = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var daysOfWeek = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var user = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var tags = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

      var params = {};
      params.quantity = quantity || 10;
      params.hours = hours || [];
      params.daysOfWeek = daysOfWeek || [];
      params.user = user;
      params.tags = tags || [];

      return this.addTask('personalizacion', 'json', [// recomendar/temas
      {
        name: 'recomendar_temas',
        params: params
      }]);
    }

    /**
     * Registra los preferibles que se encuentran en la nota a la que accede el usuario.
     * @param {Any} categoriesParam - array de categorias (preferibles) a entrenar. formato esperado: idPreferible#tipoPreferibleId#SubTipoPreferibleId
     * @param {Array} context
     */

  }, {
    key: 'registrarTemas',
    value: function registrarTemas(categoriesParam) {
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      var params = {};
      params.categories = Sugerencias.getCategoriesFrom(categoriesParam);

      var now = new Date();
      var hour = now.getHours() || 24;
      var dayOfWeek = now.getDay() || 7;

      params.hour = hour;
      params.dayOfWeek = dayOfWeek;

      if (context) params.context = context;

      return this.addTask('personalizacion', 'json', [// registrar/temas
      {
        name: 'registrar_navegacion',
        params: params
      }]);
    }

    /**
     * Registra el acceso a una url
     * @param {Any} categoriesParam - array de accesos a entrenar. formato esperado: descripcion|url|tipo
     * @param {Array} context
     */

  }, {
    key: 'registrarAccesos',
    value: function registrarAccesos(categoriesParam) {
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      var params = {};
      params.categories = Sugerencias.getCategoriesFrom(categoriesParam);

      var now = new Date();
      var hour = now.getHours() || 24;
      var dayOfWeek = now.getDay() || 7;

      params.hour = hour;
      params.dayOfWeek = dayOfWeek;

      if (context) params.context = context;

      return this.addTask('personalizacion', 'json', [{
        name: 'registrar_acceso',
        params: params
      }]);
    }

    /**
     * Obtiene los accesos entrenados
     * @param {Number} [quantity] - hasta cuantos resultados devolver
     * @param {Number[]} [hours] - en que horas buscar
     * @param {Number[]} [daysOfWeek] - en que dias de la semana buscar
     * @param {Bool} [user] - si busca solamente en el entrenamiento del usuario
     * @param {String[]} [tags]
     */

  }, {
    key: 'obtenerAccesos',
    value: function obtenerAccesos() {
      var quantity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
      var hours = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var daysOfWeek = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var user = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var tags = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

      var params = {};
      params.quantity = quantity || 10;
      params.hours = hours || [];
      params.daysOfWeek = daysOfWeek || [];
      params.user = user;
      params.tags = tags || [];

      return this.addTask('personalizacion', 'json', [{
        name: 'obtener_accesos',
        params: params
      }]);
    }

    /**
     * Registrar accion sobre contendio
     * @param {Number} contenidoId - Id del contenido 
     * @param {Number} contenidoTipoId - Id del tipo de contenido (1:nota)
     * @param {String} [accion] - acción a entrenar
     */

  }, {
    key: 'registrarAccion',
    value: function registrarAccion(contenidoId, contenidoTipoId) {
      var accion = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'lectura';

      return this.addTask('personalizacion', 'json', [{
        name: 'registrar_accion',
        params: [contenidoId, contenidoTipoId, accion]
      }]);
    }

    /**
     * Registra lectura de nota
     * @param {Number} notaId - Id de la nota
     */

  }, {
    key: 'lecturaNota',
    value: function lecturaNota(notaId) {
      return this.addTask('personalizacion', 'json', [{
        name: 'registrar_lectura_nota',
        params: [notaId]
      }]);
    }

    /**
     * @param {Number[]} [contenidosLeidos] - array con los id's de notas que se quieren excluir de la busqueda
     * @param {Number} [quantity] - hasta cuantos resultados devolver
     * @param {Number[]} [hours] - en que horas buscar
     * @param {Number[]} [daysOfWeek] - en que dias de la semana buscar
     * @param {Bool} [user] - si busca solamente en el entrenamiento del usuario
     * @param {String[]} [tags]
     * @param {String[]} [contenidosExcluidos] - array con las keys de contenidos que se quieren excluir de la busqueda
     */

  }, {
    key: 'obtener',
    value: function obtener() {
      var contenidosLeidos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var quantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
      var hours = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var daysOfWeek = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
      var user = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
      var tags = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
      var contenidosExcluidos = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];

      var params = {};

      params.quantity = quantity <= 0 ? 10 : quantity;
      params.contenidosLeidos = contenidosLeidos;
      params.hours = hours || [];
      params.daysOfWeek = daysOfWeek || [];
      params.user = user;
      params.tags = tags || [];
      params.contenidosExcluidos = contenidosExcluidos || [];

      return this.addTask('personalizacion', 'json', [{
        name: 'obtener_sugerencias',
        params: params
      }]);
    }
  }]);

  return Sugerencias;
}(_apibase2.default);

/**
   * Convert a single value to category object
   * @param  {Any} categoryParam
   * @return  {object} category
   **/


Sugerencias.getCategory = function (categoryParam) {
  if (typeof categoryParam === 'string') {
    return categoryParam;
  }

  var category = {};
  if ((typeof categoryParam === 'undefined' ? 'undefined' : _typeof(categoryParam)) === 'object') {
    category.value = categoryParam.value;
    if (categoryParam.type) category.type = categoryParam.type;else if (categoryParam.weight > CATEGORY_MAX_WEIGHT) category.weight = CATEGORY_MAX_WEIGHT;else if (categoryParam.weight) category.weight = categoryParam.weight;else category.weight = 1;
  } else {
    category.value = categoryParam;
    category.weight = 1;
  }

  return category;
};

/**
   * Convert values to array of categories
   * @param  {Any} categories
   * @return  {Array} categories
   **/
Sugerencias.getCategoriesFrom = function (categories) {
  if (categories instanceof Array) {
    return [].concat(_toConsumableArray(categories.map(Sugerencias.getCategory).filter(function (c) {
      return !!c;
    })));
  } else if ((typeof categories === 'undefined' ? 'undefined' : _typeof(categories)) === 'object') {
    return categories.categories || categories;
  }
  return [Sugerencias.getCategory(categories)];
};

exports.default = Sugerencias;

/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = {"head":{"meta":[{"name":"viewport","content":"width=device-width,initial-scale=1,minimum-scale=1"}]},"title":"LA NACION","metaTitle":"LA NACION","metaDescription":"Información confiable en Internet. Noticias de Argentina y del mundo - ¡Informate ya!","metaKeywords":"la nación, diario, argentina, noticias, información, política, economía, finanzas, deportes, futbol, tenis, rugby, basquetbol, voleibol, formula 1, cultura, espectáculos, cine, teatro, televisión, humor, juegos, horóscopo, clima, pronostico, mapa, vinos, restaurantes, quiniela, loteria, nik, criptograma literario, liniers, internacional, el mundo, ciencia, últimas noticias, clasificados","metaApplicationTask":["name=Ultimas noticias;action-uri=http://www.lanacion.com.ar/ultimas-noticias;icon-uri=http://www.lanacion.com.ar/item1.ico","name=Tránsito;action-uri=http://servicios.lanacion.com.ar/transito;icon-uri=http://www.lanacion.com.ar/item2.ico","name=Pronóstico;action-uri=http://servicios.lanacion.com.ar/informacion-general/pronostico;icon-uri=http://www.lanacion.com.ar/item3.ico","name=Horóscopo;action-uri=http://servicios.lanacion.com.ar/horoscopo;icon-uri=http://www.lanacion.com.ar/item4.ico"],"metaApplicationID":"LANACION.LANACION","metaApplicationName":"LA NACION","metaUrl":"http://www.lanacion.com.ar","metaTooltip":"Noticias actualizadas las 24 hs.","metaWindow":"width=800;height=600","metacXenseParsePageclass":"frontpage","banner":{"sites":[{"id":"9673","section":"internas_ep","maxWidth":1000000,"positions":["expandable","megaLateral","caja1","caja2","caja3"]}],"autorKeywordPrefix":"asdasd","keywords":["inicio"]},"Chapitas":[{"id":"9673","url":"internas_ep"}],"tercera":["BannerCaja1","Ranking","BannerCaja3"],"columnaCronologica":{"cantidadNotasCronologicasMax":10,"tagIdsExcluir":[57525]},"bannersUsuario":[],"banners":[{"dispositivo":"mobile","tipos":["sticky","caja_1","caja_2","caja_3","caja_4","caja_5","sticky","cinturon","cinturon_2"]},{"dispositivo":"tablet","tipos":["caja_1","caja_2","caja_3","caja_4","caja_5","billboard","sticky","cabezal","920x120","middle","cinturon"]},{"dispositivo":"desktop","tipos":["caja_1","caja_2","caja_3","caja_4","caja_5","billboard","sticky","cabezal","920x120","middle","cinturon"]}],"cantidadNotasInstanciadasColumna1DibujarBanner":3,"cantidadNotasDestacadasPorTags":2,"articleCronologicoBheight":"1","articleCronologicoBwidth":390,"articleDestacadoBheight":"1","articleDestacadoBwidth":330,"prioridadTag":[{"descripcion":"content-lab","tagtipo":10,"prioridad":1},{"descripcion":"espacio-patrocinado","tagtipo":9,"prioridad":2},{"descripcion":"producto","tagtipo":7,"prioridad":3},{"descripcion":"topico","tagtipo":1,"prioridad":4},{"descripcion":"show","tagtipo":8,"prioridad":5},{"descripcion":"seccion","tagtipo":6,"prioridad":6}],"ciudades":[{"sigla":"INI","home":"Seleccionar ciudad","nombre":"Seleccionar ciudad","referencia":"Seleccionar ciudad","id":"hide"},{"sigla":"AEP","home":"Aeroparque","nombre":"Aeroparque Buenos Aires","referencia":"AEROPARQUE BUENOS AIRES","id":"ARCF0146"},{"sigla":"AZU","home":"Azul","nombre":"Azul","referencia":"AZUL","id":"ARBA0129"},{"sigla":"BAH","home":"Bahía Blanca","nombre":"Bahía Blanca","referencia":"BAHIA BLANCA","id":"ARBA0004"},{"sigla":"BCR","home":"Bariloche","nombre":"Bariloche","referencia":"BARILOCHE","id":"ARRN0116"},{"sigla":"BEN","home":"Benito Juárez","nombre":"Benito Juárez","referencia":"BENITO JUAREZ","id":"ARBA0130"},{"sigla":"YRI","home":"B. Irigoyen","nombre":"Bernardo De Irigoyen","referencia":"BERNARDO DE IRIGOYEN","id":"ARMS0164"},{"sigla":"BOL","home":"Bolívar","nombre":"Bolívar","referencia":"BOLIVAR","id":"ARBA5002"},{"sigla":"CAP","home":"Capital Federal","nombre":"Capital Federal","referencia":"BUENOS AIRES","id":"ARCF0009"},{"sigla":"CAT","home":"Catamarca","nombre":"Catamarca","referencia":"CATAMARCA","id":"ARCC0013"},{"sigla":"CER","home":"Ceres","nombre":"Ceres","referencia":"CERES","id":"ARSF0015"},{"sigla":"CHA","home":"Chamical","nombre":"Chamical","referencia":"CHAMICAL","id":"ARLR0159"},{"sigla":"CHA","home":"Chapelco","nombre":"Chapelco","referencia":"CHAPELCO","id":"ARNN0167"},{"sigla":"CHE","home":"Chepes","nombre":"Chepes","referencia":"CHEPES","id":"ARLR0017"},{"sigla":"CHI","home":"Chilecito","nombre":"Chilecito","referencia":"CHILECITO","id":"ARLR0160"},{"sigla":"CIP","home":"Cipolletti","nombre":"Cipolletti","referencia":"CIPOLLETTI","id":"ARRN0264"},{"sigla":"CRD","home":"C. Rivadavia","nombre":"Comodoro Rivadavia","referencia":"COMODORO RIVADAVIA","id":"ARCT0021"},{"sigla":"CON","home":"Concordia","nombre":"Concordia","referencia":"CONCORDIA","id":"ARER0022"},{"sigla":"CBA","home":"Córdoba","nombre":"Córdoba","referencia":"CORDOBA","id":"ARCA0023"},{"sigla":"CBA","home":"Córdoba Obs.","nombre":"Córdoba Observatorio","referencia":"CORDOBA OBSERVATORIO","id":"ARCA0148"},{"sigla":"PRI","home":"Cnel Pringles","nombre":"Coronel Pringles","referencia":"CORONEL PRINGLES","id":"ARBA5007"},{"sigla":"SUA","home":"Cnel Suarez","nombre":"Coronel Suarez","referencia":"CORONEL SUAREZ","id":"ARBA0131"},{"sigla":"CTE","home":"Corrientes","nombre":"Corrientes","referencia":"CORRIENTES","id":"ARCS0025"},{"sigla":"CUR","home":"Curuzú Cuatiá","nombre":"Curuzú Cuatiá","referencia":"CURUZU CUATIA","id":"ARCS0027"},{"sigla":"DOL","home":"Dolores","nombre":"Dolores","referencia":"DOLORES","id":"ARBA0132"},{"sigla":"BOL","home":"El Bolsón","nombre":"El Bolsón","referencia":"EL BOLSON","id":"ARRN0168"},{"sigla":"CAL","home":"El Calafate","nombre":"El Calafate","referencia":"EL CALAFATE","id":"ARSC0171"},{"sigla":"PAL","home":"El Palomar","nombre":"El Palomar","referencia":"EL PALOMAR","id":"ARBA0134"},{"sigla":"TRE","home":"El Trébol","nombre":"El Trébol","referencia":"EL TREBOL","id":"ARSF0174"},{"sigla":"EZQ","home":"Esquel","nombre":"Esquel","referencia":"ESQUEL","id":"ARCT0146"},{"sigla":"EZE","home":"Ezeiza","nombre":"Ezeiza","referencia":"EZEIZA","id":"ARBA0135"},{"sigla":"FOR","home":"Formosa","nombre":"Formosa","referencia":"FORMOSA","id":"ARFA0030"},{"sigla":"GPO","home":"Gral Pico","nombre":"General Pico","referencia":"GENERAL PICO","id":"ARLP0158"},{"sigla":"GRE","home":"G. Gregores","nombre":"Gobernador Gregores","referencia":"GOBERNADOR GREGORES","id":"ARSC0035"},{"sigla":"GUA","home":"Gualeguaychú","nombre":"Gualeguaychú","referencia":"GUALEGUAYCHU","id":"ARER5003"},{"sigla":"IGU","home":"Iguazú","nombre":"Iguazú","referencia":"IGUAZU","id":"ARMS0117"},{"sigla":"ITU","home":"Ituzaingó","nombre":"Ituzaingó (Corrientes)","referencia":"ITUZAINGO","id":"ARCS5001"},{"sigla":"JAC","home":"Jachal","nombre":"Jachal","referencia":"JACHAL","id":"ARSJ0038"},{"sigla":"JUJ","home":"Jujuy","nombre":"Jujuy","referencia":"JUJUY","id":"ARJY0157"},{"sigla":"JUN","home":"Junín","nombre":"Junín","referencia":"JUNIN","id":"ARBA0040"},{"sigla":"LP","home":"La Plata","nombre":"La Plata","referencia":"LA PLATA","id":"ARBA0043"},{"sigla":"QUI","home":"La Quiaca","nombre":"La Quiaca","referencia":"LA QUIACA","id":"ARJY0044"},{"sigla":"RIO","home":"La Rioja","nombre":"La Rioja","referencia":"LA RIOJA","id":"ARLR0045"},{"sigla":"LAB","home":"Laboulaye","nombre":"Laboulaye","referencia":"LABOULAYE","id":"ARCA0149"},{"sigla":"FLO","home":"Las Flores","nombre":"Las Flores","referencia":"LAS FLORES","id":"ARBA0136"},{"sigla":"LOM","home":"Las Lomitas","nombre":"Las Lomitas","referencia":"LAS LOMITAS","id":"ARFA0048"},{"sigla":"MAL","home":"Malargue","nombre":"Malargue","referencia":"MALARGUE","id":"ARMA0052"},{"sigla":"MAQ","home":"Maquinchao","nombre":"Maquinchao","referencia":"MAQUINCHAO","id":"ARRN0053"},{"sigla":"MDP","home":"Mar del Plata","nombre":"Mar del Plata","referencia":"MAR DEL PLATA","id":"ARBA0054"},{"sigla":"JUA","home":"Marcos Juárez","nombre":"Marcos Juárez","referencia":"MARCOS JUAREZ","id":"ARCA0150"},{"sigla":"MDZ","home":"Mendoza","nombre":"Mendoza","referencia":"MENDOZA","id":"ARMA0056"},{"sigla":"MDZ","home":"Mendoza Obs.","nombre":"Mendoza Observatorio","referencia":"MENDOZA OBSERVATORIO","id":"ARMA0161"},{"sigla":"MDZ","home":"Monte Caseros","nombre":"Monte Caseros (Corrientes)","referencia":"MONTE CASEROS","id":"ARCC0153"},{"sigla":"MOR","home":"Morón","nombre":"Morón","referencia":"MORON","id":"ARBA5013"},{"sigla":"NEU","home":"Neuquén","nombre":"Neuquén","referencia":"NEUQUEN","id":"ARNN0059"},{"sigla":"9DJ","home":"Nueve De Julio","nombre":"Nueve De Julio","referencia":"NUEVE DE JULIO","id":"ARBA0138"},{"sigla":"OBR","home":"Oberá","nombre":"Oberá","referencia":"OBERA","id":"ARMS0165"},{"sigla":"OLA","home":"Olavarría","nombre":"Olavarría","referencia":"OLAVARRIA","id":"ARBA0060"},{"sigla":"ORA","home":"Orán","nombre":"Orán","referencia":"ORAN","id":"ARSA0061"},{"sigla":"PAR","home":"Paraná","nombre":"Paraná","referencia":"PARANA","id":"ARER0062"},{"sigla":"IND","home":"Paso De Indios","nombre":"Paso De Indios","referencia":"PASO DE INDIOS","id":"ARCT0063"},{"sigla":"LIB","home":"Paso Libres","nombre":"Paso De Los Libres","referencia":"PASO DE LOS LIBRES","id":"ARCO0154"},{"sigla":"RSP","home":"R. Saenz Peña","nombre":"Pcia. Roque Saenz Peña","referencia":"PCIA. ROQUE SAENZ PENA","id":"ARCO0066"},{"sigla":"PEH","home":"Pehuajó","nombre":"Pehuajó","referencia":"PEHUAJO","id":"ARBA0140"},{"sigla":"PMO","home":"Perito Moreno","nombre":"Perito Moreno","referencia":"PERITO MORENO","id":"ARSC0172"},{"sigla":"PIG","home":"Pigué","nombre":"Pigué","referencia":"PIGUE","id":"ARBA0065"},{"sigla":"PIL","home":"Pilar Obs","nombre":"Pilar Observatorio.","referencia":"PILAR OBS.","id":"ARBA0151"},{"sigla":"POS","home":"Posadas","nombre":"Posadas","referencia":"POSADAS","id":"ARMS0166"},{"sigla":"DES","home":"Pto Deseado","nombre":"Puerto Deseado","referencia":"PUERTO DESEADO","id":"ARSC0067"},{"sigla":"PMY","home":"Pto Madryn","nombre":"Puerto Madryn","referencia":"PUERTO MADRYN","id":"ARCT0147"},{"sigla":"PIN","home":"Punta Indio","nombre":"Punta Indio B.A.","referencia":"PUNTA INDIO B.A.","id":"ARBA0141"},{"sigla":"REC","home":"Reconquista","nombre":"Reconquista","referencia":"RECONQUISTA","id":"ARSF0071"},{"sigla":"RES","home":"Resistencia","nombre":"Resistencia","referencia":"RESISTENCIA","id":"ARCO0072"},{"sigla":"RCO","home":"Río Colorado","nombre":"Río Colorado","referencia":"RIO COLORADO","id":"ARRN5002"},{"sigla":"RCU","home":"Río Cuarto","nombre":"Río Cuarto","referencia":"RIO CUARTO","id":"ARCA0073"},{"sigla":"RGL","home":"Río Gallegos","nombre":"Río Gallegos","referencia":"RIO GALLEGOS","id":"ARSC0074"},{"sigla":"RGA","home":"Río Grande","nombre":"Río Grande","referencia":"RIO GRANDE B.A.","id":"ARTF0183"},{"sigla":"RIV","home":"Rivadavia","nombre":"Rivadavia","referencia":"RIVADAVIA","id":"ARSA0268"},{"sigla":"ROS","home":"Rosario","nombre":"Rosario","referencia":"ROSARIO","id":"ARSF0078"},{"sigla":"SAL","home":"Salta","nombre":"Salta","referencia":"SALTA","id":"ARSA0079"},{"sigla":"SAO","home":"S. A. Oeste","nombre":"San Antonio Oeste","referencia":"SAN ANTONIO OESTE","id":"ARRN0080"},{"sigla":"SFD","home":"San Fernando","nombre":"San Fernando","referencia":"SAN FERNANDO","id":"ARBA0142"},{"sigla":"SJN","home":"San Juan","nombre":"San Juan","referencia":"SAN JUAN","id":"ARSJ0084"},{"sigla":"SLN","home":"San Julián","nombre":"San Julián","referencia":"SAN JULIAN","id":"ARSC0173"},{"sigla":"SLS","home":"San Luis","nombre":"San Luis","referencia":"SAN LUIS","id":"ARSL0087"},{"sigla":"SMM","home":"San Martín","nombre":"San Martín (Mza)","referencia":"SAN MARTIN (MZA)","id":"ARMA0163"},{"sigla":"SMI","home":"San Miguel","nombre":"San Miguel","referencia":"SAN MIGUEL","id":"ARBA5019"},{"sigla":"SRF","home":"San Rafael","nombre":"San Rafael","referencia":"SAN RAFAEL","id":"ARMA0091"},{"sigla":"SFE","home":"Santa Fe","nombre":"Santa Fe","referencia":"SANTA FE","id":"ARSF0093"},{"sigla":"SRO","home":"Santa Rosa","nombre":"Santa Rosa","referencia":"SANTA ROSA","id":"ARLP0095"},{"sigla":"SRC","home":"S.R. Conlara","nombre":"Santa Rosa de Conlara","referencia":"SANTA ROSA DEL CONLARA","id":"ARSL0171"},{"sigla":"SDE","home":"S. del Estero","nombre":"Santiago del Estero","referencia":"SANTIAGO DEL ESTERO","id":"ARSE0096"},{"sigla":"TAN","home":"Tandil","nombre":"Tandil","referencia":"TANDIL","id":"ARBA0098"},{"sigla":"TAR","home":"Tartagal","nombre":"Tartagal","referencia":"TARTAGAL","id":"ARSA0170"},{"sigla":"TIN","home":"Tinogasta","nombre":"Tinogasta","referencia":"TINOGASTA","id":"ARCC0100"},{"sigla":"TOL","home":"Tolhuin","nombre":"Tolhuin","referencia":"TOLHUIN","id":"ARTF0176"},{"sigla":"TRE","home":"Trelew","nombre":"Trelew","referencia":"TRELEW","id":"ARCT0102"},{"sigla":"TLA","home":"T. Lauquen","nombre":"Trenque Lauquen","referencia":"TRENQUE LAUQUEN","id":"ARBA0211"},{"sigla":"TAR","home":"Tres Arroyos","nombre":"Tres Arroyos","referencia":"TRES ARROYOS","id":"ARBA0104"},{"sigla":"TUC","home":"Tucumán","nombre":"Tucumán","referencia":"TUCUMAN","id":"ARTM0177"},{"sigla":"USU","home":"Ushuaia","nombre":"Ushuaia","referencia":"USHUAIA","id":"ARTF0105"},{"sigla":"USP","home":"Uspallata","nombre":"Uspallata","referencia":"USPALLATA","id":"ARMA0256"},{"sigla":"VTO","home":"Venado Tuerto","nombre":"Venado Tuerto","referencia":"VENADO TUERTO","id":"ARSF0175"},{"sigla":"VIE","home":"Viedma","nombre":"Viedma","referencia":"VIEDMA","id":"ARRN0169"},{"sigla":"VDO","home":"Villa Dolores","nombre":"Villa Dolores","referencia":"VILLA DOLORES","id":"ARCA0110"},{"sigla":"VGL","home":"Villa Gesell","nombre":"Villa Gesell","referencia":"VILLA GESELL","id":"ARBA0145"},{"sigla":"VRS","home":"V.M. Río Seco","nombre":"Villa María Del Río Seco","referencia":"VILLA MARIA DEL RIO SECO","id":"ARCA0152"},{"sigla":"VRY","home":"Villa Reynolds","nombre":"Villa Reynolds","referencia":"VILLA REYNOLDS","id":"ARSL0113"}],"terceraIndicesFinancieros":["BannerCaja1","BannerCaja2","BannerCaja3","BannerCaja4","PromoContent","PromoClub"]}

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MakeCustomDimension = undefined;

var _cookie = __webpack_require__(0);

var Cookie = _interopRequireWildcard(_cookie);

var _ajax = __webpack_require__(1);

var Ajax = _interopRequireWildcard(_ajax);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var urlApiPaywall = window.config.Statics.ApiPaywall;
var urlApiSuscripcion = urlApiPaywall + window.config.Statics.ApiSuscripcion;

var MakeCustomDimension = exports.MakeCustomDimension = function MakeCustomDimension() {

    //let timeCache = localStorage.getItem("CDcacheCommon");
    // let dif = 0;  
    // let tiempoCacheMilisegundos = 300000; ///TODO:Cambiar a configuracion
    var cDlocalStorage = localStorage.getItem("CDcacheCommon");
    if (cDlocalStorage == null) {
        getAndSaveCustomDimension();
    }

    //if (timeCache) {
    //    dif = Date.now() - timeCache;
    //    if (dif > tiempoCacheMilisegundos) {
    //        cleanAndGetCustomDimensions();
    //    } else {
    //        let tokenActual = Cookie.LeerCookie('token');
    //        let cDtoken = localStorage.getItem("token");
    //        if (tokenActual && tokenActual !== cDtoken) {
    //            localStorage.removeItem("CDnotasLeidas");
    //            cleanAndGetCustomDimensions();
    //        }
    //    }
    //} else {
    //    getAndSaveCustomDimension();
    //}
};

var getAndSaveCustomDimension = function getAndSaveCustomDimension() {

    //let usuarioLogeado = Cookie.LeerCookie('token');
    var usuarioLogeado = localStorage.getItem("token");
    var productoId = Cookie.LeerCookie('ProductoPremiumId');
    var clubLn = Cookie.LeerCookie('usuarioDetalleClubNacion');
    var userId = Cookie.LeerCookie('usuario%5Fid');
    var usuarioRegistrado = Cookie.LeerCookie('usuarioemail');

    if (usuarioLogeado != null) {
        getSuscriptorType(usuarioLogeado);
    } else {
        localStorage.setItem("CDsuscriptorType", "N/A");
    }

    usuarioLogeado = usuarioLogeado != null ? "yes" : "no";
    productoId = productoId ? "yes" : "no";
    clubLn = clubLn ? clubLn : "N/A";
    userId = userId ? userId : "N/A";
    usuarioRegistrado = usuarioRegistrado ? "yes" : "no";

    localStorage.setItem("CDcacheCommon", Date.now());
    localStorage.setItem("CDusuarioLogeado", usuarioLogeado);
    localStorage.setItem("CDpayUser", productoId);
    localStorage.setItem("CDcredentialType", clubLn);
    localStorage.setItem("CDuserId", userId);
    localStorage.setItem("CDusuarioRegistrado", usuarioRegistrado);
};

var cleanAndGetCustomDimensions = function cleanAndGetCustomDimensions() {

    localStorage.removeItem("CDcacheCommon");
    localStorage.removeItem("CDusuarioLogeado");
    localStorage.removeItem("CDusuarioRegistrado");
    localStorage.removeItem("CDpayUser");
    localStorage.removeItem("CDsuscriptorType");
    localStorage.removeItem("CDcredentialType");
    localStorage.removeItem("CDuserId");
    getAndSaveCustomDimension();
};

var getSuscriptorType = function getSuscriptorType(token) {
    var objHeaders = {
        "X-Token": token
    };
    Ajax.post(urlApiSuscripcion, undefined, objHeaders).then(function (rs) {
        return saveSuscriptorType(JSON.parse(rs));
    });
};

var saveSuscriptorType = function saveSuscriptorType(data) {
    if (data && data.code && data.code === "0000") {
        var combo = data.response.nombre;
        localStorage.setItem("CDsuscriptorType", combo);
    } else {
        localStorage.setItem("CDsuscriptorType", "N/A");
    }
};

/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
 * Lazy Load - jQuery plugin for lazy loading images
 *
 * Copyright (c) 2007-2009 Mika Tuupola
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * Project home:
 *   http://www.appelsiini.net/projects/lazyload
 *
 * Version:  1.5.0
 *
 */
(function ($) {

    $.fn.lazyload = function (options) {
        var settings = {
            threshold: 400,
            failurelimit: 10,
            event: "scroll",
            effect: "show",
            container: window
        };

        if (options) {
            $.extend(settings, options);
        }

        /* Fire one scroll event per scroll. Not one scroll event per image. */
        var elements = this;
        if ("scroll" == settings.event) {
            $(settings.container).bind("scroll", function (event) {

                var counter = 0;
                elements.each(function () {
                    if ($.abovethetop(this, settings) || $.leftofbegin(this, settings)) {
                        /* Nothing. */
                    } else if (!$.belowthefold(this, settings) && !$.rightoffold(this, settings)) {
                        $(this).trigger("appear");
                    } else {
                        if (counter++ > settings.failurelimit) {
                            return false;
                        }
                    }
                });
                /* Remove image from array so it is not looped next time. */
                var temp = $.grep(elements, function (element) {
                    return !element.loaded;
                });
                elements = $(temp);
            });
        }

        this.each(function () {
            var self = this,
                src = $(self).attr("src");
            //Si tiene SRC, sale!
            if (src && src != settings.placeholder) return;

            /* Save original only if it is not defined in HTML. */
            if (undefined == $(self).attr("original")) {
                $(self).attr("original", src);
            }

            if ("scroll" != settings.event || undefined == src || "" == src || settings.placeholder == src || $.abovethetop(self, settings) || $.leftofbegin(self, settings) || $.belowthefold(self, settings) || $.rightoffold(self, settings)) {

                if (settings.placeholder) {
                    $(self).attr("src", settings.placeholder);
                } else {
                    $(self).removeAttr("src");
                }
                self.loaded = false;
            } else {
                self.loaded = true;
            }

            /* When appear is triggered load original image. */
            $(self).one("appear", function () {
                if (!this.loaded) {
                    $("<img />").bind("load", function () {
                        $(self).hide().attr("src", $(self).attr("original"))[settings.effect](settings.effectspeed);
                        self.loaded = true;
                    }).attr("src", $(self).attr("original"));
                };
            });

            /* When wanted event is triggered load original image */
            /* by triggering appear.                              */
            if ("scroll" != settings.event) {
                $(self).bind(settings.event, function (event) {
                    if (!self.loaded) {
                        $(self).trigger("appear");
                    }
                });
            }
        });

        /* Force initial check if images should appear. */
        $(settings.container).trigger(settings.event);

        return this;
    };

    /* Convenience methods in jQuery namespace.           */
    /* Use as  $.belowthefold(element, {threshold : 100, container : window}) */

    $.belowthefold = function (element, settings) {
        if (settings.container === undefined || settings.container === window) {
            var fold = $(window).height() + $(window).scrollTop();
        } else {
            var fold = $(settings.container).offset().top + $(settings.container).height();
        }
        return fold <= $(element).offset().top - settings.threshold;
    };

    $.rightoffold = function (element, settings) {
        if (settings.container === undefined || settings.container === window) {
            var fold = $(window).width() + $(window).scrollLeft();
        } else {
            var fold = $(settings.container).offset().left + $(settings.container).width();
        }
        return fold <= $(element).offset().left - settings.threshold;
    };

    $.abovethetop = function (element, settings) {
        if (settings.container === undefined || settings.container === window) {
            var fold = $(window).scrollTop();
        } else {
            var fold = $(settings.container).offset().top;
        }
        return fold >= $(element).offset().top + settings.threshold + $(element).height();
    };

    $.leftofbegin = function (element, settings) {
        if (settings.container === undefined || settings.container === window) {
            var fold = $(window).scrollLeft();
        } else {
            var fold = $(settings.container).offset().left;
        }
        return fold >= $(element).offset().left + settings.threshold + $(element).width();
    };
    /* Custom selectors for your convenience.   */
    /* Use as $("img:below-the-fold").something() */

    $.extend($.expr[':'], {
        "below-the-fold": "$.belowthefold(a, {threshold : 0, container: window})",
        "above-the-fold": "!$.belowthefold(a, {threshold : 0, container: window})",
        "right-of-fold": "$.rightoffold(a, {threshold : 0, container: window})",
        "left-of-fold": "!$.rightoffold(a, {threshold : 0, container: window})"
    });
})(jQuery);

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.implementLazyLoadImage = implementLazyLoadImage;

__webpack_require__(38);

//const img = require('../../../img/LN.svg');


var lazyLoadImage = function lazyLoadImage() {
    var elements = $(".lazyLoad");
    if (elements) {
        $(elements).lazyload({
            threshold: 400
            //placeholder: img
        });

        $(document).ready(function () {
            setTimeout(function () {
                $(".lazyLoad").trigger("scroll");
            }, 1000);
        });
    }
};

$(lazyLoadImage);

function implementLazyLoadImage() {
    $(lazyLoadImage);
};

/***/ }),
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var loadMetricsEvents = exports.loadMetricsEvents = function loadMetricsEvents() {

    Array.from(document.querySelectorAll('[data-DLdescripcion]')).filter(function (k) {
        return k.getAttribute("data-DLdescripcion") != null && k.getAttribute("data-DLdescripcion") !== "" && k.getAttribute("data-DLdescripcion") !== undefined;
    }).map(function (d) {
        d.addEventListener("click", function () {
            if (window.dataLayer != undefined && d.getAttribute("class") !== "seguir activo") {
                if (d.getAttribute("data-preferibletipoid") == 6) {
                    window.dataLayer.push({ 'event': 'followAuth', 'followedAuth': d.getAttribute("data-DLdescripcion") });
                } else if (d.getAttribute("data-preferibletipoid") == 7) {
                    window.dataLayer.push({ 'event': 'follow', 'followed': d.getAttribute("data-DLdescripcion") });
                }
            }
        });
    });
};

var eventosMetricas = exports.eventosMetricas = function eventosMetricas() {
    ///TODO agregar otro tipo de evento q no sea click 
    Array.from(document.querySelectorAll('[data-metricas="dataLayer"]')).filter(function (d) {
        return d.getAttribute("data-metricas-type") != null && d.getAttribute("data-metricas-type") !== "" && d.getAttribute("data-metricas-type") === "click";
    }).map(function (obj) {
        if (obj.getAttribute("data-metricas-categoria") != null && obj.getAttribute("data-metricas-categoria") != "" && obj.getAttribute("data-metricas-etiqueta") != null && obj.getAttribute("data-metricas-etiqueta") != "") {
            // Home , Footer , Header , Nota , etc
            var categoria = obj.getAttribute("data-metricas-categoria");
            // click
            var tipoEvento = obj.getAttribute("data-metricas-type");
            // Politica, inflacion , pronostico , etc 
            var etiqueta = obj.getAttribute("data-metricas-etiqueta");
            obj.addEventListener("click", function () {
                if (window.dataLayer != undefined) {
                    window.dataLayer.push({ 'event': 'trackEvent', 'eventCategory': categoria, 'eventAction': tipoEvento, 'eventLabel': etiqueta, 'nonInteraction': false });
                }
            });
        }
    });
};

var createDatalayer = exports.createDatalayer = function createDatalayer() {
    var metaRefresh = localStorage.getItem("CDmetaRefresh");
    var usuarioLogeado = localStorage.getItem("CDusuarioLogeado");
    var credentialType = localStorage.getItem("CDcredentialType");
    var payUser = localStorage.getItem("CDpayUser");
    var suscriptorType = localStorage.getItem("CDsuscriptorType");
    var userId = localStorage.getItem("CDuserId");
    var usuarioRegistrado = localStorage.getItem("CDusuarioRegistrado");
    //   let notasLeidas = localStorage.getItem("CDnotasLeidas");
    var countNotas = localStorage.getItem("countNotas");
    var naveggObj = {};
    var navegData = localStorage.getItem("nvgpersona18894");
    if (navegData != null) {
        naveggObj = JSON.parse(navegData);
    }

    metaRefresh = metaRefresh != null ? "yes" : "no";
    usuarioLogeado = usuarioLogeado ? usuarioLogeado : "no";
    credentialType = credentialType ? credentialType : "N/A";
    payUser = payUser ? payUser : "no";
    suscriptorType = suscriptorType ? suscriptorType : "N/A";
    userId = userId ? userId : "N/A";
    usuarioRegistrado = usuarioRegistrado ? usuarioRegistrado : "no";
    //notasLeidas = notasLeidas ? notasLeidas : 0;
    countNotas = countNotas ? countNotas : 0;

    if (metaRefresh === "yes") {
        localStorage.removeItem("CDmetaRefresh");
    }
    var datalayerDom = document.querySelector('div[data-layer]');
    window.dataLayer = [{
        "metarefresh": metaRefresh,
        "pageType": datalayerDom.getAttribute('data-pageType').toString(),
        "mainTag": datalayerDom.getAttribute('data-mainTag').toString(),
        "tags": datalayerDom.getAttribute('data-tags').toString(),
        "autor": datalayerDom.getAttribute('data-autor').toString(),
        "seccion": datalayerDom.getAttribute('data-seccion').toString(),
        "longitud": datalayerDom.getAttribute('data-longitud').toString(),
        "formato": datalayerDom.getAttribute('data-formato').toString(),
        "genero": datalayerDom.getAttribute('data-genero').toString(),
        "tematica": datalayerDom.getAttribute('data-tematica').toString(),
        "valor": datalayerDom.getAttribute('data-valor').toString()
    }];
    window.dataLayer[0].usuarioLogeado = usuarioLogeado;
    window.dataLayer[0].credentialType = credentialType;
    window.dataLayer[0].payUser = payUser;
    window.dataLayer[0].suscriptorType = suscriptorType;
    window.dataLayer[0].userId = userId;
    window.dataLayer[0].usuarioRegistrado = usuarioRegistrado;
    ///TODO : Pasar a configuracion, no se hace ahora porq se pide con urgencia.
    var navegItems = ["age", "career", "city", "country", "income", "education", "gender", "industry", "interest", "marital"];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = navegItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var itemProp = _step.value;

            if (naveggObj.hasOwnProperty(itemProp)) {
                window.dataLayer[0][itemProp] = naveggObj[itemProp];
            } else {
                window.dataLayer[0][itemProp] = "N/A";
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    if (datalayerDom.getAttribute('data-pageType').toString() === "nota") {
        window.dataLayer[0].notasLeidas = countNotas;
        // dataLayer[0].countNotas = countNotas;
    }

    function clean(obj) {
        var propNames = Object.getOwnPropertyNames(obj);
        for (var i = 0; i < propNames.length; i++) {
            var propName = propNames[i];
            if (obj[propName] === "" || obj[propName] === null || obj[propName] === undefined || obj[propName] === "0") {
                delete obj[propName];
            }
        }
    }
    clean(window.dataLayer[0]);
};

var googleOptimazerHead = exports.googleOptimazerHead = function googleOptimazerHead() {
    (function (a, s, y, n, c, h, i, d, e) {
        s.className += ' ' + y;
        h.end = i = function i() {
            s.className = s.className.replace(RegExp(' ?' + y), '');
        };
        (a[n] = a[n] || []).hide = h;setTimeout(function () {
            i();h.end = null;
        }, c);
    })(window, document.documentElement, 'async-hide', 'dataLayer', 4000, { 'GTM-GHV6': true });
};

var tagManagerHead = exports.tagManagerHead = function tagManagerHead() {
    (function (w, d, s, l, i) {
        w[l] = w[l] || [];w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-GHV6');
};

/***/ }),
/* 43 */,
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.render = render;

var _video = __webpack_require__(47);

var _video2 = _interopRequireDefault(_video);

__webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var jwplayer = window.jwplayer;
//jwplayer.key = "rgP22Py/jYzmXcg4SWRmPOsIvMZfZ8yx/nnong==";

//import jwplayer from "../../../libs/jwplayer-7.6/jwplayer";
jwplayer.key = "tKafT/E+mI/GayzyW3yBtpLleVrJr9bZ0SCgLw==";
//window.jwplayer = jwplayer;

function render(nodo, video_id, multimediofileId, multimedioJWKey, multimediofileJWKey, videoDestacado, showAds, autoPlay, arrayTags, videoTag_Home, contenedor, titulo) {
    var nodoId = "jwVideo" + multimediofileId,
        playlistUrlBase = _video2.default.playlistUrlBase,
        settings = _video2.default.settings; //new LN.conf.video.settings();

    if (multimedioJWKey) {
        /* Es una playlist */
        settings.playlist = playlistUrlBase + multimedioJWKey + ".xml";
        //settings.skin = undefined;
    } else if (multimediofileJWKey) {
        /* Es un video */
        settings.playlist = playlistUrlBase + multimediofileJWKey + ".xml";
    }

    //TODO: SHARING FUNCTION (<iframe>)---------------------------------------------------------------------------------------------------
    //if (video_id != '' && settings.sharing.code ){ 
    //    settings.sharing.code = '<iframe src="' + document.location.origin + '/herramientas/modal-video/-multimedio_id=' + video_id + '" width="100%" height="650"/>'
    //}

    //if (settings.sharing.link && settings.sharing.link.indexOf('http://') != 0)
    //    settings.sharing.link = document.location.origin + settings.sharing.link;
    //-------------------------------------------------------------------------------------------------------------------------------------

    //TODO: VER EL TEMA DE LOS ADS EN LOS VIDEOS------------------------------------------------------------------------------------------
    if (showAds != undefined && showAds == 0 || window.innerWidth > 1359 && window.LN.tipoPaginaBanner == "home") {
        settings.advertising = {};
    } else {
        settings.advertising.schedule = ads.getVideoURL("vmap");
        //settings.advertising.schedule.postroll.tag = window.JW.ads.getVideoURL("vast","postroll");   
    }

    nodo.innerHTML += '<div id="' + nodoId + '"></div>';

    if (autoPlay === true) {
        settings.autostart = true;
    } else {
        settings.autostart = false;
    }
    var player = jwplayer(nodoId).setup(settings);
    //TODO: GOOGLE ANALYTICS---------------------------------------------------------------------------------------------------
    //let eventosParametro = video_id.toString();
    //contenedor.toString();


    player.on('adPlay', function () {
        if (isInDatalayerEvent(video_id, 'videoPlay', dataLayer)) dataLayer.push({ 'event': 'videoPlay', 'videoName': titulo, 'videoTags': arrayTags, 'videoID': video_id });
    });

    player.on("play", function (data) {
        //if (data.oldState === "buffering" && player.getPosition() === 0 && isInDatalayerEvent(video_id, dataLayer)) {
        if (isInDatalayerEvent(video_id, 'videoPlay', dataLayer)) {
            dataLayer.push({ 'event': 'videoPlay', 'videoName': titulo, 'videoTags': arrayTags, 'videoID': video_id });
        }
    });

    player.on("time", function (event) {
        var percent = Math.floor(100 * event.position / event.duration);
        switch (percent) {
            case 25:
                if (isInDatalayerEvent(video_id, '25', dataLayer)) {
                    dataLayer.push({ 'event': '25', 'videoName': titulo, 'videoTags': arrayTags, 'videoID': video_id });
                }
                break;
            case 50:
                if (isInDatalayerEvent(video_id, '50', dataLayer)) {
                    dataLayer.push({ 'event': '50', 'videoName': titulo, 'videoTags': arrayTags, 'videoID': video_id });
                }
                break;
            case 75:
                if (isInDatalayerEvent(video_id, '75', dataLayer)) {
                    dataLayer.push({ 'event': '75', 'videoName': titulo, 'videoTags': arrayTags, 'videoID': video_id });
                }
                break;
            default:
        }
    });
    //player.on("complete", function () {
    //    ga("send", "event", "Video-Nativo", "complete", eventosParametro, { 'dimension10': contenedor });
    //});
    //-------------------------------------------------------------------------------------------------------------------
    player.on("complete", function () {
        if (dataLayer) {
            dataLayer.push({ 'event': 'videoComplete', 'videoName': titulo, 'videoTags': arrayTags, 'videoID': video_id });
        }
    });

    //PLAYLIST-----------------------------------------------------------------------------------------------------------
    if (multimedioJWKey) {
        /* Dar formato a la playlist */
        player.on("ready", function () {
            var html = "";
            var playlist = player.getPlaylist();
            //console.log(playlist.length);
            //if (playlist.length > 1) {
            if (playlist.length > 1) {
                for (var index = 0; index < playlist.length; index++) {
                    html += "<a href='javascript:void(0)' onclick='javascript:playVideoPlayList(\"" + nodoId + "\", " + index + ")'>";
                    html += "<span class='play-list icon-play'></span>" + "<p>" + playlist[index].title + "</p>";
                    html += "</a>";
                }

                var elemDiv = document.createElement("div");
                elemDiv.setAttribute("class", "playlist-generico");
                elemDiv.setAttribute("id", "PlayList-" + video_id);
                document.getElementById("videoContainerVideo-" + video_id).appendChild(elemDiv);

                document.getElementById("PlayList-" + video_id).innerHTML = html;
            }
            //}
        });
    }

    if (dataLayer) {
        //indica que se dibujo un video
        dataLayer.push({ 'event': 'videoDisplay', 'videoName': titulo, 'videoTags': arrayTags, 'videoID': video_id });
    }

    //-------------------------------------------------------------------------------------------------------------------
    //  ga('send', 'event', 'Video-Nativo', 'Embed', eventosParametro, { 'dimension10': contenedor });
    return nodo;
}

function isInDatalayerEvent(video_id, event, datalayer) {
    var array = datalayer.filter(function (element) {
        if (element['event'] == event && element['videoID'] == video_id) return element;
    });

    return array.length > 0 ? false : true;
}

//function areAdsShowed(settings, showAds) {
//    if (showAds != undefined && showAds == 0)
//    {
//        settings.advertising = undefined;
//    }
//    else
//    {
//        settings.advertising.schedule.myAds.tag = ads.getVideoURL("vast", "preroll");
//        settings.advertising.schedule.postroll.tag = ads.getVideoURL("vast","postroll");   
//    }

//    return settings;
//}

function playVideoPlayList(nodoId, index) {
    var player = jwplayer(nodoId);
    player.playlistItem(index);
}
window.playVideoPlayList = playVideoPlayList;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initialize = undefined;

var _jwplayerRender = __webpack_require__(44);

var Jwp = _interopRequireWildcard(_jwplayerRender);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialize = exports.initialize = function initialize() {
    //todo: como se cargan asincronicamente tengo que esperar que las variables esten llenas. Pero una vez que este importado en el proyecto se elimina el interval.
    var interval = setInterval(function () {
        if (window.JW != undefined && window.JW.ads != undefined && window.JW.ads != null || window.innerWidth > 1359) {
            clearInterval(interval);
            var videos = Array.from(document.getElementsByClassName("videoAside"));

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = videos[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var video = _step.value;

                    var videoId = video.getAttribute("data-video_id"),
                        multimediofileId = video.getAttribute("data-multimediofile_id"),
                        multimediofileJWKey = video.getAttribute("data-jwkey"),
                        multimedioJWKey = video.getAttribute("data-multimediojwkey"),
                        videoDestacado = video.getAttribute("data-destacado"),
                        showAds = video.getAttribute("data-showads"),
                        arrayTags = video.getAttribute("data-arraytags"),
                        videoTagHome = video.getAttribute("data-videotag_home"),
                        contenedor = video.getAttribute("data-contenedor"),
                        titulo = video.getAttribute("data-titulo"),
                        autoPlay = video.getAttribute("data-autoplay") === 1;

                    if (videoId && multimediofileId) {
                        Jwp.render(video, videoId, multimediofileId, multimedioJWKey, multimediofileJWKey, !!videoDestacado, showAds, autoPlay, arrayTags, videoTagHome, contenedor, titulo);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }, 2000);
};

/***/ }),
/* 46 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function() {

"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

window.jwplayer = function (e) {
  function t(n) {
    if (r[n]) return r[n].exports;var i = r[n] = { i: n, l: !1, exports: {} };return e[n].call(i.exports, i, i.exports, t), i.l = !0, i.exports;
  }var n = window.webpackJsonpjwplayer;window.webpackJsonpjwplayer = function (t, r, o) {
    for (var a, u, c = 0, s = []; c < t.length; c++) {
      u = t[c], i[u] && s.push(i[u][0]), i[u] = 0;
    }for (a in r) {
      Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }for (n && n(t, r, o); s.length;) {
      s.shift()();
    }
  };var r = {},
      i = { 16: 0 };return t.e = function (e) {
    function n() {
      u.onerror = u.onload = null, clearTimeout(c);var t = i[e];0 !== t && (t && t[1](new Error("Loading chunk " + e + " failed.")), i[e] = void 0);
    }var r = i[e];if (0 === r) return new Promise(function (e) {
      e();
    });if (r) return r[2];var o = new Promise(function (t, n) {
      r = i[e] = [t, n];
    });r[2] = o;var a = document.getElementsByTagName("head")[0],
        u = document.createElement("script");u.type = "text/javascript", u.charset = "utf-8", u.async = !0, u.timeout = 35e3, t.nc && u.setAttribute("nonce", t.nc), u.src = t.p + "" + ({ 0: "jwplayer.core.controls.polyfills.html5", 1: "jwplayer.core.controls.html5", 2: "jwplayer.core.controls.polyfills", 3: "jwplayer.core.controls", 4: "jwplayer.controls", 5: "provider.shaka", 6: "provider.hlsjs", 7: "provider.html5", 8: "jwplayer.core", 9: "provider.flash", 10: "polyfills.intersection-observer", 11: "jwplayer.vr", 12: "provider.cast", 13: "vttparser", 14: "provider.airplay", 15: "polyfills.webvtt" }[e] || e) + ".js";var c = setTimeout(n, 35e3);return u.onerror = u.onload = n, a.appendChild(u), o;
  }, t.m = e, t.c = r, t.d = function (e, n, r) {
    t.o(e, n) || Object.defineProperty(e, n, { configurable: !1, enumerable: !0, get: r });
  }, t.n = function (e) {
    var n = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };return t.d(n, "a", n), n;
  }, t.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, t.p = "", t.oe = function (e) {
    throw console.error(e), e;
  }, t(t.s = 53);
}([function (e, t, n) {
  "use strict";
  n.d(t, "a", function () {
    return P;
  }), n.d(t, "b", function () {
    return T;
  });var r = n(23),
      i = {},
      o = Array.prototype,
      a = Object.prototype,
      u = Function.prototype,
      c = o.slice,
      s = o.concat,
      l = a.toString,
      f = a.hasOwnProperty,
      d = o.map,
      p = o.reduce,
      v = o.forEach,
      h = o.filter,
      m = o.every,
      g = o.some,
      y = o.indexOf,
      b = Array.isArray,
      w = Object.keys,
      j = u.bind,
      O = function e(t) {
    return t instanceof e ? t : this instanceof e ? void 0 : new e(t);
  },
      k = O.each = O.forEach = function (e, t, n) {
    var r, o;if (null == e) return e;if (v && e.forEach === v) e.forEach(t, n);else if (e.length === +e.length) {
      for (r = 0, o = e.length; r < o; r++) {
        if (t.call(n, e[r], r, e) === i) return;
      }
    } else {
      var a = O.keys(e);for (r = 0, o = a.length; r < o; r++) {
        if (t.call(n, e[a[r]], a[r], e) === i) return;
      }
    }return e;
  };O.map = O.collect = function (e, t, n) {
    var r = [];return null == e ? r : d && e.map === d ? e.map(t, n) : (k(e, function (e, i, o) {
      r.push(t.call(n, e, i, o));
    }), r);
  };O.reduce = O.foldl = O.inject = function (e, t, n, r) {
    var i = arguments.length > 2;if (null == e && (e = []), p && e.reduce === p) return r && (t = O.bind(t, r)), i ? e.reduce(t, n) : e.reduce(t);if (k(e, function (e, o, a) {
      i ? n = t.call(r, n, e, o, a) : (n = e, i = !0);
    }), !i) throw new TypeError("Reduce of empty array with no initial value");return n;
  }, O.find = O.detect = function (e, t, n) {
    var r;return C(e, function (e, i, o) {
      if (t.call(n, e, i, o)) return r = e, !0;
    }), r;
  }, O.filter = O.select = function (e, t, n) {
    var r = [];return null == e ? r : h && e.filter === h ? e.filter(t, n) : (k(e, function (e, i, o) {
      t.call(n, e, i, o) && r.push(e);
    }), r);
  }, O.reject = function (e, t, n) {
    return O.filter(e, function (e, r, i) {
      return !t.call(n, e, r, i);
    }, n);
  }, O.compact = function (e) {
    return O.filter(e, O.identity);
  }, O.every = O.all = function (e, t, n) {
    t || (t = O.identity);var r = !0;return null == e ? r : m && e.every === m ? e.every(t, n) : (k(e, function (e, o, a) {
      if (!(r = r && t.call(n, e, o, a))) return i;
    }), !!r);
  };var C = O.some = O.any = function (e, t, n) {
    t || (t = O.identity);var r = !1;return null == e ? r : g && e.some === g ? e.some(t, n) : (k(e, function (e, o, a) {
      if (r || (r = t.call(n, e, o, a))) return i;
    }), !!r);
  };O.size = function (e) {
    return null == e ? 0 : e.length === +e.length ? e.length : O.keys(e).length;
  }, O.last = function (e, t, n) {
    if (null != e) return null == t || n ? e[e.length - 1] : c.call(e, Math.max(e.length - t, 0));
  }, O.after = function (e, t) {
    return function () {
      if (--e < 1) return t.apply(this, arguments);
    };
  }, O.before = function (e, t) {
    var n;return function () {
      return --e > 0 && (n = t.apply(this, arguments)), e <= 1 && (t = null), n;
    };
  };var x = function x(e) {
    return null == e ? O.identity : O.isFunction(e) ? e : O.property(e);
  },
      E = function E(e) {
    return function (t, n, r) {
      var i = {};return n = x(n), k(t, function (o, a) {
        var u = n.call(r, o, a, t);e(i, u, o);
      }), i;
    };
  };O.groupBy = E(function (e, t, n) {
    O.has(e, t) ? e[t].push(n) : e[t] = [n];
  }), O.indexBy = E(function (e, t, n) {
    e[t] = n;
  }), O.sortedIndex = function (e, t, n, r) {
    n = x(n);for (var i = n.call(r, t), o = 0, a = e.length; o < a;) {
      var u = o + a >>> 1;n.call(r, e[u]) < i ? o = u + 1 : a = u;
    }return o;
  }, O.contains = O.include = function (e, t) {
    return null != e && (e.length !== +e.length && (e = O.values(e)), O.indexOf(e, t) >= 0);
  }, O.pluck = function (e, t) {
    return O.map(e, O.property(t));
  }, O.where = function (e, t) {
    return O.filter(e, O.matches(t));
  }, O.findWhere = function (e, t) {
    return O.find(e, O.matches(t));
  }, O.max = function (e, t, n) {
    if (!t && O.isArray(e) && e[0] === +e[0] && e.length < 65535) return Math.max.apply(Math, e);var r = -1 / 0,
        i = -1 / 0;return k(e, function (e, o, a) {
      var u = t ? t.call(n, e, o, a) : e;u > i && (r = e, i = u);
    }), r;
  }, O.difference = function (e) {
    var t = s.apply(o, c.call(arguments, 1));return O.filter(e, function (e) {
      return !O.contains(t, e);
    });
  }, O.without = function (e) {
    return O.difference(e, c.call(arguments, 1));
  }, O.indexOf = function (e, t, n) {
    if (null == e) return -1;var r = 0,
        i = e.length;if (n) {
      if ("number" != typeof n) return r = O.sortedIndex(e, t), e[r] === t ? r : -1;r = n < 0 ? Math.max(0, i + n) : n;
    }if (y && e.indexOf === y) return e.indexOf(t, n);for (; r < i; r++) {
      if (e[r] === t) return r;
    }return -1;
  };var S = function S() {};O.bind = function (e, t) {
    var n, _r;if (j && e.bind === j) return j.apply(e, c.call(arguments, 1));if (!O.isFunction(e)) throw new TypeError();return n = c.call(arguments, 2), _r = function r() {
      if (!(this instanceof _r)) return e.apply(t, n.concat(c.call(arguments)));S.prototype = e.prototype;var i = new S();S.prototype = null;var o = e.apply(i, n.concat(c.call(arguments)));return Object(o) === o ? o : i;
    };
  }, O.partial = function (e) {
    var t = c.call(arguments, 1);return function () {
      for (var n = 0, r = t.slice(), i = 0, o = r.length; i < o; i++) {
        r[i] === O && (r[i] = arguments[n++]);
      }for (; n < arguments.length;) {
        r.push(arguments[n++]);
      }return e.apply(this, r);
    };
  }, O.once = O.partial(O.before, 2), O.memoize = function (e, t) {
    var n = {};return t || (t = O.identity), function () {
      var r = t.apply(this, arguments);return O.has(n, r) ? n[r] : n[r] = e.apply(this, arguments);
    };
  }, O.delay = function (e, t) {
    var n = c.call(arguments, 2);return setTimeout(function () {
      return e.apply(null, n);
    }, t);
  }, O.defer = function (e) {
    return O.delay.apply(O, [e, 1].concat(c.call(arguments, 1)));
  }, O.throttle = function (e, t, n) {
    var i,
        o,
        a,
        u = null,
        c = 0;n || (n = {});var s = function s() {
      c = !1 === n.leading ? 0 : Object(r.a)(), u = null, a = e.apply(i, o), i = o = null;
    };return function () {
      c || !1 !== n.leading || (c = r.a);var l = t - (r.a - c);return i = this, o = arguments, l <= 0 ? (clearTimeout(u), u = null, c = r.a, a = e.apply(i, o), i = o = null) : u || !1 === n.trailing || (u = setTimeout(s, l)), a;
    };
  }, O.keys = function (e) {
    if (!O.isObject(e)) return [];if (w) return w(e);var t = [];for (var n in e) {
      O.has(e, n) && t.push(n);
    }return t;
  }, O.invert = function (e) {
    for (var t = {}, n = O.keys(e), r = 0, i = n.length; r < i; r++) {
      t[e[n[r]]] = n[r];
    }return t;
  }, O.defaults = function (e) {
    return k(c.call(arguments, 1), function (t) {
      if (t) for (var n in t) {
        void 0 === e[n] && (e[n] = t[n]);
      }
    }), e;
  }, O.extend = function (e) {
    return k(c.call(arguments, 1), function (t) {
      if (t) for (var n in t) {
        e[n] = t[n];
      }
    }), e;
  }, O.pick = function (e) {
    var t = {},
        n = s.apply(o, c.call(arguments, 1));return k(n, function (n) {
      n in e && (t[n] = e[n]);
    }), t;
  }, O.omit = function (e) {
    var t = {},
        n = s.apply(o, c.call(arguments, 1));for (var r in e) {
      O.contains(n, r) || (t[r] = e[r]);
    }return t;
  }, O.clone = function (e) {
    return O.isObject(e) ? O.isArray(e) ? e.slice() : O.extend({}, e) : e;
  }, O.isArray = b || function (e) {
    return "[object Array]" == l.call(e);
  }, O.isObject = function (e) {
    return e === Object(e);
  }, k(["Function", "String", "Number", "Date", "RegExp"], function (e) {
    O["is" + e] = function (t) {
      return l.call(t) == "[object " + e + "]";
    };
  }), O.isFunction = function (e) {
    return "function" == typeof e;
  }, O.isFinite = function (e) {
    return isFinite(e) && !isNaN(parseFloat(e));
  };var P = O.isNaN = function (e) {
    return O.isNumber(e) && e != +e;
  };O.isBoolean = function (e) {
    return !0 === e || !1 === e || "[object Boolean]" == l.call(e);
  }, O.isNull = function (e) {
    return null === e;
  }, O.isUndefined = function (e) {
    return void 0 === e;
  }, O.has = function (e, t) {
    return f.call(e, t);
  }, O.identity = function (e) {
    return e;
  }, O.constant = function (e) {
    return function () {
      return e;
    };
  }, O.property = function (e) {
    return function (t) {
      return t[e];
    };
  }, O.propertyOf = function (e) {
    return null == e ? function () {} : function (t) {
      return e[t];
    };
  }, O.matches = function (e) {
    return function (t) {
      if (t === e) return !0;for (var n in e) {
        if (e[n] !== t[n]) return !1;
      }return !0;
    };
  }, O.now = r.a, O.result = function (e, t) {
    if (null != e) {
      var n = e[t];return O.isFunction(n) ? n.call(e) : n;
    }
  };var T = O.isNumber;t.c = O;
}, function (e, t, n) {
  "use strict";
  function r() {}function i(e, t) {
    return function () {
      e.apply(t, arguments);
    };
  }function o(e) {
    if ("object" !== d(this)) throw new TypeError("Promises must be constructed via new");if ("function" != typeof e) throw new TypeError("not a function");this._state = 0, this._handled = !1, this._value = void 0, this._deferreds = [], f(e, this);
  }function a(e, t) {
    for (; 3 === e._state;) {
      e = e._value;
    }if (0 === e._state) return void e._deferreds.push(t);e._handled = !0, o._immediateFn(function () {
      var n = 1 === e._state ? t.onFulfilled : t.onRejected;if (null === n) return void (1 === e._state ? u : c)(t.promise, e._value);var r;try {
        r = n(e._value);
      } catch (e) {
        return void c(t.promise, e);
      }u(t.promise, r);
    });
  }function u(e, t) {
    try {
      if (t === e) throw new TypeError("A promise cannot be resolved with itself.");if (t && ("object" === (void 0 === t ? "undefined" : d(t)) || "function" == typeof t)) {
        var n = t.then;if (t instanceof o) return e._state = 3, e._value = t, void s(e);if ("function" == typeof n) return void f(i(n, t), e);
      }e._state = 1, e._value = t, s(e);
    } catch (t) {
      c(e, t);
    }
  }function c(e, t) {
    e._state = 2, e._value = t, s(e);
  }function s(e) {
    2 === e._state && 0 === e._deferreds.length && o._immediateFn(function () {
      e._handled || o._unhandledRejectionFn(e._value);
    });for (var t = 0, n = e._deferreds.length; t < n; t++) {
      a(e, e._deferreds[t]);
    }e._deferreds = null;
  }function l(e, t, n) {
    this.onFulfilled = "function" == typeof e ? e : null, this.onRejected = "function" == typeof t ? t : null, this.promise = n;
  }function f(e, t) {
    var n = !1;try {
      e(function (e) {
        n || (n = !0, u(t, e));
      }, function (e) {
        n || (n = !0, c(t, e));
      });
    } catch (e) {
      if (n) return;n = !0, c(t, e);
    }
  }n.d(t, "b", function () {
    return m;
  });var d = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
    return typeof e === "undefined" ? "undefined" : _typeof(e);
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : _typeof(e);
  },
      p = window.setTimeout,
      v = window.setImmediate;o.prototype.catch = function (e) {
    return this.then(null, e);
  }, o.prototype.then = function (e, t) {
    var n = new this.constructor(r);return a(this, new l(e, t, n)), n;
  }, o.all = function (e) {
    var t = Array.prototype.slice.call(e);return new o(function (e, n) {
      function r(o, a) {
        try {
          if (a && ("object" === (void 0 === a ? "undefined" : d(a)) || "function" == typeof a)) {
            var u = a.then;if ("function" == typeof u) return void u.call(a, function (e) {
              r(o, e);
            }, n);
          }t[o] = a, 0 == --i && e(t);
        } catch (e) {
          n(e);
        }
      }if (0 === t.length) return e([]);for (var i = t.length, o = 0; o < t.length; o++) {
        r(o, t[o]);
      }
    });
  }, o.resolve = function (e) {
    return e && "object" === (void 0 === e ? "undefined" : d(e)) && e.constructor === o ? e : new o(function (t) {
      t(e);
    });
  }, o.reject = function (e) {
    return new o(function (t, n) {
      n(e);
    });
  }, o.race = function (e) {
    return new o(function (t, n) {
      for (var r = 0, i = e.length; r < i; r++) {
        e[r].then(t, n);
      }
    });
  }, o._immediateFn = "function" == typeof v && function (e) {
    v(e);
  } || function (e) {
    p(e, 0);
  }, o._unhandledRejectionFn = function (e) {
    "undefined" != typeof console && console && console.warn("Possible Unhandled Promise Rejection:", e);
  };var h = window.Promise || (window.Promise = o),
      m = h.resolve();t.a = h;
}, function (e, t, n) {
  "use strict";
  function r(e) {
    return e.replace(/^\s+|\s+$/g, "");
  }function i(e, t, n) {
    for (e = "" + e, n = n || "0"; e.length < t;) {
      e = n + e;
    }return e;
  }function o(e, t) {
    for (var n = 0; n < e.attributes.length; n++) {
      if (e.attributes[n].name && e.attributes[n].name.toLowerCase() === t.toLowerCase()) return e.attributes[n].value.toString();
    }return "";
  }function a(e) {
    return (/[(,]format=m3u8-/i.test(e) ? "m3u8" : !!/[(,]format=mpd-/i.test(e) && "mpd"
    );
  }function u(e) {
    if (!e || "rtmp" === e.substr(0, 4)) return "";var t = a(e);return t || (e = e.split("?")[0].split("#")[0], e.lastIndexOf(".") > -1 ? e.substr(e.lastIndexOf(".") + 1, e.length).toLowerCase() : void 0);
  }function c(e) {
    var t = parseInt(e / 3600),
        n = parseInt(e / 60) % 60,
        r = e % 60;return i(t, 2) + ":" + i(n, 2) + ":" + i(r.toFixed(3), 6);
  }function s(e, t) {
    if (!e) return 0;if (p.c.isNumber(e) && !p.c.isNaN(e)) return e;e = e.replace(",", ".");var n = e.split(":"),
        r = n.length,
        i = 0;if ("s" === e.slice(-1)) i = parseFloat(e);else if ("m" === e.slice(-1)) i = 60 * parseFloat(e);else if ("h" === e.slice(-1)) i = 3600 * parseFloat(e);else if (r > 1) {
      var o = r - 1;4 === r && (t && (i = parseFloat(n[o]) / t), o -= 1), i += parseFloat(n[o]), i += 60 * parseFloat(n[o - 1]), r >= 3 && (i += 3600 * parseFloat(n[o - 2]));
    } else i = parseFloat(e);return p.c.isNaN(i) ? 0 : i;
  }function l(e, t, n) {
    if (p.c.isString(e) && "%" === e.slice(-1)) {
      var r = parseFloat(e);return !t || isNaN(t) || isNaN(r) ? null : t * r / 100;
    }return s(e, n);
  }function f(e, t) {
    return p.c.map(e, function (e) {
      return t + e;
    });
  }function d(e, t) {
    return p.c.map(e, function (e) {
      return e + t;
    });
  }t.h = r, t.d = i, t.i = o, t.a = u, t.b = c, t.f = s, t.c = l, t.e = f, t.g = d;var p = n(0);
},,, function (e, t, n) {
  "use strict";
  n.d(t, "_2", function () {
    return r;
  }), n.d(t, "_5", function () {
    return i;
  }), n.d(t, "_3", function () {
    return o;
  }), n.d(t, "_7", function () {
    return a;
  }), n.d(t, "_8", function () {
    return u;
  }), n.d(t, "_4", function () {
    return c;
  }), n.d(t, "_6", function () {
    return s;
  }), n.d(t, "_9", function () {
    return l;
  }), n.d(t, "m", function () {
    return f;
  }), n.d(t, "o", function () {
    return d;
  }), n.d(t, "n", function () {
    return p;
  }), n.d(t, "h", function () {
    return v;
  }), n.d(t, "k", function () {
    return h;
  }), n.d(t, "_10", function () {
    return m;
  }), n.d(t, "l", function () {
    return g;
  }), n.d(t, "R", function () {
    return y;
  }), n.d(t, "O", function () {
    return b;
  }), n.d(t, "p", function () {
    return w;
  }), n.d(t, "Q", function () {
    return j;
  }), n.d(t, "q", function () {
    return O;
  }), n.d(t, "a", function () {
    return k;
  }), n.d(t, "y", function () {
    return C;
  }), n.d(t, "Z", function () {
    return x;
  }), n.d(t, "I", function () {
    return E;
  }), n.d(t, "v", function () {
    return S;
  }), n.d(t, "u", function () {
    return P;
  }), n.d(t, "x", function () {
    return T;
  }), n.d(t, "j", function () {
    return _;
  }), n.d(t, "U", function () {
    return N;
  }), n.d(t, "g", function () {
    return L;
  }), n.d(t, "z", function () {
    return A;
  }), n.d(t, "A", function () {
    return M;
  }), n.d(t, "F", function () {
    return F;
  }), n.d(t, "G", function () {
    return I;
  }), n.d(t, "J", function () {
    return R;
  }), n.d(t, "_1", function () {
    return B;
  }), n.d(t, "T", function () {
    return q;
  }), n.d(t, "w", function () {
    return D;
  }), n.d(t, "K", function () {
    return Q;
  }), n.d(t, "H", function () {
    return X;
  }), n.d(t, "L", function () {
    return z;
  }), n.d(t, "N", function () {
    return V;
  }), n.d(t, "E", function () {
    return W;
  }), n.d(t, "D", function () {
    return H;
  }), n.d(t, "B", function () {
    return U;
  }), n.d(t, "C", function () {
    return J;
  }), n.d(t, "M", function () {
    return $;
  }), n.d(t, "i", function () {
    return K;
  }), n.d(t, "r", function () {
    return Y;
  }), n.d(t, "_0", function () {
    return G;
  }), n.d(t, "V", function () {
    return Z;
  }), n.d(t, "W", function () {
    return ee;
  }), n.d(t, "b", function () {
    return te;
  }), n.d(t, "c", function () {
    return ne;
  }), n.d(t, "S", function () {
    return re;
  }), n.d(t, "t", function () {
    return ie;
  }), n.d(t, "f", function () {
    return oe;
  }), n.d(t, "e", function () {
    return ae;
  }), n.d(t, "X", function () {
    return ue;
  }), n.d(t, "Y", function () {
    return ce;
  }), n.d(t, "_11", function () {
    return se;
  }), n.d(t, "s", function () {
    return le;
  }), n.d(t, "d", function () {
    return fe;
  }), n.d(t, "P", function () {
    return de;
  });var r = "buffering",
      i = "idle",
      o = "complete",
      a = "paused",
      u = "playing",
      c = "error",
      s = "loading",
      l = "stalled",
      f = "drag",
      d = "dragStart",
      p = "dragEnd",
      v = "click",
      h = "doubleClick",
      m = "tap",
      g = "doubleTap",
      y = "over",
      b = "move",
      w = "enter",
      j = "out",
      O = c,
      k = "adSkipped",
      C = o,
      x = "ready",
      E = "seek",
      S = "beforePlay",
      P = "beforeComplete",
      T = "bufferFull",
      _ = "displayClick",
      N = "playlistComplete",
      L = "cast",
      A = "mediaError",
      M = "firstFrame",
      F = "playAttempt",
      I = "playAttemptFailed",
      R = "seeked",
      B = "setupError",
      q = "state",
      D = "bufferChange",
      Q = "time",
      X = "ratechange",
      z = "mediaType",
      V = "volume",
      W = "mute",
      H = "meta",
      U = "levels",
      J = "levelsChanged",
      $ = "visualQuality",
      K = "controls",
      Y = "fullscreen",
      G = "resize",
      Z = "playlistItem",
      ee = "playlist",
      te = "audioTracks",
      ne = "audioTrackChanged",
      re = "playbackRateChanged",
      ie = "logoClick",
      oe = "captionsList",
      ae = "captionsChanged",
      ue = "providerChanged",
      ce = "providerFirstFrame",
      se = "userAction",
      le = "instreamClick",
      fe = "breakpoint",
      de = "fullscreenchange";
}, function (e, t, n) {
  "use strict";
  function r(e, t) {
    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [];if (l.a.debug) return e.apply(t || this, n);try {
      return e.apply(t || this, n);
    } catch (t) {
      return new i(e.name, t);
    }
  }function i(e, t) {
    this.name = e, this.message = t.message || t.toString(), this.error = t;
  }var o = n(16),
      a = n(11),
      u = n(12),
      c = n(2),
      s = n(21),
      l = n(15),
      f = n(0),
      d = n(29),
      p = n(25),
      v = n(26),
      h = n(51);n.d(t, "b", function () {
    return g;
  });var m = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }return e;
  },
      g = "function" == typeof console.log ? console.log.bind(console) : function () {},
      y = function y(e, t, n) {
    return Math.max(Math.min(e, n), t);
  },
      b = function b(e, t) {
    for (var n in e) {
      Object.prototype.hasOwnProperty.call(e, n) && t(n, e[n]);
    }
  },
      w = f.c.indexOf,
      j = function j() {},
      O = m({}, u, a, o, { addClass: p.a, hasClass: p.h, removeClass: p.j, replaceClass: p.k, toggleClass: p.m, classList: p.d, styleDimension: p.l, createElement: p.e, emptyElement: p.g, addStyleSheet: p.b, bounds: p.c, css: v.b, clearCss: v.a, style: v.d, transform: v.e, getRgba: v.c, ajax: h.a, crossdomain: h.b, tryCatch: r, Error: i, Timer: s.a, log: g, between: y, foreach: b, flashVersion: d.a, isIframe: d.m, indexOf: w, trim: c.h, pad: c.d, extension: c.a, hms: c.b, seconds: c.f, prefix: c.e, suffix: c.g, noop: j });t.a = O;
}, function (e, t, n) {
  "use strict";
  function r(e, t, n) {
    if (!c(this, "on", e, [t, n]) || !t) return this;var r = this._events || (this._events = {});return (r[e] || (r[e] = [])).push({ callback: t, context: n }), this;
  }function i(e, t, n) {
    if (!c(this, "once", e, [t, n]) || !t) return this;var r = 0,
        i = this,
        o = function n() {
      r++ || (i.off(e, n), t.apply(this, arguments));
    };return o._callback = t, this.on(e, o, n);
  }function o(e, t, n) {
    if (!this._events || !c(this, "off", e, [t, n])) return this;if (!e && !t && !n) return delete this._events, this;for (var r = e ? [e] : Object.keys(this._events), i = 0, o = r.length; i < o; i++) {
      e = r[i];var a = this._events[e];if (a) {
        var u = this._events[e] = [];if (t || n) for (var s = 0, l = a.length; s < l; s++) {
          var f = a[s];(t && t !== f.callback && t !== f.callback._callback || n && n !== f.context) && u.push(f);
        }u.length || delete this._events[e];
      }
    }return this;
  }function a(e) {
    if (!this._events) return this;var t = f.call(arguments, 1);if (!c(this, "trigger", e, t)) return this;var n = this._events[e],
        r = this._events.all;return n && s(n, t, this), r && s(r, arguments, this), this;
  }function u(e) {
    if (!this._events) return this;var t = f.call(arguments, 1);if (!c(this, "trigger", e, t)) return this;var n = this._events[e],
        r = this._events.all;return n && s(n, t, this, e), r && s(r, arguments, this, e), this;
  }function c(e, t, n, r) {
    if (!n) return !0;if ("object" === (void 0 === n ? "undefined" : l(n))) {
      for (var i in n) {
        Object.prototype.hasOwnProperty.call(n, i) && e[t].apply(e, [i, n[i]].concat(r));
      }return !1;
    }if (d.test(n)) {
      for (var o = n.split(d), a = 0, u = o.length; a < u; a++) {
        e[t].apply(e, [o[a]].concat(r));
      }return !1;
    }return !0;
  }function s(e, t, n, r) {
    for (var i = -1, o = e.length; ++i < o;) {
      var a = e[i];if (r) try {
        a.callback.apply(a.context || n, t);
      } catch (e) {
        console.log('Error in "' + r + '" event handler:', e);
      } else a.callback.apply(a.context || n, t);
    }
  }t.c = r, t.d = i, t.b = o, t.e = a, t.f = u;var l = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
    return typeof e === "undefined" ? "undefined" : _typeof(e);
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : _typeof(e);
  },
      f = [].slice,
      d = /\s+/;t.a = { on: r, once: i, off: o, trigger: a };
}, function (e, t, n) {
  "use strict";
  function r(e, t) {
    var n = void 0,
        r = void 0,
        i = void 0,
        o = void 0;return e.chrome ? n = -1 !== t.indexOf("Chrome") ? t.substring(t.indexOf("Chrome") + 7) : t.substring(t.indexOf("CriOS") + 6) : e.safari ? n = t.substring(t.indexOf("Version") + 8) : e.firefox ? n = t.substring(t.indexOf("Firefox") + 8) : e.edge ? n = t.substring(t.indexOf("Edge") + 5) : e.ie && (-1 !== t.indexOf("rv:") ? n = t.substring(t.indexOf("rv:") + 3) : -1 !== t.indexOf("MSIE") && (n = t.substring(t.indexOf("MSIE") + 5))), n && (-1 !== (o = n.indexOf(";")) && (n = n.substring(0, o)), -1 !== (o = n.indexOf(" ")) && (n = n.substring(0, o)), -1 !== (o = n.indexOf(")")) && (n = n.substring(0, o)), r = parseInt(n, 10), i = parseInt(n.split(".")[1], 10)), { version: n, major: r, minor: i };
  }function i(e, t) {
    if (e && e.length > t) return e[t];
  }function o(e, t) {
    var n = void 0,
        r = void 0,
        o = void 0;if (e.windows) switch (n = i(/Windows(?: NT|)? ([._\d]+)/.exec(t), 1)) {case "6.1":
        n = "7.0";break;case "6.2":
        n = "8.0";break;case "6.3":
        n = "8.1";} else e.android ? n = i(/Android ([._\d]+)/.exec(t), 1) : e.iOS ? n = i(/OS ([._\d]+)/.exec(t), 1) : e.mac && (n = i(/Mac OS X (10[._\d]+)/.exec(t), 1));if (n) {
      r = parseInt(n, 10);var a = n.split(/[._]/);a && (o = parseInt(a[1], 10));
    }return { version: n, major: r, minor: o };
  }function a() {
    var e = !1;try {
      var t = Object.defineProperty({}, "passive", { get: function get() {
          e = !0;
        } });window.addEventListener("testPassive", null, t), window.removeEventListener("testPassive", null, t);
    } catch (e) {}return e;
  }Object.defineProperty(t, "__esModule", { value: !0 });var u = n(29),
      c = n(0);n.d(t, "Browser", function () {
    return f;
  }), n.d(t, "OS", function () {
    return d;
  }), n.d(t, "Features", function () {
    return p;
  });var s = c.c.memoize,
      l = navigator.userAgent,
      f = {},
      d = {},
      p = {},
      v = function v() {
    return l.indexOf("Windows") > -1;
  };Object.defineProperties(f, { androidNative: { get: s(u.c), enumerable: !0 }, chrome: { get: s(u.d), enumerable: !0 }, edge: { get: s(u.e), enumerable: !0 }, facebook: { get: s(u.g), enumerable: !0 }, firefox: { get: s(u.f), enumerable: !0 }, ie: { get: s(u.i), enumerable: !0 }, msie: { get: s(u.n), enumerable: !0 }, safari: { get: s(u.q), enumerable: !0 }, version: { get: s(r.bind(this, f, l)), enumerable: !0 } }), Object.defineProperties(d, { android: { get: s(u.b), enumerable: !0 }, iOS: { get: s(u.j), enumerable: !0 }, mobile: { get: s(u.o), enumerable: !0 }, mac: { get: s(u.p), enumerable: !0 }, iPad: { get: s(u.k), enumerable: !0 }, iPhone: { get: s(u.l), enumerable: !0 }, windows: { get: s(v), enumerable: !0 }, version: { get: s(o.bind(this, d, l)), enumerable: !0 } }), Object.defineProperties(p, { flash: { get: s(u.h), enumerable: !0 }, flashVersion: { get: s(u.a), enumerable: !0 }, iframe: { get: s(u.m), enumerable: !0 }, passiveEvents: { get: s(a), enumerable: !0 }, backgroundLoading: { get: s(function () {
        return !(d.iOS || f.safari);
      }), enumerable: !0 } });
}, function (e, t, n) {
  "use strict";
  function r(e) {
    return b || (b = o(e)), b;
  }function i() {
    throw new Error("Network error");
  }function o(e) {
    var t = e.get("controls"),
        n = a(),
        r = u(e, "html5");return t && n && r ? c() : t && r ? s() : t && n ? l() : t ? f() : d();
  }function a() {
    var e = window.IntersectionObserverEntry;return !(e && "IntersectionObserver" in window && "intersectionRatio" in e.prototype);
  }function u(e, t) {
    var n = e.get("playlist");if (Array.isArray(n) && n.length) for (var r = Object(v.a)(n[0]).sources, i = 0; i < r.length; i++) {
      for (var o = r[i], a = e.getProviders(), u = 0; u < h.a.length; u++) {
        var c = h.a[u];if (a.providerSupports(c, o)) return c.name === t;
      }
    }return !1;
  }function c() {
    return w.html5 = !0, n.e(0).then(function (e) {
      n(10);var t = n(4).default;return g.b.controls = n(3).default, Object(m.a)(n(110).default), t;
    }.bind(null, n)).catch(i);
  }function s() {
    return w.html5 = !0, n.e(1).then(function (e) {
      var t = n(4).default;return g.b.controls = n(3).default, Object(m.a)(n(110).default), t;
    }.bind(null, n)).catch(i);
  }function l() {
    return n.e(2).then(function (e) {
      n(10);var t = n(4).default;return g.b.controls = n(3).default, t;
    }.bind(null, n)).catch(i);
  }function f() {
    return n.e(3).then(function (e) {
      var t = n(4).default;return g.b.controls = n(3).default, t;
    }.bind(null, n)).catch(i);
  }function d() {
    return p().then(function () {
      return n.e(8).then(function (e) {
        return n(4).default;
      }.bind(null, n)).catch(i);
    });
  }function p() {
    return a() ? n.e(10).then(function (e) {
      return n(10);
    }.bind(null, n)).catch(i) : y.b;
  }n.d(t, "a", function () {
    return w;
  }), t.c = r, t.b = i;var v = n(24),
      h = n(17),
      m = n(18),
      g = n(46),
      y = n(1),
      b = null,
      w = {};
},, function (e, t, n) {
  "use strict";
  function r(e) {
    switch (void 0 === e ? "undefined" : c(e)) {case "string":
        return e.length > 0;case "object":
        return null !== e;case "undefined":
        return !1;default:
        return !0;}
  }function i() {
    return "https:" === window.location.protocol;
  }function o(e, t) {
    return 0 === e.indexOf("rtmp:") || "rtmp" === t;
  }function a(e, t) {
    return "youtube" === t || /^(http|\/\/).*(youtube\.com|youtu\.be)\/.+/.test(e);
  }function u(e) {
    if (null === e) return "null";var t = void 0 === e ? "undefined" : c(e);return "object" === t && Array.isArray(e) ? "array" : t;
  }Object.defineProperty(t, "__esModule", { value: !0 }), t.exists = r, t.isHTTPS = i, t.isRtmp = o, t.isYouTube = a, t.typeOf = u;var c = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
    return typeof e === "undefined" ? "undefined" : _typeof(e);
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : _typeof(e);
  };
}, function (e, t, n) {
  "use strict";
  function r(e, t) {
    if (Object(l.exists)(t) || (t = document.location.href), Object(l.exists)(e)) {
      if (i(e)) return e;var n = t.substring(0, t.indexOf("://") + 3),
          r = t.substring(n.length, t.indexOf("/", n.length + 1)),
          o = void 0;if (0 === e.indexOf("/")) o = e.split("/");else {
        var a = t.split("?")[0];a = a.substring(n.length + r.length + 1, a.lastIndexOf("/")), o = a.split("/").concat(e.split("/"));
      }for (var u = [], c = 0; c < o.length; c++) {
        o[c] && Object(l.exists)(o[c]) && "." !== o[c] && (".." === o[c] ? u.pop() : u.push(o[c]));
      }return n + r + "/" + u.join("/");
    }
  }function i(e) {
    return (/^(?:(?:https?|file):)?\/\//.test(e)
    );
  }function o(e) {
    return f.c.some(e, function (e) {
      return "parsererror" === e.nodeName;
    });
  }function a(e) {
    var t = null;try {
      "DOMParser" in window ? (t = new window.DOMParser().parseFromString(e, "text/xml"), (o(t.childNodes) || t.childNodes && o(t.childNodes[0].childNodes)) && (t = null)) : (t = new window.ActiveXObject("Microsoft.XMLDOM"), t.async = "false", t.loadXML(e));
    } catch (e) {}return t;
  }function u(e) {
    if (void 0 === e) return null;if ("string" == typeof e && e.length < 6) {
      var t = e.toLowerCase();if ("true" === t) return !0;if ("false" === t) return !1;if (!isNaN(Number(e)) && !isNaN(parseFloat(e))) return Number(e);
    }return e;
  }function c(e) {
    return "string" == typeof e ? "" === e ? 0 : e.lastIndexOf("%") > -1 ? e : parseInt(e.replace("px", ""), 10) : e;
  }function s(e, t) {
    if (e <= 0 && !t || f.c.isNaN(parseInt(e))) return "00:00";var n = e < 0 ? "-" : "";e = Math.abs(e);var r = Math.floor(e / 3600),
        i = Math.floor((e - 3600 * r) / 60),
        o = Math.floor(e % 60);return n + (r ? r + ":" : "") + (i < 10 ? "0" : "") + i + ":" + (o < 10 ? "0" : "") + o;
  }Object.defineProperty(t, "__esModule", { value: !0 }), t.getAbsolutePath = r, t.isAbsolutePath = i, t.parseXML = a, t.serialize = u, t.parseDimension = c, t.timeFormat = s;var l = n(11),
      f = n(0);
}, function (e, t, n) {
  "use strict";
  function r(e) {
    var t = "";return e && (e.localName ? t = e.localName : e.baseName && (t = e.baseName)), t;
  }function i(e) {
    var t = "";return e && (e.textContent ? t = Object(u.h)(e.textContent) : e.text && (t = Object(u.h)(e.text))), t;
  }function o(e, t) {
    return e.childNodes[t];
  }function a(e) {
    return e.childNodes ? e.childNodes.length : 0;
  }t.b = r, t.d = i, t.a = o, t.c = a;var u = n(2);
}, function (e, t, n) {
  "use strict";
  function r(e) {
    var t = { setup: [i, o, a, u, c, l, f, d, s], drm: [c, l, f, d], ads: [l, f, d, s, c], jwpsrv: [i, o, a, u, c, l, d, s], discovery: [l, c, d, f] };return function (n) {
      return t[n] && t[n].indexOf(e) > -1;
    };
  }t.a = r;var i = "free",
      o = "starter",
      a = "business",
      u = "premium",
      c = "enterprise",
      s = "platinum",
      l = "ads",
      f = "unlimited",
      d = "trial";
}, function (e, t, n) {
  "use strict";
  t.a = { debug: !1 };
}, function (e, t, n) {
  "use strict";
  Object.defineProperty(t, "__esModule", { value: !0 }), n.d(t, "getScriptPath", function () {
    return i;
  }), n.d(t, "repo", function () {
    return o;
  }), n.d(t, "versionCheck", function () {
    return a;
  }), n.d(t, "loadFrom", function () {
    return u;
  });var r = n(20),
      i = function i(e) {
    for (var t = document.getElementsByTagName("script"), n = 0; n < t.length; n++) {
      var r = t[n].src;if (r) {
        var i = r.lastIndexOf("/" + e);if (i >= 0) return r.substr(0, i + 1);
      }
    }return "";
  },
      o = function o() {
    var e = "//ssl.p.jwpcdn.com/player/v/8.1.11/";return ("file:" === window.location.protocol ? "https:" : "") + e;
  },
      a = function a(e) {
    var t = ("0" + e).split(/\W/),
        n = r.a.split(/\W/),
        i = parseFloat(t[0]),
        o = parseFloat(n[0]);return !(i > o) && !(i === o && parseFloat("0" + t[1]) > parseFloat(n[1]));
  },
      u = function u() {
    return o();
  };
}, function (e, t, n) {
  "use strict";
  function r() {
    return !!window.MediaSource && !!window.MediaSource.isTypeSupported && window.MediaSource.isTypeSupported('video/mp4;codecs="avc1.4d400d,mp4a.40.2"');
  }function i(e) {
    if (f.Browser.safari) return !1;if (e.drm && !Object(v.a)(e.drm)) return !1;var t = window.MediaSource;if (!window.HTMLVideoElement || !t) return !1;var n = !0;return e.mediaTypes && (n = p.c.all(e.mediaTypes, function (e) {
      return t.isTypeSupported(e);
    })), n && ("dash" === e.type || "mpd" === e.type || (e.file || "").indexOf("mpd-time-csf") > -1);
  }var o = n(52),
      a = n(11),
      u = n(32),
      c = { aac: "audio/mp4", mp4: "video/mp4", f4v: "video/mp4", m4v: "video/mp4", mov: "video/mp4", mp3: "audio/mpeg", mpeg: "audio/mpeg", ogv: "video/ogg", ogg: "video/ogg", oga: "video/ogg", vorbis: "video/ogg", webm: "video/webm", f4a: "video/aac", m3u8: "application/vnd.apple.mpegurl", m3u: "application/vnd.apple.mpegurl", hls: "application/vnd.apple.mpegurl" },
      s = [{ name: "html5", supports: function supports(e) {
      if (!1 === Object(o.a)(e)) return !1;if (!u.a.canPlayType) return !1;var t = e.file,
          n = e.type;if (Object(a.isRtmp)(t, n)) return !1;var r = e.mimeType || c[n];return !!r && !!u.a.canPlayType(r);
    } }],
      l = s,
      f = n(8),
      d = n(14),
      p = n(0),
      v = n(28),
      h = p.c.find(l, p.c.matches({ name: "html5" })),
      m = h.supports;h.supports = function (e, t) {
    var n = m.apply(this, arguments);if (n && e.drm && "hls" === e.type) {
      var r = Object(d.a)(t),
          i = r("drm");if (i && e.drm.fairplay) {
        var o = window.WebKitMediaKeys;return o && o.isTypeSupported && o.isTypeSupported("com.apple.fps.1_0", "video/mp4");
      }return i;
    }return n;
  }, l.push({ name: "shaka", supports: i }), l.splice(0, 0, { name: "hlsjs", supports: function supports(e) {
      if (e.drm) return !1;var t = f.Browser.chrome || f.Browser.firefox || f.Browser.edge || f.Browser.ie && 11 === f.Browser.version.major,
          n = f.OS.android && !!e.hlsjsdefault,
          i = !f.OS.iOS && f.Browser.safari && !!e.safarihlsjs,
          o = r() && (t || n || i),
          a = e.file.indexOf(".m3u8") > -1,
          u = "hls" === e.type || "m3u8" === e.type;return o && (a || u);
    } }), l.push({ name: "flash", supports: function supports(e) {
      if (!f.Features.flash || e.drm) return !1;var t = e.type;return "hls" === t || "m3u8" === t || !Object(a.isRtmp)(e.file, t) && ["flv", "f4v", "mov", "m4a", "m4v", "mp4", "aac", "f4a", "mp3", "mpeg", "smil"].indexOf(t) > -1;
    } });t.a = l;
}, function (e, t, n) {
  "use strict";
  function r(e) {
    var t = e.getName().name;if (!i.a[t]) {
      if (!u.c.find(o.a, u.c.matches({ name: t }))) {
        if (!u.c.isFunction(e.supports)) throw new Error("Tried to register a provider with an invalid object");o.a.unshift({ name: t, supports: e.supports });
      }u.c.defaults(e.prototype, a.a), i.a[t] = e;
    }
  }t.a = r;var i = n(33),
      o = n(17),
      a = n(44),
      u = n(0);
}, function (e, t, n) {
  "use strict";
  function r(e, t, n) {
    var r = e.name,
        i = document.createElement("div");i.id = n.id + "_" + r, i.className = "jw-plugin jw-reset";var o = s({}, t),
        a = e.getNewInstance(n, o, i);n.addPlugin(r, a);
  }function i(e) {
    switch (y(e)) {case m:
        return e;case g:
        return Object(p.getAbsolutePath)(e, window.location.href);}
  }function o(e) {
    return S[e] = new f(), S[e];
  }function a(e, t) {
    var n = e.get("id"),
        r = e.get("plugins");window.jwplayerPluginJsonp = P;var i = o(n);return i.load(t, E, r).then(function (e) {
      i === S[n] && (e && e.forEach(function (e) {
        e instanceof Error && Object(j.b)(e.message);
      }), delete window.jwplayerPluginJsonp);
    });
  }var u = n(1),
      c = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
    return typeof e === "undefined" ? "undefined" : _typeof(e);
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : _typeof(e);
  },
      s = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }return e;
  },
      l = function l() {
    this.load = function (e, t, n) {
      return n && "object" === (void 0 === n ? "undefined" : c(n)) ? u.a.all(Object.keys(n).filter(function (e) {
        return e;
      }).map(function (i) {
        var o = t.addPlugin(i, !0),
            a = n[i];return o.load().then(function () {
          r(o, a, e);
        }).catch(function (e) {
          return e instanceof Error ? e : new Error("Error in " + i + ' "' + e + '"');
        });
      })) : u.b;
    };
  },
      f = l,
      d = n(22),
      p = n(12),
      v = n(2),
      h = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }return e;
  },
      m = 0,
      g = 1,
      y = function y(e) {
    if ("string" == typeof e) {
      e = e.split("?")[0];var t = e.indexOf("://");if (t > 0) return m;var n = e.indexOf("/"),
          r = Object(v.a)(e);return !(t < 0 && n < 0) || r && isNaN(r) ? g : 2;
    }
  },
      b = function b(e) {
    this.url = e;
  };h(b.prototype, { load: function load() {
      if (2 === y(this.url)) return u.b;var e = new d.a(i(this.url));return this.loader = e, e.load();
    }, registerPlugin: function registerPlugin(e, t, n) {
      this.name = e, this.target = t, this.js = n;
    }, getNewInstance: function getNewInstance(e, t, n) {
      var r = this.js,
          i = new r(e, t, n);return i.addToPlayer = function () {
        var t = e.getContainer().querySelector(".jw-overlays");t && (n.left = t.style.left, n.top = t.style.top, t.appendChild(n), i.displayArea = t);
      }, i.resizeHandler = function () {
        var e = i.displayArea;e && i.resize(e.clientWidth, e.clientHeight);
      }, i;
    } });var w = b,
      j = n(6),
      O = {},
      k = function k(e) {
    return e.replace(/^(.*\/)?([^-]*)-?.*\.(js)$/, "$2");
  },
      C = function C() {
    this.addPlugin = function (e, t) {
      var n = k(e),
          r = O[n];return r ? t && r.url !== e && Object(j.b)('JW Plugin "' + n + '" already loaded from "' + r.url + '". Ignoring "' + e + '."') : (r = new w(e), O[n] = r), r;
    }, this.getPlugins = function () {
      return O;
    };
  },
      x = C;n.d(t, "b", function () {
    return P;
  }), t.a = a;var E = new x(),
      S = {},
      P = function P(e, t, n) {
    var r = E.addPlugin(e);r.js || r.registerPlugin(e, t, n);
  };
}, function (e, t, n) {
  "use strict";
  n.d(t, "a", function () {
    return r;
  });var r = "8.1.11+commercial_v8-1-11.245.commercial.5be18a.hlsjs..jwplayer.c9fefd.dai.c24260.freewheel.782b72.googima.32098a.vast.520a81.jwpsrv.785f4d.gapro.fb7ea6.related.bce080";
}, function (e, t, n) {
  "use strict";
  function r() {
    return a + o.now();
  }var i = n(23),
      o = window.performance || { timing: {} },
      a = o.timing.navigationStart || Object(i.a)();"now" in o || (o.now = function () {
    return Object(i.a)() - a;
  });var u = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }return e;
  },
      c = function c() {
    var e = {},
        t = {},
        n = {},
        i = {};return { start: function start(t) {
        e[t] = r(), n[t] = n[t] + 1 || 1;
      }, end: function end(n) {
        if (e[n]) {
          var i = r(),
              o = i - e[n];delete e[n], t[n] = t[n] + o || o;
        }
      }, dump: function dump() {
        var o = u({}, t);for (var a in e) {
          if (Object.prototype.hasOwnProperty.call(e, a)) {
            var c = r(),
                s = c - e[a];o[a] = o[a] + s || s;
          }
        }return { counts: u({}, n), sums: o, events: u({}, i) };
      }, tick: function tick(e) {
        i[e] = r();
      }, clear: function clear(e) {
        delete i[e];
      }, between: function between(e, t) {
        return i[t] && i[e] ? i[t] - i[e] : null;
      } };
  };t.a = c;
}, function (e, t, n) {
  "use strict";
  function r(e) {
    var t = document.createElement("link");return t.type = "text/css", t.rel = "stylesheet", t.href = e, t;
  }function i(e) {
    var t = document.createElement("script");return t.type = "text/javascript", t.charset = "utf-8", t.async = !0, t.timeout = l, t.src = e, t;
  }var o = n(7),
      a = n(5),
      u = n(1),
      c = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }return e;
  },
      s = {},
      l = 15e3,
      f = 2,
      d = 3,
      p = function p(e, t) {
    function n(e) {
      p = f, c.trigger(a.q, e).off();
    }function o(e) {
      p = d, c.trigger(a._3, e).off();
    }var c = this,
        p = 0;this.getStatus = function () {
      return p;
    }, this.load = function () {
      var a = s[e];return 0 !== p ? a : (a && a.then(o).catch(n), p = 1, a = new u.a(function (a, u) {
        var c = t ? r : i,
            s = c(e),
            f = function f() {
          s.onerror = s.onload = null, clearTimeout(p);
        },
            d = function d(e) {
          f(), n(e), u(e);
        },
            p = setTimeout(function () {
          d(new Error("Network timeout " + e));
        }, l);s.onerror = function () {
          d(new Error("Failed to load " + e));
        }, s.onload = function (e) {
          f(), o(e), a(e);
        };var v = document.getElementsByTagName("head")[0] || document.documentElement;v.insertBefore(s, v.firstChild);
      }), s[e] = a, a);
    };
  };c(p.prototype, o.a), t.a = p;
}, function (e, t, n) {
  "use strict";
  n.d(t, "a", function () {
    return r;
  });var r = Date.now || function () {
    return new Date().getTime();
  };
}, function (e, t, n) {
  "use strict";
  var r = n(36),
      i = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }return e;
  },
      o = function o(e) {
    if (e && e.file) return i({}, { kind: "captions", default: !1 }, e);
  },
      a = o,
      u = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }return e;
  },
      c = Array.isArray,
      s = function s(e) {
    e = e || {}, c(e.tracks) || delete e.tracks;var t = u({}, { sources: [], tracks: [], minDvrWindow: 120 }, e);t.sources !== Object(t.sources) || c(t.sources) || (t.sources = [Object(r.a)(t.sources)]), c(t.sources) && 0 !== t.sources.length || (e.levels ? t.sources = e.levels : t.sources = [Object(r.a)(e)]);for (var n = 0; n < t.sources.length; n++) {
      var i = t.sources[n];if (i) {
        var o = i.default;i.default = !!o && "true" === o.toString(), t.sources[n].label || (t.sources[n].label = n.toString()), t.sources[n] = Object(r.a)(t.sources[n]);
      }
    }return t.sources = t.sources.filter(function (e) {
      return !!e;
    }), c(t.tracks) || (t.tracks = []), c(t.captions) && (t.tracks = t.tracks.concat(t.captions), delete t.captions), t.tracks = t.tracks.map(a).filter(function (e) {
      return !!e;
    }), t;
  };t.a = s;
}, function (e, t, n) {
  "use strict";
  function r(e, t) {
    var n = " " + t + " ";return 1 === e.nodeType && (" " + e.className + " ").replace(/[\t\r\n\f]/g, " ").indexOf(n) >= 0;
  }function i(e) {
    var t = document.createElement("div");return t.innerHTML = e, t.firstChild;
  }function o(e) {
    return e + (e.toString().indexOf("%") > 0 ? "" : "px");
  }function a(e) {
    return b.c.isString(e.className) ? e.className.split(" ") : [];
  }function u(e, t) {
    t = Object(y.h)(t), e.className !== t && (e.className = t);
  }function c(e) {
    return e.classList ? e.classList : a(e);
  }function s(e, t) {
    var n = a(e),
        r = b.c.isArray(t) ? t : t.split(" ");b.c.each(r, function (e) {
      b.c.contains(n, e) || n.push(e);
    }), u(e, n.join(" "));
  }function l(e, t) {
    var n = a(e),
        r = b.c.isArray(t) ? t : t.split(" ");u(e, b.c.difference(n, r).join(" "));
  }function f(e, t, n) {
    var r = e.className || "";t.test(r) ? r = r.replace(t, n) : n && (r += " " + n), u(e, r);
  }function d(e, t, n) {
    var i = r(e, t);(n = b.c.isBoolean(n) ? n : !i) !== i && (n ? s(e, t) : l(e, t));
  }function p(e) {
    for (; e.firstChild;) {
      e.removeChild(e.firstChild);
    }
  }function v(e) {
    var t = document.createElement("link");t.rel = "stylesheet", t.href = e, document.getElementsByTagName("head")[0].appendChild(t);
  }function h(e) {
    e && p(e);
  }function m(e) {
    var t = { left: 0, right: 0, width: 0, height: 0, top: 0, bottom: 0 };if (!e || !document.body.contains(e)) return t;var n = e.getBoundingClientRect(),
        r = window.pageYOffset,
        i = window.pageXOffset;return n.width || n.height || n.left || n.top ? (t.left = n.left + i, t.right = n.right + i, t.top = n.top + r, t.bottom = n.bottom + r, t.width = n.right - n.left, t.height = n.bottom - n.top, t) : t;
  }function g(e, t) {
    e.insertBefore(t, e.firstChild);
  }t.h = r, t.e = i, t.l = o, t.d = c, t.a = s, t.j = l, t.k = f, t.m = d, t.g = p, t.b = v, t.f = h, t.c = m, t.i = g;var y = n(2),
      b = n(0);
}, function (e, t, n) {
  "use strict";
  function r(e, t, n, r) {
    n = n || "all-players";var o = "";if ("object" === (void 0 === t ? "undefined" : d(t))) {
      var a = document.createElement("div");i(a, t);var u = a.style.cssText;r && u && (u = u.replace(/;/g, " !important;")), o = "{" + u + "}";
    } else "string" == typeof t && (o = t);if ("" === o || "{}" === o) return void f.a.clear(n, e);f.a.style([[e, e + o]], n);
  }function i(e, t) {
    if (void 0 !== e && null !== e) {
      void 0 === e.length && (e = [e]);var n,
          r = {};for (n in t) {
        Object.prototype.hasOwnProperty.call(t, n) && (r[n] = a(n, t[n]));
      }for (var i = 0; i < e.length; i++) {
        var u,
            c = e[i];if (void 0 !== c && null !== c) for (n in r) {
          Object.prototype.hasOwnProperty.call(r, n) && (u = o(n), c.style[u] !== r[n] && (c.style[u] = r[n]));
        }
      }
    }
  }function o(e) {
    e = e.split("-");for (var t = 1; t < e.length; t++) {
      e[t] = e[t].charAt(0).toUpperCase() + e[t].slice(1);
    }return e.join("");
  }function a(e, t) {
    return "" === t || void 0 === t || null === t ? "" : "string" == typeof t && isNaN(t) ? /png|gif|jpe?g/i.test(t) && t.indexOf("url") < 0 ? "url(" + t + ")" : t : 0 === t || "z-index" === e || "opacity" === e ? "" + t : /color/i.test(e) ? "#" + Object(s.d)(t.toString(16).replace(/^0x/i, ""), 6) : Math.ceil(t) + "px";
  }function u(e, t) {
    i(e, { transform: t, webkitTransform: t, msTransform: t, mozTransform: t, oTransform: t });
  }function c(e, t) {
    var n = "rgb",
        r = void 0 !== t && 100 !== t;if (r && (n += "a"), !v) {
      var i = document.createElement("canvas");i.height = 1, i.width = 1, v = i.getContext("2d");
    }e ? isNaN(parseInt(e, 16)) || (e = "#" + e) : e = "#000000", v.clearRect(0, 0, 1, 1), v.fillStyle = e, v.fillRect(0, 0, 1, 1);var o = v.getImageData(0, 0, 1, 1).data;return n += "(" + o[0] + ", " + o[1] + ", " + o[2], r && (n += ", " + t / 100), n + ")";
  }n.d(t, "a", function () {
    return p;
  }), t.b = r, t.d = i, t.e = u, t.c = c;var s = n(2),
      l = n(39),
      f = n.n(l),
      d = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
    return typeof e === "undefined" ? "undefined" : _typeof(e);
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : _typeof(e);
  },
      p = f.a.clear,
      v = void 0;
}, function (e, t, n) {
  "use strict";
  var r = [];t.a = r;
}, function (e, t, n) {
  "use strict";
  function r(e) {
    return e.some(function (e) {
      return !!e.drm || e.sources.some(function (e) {
        return !!e.drm;
      });
    });
  }function i(e) {
    return new l.a(function (t, n) {
      var r = void 0;try {
        r = new window.MSMediaKeys(e);
      } catch (e) {
        return void n(e);
      }t(r);
    });
  }function o(e) {
    if (v) return v;if (a() && Object(s.a)(e)("drm")) {
      var t = i;return navigator.requestMediaKeySystemAccess && (t = navigator.requestMediaKeySystemAccess.bind(navigator)), f.forEach(function (e) {
        var n = t(e.keyName, [{ initDataTypes: ["cenc"], videoCapabilities: [{ contentType: 'video/mp4;codecs="avc1.4d401e"' }], audioCapabilities: [{ contentType: 'audio/mp4;codecs="mp4a.40.2"' }] }]).then(function () {
          p[e.configName] = !0;
        }).catch(function () {
          p[e.configName] = !1;
        });d.push(n);
      }), v = l.a.all(d);
    }return l.b;
  }function a() {
    return !!navigator.requestMediaKeySystemAccess && !!MediaKeySystemAccess.prototype.getConfiguration || !!window.MSMediaKeys;
  }function u(e) {
    return p[e];
  }function c(e) {
    if (v) return Object.keys(e).some(function (e) {
      return u(e);
    });
  }t.b = r, t.d = o, t.c = u, t.a = c;var s = n(14),
      l = n(1),
      f = [{ configName: "clearkey", keyName: "org.w3.clearkey" }, { configName: "widevine", keyName: "com.widevine.alpha" }, { configName: "playready", keyName: "com.microsoft.playready" }],
      d = [],
      p = {},
      v = void 0;
}, function (e, t, n) {
  "use strict";
  function r(e) {
    return null !== g.match(e);
  }function i(e) {
    return function () {
      return r(e);
    };
  }function o() {
    var e = m();return !!(e && e >= 18);
  }function a() {
    return r(/\sEdge\/\d+/i);
  }function u() {
    return r(/msie/i);
  }function c() {
    return r(/\s(?:Chrome|CriOS)\//i) && !a();
  }function s() {
    return a() || b() || u();
  }function l() {
    return r(/safari/i) && !r(/(?:Chrome|CriOS|chromium|android|phantom)/i);
  }function f() {
    return r(/iP(hone|ad|od)/i);
  }function d() {
    return !(r(/chrome\/[123456789]/i) && !r(/chrome\/18/i) && !y()) && p();
  }function p() {
    return r(/Android/i) && !r(/Windows Phone/i);
  }function v() {
    return f() || p() || r(/Windows Phone/i);
  }function h() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return !0;
    }
  }function m() {
    if (p()) return 0;var e,
        t = navigator.plugins;if (t && (e = t["Shockwave Flash"]) && e.description) return parseFloat(e.description.replace(/\D+(\d+\.?\d*).*/, "$1"));if (void 0 !== window.ActiveXObject) {
      try {
        if (e = new window.ActiveXObject("ShockwaveFlash.ShockwaveFlash")) return parseFloat(e.GetVariable("$version").split(" ")[1].replace(/\s*,\s*/, "."));
      } catch (e) {
        return 0;
      }return e;
    }return 0;
  }t.h = o, n.d(t, "f", function () {
    return y;
  }), n.d(t, "l", function () {
    return w;
  }), n.d(t, "k", function () {
    return j;
  }), n.d(t, "p", function () {
    return O;
  }), n.d(t, "g", function () {
    return k;
  }), t.e = a, t.n = u, t.d = c, t.i = s, t.q = l, t.j = f, t.c = d, t.b = p, t.o = v, t.m = h, t.a = m;var g = navigator.userAgent,
      y = i(/gecko\//i),
      b = i(/trident\/.+rv:\s*11/i),
      w = i(/iP(hone|od)/i),
      j = i(/iPad/i),
      O = i(/Macintosh/i),
      k = i(/FBAV/i);
}, function (e, t, n) {
  "use strict";
  function r(e) {
    this.config = e || {};
  }var i = n(17),
      o = n(18),
      a = n(33),
      u = n(9),
      c = n(1),
      s = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }return e;
  },
      l = { html5: function html5() {
      return n.e(7).then(function (e) {
        var t = n(110).default;return Object(o.a)(t), t;
      }.bind(null, n)).catch(u.b);
    } };s(r.prototype, { load: function load(e) {
      return c.a.all(e.filter(function (e) {
        return !!l[e.name];
      }).map(function (e) {
        return (0, l[e.name])();
      }));
    }, providerSupports: function providerSupports(e, t) {
      return e.supports(t);
    }, required: function required(e) {
      var t = this;return e = e.slice(), i.a.filter(function (n) {
        for (var r = !1, i = e.length; i--;) {
          var o = e[i],
              a = o.sources[0];if (a) {
            var u = t.providerSupports(n, a);u && e.splice(i, 1), r = r || u;
          }
        }return r;
      });
    }, choose: function choose(e) {
      e = e === Object(e) ? e : {};for (var t = i.a.length, n = 0; n < t; n++) {
        var r = i.a[n];if (this.providerSupports(r, e)) {
          return { priority: t - n - 1, name: r.name, type: e.type, providerToCheck: r, provider: a.a[r.name] };
        }
      }return null;
    } });var f = r,
      d = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }return e;
  },
      p = void 0;d(l, { shaka: function shaka() {
      return n.e(5).then(function (e) {
        var t = n(119).default;return Object(o.a)(t), t;
      }.bind(null, n)).catch(u.b);
    }, hlsjs: function hlsjs() {
      return n.e(6).then(function (e) {
        var t = n(120).default;return t.setEdition && t.setEdition(p), Object(o.a)(t), t;
      }.bind(null, n)).catch(u.b);
    }, flash: function flash() {
      return n.e(9).then(function (e) {
        var t = n(121).default;return Object(o.a)(t), t;
      }.bind(null, n)).catch(u.b);
    } }), f.prototype.providerSupports = function (e, t) {
    return p = this.config.edition, e.supports(t, p);
  };t.a = f;
}, function (e, t, n) {
  "use strict";
  function r(e) {
    this.message = e;
  }function i(e) {
    var t = String(e).replace(/=+$/, "");if (t.length % 4 == 1) throw new r("'atob' failed: The string to be decoded is not correctly encoded.");for (var n, i, a = "", u = 0, c = 0; i = t.charAt(c++); ~i && (n = u % 4 ? 64 * n + i : i, u++ % 4) ? a += String.fromCharCode(255 & n >> (-2 * u & 6)) : 0) {
      i = o.indexOf(i);
    }return a;
  }n.d(t, "a", function () {
    return a;
  });var o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";r.prototype = new Error(), r.prototype.name = "InvalidCharacterError";var a = window.atob || i;
}, function (e, t, n) {
  "use strict";
  var r = document.createElement("video");t.a = r;
}, function (e, t, n) {
  "use strict";
  var r = {};t.a = r;
}, function (e, t, n) {
  "use strict";
  var r = n(35),
      i = n(14),
      o = n(31),
      a = "invalid",
      u = function u(e) {
    var t = void 0,
        n = void 0,
        u = void 0;this.edition = function () {
      return u && u.getTime() < new Date().getTime() ? a : t;
    }, this.token = function () {
      return n;
    }, this.expiration = function () {
      return u;
    }, function (e, c) {
      try {
        var s = Object(r.a)(e, Object(o.a)(c)),
            l = s.split("/");"pro" === (t = l[0]) && (t = "premium");var f = Object(i.a)(t);if (l.length > 2 && f("setup")) {
          n = l[1];var d = parseInt(l[2]);d > 0 && (u = new Date(), u.setTime(d));
        } else t = a;
      } catch (e) {
        t = a;
      }
    }(e || "", "NDh2aU1Cb0NHRG5hcDFRZQ==");
  };t.a = u;
}, function (e, t, n) {
  "use strict";
  function r(e) {
    return Object(s.a)(e);
  }function i(e) {
    return unescape(encodeURIComponent(e));
  }function o(e) {
    try {
      return decodeURIComponent(escape(e));
    } catch (t) {
      return e;
    }
  }function a(e) {
    for (var t = new Array(Math.ceil(e.length / 4)), n = 0; n < t.length; n++) {
      t[n] = e.charCodeAt(4 * n) + (e.charCodeAt(4 * n + 1) << 8) + (e.charCodeAt(4 * n + 2) << 16) + (e.charCodeAt(4 * n + 3) << 24);
    }return t;
  }function u(e) {
    for (var t = new Array(e.length), n = 0; n < e.length; n++) {
      t[n] = String.fromCharCode(255 & e[n], e[n] >>> 8 & 255, e[n] >>> 16 & 255, e[n] >>> 24 & 255);
    }return t.join("");
  }function c(e, t) {
    if (e = String(e), t = String(t), 0 === e.length) return "";for (var n = a(r(e)), c = a(i(t).slice(0, 16)), s = n.length, l = n[s - 1], f = n[0], d = void 0, p = void 0, v = 2654435769 * Math.floor(6 + 52 / s); v;) {
      p = v >>> 2 & 3;for (var h = s - 1; h >= 0; h--) {
        l = n[h > 0 ? h - 1 : s - 1], d = (l >>> 5 ^ f << 2) + (f >>> 3 ^ l << 4) ^ (v ^ f) + (c[3 & h ^ p] ^ l), f = n[h] -= d;
      }v -= 2654435769;
    }return o(u(n).replace(/\0+$/, ""));
  }t.a = c;var s = n(31);
}, function (e, t, n) {
  "use strict";
  var r = n(11),
      i = n(2),
      o = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }return e;
  },
      a = function a(e) {
    if (e && e.file) {
      var t = o({}, { default: !1 }, e);t.file = Object(i.h)("" + t.file);var n = /^[^\/]+\/(?:x-)?([^\/]+)$/;if (n.test(t.type) && (t.mimeType = t.type, t.type = t.type.replace(n, "$1")), Object(r.isYouTube)(t.file) ? t.type = "youtube" : Object(r.isRtmp)(t.file) ? t.type = "rtmp" : t.type || (t.type = Object(i.a)(t.file)), t.type) {
        switch (t.type) {case "m3u8":case "vnd.apple.mpegurl":
            t.type = "hls";break;case "dash+xml":
            t.type = "dash";break;case "m4a":
            t.type = "aac";break;case "smil":
            t.type = "rtmp";}return Object.keys(t).forEach(function (e) {
          "" === t[e] && delete t[e];
        }), t;
      }
    }
  };t.a = a;
}, function (e, t, n) {
  "use strict";
  function r(e) {
    for (var t = [], n = 0; n < Object(a.c)(e); n++) {
      var r = e.childNodes[n];"jwplayer" === r.prefix && "mediatypes" === Object(a.b)(r).toLowerCase() && t.push(Object(a.d)(r));
    }return t;
  }function i(e) {
    var t = [];t.feedData = {};for (var n = 0; n < Object(a.c)(e); n++) {
      var r = Object(a.a)(e, n);if ("channel" === Object(a.b)(r).toLowerCase()) for (var i = 0; i < Object(a.c)(r); i++) {
        var u = Object(a.a)(r, i),
            c = Object(a.b)(u).toLowerCase();"item" === c ? t.push(o(u)) : c && (t.feedData[c] = Object(a.d)(u));
      }
    }return t;
  }function o(e) {
    for (var t = {}, n = 0; n < e.childNodes.length; n++) {
      var r = e.childNodes[n],
          i = Object(a.b)(r);if (i) switch (i.toLowerCase()) {case "enclosure":
          t.file = Object(u.i)(r, "url");break;case "title":
          t.title = Object(a.d)(r);break;case "guid":
          t.mediaid = Object(a.d)(r);break;case "pubdate":
          t.date = Object(a.d)(r);break;case "description":
          t.description = Object(a.d)(r);break;case "link":
          t.link = Object(a.d)(r);break;case "category":
          t.tags ? t.tags += Object(a.d)(r) : t.tags = Object(a.d)(r);}
    }return new p.a(d(e, l(e, t)));
  }var a = n(13),
      u = n(2),
      c = n(6),
      s = function e(t, n) {
    for (var i = [], o = 0; o < Object(a.c)(t); o++) {
      var s = t.childNodes[o];if ("media" === s.prefix) {
        if (!Object(a.b)(s)) continue;switch (Object(a.b)(s).toLowerCase()) {case "content":
            if (Object(u.i)(s, "duration") && (n.duration = c.a.seconds(Object(u.i)(s, "duration"))), Object(u.i)(s, "url")) {
              n.sources || (n.sources = []);var l = { file: Object(u.i)(s, "url"), type: Object(u.i)(s, "type"), width: Object(u.i)(s, "width"), label: Object(u.i)(s, "label") },
                  f = r(s);f.length && (l.mediaTypes = f), n.sources.push(l);
            }Object(a.c)(s) > 0 && (n = e(s, n));break;case "title":
            n.title = Object(a.d)(s);break;case "description":
            n.description = Object(a.d)(s);break;case "guid":
            n.mediaid = Object(a.d)(s);break;case "thumbnail":
            n.image || (n.image = Object(u.i)(s, "url"));break;case "group":
            e(s, n);break;case "subtitle":
            var d = {};d.file = Object(u.i)(s, "url"), d.kind = "captions", Object(u.i)(s, "lang").length > 0 && (d.label = function (e) {
              var t = { zh: "Chinese", nl: "Dutch", en: "English", fr: "French", de: "German", it: "Italian", ja: "Japanese", pt: "Portuguese", ru: "Russian", es: "Spanish" };return t[e] ? t[e] : e;
            }(Object(u.i)(s, "lang"))), i.push(d);}
      }
    }n.hasOwnProperty("tracks") || (n.tracks = []);for (var p = 0; p < i.length; p++) {
      n.tracks.push(i[p]);
    }return n;
  },
      l = s,
      f = function f(e, t) {
    for (var n = "default", r = [], i = [], o = 0; o < e.childNodes.length; o++) {
      var s = e.childNodes[o];if ("jwplayer" === s.prefix) {
        var l = Object(a.b)(s);"source" === l ? (delete t.sources, r.push({ file: Object(u.i)(s, "file"), default: Object(u.i)(s, n), label: Object(u.i)(s, "label"), type: Object(u.i)(s, "type") })) : "track" === l ? (delete t.tracks, i.push({ file: Object(u.i)(s, "file"), default: Object(u.i)(s, n), kind: Object(u.i)(s, "kind"), label: Object(u.i)(s, "label") })) : (t[l] = c.a.serialize(Object(a.d)(s)), "file" === l && t.sources && delete t.sources);
      }t.file || (t.file = t.link);
    }if (r.length) {
      t.sources = [];for (var f = 0; f < r.length; f++) {
        r[f].file.length > 0 && (r[f][n] = "true" === r[f][n], r[f].label.length || delete r[f].label, t.sources.push(r[f]));
      }
    }if (i.length) {
      t.tracks = [];for (var d = 0; d < i.length; d++) {
        i[d].file.length > 0 && (i[d][n] = "true" === i[d][n], i[d].kind = i[d].kind.length ? i[d].kind : "captions", i[d].label.length || delete i[d].label, t.tracks.push(i[d]));
      }
    }return t;
  },
      d = f,
      p = n(24);t.a = i;
}, function (e, t, n) {
  "use strict";
  function r(e, t) {
    return (/touch/.test(e.type) ? (e.originalEvent || e).changedTouches[0]["page" + t] : e["page" + t]
    );
  }function i(e) {
    var t = e || window.event;return e instanceof MouseEvent && ("which" in t ? 3 === t.which : "button" in t && 2 === t.button);
  }function o(e) {
    var t = e || window.event;return t instanceof KeyboardEvent && 13 === t.keyCode && (e.stopPropagation(), !0);
  }function a(e, t, n) {
    var r = void 0;return r = t instanceof MouseEvent || !t.touches && !t.changedTouches ? t : t.touches && t.touches.length ? t.touches[0] : t.changedTouches[0], { type: e, sourceEvent: t, target: t.target, currentTarget: n, pageX: r.pageX, pageY: r.pageY };
  }function u(e) {
    (e instanceof MouseEvent || e instanceof v) && (e.preventManipulation && e.preventManipulation(), e.preventDefault && e.preventDefault());
  }function c(e) {
    return g && e instanceof v || m && e instanceof h && "touch" === e.pointerType ? "touch" : "mouse";
  }t.b = c;var s = n(8),
      l = n(5),
      f = n(7),
      d = n(23),
      p = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }return e;
  },
      v = window.TouchEvent,
      h = window.PointerEvent,
      m = "PointerEvent" in window && !s.OS.android,
      g = "ontouchstart" in window,
      y = !(m || g && s.OS.mobile),
      b = s.Browser.firefox && s.OS.mac,
      w = function w(e, t) {
    function n(e) {
      "touch" !== e.pointerType && j(l.R, e);
    }function c(e) {
      "touch" !== e.pointerType && j(l.O, e);
    }function f(t) {
      (y || m && "touch" !== t.pointerType && !e.contains(document.elementFromPoint(t.x, t.y))) && j(l.Q, t);
    }function p(e) {
      o(e) && j(l.p, e);
    }function v(e, t, n) {
      e.removeEventListener(t, n), e.addEventListener(t, n);
    }function h(n) {
      P = n.target, C = r(n, "X"), x = r(n, "Y"), i(n) || ("pointerdown" === n.type && n.isPrimary ? (t.preventScrolling && (T = n.pointerId, e.setPointerCapture(T)), v(e, "pointermove", g, _), v(e, "pointercancel", w), "mouse" === n.pointerType && "OBJECT" === P.nodeName ? v(document, "mouseup", w) : v(e, "pointerup", w)) : "mousedown" === n.type ? (v(document, "mousemove", g, _), b && "object" === n.target.nodeName.toLowerCase() ? v(e, "click", w) : v(document, "mouseup", w)) : "touchstart" === n.type && (v(P, "touchmove", g, _), v(P, "touchcancel", w), v(P, "touchend", w)), t.preventScrolling && u(n));
    }function g(e) {
      if (k) j(l.m, e);else {
        var n = r(e, "X"),
            i = r(e, "Y"),
            o = n - C,
            a = i - x;o * o + a * a > 36 && (j(l.o, e), k = !0, j(l.m, e));
      }t.preventScrolling && u(e);
    }function w(n) {
      var r = "pointerup" === n.type || "pointercancel" === n.type;r && t.preventScrolling && e.releasePointerCapture(T), e.removeEventListener("pointermove", g), e.removeEventListener("pointercancel", w), e.removeEventListener("pointerup", w), document.removeEventListener("mousemove", g), document.removeEventListener("mouseup", w), P && (P.removeEventListener("touchmove", g), P.removeEventListener("touchcancel", w), P.removeEventListener("touchend", w)), k ? j(l.n, n) : t.directSelect && n.target !== e || -1 !== n.type.indexOf("cancel") || ("mouseup" === n.type || "click" === n.type || r && "mouse" === n.pointerType ? j(l.h, n) : (j(l._10, n), "touchend" === n.type && u(n))), P = null, k = !1;
    }function j(e, n) {
      var r = void 0;if (t.enableDoubleTap && (e === l.h || e === l._10)) if (Object(d.a)() - E < S) {
        var i = e === l.h ? l.k : l.l;r = a(i, n, O), N.trigger(i, r), E = 0;
      } else E = Object(d.a)();r = a(e, n, O), N.trigger(e, r);
    }var O = e,
        k = !1,
        C = 0,
        x = 0,
        E = 0,
        S = 300,
        P = void 0,
        T = void 0;t = t || {};var _ = !!s.Features.passiveEvents && { passive: !t.preventScrolling };m ? (e.addEventListener("pointerdown", h, _), t.useHover && (e.addEventListener("pointerover", n), e.addEventListener("pointerout", f)), t.useMove && e.addEventListener("pointermove", c)) : (y && (e.addEventListener("mousedown", h, _), t.useHover && (e.addEventListener("mouseover", n), e.addEventListener("mouseout", f)), t.useMove && e.addEventListener("mousemove", c)), e.addEventListener("touchstart", h, _)), e.addEventListener("keydown", p), t.useFocus && (e.addEventListener("focus", n), e.addEventListener("blur", f));var N = this;return this.triggerEvent = j, this.destroy = function () {
      this.off(), e.removeEventListener("touchstart", h), e.removeEventListener("mousedown", h), e.removeEventListener("keydown", p), P && (P.removeEventListener("touchmove", g), P.removeEventListener("touchcancel", w), P.removeEventListener("touchend", w), P = null), m && (t.preventScrolling && e.releasePointerCapture(T), e.removeEventListener("pointerover", n), e.removeEventListener("pointerdown", h), e.removeEventListener("pointermove", g), e.removeEventListener("pointermove", c), e.removeEventListener("pointercancel", w), e.removeEventListener("pointerout", f), e.removeEventListener("pointerup", w)), e.removeEventListener("click", w), e.removeEventListener("mouseover", n), e.removeEventListener("mousemove", c), e.removeEventListener("mouseout", f), document.removeEventListener("mousemove", g), document.removeEventListener("mouseup", w), t.useFocus && (e.removeEventListener("focus", n), e.removeEventListener("blur", f));
    }, this;
  };p(w.prototype, f.a), t.a = w;
}, function (e, t, n) {
  var r;void 0 !== (r = function (e, t, n) {
    function r(e, t) {
      o(t, a(e));
    }function i(e, t) {
      var n = f[e];if (n) if (t) {
        var r = n[t];if (r) for (var i = 0; i < r.parts.length; i += 1) {
          r.parts[i]();
        }
      } else {
        for (var o = Object.keys(n), a = 0; a < o.length; a += 1) {
          for (var u = n[o[a]], c = 0; c < u.parts.length; c += 1) {
            u.parts[c]();
          }
        }delete f[e];
      }
    }function o(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n],
            i = (f[e] || {})[r.id];if (i) {
          for (var o = 0; o < i.parts.length; o++) {
            i.parts[o](r.parts[o]);
          }for (; o < r.parts.length; o++) {
            i.parts.push(s(e, r.parts[o]));
          }
        } else {
          for (var a = [], o = 0; o < r.parts.length; o++) {
            a.push(s(e, r.parts[o]));
          }f[e] = f[e] || {}, f[e][r.id] = { id: r.id, parts: a };
        }
      }
    }function a(e) {
      for (var t = [], n = {}, r = 0; r < e.length; r++) {
        var i = e[r],
            o = i[0],
            a = i[1],
            u = i[2],
            c = { css: a, media: u };n[o] ? n[o].parts.push(c) : t.push(n[o] = { id: o, parts: [c] });
      }return t;
    }function u(e) {
      p().appendChild(e);
    }function c(e) {
      var t = document.createElement("style");return t.type = "text/css", t.setAttribute("data-jwplayer-id", e), u(t), t;
    }function s(e, t) {
      var n,
          r,
          i,
          o = d[e];o || (o = d[e] = { element: c(e), counter: 0 });var a = o.counter++;return n = o.element, r = function r(e) {
        l(n, a, e);
      }, i = function i() {
        l(n, a, "");
      }, r(t.css), function (e) {
        if (e) {
          if (e.css === t.css && e.media === t.media) return;t = e, r(t.css);
        } else i();
      };
    }function l(e, t, n) {
      if (e.styleSheet) e.styleSheet.cssText = v(t, n);else {
        var r = document.createTextNode(n),
            i = e.childNodes,
            o = i[t];o ? e.replaceChild(r, o) : e.appendChild(r);
      }
    }var f = {},
        d = {},
        p = function (e) {
      var t;return function () {
        return void 0 === t && (t = e.apply(this, arguments)), t;
      };
    }(function () {
      return document.head || document.getElementsByTagName("head")[0];
    });n.exports = { style: r, clear: i };var v = function () {
      var e = [];return function (t, n) {
        return e[t] = n, e.filter(Boolean).join("\n");
      };
    }();
  }.call(t, n, t, e)) && (e.exports = r);
}, function (e, t, n) {
  "use strict";
  function r(e, t, n) {
    function r() {
      for (; i.length > 0;) {
        var t = i.shift(),
            n = t.command,
            r = t.args;(o[n] || e[n]).apply(e, r);
      }
    }var i = [],
        o = {};t.forEach(function (t) {
      var a = e[t];o[t] = a, e[t] = function () {
        var e = Array.prototype.slice.call(arguments, 0);n() ? i.push({ command: t, args: e }) : (r(), a && a.apply(this, e));
      };
    }), Object.defineProperty(this, "queue", { enumerable: !0, get: function get() {
        return i;
      } }), this.flush = r, this.empty = function () {
      i.length = 0;
    }, this.off = function () {
      t.forEach(function (t) {
        var n = o[t];n && (e[t] = n, delete o[t]);
      });
    }, this.destroy = function () {
      this.off(), this.empty();
    };
  }t.a = r;
}, function (e, t, n) {
  "use strict";
  function r(e, t) {
    var n = t.indexOf(":") + 1,
        r = n > 0 ? t.substr(0, n) : "Error loading player:",
        u = t.substr(n),
        c = i(e.get("id"), r, u),
        s = e.get("width"),
        l = e.get("height"),
        f = Object(o.e)(c);return Object(a.d)(f, { width: s.toString().indexOf("%") > 0 ? s : s + "px", height: l.toString().indexOf("%") > 0 ? l : l + "px" }), f;
  }var i = function i(e) {
    return '<div id="' + e + '" class="jw-error jw-reset"><div class="jw-error-msg jw-reset"><style>[id="' + e + '"].jw-error{position:relative;background:#000;overflow:hidden;position:relative}[id="' + e + '"] .jw-error-msg{top:50%;left:50%;position:absolute;align-items:center;display:flex;transform:translate(-50%,-50%)}[id="' + e + '"] .jw-title{color:#FFF;position:static}[id="' + e + '"] .jw-title-primary,[id="' + e + '"] .jw-title-secondary{font:600 14px/1.35 Arial,Helvetica,sans-serif}[id="' + e + '"] .jw-title-secondary{font-weight:400}</style><div class="jw-icon jw-reset"></div><div class="jw-title jw-reset"><div class="jw-title-primary jw-reset">' + (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "") + '</div><div class="jw-title-secondary jw-reset">' + (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "") + "</div></div></div></div>";
  },
      o = n(25),
      a = n(26);t.a = r;
}, function (e, t, n) {
  "use strict";
  var r = n(7),
      i = { on: r.a.on, once: r.a.once, off: r.a.off, trigger: r.a.trigger, get: function get(e) {
      return this.attributes = this.attributes || {}, this.attributes[e];
    }, set: function set(e, t) {
      if (this.attributes = this.attributes || {}, this.attributes[e] !== t) {
        var n = this.attributes[e];this.attributes[e] = t, this.trigger("change:" + e, this, t, n);
      }
    }, clone: function clone() {
      var e = {},
          t = this.attributes;if (t) for (var n in t) {
        e[n] = t[n];
      }return e;
    }, change: function change(e, t, n) {
      this.on("change:" + e, t, n);var r = this.get(e);return t.call(n, this, r, r), this;
    } };t.a = i;
}, function (e, t, n) {
  "use strict";
  n.d(t, "b", function () {
    return i;
  }), n.d(t, "a", function () {
    return o;
  });var r = n(5),
      i = { audioMode: !1, flashBlocked: !1, item: 0, itemMeta: {}, playbackRate: 1, playRejected: !1, state: r._5, itemReady: !1 },
      o = { position: 0, duration: 0, buffer: 0 };
}, function (e, t, n) {
  "use strict";
  var r = n(5),
      i = function i() {},
      o = function o() {
    return !1;
  },
      a = { name: "default" },
      u = function u() {
    return a;
  },
      c = { supports: o, play: i, pause: i, preload: i, load: i, stop: i, volume: i, mute: i, seek: i, resize: i, remove: i, destroy: i, eventsOn_: i, eventsOff_: i, setVisibility: i, setFullscreen: i, getFullscreen: o, getContainer: i, setContainer: o, getName: u, getQualityLevels: i, getCurrentQuality: i, setCurrentQuality: i, getAudioTracks: i, getCurrentAudioTrack: i, setCurrentAudioTrack: i, setPlaybackRate: i, getPlaybackRate: function getPlaybackRate() {
      return 1;
    }, checkComplete: i, setControls: i, attachMedia: i, detachMedia: i, init: i, setState: function setState(e) {
      this.state = e, this.trigger(r.T, { newstate: e });
    }, sendMediaType: function sendMediaType(e) {
      var t = e[0].type,
          n = "oga" === t || "aac" === t || "mp3" === t || "mpeg" === t || "vorbis" === t;this.trigger(r.L, { mediaType: n ? "audio" : "video" });
    } };t.a = c;
}, function (e, t, n) {
  "use strict";
  function r(e) {
    Object.keys(e).forEach(function (t) {
      "id" !== t && (e[t] = Object(S.serialize)(e[t]));
    });
  }function i(e) {
    return e.slice && "px" === e.slice(-2) && (e = e.slice(0, -2)), e;
  }function o(e, t) {
    if (-1 === t.toString().indexOf("%")) return 0;if ("string" != typeof e || !e) return 0;if (/^\d*\.?\d+%$/.test(e)) return e;var n = e.indexOf(":");if (-1 === n) return 0;var r = parseFloat(e.substr(0, n)),
        i = parseFloat(e.substr(n + 1));return r <= 0 || i <= 0 ? 0 : i / r * 100 + "%";
  }function a(e) {
    var t = e.flashplayer;return t || (t = (Object(E.getScriptPath)("jwplayer.js") || e.base) + "jwplayer.flash.swf"), "http:" === window.location.protocol && (t = t.replace(/^https/, "http")), t;
  }function u(e) {
    var t = "file:" === window.location.protocol ? "https:" : "",
        n = { jwpsrv: "//ssl.p.jwpcdn.com/player/v/8.1.11/jwpsrv.js", dai: "//ssl.p.jwpcdn.com/player/plugins/dai/v/0.2.1/dai.js", vast: "//ssl.p.jwpcdn.com/player/plugins/vast/v/8.1.3/vast.js", googima: "//ssl.p.jwpcdn.com/player/plugins/googima/v/8.1.9/googima.js", freewheel: "//ssl.p.jwpcdn.com/player/plugins/freewheel/v/2.1.2/freewheel.js", related: "//ssl.p.jwpcdn.com/player/plugins/related/v/6.1.6/related.js", gapro: "//ssl.p.jwpcdn.com/player/plugins/gapro/v/2.1.3/gapro.js" },
        r = n[e];return r ? t + r : "";
  }function c(e, t, n) {
    if (t) {
      e[t.client || u(n)] = t, delete t.client;
    }
  }function s(e) {
    var t = M({}, e.plugins),
        n = e.edition,
        r = Object(A.a)(n);if (r("ads")) {
      var i = M({}, e.advertising),
          o = i.client;if (o) {
        t[u(o) || o] = i, delete i.client;
      }
    }if (r("jwpsrv")) {
      var a = e.analytics;a !== Object(a) && (a = {}), c(t, a, "jwpsrv");
    }c(t, e.ga, "gapro");var s = e.related,
        l = s === Object(s) && r("discovery");if (!1 !== e.controls || l) {
      var f = !1 !== e.visualplaylist || l;l || (s = { disableRelated: !0 }), s.showButton = f, c(t, s, "related");
    }return t;
  }function l(e) {
    var t = e.get("playlist");if ("string" == typeof t) return new q.a(function (n, r) {
      var i = new D.a();i.on(B.W, function (t) {
        var r = t.playlist;delete t.playlist, f(e, r, t), n();
      }), i.on(B.q, function (t) {
        f(e, [], {}), r(new Error("Error loading playlist: " + t.message));
      }), i.load(t);
    });var n = e.get("feedData") || {};return f(e, t, n), q.b;
  }function f(e, t, n) {
    var r = e.attributes;r.playlist = Object(Q.a)(t), r.feedData = n;
  }function d(e) {
    return l(e).then(function () {
      if (!h(e)) {
        var t = Object(Q.b)(e.get("playlist"), e);Object(Q.c)(t);var n = e.getProviders(),
            r = n.required([t[0]]);if (!R.a.html5 || !r || "html5" !== r[0].name) return n.load(r);
      }
    });
  }function p(e) {
    for (var t = document.styleSheets, n = 0, r = t.length; n < r; n++) {
      if (t[n].href === e) return !0;
    }return !1;
  }function v(e) {
    var t = e.get("skin") ? e.get("skin").url : void 0;if ("string" == typeof t && !p(t)) {
      return new X.a(t, !0).load().catch(function (e) {
        return e;
      });
    }return q.b;
  }function h(e) {
    return e.attributes._destroyed;
  }function m(e) {
    return l(e).then(function () {
      return e.get("drm") || Object(W.b)(e.get("playlist")) ? Object(W.d)(e.get("edition")) : q.b;
    });
  }function g(e) {
    return m(e).then(function () {
      return V(e);
    });
  }function y(e, t) {
    this.namespace = e, this.items = t;
  }function b() {
    for (var e = oe.c, t = [], n = [], r = 0; r < e; r++) {
      var i = j();t.push(i), n.push(i);
    }var o = n.shift();return { prime: function prime() {
        t.forEach(w);
      }, getPrimedElement: function getPrimedElement() {
        return n.length ? n.shift() : null;
      }, getAdElement: function getAdElement() {
        return o;
      }, clean: function clean(e) {
        if (e.src) {
          e.removeAttribute("src");try {
            e.load();
          } catch (e) {}
        }
      }, recycle: function recycle(e) {
        e && !n.some(function (t) {
          return t === e;
        }) && (this.clean(e), n.push(e));
      }, syncVolume: function syncVolume(e) {
        t.forEach(function (t) {
          t.volume = e / 100;
        });
      }, syncMute: function syncMute(e) {
        t.forEach(function (t) {
          t.muted = e;
        });
      } };
  }function w(e) {
    if (e.src) {
      if (ae.OS.android && !e.parentNode) {
        var t = e.played;(!t || t && !t.length) && e.load();
      }
    } else e.load();
  }function j() {
    var e = document.createElement("video");return e.className = "jw-video jw-reset", e.setAttribute("disableRemotePlayback", ""), e.setAttribute("webkit-playsinline", ""), e.setAttribute("playsinline", ""), e;
  }function O(e, t) {
    q.b.then(function () {
      var n = t.message,
          r = t.code,
          i = Object(ie.a)(e, n);ie.a.cloneIcon && i.querySelector(".jw-icon").appendChild(ie.a.cloneIcon("error")), k(e, i);var o = { message: n, code: r, error: t },
          a = e._model || e.modelShim;a.set("errorEvent", o), a.set("state", B._4), e.trigger(B._1, o);
    });
  }function k(e, t) {
    if (!document.body.contains(e.currentContainer)) {
      var n = document.getElementById(e.get("id"));n && (e.currentContainer = n);
    }e.currentContainer.parentElement && e.currentContainer.parentElement.replaceChild(t, e.currentContainer), e.currentContainer = t;
  }var C = n(40),
      x = n(0),
      E = n(16),
      S = n(12),
      P = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }return e;
  },
      T = { autostart: !1, castAvailable: !1, controls: !0, defaultPlaybackRate: 1, displaydescription: !0, displaytitle: !0, height: 360, liveTimeout: null, localization: { player: "Video Player", play: "Play", playback: "Start Playback", pause: "Pause", volume: "Volume", prev: "Previous", next: "Next", cast: "Chromecast", airplay: "AirPlay", fullscreen: "Fullscreen", playlist: "Playlist", hd: "Quality", cc: "Closed Captions", audioTracks: "Audio Tracks", playbackRates: "Playback Rates", replay: "Replay", buffer: "Loading", more: "More", liveBroadcast: "Live", loadingAd: "Loading ad", rewind: "Rewind 10 Seconds", nextUp: "Next Up", nextUpClose: "Next Up Close", related: "More Videos", close: "Close", settings: "Settings", unmute: "Unmute", copied: "Copied" }, mute: !1, nextUpDisplay: !0, playbackRateControls: !1, playbackRates: [.5, 1, 1.25, 1.5, 2], renderCaptionsNatively: !1, repeat: !1, stretching: "uniform", volume: 90, width: 640 },
      _ = function _(e, t) {
    var a = P({}, (window.jwplayer || {}).defaults, t, e);r(a), a.localization = P({}, T.localization, a.localization);var u = P({}, T, a);"." === u.base && (u.base = Object(E.getScriptPath)("jwplayer.js")), u.base = (u.base || Object(E.loadFrom)()).replace(/\/?$/, "/"), n.p = u.base, u.width = i(u.width), u.height = i(u.height), u.aspectratio = o(u.aspectratio, u.width);var c = u.playbackRateControls;if (c) {
      var s = u.playbackRates;Array.isArray(c) && (s = c), s = s.filter(function (e) {
        return x.c.isNumber(e) && e >= .25 && e <= 4;
      }).map(function (e) {
        return Math.round(4 * e) / 4;
      }), s.indexOf(1) < 0 && s.push(1), s.sort(), u.playbackRateControls = !0, u.playbackRates = s;
    }(!u.playbackRateControls || u.playbackRates.indexOf(u.defaultPlaybackRate) < 0) && (u.defaultPlaybackRate = 1), u.playbackRate = u.defaultPlaybackRate, u.aspectratio || delete u.aspectratio;var l = u.playlist;if (l) Array.isArray(l.playlist) && (u.feedData = l, u.playlist = l.playlist);else {
      var f = x.c.pick(u, ["title", "description", "type", "mediaid", "image", "file", "sources", "tracks", "preload", "duration"]);u.playlist = [f];
    }u.qualityLabels = u.qualityLabels || u.hlslabels, delete u.duration;var d = u.liveTimeout;return null !== d && (Object(x.a)(d) || !Object(x.b)(d) ? d = null : 0 !== d && (d = Math.max(30, d)), u.liveTimeout = d), u;
  },
      N = _,
      L = n(34),
      A = n(14),
      M = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }return e;
  },
      F = function F(e, t) {
    var r = N(e, t),
        i = r.key || window.jwplayer && window.jwplayer.key,
        o = new L.a(i),
        u = o.edition();if (r.key = i, r.edition = u, r.error = null, "unlimited" === u) {
      var c = Object(E.getScriptPath)("jwplayer.js");if (!c) throw new Error("Error setting up player: Could not locate jwplayer.js script tag");n.p = c;
    }if ("invalid" === u) {
      var l = void 0 === i ? "Missing" : "Invalid";r.error = new Error("Error setting up player: " + l + " license key");
    }r.flashplayer = a(r), r.plugins = s(r);var f = r.ab;return f && Object.keys(f.tests).forEach(function (e) {
      f.tests[e].forEach(function (e) {
        e.addConfig && e.addConfig(r, e.selection);
      });
    }), r;
  },
      I = F,
      R = n(9),
      B = n(5),
      q = n(1),
      D = n(47),
      Q = n(48),
      X = n(22),
      z = function z(e) {
    return h(e) ? q.a.reject() : q.a.all([d(e), v(e)]);
  },
      V = z,
      W = n(28),
      H = n(19),
      U = function U(e) {
    var t = void 0;this.start = function (n) {
      var r = q.a.all([Object(R.c)(e), g(e), Object(H.a)(e, n)]),
          i = new q.a(function (e, n) {
        t = setTimeout(function () {
          n(new Error("Setup Timeout Error: Setup took longer than 30 seconds to complete."));
        }, 3e4);var i = function i() {
          clearTimeout(t), e();
        };r.then(i).catch(i);
      });return q.a.race([r, i]);
    }, this.destroy = function () {
      clearTimeout(t), e = null;
    };
  },
      J = U,
      $ = n(30),
      K = n(21),
      Y = n(15),
      G = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }return e;
  },
      Z = { removeItem: function removeItem() {} };try {
    Z = window.localStorage || Z;
  } catch (e) {}G(y.prototype, { getAllItems: function getAllItems() {
      var e = this;return this.items.reduce(function (t, n) {
        var r = Z[e.namespace + "." + n];return r && (t[n] = Object(S.serialize)(r)), t;
      }, {});
    }, track: function track(e) {
      var t = this;this.items.forEach(function (n) {
        e.on("change:" + n, function (e, r) {
          try {
            Z[t.namespace + "." + n] = r;
          } catch (e) {
            Y.a.debug && console.error(e);
          }
        });
      });
    }, clear: function clear() {
      var e = this;this.items.forEach(function (t) {
        Z.removeItem(e.namespace + "." + t);
      });
    } });var ee = y,
      te = n(42),
      ne = n(43),
      re = n(7),
      ie = n(41),
      oe = n(49),
      ae = n(8),
      ue = n(50);t.b = k;var ce = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }return e;
  },
      se = function se() {};ce(se.prototype, te.a);var le = function le(e) {
    this._events = {}, this.modelShim = new se(), this.modelShim._qoeItem = new K.a(), this.mediaShim = {}, this.setup = new J(this.modelShim), this.currentContainer = this.originalContainer = e, this.apiQueue = new C.a(this, ["load", "play", "pause", "seek", "stop", "playlistItem", "playlistNext", "playlistPrev", "next", "setConfig", "setCurrentAudioTrack", "setCurrentCaptions", "setCurrentQuality", "setFullscreen", "addButton", "removeButton", "castToggle", "setMute", "setVolume", "setPlaybackRate", "setCues", "resize", "setCaptions", "setControls"], function () {
      return !0;
    });
  };ce(le.prototype, { on: re.a.on, once: re.a.once, off: re.a.off, trigger: re.a.trigger, init: function init(e, t) {
      var n = this,
          r = this.modelShim,
          i = new ee("jwplayer", ["volume", "mute", "captionLabel", "qualityLabel"]),
          o = i && i.getAllItems();r.attributes = r.attributes || {}, ce(this.mediaShim, ne.a);var a = I(e, o);ce(r.attributes, a, ne.b), r.getProviders = function () {
        return new $.a(a);
      }, r.setProvider = function () {};var u = b();return ae.Features.backgroundLoading || (u = Object(ue.a)(u.getPrimedElement(), u)), u.prime(), this.setup.start(t).then(function (e) {
        var r = e[0];if (n.setup) {
          var o = n.modelShim.clone();if (o.error instanceof Error) throw o.error;var a = n.apiQueue.queue.slice(0);n.apiQueue.destroy(), ce(n, r.prototype), n.setup(o, t, n.originalContainer, n._events, a, u);var c = n._model;return i.track(c), n.updatePlaylist(c.get("playlist"), c.get("feedData"));
        }
      }).then(function () {
        n.setup && n.playerReady();
      }).catch(function (e) {
        n.setup && O(n, e);
      });
    }, playerDestroy: function playerDestroy() {
      this.apiQueue && this.apiQueue.destroy(), this.setup && this.setup.destroy(), this.off(), this._events = this._model = this.originalContainer = this.apiQueue = this.setup = null;
    }, getContainer: function getContainer() {
      return this.currentContainer;
    }, get: function get(e) {
      return e in this.mediaShim ? this.mediaShim[e] : this.modelShim.get(e);
    }, getItemQoe: function getItemQoe() {
      return this.modelShim._qoeItem;
    }, getConfig: function getConfig() {
      return ce({}, this.modelShim.attributes, this.mediaShim);
    }, getCurrentCaptions: function getCurrentCaptions() {
      return this.get("captionsIndex");
    }, getWidth: function getWidth() {
      return this.get("containerWidth");
    }, getHeight: function getHeight() {
      return this.get("containerHeight");
    }, getMute: function getMute() {
      return this.get("mute");
    }, getProvider: function getProvider() {
      return this.get("provider");
    }, getState: function getState() {
      return this.get("state");
    }, getAudioTracks: function getAudioTracks() {
      return null;
    }, getCaptionsList: function getCaptionsList() {
      return null;
    }, getQualityLevels: function getQualityLevels() {
      return null;
    }, getVisualQuality: function getVisualQuality() {
      return null;
    }, getCurrentQuality: function getCurrentQuality() {
      return -1;
    }, getCurrentAudioTrack: function getCurrentAudioTrack() {
      return -1;
    }, getSafeRegion: function getSafeRegion() {
      return { x: 0, y: 0, width: 0, height: 0 };
    }, isBeforeComplete: function isBeforeComplete() {
      return !1;
    }, isBeforePlay: function isBeforePlay() {
      return !1;
    }, createInstream: function createInstream() {
      return null;
    }, skipAd: function skipAd() {}, attachMedia: function attachMedia() {}, detachMedia: function detachMedia() {
      return null;
    } });t.a = le;
}, function (e, t, n) {
  "use strict";
  function r() {
    return o || (o = n.e(4).then(function (t) {
      var r = n(3).default;return e.controls = r, r;
    }.bind(null, n)).catch(function () {
      o = null, Object(i.b)();
    })), o;
  }n.d(t, "b", function () {
    return e;
  }), t.a = r;var i = n(9),
      o = null,
      e = {};
}, function (e, t, n) {
  "use strict";
  var r = n(5),
      i = n(13),
      o = n(37),
      a = n(6),
      u = n(7),
      c = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }return e;
  },
      s = function s() {
    function e(e) {
      try {
        var a,
            u = e.responseXML ? e.responseXML.childNodes : null,
            s = "";if (u) {
          for (var l = 0; l < u.length && (s = u[l], 8 === s.nodeType); l++) {}if ("xml" === Object(i.b)(s) && (s = s.nextSibling), "rss" === Object(i.b)(s)) {
            var f = Object(o.a)(s);a = c({ playlist: f }, f.feedData);
          }
        }if (!a) try {
          var d = JSON.parse(e.responseText);if (Array.isArray(d)) a = { playlist: d };else {
            if (!Array.isArray(d.playlist)) throw Error;a = d;
          }
        } catch (e) {
          throw new Error("Not a valid RSS/JSON feed");
        }n.trigger(r.W, a);
      } catch (e) {
        t(e.message);
      }
    }function t(e) {
      n.trigger(r.q, { message: e || "Error loading file" });
    }var n = c(this, u.a);this.load = function (n) {
      a.a.ajax(n, e, t);
    }, this.destroy = function () {
      this.off();
    };
  };t.a = s;
}, function (e, t, n) {
  "use strict";
  function r(e, t) {
    return l[e] ? e : l[t] ? t : "metadata";
  }function i(e, t, n) {
    var i = [],
        o = t.getProviders(),
        c = t.get("preload"),
        s = v({}, n);return delete s.playlist, e.forEach(function (e) {
      e = v({}, e), e.preload = r(e.preload, c), e.allSources = a(e, t), e.sources = u(e.allSources, o), e.sources.length && (e.file = e.sources[0].file, n && (e.feedData = s), i.push(e));
    }), i;
  }function o(e) {
    if (!Array.isArray(e) || 0 === e.length) throw new Error("No playable sources found");
  }function a(e, t) {
    var n = e.sources,
        i = t.get("androidhls"),
        o = t.get("safarihlsjs"),
        a = e.drm || t.get("drm"),
        u = s(e.withCredentials, t.get("withCredentials")),
        c = !1 !== t.get("hlsjsdefault");return n.map(function (t) {
      if (t !== Object(t)) return null;void 0 !== i && null !== i && (t.androidhls = i), void 0 !== o && null !== o && (t.safarihlsjs = o), void 0 !== o && null !== o && (t.safarihlsjs = o), (t.drm || a) && (t.drm = t.drm || a), t.preload = r(t.preload, e.preload);var n = s(t.withCredentials, u);return void 0 !== n && (t.withCredentials = n), c && (t.hlsjsdefault = c), Object(d.a)(t);
    }).filter(function (e) {
      return !!e;
    });
  }function u(e, t) {
    t && t.choose || (t = new p.a());var n = c(e, t);if (!n) return [];var r = n.provider,
        i = n.type;return e.filter(function (e) {
      return e.type === i && t.providerSupports(r, e);
    });
  }function c(e, t) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n],
          i = t.choose(r);if (i) return { type: r.type, provider: i.providerToCheck };
    }return null;
  }function s(e, t) {
    return void 0 === e ? t : e;
  }var l = { none: !0, metadata: !0, auto: !0 },
      f = n(24),
      d = n(36),
      p = n(30);t.b = i, t.c = o;var v = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }return e;
  },
      h = function h(e) {
    return (Array.isArray(e) ? e : [e]).map(f.a);
  };t.a = h;
}, function (e, t, n) {
  "use strict";
  n.d(t, "c", function () {
    return r;
  }), n.d(t, "b", function () {
    return i;
  }), n.d(t, "a", function () {
    return o;
  });var r = 3,
      i = 2,
      o = 1;
}, function (e, t, n) {
  "use strict";
  function r(e, t) {
    return i({}, t, { prime: function prime() {
        e.load();
      }, getPrimedElement: function getPrimedElement() {
        return e;
      }, clean: function clean() {
        t.clean(e);
      }, recycle: function recycle() {
        t.clean(e);
      } });
  }t.a = r;var i = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }return e;
  };
}, function (e, t, n) {
  "use strict";
  function r(e) {
    var t = document.createElement("a"),
        n = document.createElement("a");t.href = location.href;try {
      return n.href = e, n.href = n.href, t.protocol + "//" + t.host != n.protocol + "//" + n.host;
    } catch (e) {}return !0;
  }function i(e, t, n, i) {
    d.c.isObject(e) && (i = e, e = i.url);var s,
        l = p({ xhr: null, url: e, withCredentials: !1, retryWithoutCredentials: !1, timeout: 6e4, timeoutId: -1, oncomplete: t || v, onerror: n || v, mimeType: i && !i.responseType ? "text/xml" : "", requireValidXML: !1, responseType: i && i.plainText ? "text" : "" }, i);if ("XDomainRequest" in window && r(e)) s = l.xhr = new window.XDomainRequest(), s.onload = c(l), s.ontimeout = s.onprogress = v, h = !0;else {
      if (!("XMLHttpRequest" in window)) return void l.onerror("", e);s = l.xhr = new window.XMLHttpRequest(), s.onreadystatechange = u(l);
    }var f = a("Error loading file", l);s.onerror = f, "overrideMimeType" in s ? l.mimeType && s.overrideMimeType(l.mimeType) : h = !0;try {
      e = e.replace(/#.*$/, ""), s.open("GET", e, !0);
    } catch (e) {
      return f(e), s;
    }if (l.responseType) try {
      s.responseType = l.responseType;
    } catch (e) {}l.timeout && (l.timeoutId = setTimeout(function () {
      o(s), l.onerror("Timeout", e, s);
    }, l.timeout), s.onabort = function () {
      clearTimeout(l.timeoutId);
    });try {
      l.withCredentials && "withCredentials" in s && (s.withCredentials = !0), s.send();
    } catch (e) {
      f(e);
    }return s;
  }function o(e) {
    e.onload = null, e.onprogress = null, e.onreadystatechange = null, e.onerror = null, "abort" in e && e.abort();
  }function a(e, t) {
    return function (n) {
      var r = n.currentTarget || t.xhr;if (clearTimeout(t.timeoutId), t.retryWithoutCredentials && t.xhr.withCredentials) {
        o(r);return void i(p({}, t, { xhr: null, withCredentials: !1, retryWithoutCredentials: !1 }));
      }t.onerror(e, t.url, r);
    };
  }function u(e) {
    return function (t) {
      var n = t.currentTarget || e.xhr;if (4 === n.readyState) {
        if (clearTimeout(e.timeoutId), n.status >= 400) {
          var r;return r = 404 === n.status ? "File not found" : n.status + "(" + n.statusText + ")", e.onerror(r, e.url, n);
        }if (200 === n.status) return c(e)(t);
      }
    };
  }function c(e) {
    return function (t) {
      var n = t.currentTarget || e.xhr;if (clearTimeout(e.timeoutId), e.responseType) {
        if ("json" === e.responseType) return s(n, e);
      } else {
        var r,
            i = n.responseXML;if (i) try {
          r = i.firstChild;
        } catch (e) {}if (i && r) return l(n, i, e);if (h && n.responseText && !i && (i = Object(f.parseXML)(n.responseText)) && i.firstChild) return l(n, i, e);if (e.requireValidXML) return void e.onerror("Invalid XML", e.url, n);
      }e.oncomplete(n);
    };
  }function s(e, t) {
    if (!e.response || d.c.isString(e.response) && '"' !== e.responseText.substr(1)) try {
      e = p({}, e, { response: JSON.parse(e.responseText) });
    } catch (n) {
      return void t.onerror("Invalid JSON", t.url, e);
    }return t.oncomplete(e);
  }function l(e, t, n) {
    var r = t.documentElement;return n.requireValidXML && ("parsererror" === r.nodeName || r.getElementsByTagName("parsererror").length) ? void n.onerror("Invalid XML", n.url, e) : (e.responseXML || (e = p({}, e, { responseXML: t })), n.oncomplete(e));
  }t.b = r, t.a = i;var f = n(12),
      d = n(0),
      p = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }return e;
  },
      v = function v() {},
      h = !1;
}, function (e, t, n) {
  "use strict";
  function r(e) {
    return "hls" === e.type && i.OS.android ? !1 !== e.androidhls && !i.Browser.firefox && parseFloat(i.OS.version.version) >= 4.4 : null;
  }t.a = r;var i = n(8);
}, function (e, t, n) {
  "use strict";
  function r(e, t) {
    var n = new y.a(t);return n.on(b.Z, function (t) {
      e._qoe.tick("ready"), t.setupTime = e._qoe.between("setup", "ready");
    }), n.on("all", function (t, n) {
      e.trigger(t, n);
    }), n;
  }function i(e, t) {
    e.off(), t.playerDestroy(), t.getContainer().removeAttribute("data-jwplayer-id");
  }function o(e) {
    for (var t = s.a.length; t--;) {
      if (s.a[t].uniqueId === e.uniqueId) {
        s.a.splice(t, 1);break;
      }
    }
  }function a(e) {
    var t = ++x,
        n = e.id || "player-" + t,
        a = new w.a(),
        u = {},
        c = r(this, e);a.tick("init"), e.setAttribute("data-jwplayer-id", n), Object.defineProperties(this, { id: { get: function get() {
          return n;
        } }, uniqueId: { get: function get() {
          return t;
        } }, plugins: { get: function get() {
          return u;
        } }, _qoe: { get: function get() {
          return a;
        } }, version: { get: function get() {
          return h.a;
        } }, Events: { get: function get() {
          return j.a;
        } }, utils: { get: function get() {
          return O.a;
        } }, _: { get: function get() {
          return k.c;
        } } }), C(this, { _events: {}, setup: function setup(t) {
        return a.clear("ready"), a.tick("setup"), i(this, c), c = r(this, e), t.id = n, c.init(t, this), this.on(t.events, null, this);
      }, remove: function remove() {
        return o(this), this.trigger("remove"), i(this, c), this;
      }, qoe: function qoe() {
        var e = c.getItemQoe();return { setupTime: this._qoe.between("setup", "ready"), firstFrame: e.getFirstFrame ? e.getFirstFrame() : null, player: this._qoe.dump(), item: e.dump() };
      }, getAudioTracks: function getAudioTracks() {
        return c.getAudioTracks();
      }, getBuffer: function getBuffer() {
        return c.get("buffer");
      }, getCaptions: function getCaptions() {
        return c.get("captions");
      }, getCaptionsList: function getCaptionsList() {
        return c.getCaptionsList();
      }, getConfig: function getConfig() {
        return c.getConfig();
      }, getContainer: function getContainer() {
        return c.getContainer();
      }, getControls: function getControls() {
        return c.get("controls");
      }, getCurrentAudioTrack: function getCurrentAudioTrack() {
        return c.getCurrentAudioTrack();
      }, getCurrentCaptions: function getCurrentCaptions() {
        return c.getCurrentCaptions();
      }, getCurrentQuality: function getCurrentQuality() {
        return c.getCurrentQuality();
      }, getDuration: function getDuration() {
        return c.get("duration");
      }, getEnvironment: function getEnvironment() {
        return g;
      }, getFullscreen: function getFullscreen() {
        return c.get("fullscreen");
      }, getHeight: function getHeight() {
        return c.getHeight();
      }, getItemMeta: function getItemMeta() {
        return c.get("itemMeta") || {};
      }, getMute: function getMute() {
        return c.getMute();
      }, getPlaybackRate: function getPlaybackRate() {
        return c.get("playbackRate");
      }, getPlaylist: function getPlaylist() {
        return c.get("playlist");
      }, getPlaylistIndex: function getPlaylistIndex() {
        return c.get("item");
      }, getPlaylistItem: function getPlaylistItem(e) {
        if (!O.a.exists(e)) return c.get("playlistItem");var t = this.getPlaylist();return t ? t[e] : null;
      }, getPosition: function getPosition() {
        return c.get("position");
      }, getProvider: function getProvider() {
        return c.getProvider();
      }, getQualityLevels: function getQualityLevels() {
        return c.getQualityLevels();
      }, getSafeRegion: function getSafeRegion() {
        var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];return c.getSafeRegion(e);
      }, getState: function getState() {
        return c.getState();
      }, getStretching: function getStretching() {
        return c.get("stretching");
      }, getViewable: function getViewable() {
        return c.get("viewable");
      }, getVisualQuality: function getVisualQuality() {
        return c.getVisualQuality();
      }, getVolume: function getVolume() {
        return c.get("volume");
      }, getWidth: function getWidth() {
        return c.getWidth();
      }, setCaptions: function setCaptions(e) {
        return c.setCaptions(e), this;
      }, setConfig: function setConfig(e) {
        return c.setConfig(e), this;
      }, setControls: function setControls(e) {
        return c.setControls(e), this;
      }, setCurrentAudioTrack: function setCurrentAudioTrack(e) {
        c.setCurrentAudioTrack(e);
      }, setCurrentCaptions: function setCurrentCaptions(e) {
        c.setCurrentCaptions(e);
      }, setCurrentQuality: function setCurrentQuality(e) {
        c.setCurrentQuality(e);
      }, setFullscreen: function setFullscreen(e) {
        return c.setFullscreen(e), this;
      }, setMute: function setMute(e) {
        return c.setMute(e), this;
      }, setPlaybackRate: function setPlaybackRate(e) {
        return c.setPlaybackRate(e), this;
      }, setCues: function setCues(e) {
        return c.setCues(e), this;
      }, setVolume: function setVolume(e) {
        return c.setVolume(e), this;
      }, load: function load(e, t) {
        return c.load(e, t), this;
      }, play: function play(e) {
        return c.play(e), this;
      }, pause: function pause(e) {
        return c.pause(e), this;
      }, playToggle: function playToggle(e) {
        switch (this.getState()) {case b._8:case b._2:
            return this.pause(e);default:
            return this.play(e);}
      }, seek: function seek(e, t) {
        return c.seek(e, t), this;
      }, playlistItem: function playlistItem(e, t) {
        return c.playlistItem(e, t), this;
      }, playlistNext: function playlistNext(e) {
        return c.playlistNext(e), this;
      }, playlistPrev: function playlistPrev(e) {
        return c.playlistPrev(e), this;
      }, next: function next() {
        return c.next(), this;
      }, castToggle: function castToggle() {
        return c.castToggle(), this;
      }, createInstream: function createInstream() {
        return c.createInstream();
      }, skipAd: function skipAd() {
        return c.skipAd(), this;
      }, stop: function stop() {
        return c.stop(), this;
      }, resize: function resize(e, t) {
        return c.resize(e, t), this;
      }, addButton: function addButton(e, t, n, r, i) {
        return c.addButton(e, t, n, r, i), this;
      }, removeButton: function removeButton(e) {
        return c.removeButton(e), this;
      }, attachMedia: function attachMedia() {
        return c.attachMedia(), this;
      }, detachMedia: function detachMedia() {
        return c.detachMedia(), this;
      }, isBeforeComplete: function isBeforeComplete() {
        return c.isBeforeComplete();
      }, isBeforePlay: function isBeforePlay() {
        return c.isBeforePlay();
      } });
  }function u(e) {
    for (var t = 0; t < s.a.length; t++) {
      if (s.a[t].id === e) return s.a[t];
    }return null;
  }Object.defineProperty(t, "__esModule", { value: !0 });var c = n(16),
      s = n(27),
      l = n(17),
      f = n(18),
      d = { availableProviders: l.a, registerProvider: f.a },
      p = n(19);d.registerPlugin = function (e, t, n) {
    "jwpsrv" !== e && Object(p.b)(e, t, n);
  };var v = d,
      h = n(20),
      m = n(15),
      g = n(8),
      y = n(45),
      b = n(5),
      w = n(21),
      j = n(7),
      O = n(6),
      k = n(0),
      C = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }return e;
  },
      x = 0;C(a.prototype, { on: function on(e, t, n) {
      return j.c.call(this, e, t, n);
    }, once: function once(e, t, n) {
      return j.d.call(this, e, t, n);
    }, off: function off(e, t, n) {
      return j.b.call(this, e, t, n);
    }, trigger: function trigger(e, t) {
      return t = k.c.isObject(t) ? C({}, t) : {}, t.type = e, m.a.debug ? j.e.call(this, e, t) : j.f.call(this, e, t);
    }, getPlugin: function getPlugin(e) {
      return this.plugins[e];
    }, addPlugin: function addPlugin(e, t) {
      this.plugins[e] = t, this.on("ready", t.addToPlayer), t.resize && this.on("resize", t.resizeHandler);
    }, registerPlugin: function registerPlugin(e, t, n) {
      Object(p.b)(e, t, n);
    }, getAdBlock: function getAdBlock() {
      return !1;
    }, playAd: function playAd(e) {}, pauseAd: function pauseAd(e) {} }), n.p = Object(c.loadFrom)();var E = function E(e) {
    var t = void 0,
        n = void 0;if (e ? "string" == typeof e ? (t = u(e)) || (n = document.getElementById(e)) : "number" == typeof e ? t = s.a[e] : e.nodeType && (n = e, t = u(n.id || n.getAttribute("data-jwplayer-id"))) : t = s.a[0], t) return t;if (n) {
      var r = new a(n);return s.a.push(r), r;
    }return { registerPlugin: p.b };
  };Object.defineProperties(E, { api: { get: function get() {
        return v;
      }, set: function set() {} }, version: { get: function get() {
        return h.a;
      }, set: function set() {} }, debug: { get: function get() {
        return m.a.debug;
      }, set: function set(e) {
        m.a.debug = !!e;
      } } });var S = E,
      P = n(38),
      T = n(34),
      _ = n(22),
      N = n(35),
      L = n(37),
      A = n(32),
      M = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }return e;
  },
      F = k.c.extend,
      I = {};I.api = v, I._ = k.c, I.version = "8.1.11+commercial_v8-1-11.245.commercial.5be18a.hlsjs..jwplayer.c9fefd.dai.c24260.freewheel.782b72.googima.32098a.vast.520a81.jwpsrv.785f4d.gapro.fb7ea6.related.bce080", I.utils = M(O.a, { key: T.a, extend: F, scriptloader: _.a, rssparser: { parse: L.a }, tea: N.a, UI: P.a }), I.utils.css.style = I.utils.style, I.vid = A.a;var R = I,
      B = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }return e;
  },
      q = window;B(S, R), "function" == typeof q.define && q.define.amd && q.define([], function () {
    return S;
  });var D = S;q.jwplayer && (D = q.jwplayer);t.default = D;
}]).default;
}.call(window));

/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports = {"playlistUrlBase":"//content.jwplatform.com/jw6/","settings":{"advertising":{"vpaidmode":"disabled","client":"vast","schedule":"","skipoffset":5,"skipmessage":"Omitir en \"xx\"","skiptext":"Omitir","admessage":"Este video comenzará en \"xx\" segundos."},"aspectratio":"16:9","autostart":false,"controls":true,"displaydescription":false,"displaytitle":false,"flashplayer":"//ssl.p.jwpcdn.com/player/v/8.1.11/jwplayer.flash.swf","ga":{"idstring":"title"},"height":270,"mute":false,"ph":1,"pid":"M4wOsGBi","playbackRateControls":false,"primary":"html5","hlshtml":true,"plugins":{"ping":{}},"preload":"none","repeat":false,"sharing":{"code":"%3Ciframe%20src%3D%22//content.jwplatform.com/players/MEDIAID-M4wOsGBi.html%22%20width%3D%22640%22%20height%3D%22360%22%20frameborder%3D%220%22%20scrolling%3D%22auto%22%3E%3C/iframe%3E","sites":[],"heading":"Compartir"},"stagevideo":false,"stretching":"uniform","visualplaylist":false,"width":"100%"}}

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*! pym.js - v1.3.2 - 2018-02-13 */

!function (a) {
   true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (a),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "undefined" != typeof module && module.exports ? module.exports = a() : window.pym = a.call(this);
}(function () {
  var a = {},
      b = function b(a) {
    var b = document.createEvent("Event");b.initEvent("pym:" + a, !0, !0), document.dispatchEvent(b);
  },
      c = function c(a) {
    var b = new RegExp("[\\?&]" + a.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]") + "=([^&#]*)"),
        c = b.exec(location.search);return null === c ? "" : decodeURIComponent(c[1].replace(/\+/g, " "));
  },
      d = function d(a, b) {
    if (("*" === b.xdomain || a.origin.match(new RegExp(b.xdomain + "$"))) && "string" == typeof a.data) return !0;
  },
      e = function e(a) {
    var b = /^(?:(?:https?|mailto|ftp):|[^&:\/?#]*(?:[\/?#]|$))/gi;if (a.match(b)) return !0;
  },
      f = function f(a, b, c) {
    return ["pym", a, b, c].join("xPYMx");
  },
      g = function g(a) {
    var b = ["pym", a, "(\\S+)", "(.*)"];return new RegExp("^" + b.join("xPYMx") + "$");
  },
      h = Date.now || function () {
    return new Date().getTime();
  },
      i = function i(a, b, c) {
    var d,
        e,
        f,
        g = null,
        i = 0;c || (c = {});var j = function j() {
      i = !1 === c.leading ? 0 : h(), g = null, f = a.apply(d, e), g || (d = e = null);
    };return function () {
      var k = h();i || !1 !== c.leading || (i = k);var l = b - (k - i);return d = this, e = arguments, l <= 0 || l > b ? (g && (clearTimeout(g), g = null), i = k, f = a.apply(d, e), g || (d = e = null)) : g || !1 === c.trailing || (g = setTimeout(j, l)), f;
    };
  },
      j = function j() {
    for (var b = a.autoInitInstances.length, c = b - 1; c >= 0; c--) {
      var d = a.autoInitInstances[c];d.el.getElementsByTagName("iframe").length && d.el.getElementsByTagName("iframe")[0].contentWindow || a.autoInitInstances.splice(c, 1);
    }
  };return a.autoInitInstances = [], a.autoInit = function (c) {
    var d = document.querySelectorAll("[data-pym-src]:not([data-pym-auto-initialized])"),
        e = d.length;j();for (var f = 0; f < e; ++f) {
      var g = d[f];g.setAttribute("data-pym-auto-initialized", ""), "" === g.id && (g.id = "pym-" + f + "-" + Math.random().toString(36).substr(2, 5));var h = g.getAttribute("data-pym-src"),
          i = { xdomain: "string", title: "string", name: "string", id: "string", sandbox: "string", allowfullscreen: "boolean", parenturlparam: "string", parenturlvalue: "string", optionalparams: "boolean", trackscroll: "boolean", scrollwait: "number" },
          k = {};for (var l in i) {
        if (null !== g.getAttribute("data-pym-" + l)) switch (i[l]) {case "boolean":
            k[l] = !("false" === g.getAttribute("data-pym-" + l));break;case "string":
            k[l] = g.getAttribute("data-pym-" + l);break;case "number":
            var m = Number(g.getAttribute("data-pym-" + l));isNaN(m) || (k[l] = m);break;default:
            console.err("unrecognized attribute type");}
      }var n = new a.Parent(g.id, h, k);a.autoInitInstances.push(n);
    }return c || b("pym-initialized"), a.autoInitInstances;
  }, a.Parent = function (a, b, c) {
    this.id = a, this.url = b, this.el = document.getElementById(a), this.iframe = null, this.settings = { xdomain: "*", optionalparams: !0, parenturlparam: "parentUrl", parenturlvalue: window.location.href, trackscroll: !1, scrollwait: 100 }, this.messageRegex = g(this.id), this.messageHandlers = {}, c = c || {}, this._constructIframe = function () {
      var a = this.el.offsetWidth.toString();this.iframe = document.createElement("iframe");var b = "",
          c = this.url.indexOf("#");for (c > -1 && (b = this.url.substring(c, this.url.length), this.url = this.url.substring(0, c)), this.url.indexOf("?") < 0 ? this.url += "?" : this.url += "&", this.iframe.src = this.url + "initialWidth=" + a + "&childId=" + this.id, this.settings.optionalparams && (this.iframe.src += "&parentTitle=" + encodeURIComponent(document.title), this.iframe.src += "&" + this.settings.parenturlparam + "=" + encodeURIComponent(this.settings.parenturlvalue)), this.iframe.src += b, this.iframe.setAttribute("width", "100%"), this.iframe.setAttribute("scrolling", "no"), this.iframe.setAttribute("marginheight", "0"), this.iframe.setAttribute("frameborder", "0"), this.settings.title && this.iframe.setAttribute("title", this.settings.title), void 0 !== this.settings.allowfullscreen && !1 !== this.settings.allowfullscreen && this.iframe.setAttribute("allowfullscreen", ""), void 0 !== this.settings.sandbox && "string" == typeof this.settings.sandbox && this.iframe.setAttribute("sandbox", this.settings.sandbox), this.settings.id && (document.getElementById(this.settings.id) || this.iframe.setAttribute("id", this.settings.id)), this.settings.name && this.iframe.setAttribute("name", this.settings.name); this.el.firstChild;) {
        this.el.removeChild(this.el.firstChild);
      }this.el.appendChild(this.iframe), window.addEventListener("resize", this._onResize), this.settings.trackscroll && window.addEventListener("scroll", this._throttleOnScroll);
    }, this._onResize = function () {
      this.sendWidth(), this.settings.trackscroll && this.sendViewportAndIFramePosition();
    }.bind(this), this._onScroll = function () {
      this.sendViewportAndIFramePosition();
    }.bind(this), this._fire = function (a, b) {
      if (a in this.messageHandlers) for (var c = 0; c < this.messageHandlers[a].length; c++) {
        this.messageHandlers[a][c].call(this, b);
      }
    }, this.remove = function () {
      window.removeEventListener("message", this._processMessage), window.removeEventListener("resize", this._onResize), this.el.removeChild(this.iframe), j();
    }, this._processMessage = function (a) {
      if (d(a, this.settings) && "string" == typeof a.data) {
        var b = a.data.match(this.messageRegex);if (!b || 3 !== b.length) return !1;var c = b[1],
            e = b[2];this._fire(c, e);
      }
    }.bind(this), this._onHeightMessage = function (a) {
      var b = parseInt(a);this.iframe.setAttribute("height", b + "px");
    }, this._onNavigateToMessage = function (a) {
      e(a) && (document.location.href = a);
    }, this._onScrollToChildPosMessage = function (a) {
      var b = document.getElementById(this.id).getBoundingClientRect().top + window.pageYOffset,
          c = b + parseInt(a);window.scrollTo(0, c);
    }, this.onMessage = function (a, b) {
      a in this.messageHandlers || (this.messageHandlers[a] = []), this.messageHandlers[a].push(b);
    }, this.sendMessage = function (a, b) {
      this.el.getElementsByTagName("iframe").length && (this.el.getElementsByTagName("iframe")[0].contentWindow ? this.el.getElementsByTagName("iframe")[0].contentWindow.postMessage(f(this.id, a, b), "*") : this.remove());
    }, this.sendWidth = function () {
      var a = this.el.offsetWidth.toString();this.sendMessage("width", a);
    }, this.sendViewportAndIFramePosition = function () {
      var a = this.iframe.getBoundingClientRect(),
          b = window.innerWidth || document.documentElement.clientWidth,
          c = window.innerHeight || document.documentElement.clientHeight,
          d = b + " " + c;d += " " + a.top + " " + a.left, d += " " + a.bottom + " " + a.right, this.sendMessage("viewport-iframe-position", d);
    };for (var h in c) {
      this.settings[h] = c[h];
    }return this._throttleOnScroll = i(this._onScroll.bind(this), this.settings.scrollwait), this.onMessage("height", this._onHeightMessage), this.onMessage("navigateTo", this._onNavigateToMessage), this.onMessage("scrollToChildPos", this._onScrollToChildPosMessage), this.onMessage("parentPositionInfo", this.sendViewportAndIFramePosition), window.addEventListener("message", this._processMessage, !1), this._constructIframe(), this;
  }, a.Child = function (a) {
    this.parentWidth = null, this.id = null, this.parentTitle = null, this.parentUrl = null, this.settings = { renderCallback: null, xdomain: "*", polling: 0, parenturlparam: "parentUrl" }, this.timerId = null, this.messageRegex = null, this.messageHandlers = {}, a = a || {}, this.onMessage = function (a, b) {
      a in this.messageHandlers || (this.messageHandlers[a] = []), this.messageHandlers[a].push(b);
    }, this._fire = function (a, b) {
      if (a in this.messageHandlers) for (var c = 0; c < this.messageHandlers[a].length; c++) {
        this.messageHandlers[a][c].call(this, b);
      }
    }, this._processMessage = function (a) {
      if (d(a, this.settings) && "string" == typeof a.data) {
        var b = a.data.match(this.messageRegex);if (b && 3 === b.length) {
          var c = b[1],
              e = b[2];this._fire(c, e);
        }
      }
    }.bind(this), this._onWidthMessage = function (a) {
      var b = parseInt(a);b !== this.parentWidth && (this.parentWidth = b, this.settings.renderCallback && this.settings.renderCallback(b), this.sendHeight());
    }, this.sendMessage = function (a, b) {
      window.parent.postMessage(f(this.id, a, b), "*");
    }, this.sendHeight = function () {
      var a = document.getElementsByTagName("body")[0].offsetHeight.toString();return this.sendMessage("height", a), a;
    }.bind(this), this.getParentPositionInfo = function () {
      this.sendMessage("parentPositionInfo");
    }, this.scrollParentTo = function (a) {
      this.sendMessage("navigateTo", "#" + a);
    }, this.navigateParentTo = function (a) {
      this.sendMessage("navigateTo", a);
    }, this.scrollParentToChildEl = function (a) {
      var b = document.getElementById(a).getBoundingClientRect().top + window.pageYOffset;this.scrollParentToChildPos(b);
    }, this.scrollParentToChildPos = function (a) {
      this.sendMessage("scrollToChildPos", a.toString());
    };this.remove = function () {
      window.removeEventListener("message", this._processMessage), this.timerId && clearInterval(this.timerId);
    };for (var e in a) {
      this.settings[e] = a[e];
    }this.id = c("childId") || a.id, this.messageRegex = new RegExp("^pymxPYMx" + this.id + "xPYMx(\\S+)xPYMx(.*)$");var g = parseInt(c("initialWidth"));return this.parentUrl = c(this.settings.parenturlparam), this.parentTitle = c("parentTitle"), this.onMessage("width", this._onWidthMessage), window.addEventListener("message", this._processMessage, !1), this.settings.renderCallback && this.settings.renderCallback(g), this.sendHeight(), this.settings.polling && (this.timerId = window.setInterval(this.sendHeight, this.settings.polling)), function (a) {
      var c,
          d = document.getElementsByTagName("html")[0],
          e = d.className;try {
        c = window.self !== window.top ? "embedded" : "not-embedded";
      } catch (a) {
        c = "embedded";
      }e.indexOf(c) < 0 && (d.className = e ? e + " " + c : c, a && a(c), b("marked-embedded"));
    }(a.onMarkedEmbeddedStatus), this;
  }, "undefined" != typeof document && a.autoInit(!0), a;
});

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var tableroUrlWS = window.config.Statics.TableroUrl;
var pathDatosUrl = "obtenerTableros/procesarTablero/";
var pathCambiosWS = "obtenerCC/procesarCC/";
var isDebugging = false;
var tableros = [];

/* CodigoControl*/ /////////////////////////////////////////////////////////////////////////////
var codigoControl = function codigoControl(encuentroId, _codigoControl) {
    //console.log("this " + this)
    this._encuentroId = encuentroId, this._codigo = parseInt("0x" + _codigoControl, 16), this._encuentro = 0x0000000F & this._codigo, this._incidencias = (0x0000FFF0 & this._codigo) >> 4, this._formaciones = (0x000F0000 & this._codigo) >> 16, this._imagenes = (0x0FF00000 & this._codigo) >> 20, this._tablero = (0xF0000000 & this._codigo) >> 28, this.encuentroId = function () {
        return this._encuentroId;
    }, this.incidencias = function () {
        return this._incidencias;
    }, this.encuentro = function () {
        return this._encuentro;
    }, this.formaciones = function () {
        return this._formaciones;
    }, this.imagenes = function () {
        return this._imagenes;
    }, this.tablero = function () {
        return this._tablero;
    }, this.isTypeOf = function (value) {
        var _isTypeCodigoControl = false;
        if (value == "codigoControl") _isTypeCodigoControl = !_isTypeCodigoControl;
        return _isTypeCodigoControl;
    };
    return false;
};

/* metodo que recibe un array en notacion json ej: {"cc":[{"id":000,"valor":001},{..},{..}]} */
/* lo convierte en array de objetos tipo CodigoControl */
function factoryCodigoControl(arr) {
    var list = new Array();
    //  console.log("factoryCodigoControl")
    try {
        for (var x = 0; x <= arr.length - 1; x++) {
            var codControl = new codigoControl(arr[x].id, arr[x].valor);
            list.push(codControl);
        }
    } catch (err) {
        if (isDebugging) {
            showError('factoryCodigoControl', err);
        };
    }
    return list;
};

/*recibe una lista de objetos de tipo ComparadorCodigoControl*/
/*devuelve una lista de objetos CodigoSolicitud concatenados */
function generarUrlParamCodigoSolicitud(arr) {
    try {
        var list = new Array();
        for (var x = 0; x <= arr.length - 1; x++) {
            var cs = new codigoSolicitud(arr[x].cambiosEncuentro(), arr[x].cambiosIncidencias(), arr[x].cambiosFormaciones());
            // verifico si hay cambios.                             
            if (!cs.allFalse()) {
                list.push(arr[x].encuentroId() + "-" + cs.toString() + "1");
            };
        }
        /// agregar la validacion de todos, que hago si ninguno va?
        return list.toString();
    } catch (err) {
        if (isDebugging) {
            showError('generarUrlParamCodigoSolicitud', err);
        };
        return "";
    }
};

/*recibe dos objetos de tipo CodigoControl y permite comparlos*/
var comparadorCodigoControl = function comparadorCodigoControl(old, newslast) {
    //  console.log("comparadorCodigoControl")
    this.encuentroId = function () {
        return old.encuentroId();
    }, this.cambiosIncidencias = function () {
        var _hayCambios = false;
        if (old.incidencias() != newslast.incidencias()) {
            _hayCambios = !_hayCambios;
        }
        return _hayCambios;
    }, this.cambiosFormaciones = function () {
        var _hayCambios = false;
        if (old.formaciones() != newslast.formaciones()) {
            _hayCambios = !_hayCambios;
        }
        return _hayCambios;
    }, this.cambiosEncuentro = function () {
        var _hayCambios = false;
        if (old.encuentro() != newslast.encuentro()) {
            _hayCambios = !_hayCambios;
        }
        return _hayCambios;
    };
};

/*recibe los parametros (booleans) relacionados con los cambios en el nuevo codigo de control*/
/*devuelve la concatenacion*/
var codigoSolicitud = function codigoSolicitud(e, i, f) {
    this.allFalse = function () {
        var _allFalse = false;
        if (!e && !i && !f) {
            _allFalse = !_allFalse;
        }
        return _allFalse;
    };

    var convert = function convert(value) {
        var _hasValue = '0';
        if (value) {
            _hasValue = '1';
        }
        return _hasValue;
    };

    this.toString = function () {
        return convert(e) + convert(i) + convert(f);
    };
};

/*agrega un objeto de tipo tablero a el array tableros*/
function agregarTablero(value) {
    tableros.push(value);
};

/* procesa el codigo de control verificando que tipo de cambios hubo */
/* solicitando la actualizacion de los tableros*/
window.procesarCC = function (json) {
    // console.log("procesarCC")
    try {
        // array de objetos comparador // 
        var _arrComparador = new Array();

        // creo los codigo de control //
        var _arr = factoryCodigoControl(json);

        // comparo los codigos de control //
        for (var i = 0; i < _arr.length; i++) {
            //console.log("buscarTablero")
            var oTablero = buscarTablero(_arr[i].encuentroId());
            //console.log("actualizarReloj")
            oTablero.actualizarReloj();
            //console.log("codigoControl")
            var oCCOld = new codigoControl(oTablero._value.cc.id, oTablero._value.cc.valor);
            // comparo los codigo de control, el que tengo y el actualizado //
            var oComparador = new comparadorCodigoControl(oCCOld, _arr[i]);
            _arrComparador.push(oComparador);
        }
        //console.log("generarUrlParamCodigoSolicitud")
        var _param = generarUrlParamCodigoSolicitud(_arrComparador);

        /*solicito la actualizacion de los tableros*/
        /*siempre y cuando existan tableros para actualizar*/
        if (_param != "") {
            //console.log("actualizarTablero")
            actualizarTablero(_param);
        }
    } catch (err) {
        if (isDebugging) {
            showError('procesarCC', err);
        };
    }
};

var verificarCambiosCodigoControl = exports.verificarCambiosCodigoControl = function verificarCambiosCodigoControl() {
    //console.log("verificarCambiosCodigoControl")
    // tomo todos los objeto de tipo tablero de tableros[] //
    var _arr = new Array();

    try {
        //obtengo los codigo de control y defino que voy a pedir // 
        for (var i = 0; i < tableros.length; i++) {
            // armo la url con el encuentroId - cc //
            var _cadena = tableros[i]._value.cc.id;
            if (tableros[i]._estaActivo) {
                _arr.push(_cadena);
            }
        }
        _arr = Array.from(new Set(_arr));
        if (_arr.length > 0) {
            //console.log("parametros " + tableroUrlWS + pathCambiosWS + _arr.toString())
            var obj = new Object();
            obj.url = tableroUrlWS + pathCambiosWS;
            obj.pars = _arr.toString(); // recibe un cadena de ids o un objeto tablero??
            var ajaxConexion = new ajaxData(obj);
            ajaxConexion.conectar();
        }
    } catch (err) {
        if (isDebugging) {
            showError('verificarCambiosCodigoControl', err);
        };
    }
};

/*busca un objeto de tipo tablero dentro del array tableros*/
function buscarTablero(value) {
    //console.log("buscarTablero")
    var oTablero = null;
    try {
        for (var i = 0; i < tableros.length; i++) {
            if (tableros[i]._value.cc.id == value) {
                oTablero = tableros[i];
            }
        }
    } catch (err) {
        if (isDebugging) {
            showError('buscarTablero', err);
        };
    }
    return oTablero;
};

function showError(m, e) {
    alert("metodo: " + m + ", error = " + e);
}

var ajaxData = function ajaxData(options) {
    this._pars = options.pars, this._url = options.url, this._metodoCallBack = options.metodoCallBack, this.conectar = function () {
        $.ajax({
            dataType: "jsonp",
            url: this._url + this._pars,
            success: function success(json) {}
        });
    };
};
window.procesarTablero = function (json) {
    //console.log("procesarTablero")
    /*este metodo tiene que recibir un json que actualice los tableros*/
    var _arr = new Array();
    try {
        _arr = json;
        for (var i = 0; i < _arr.length; i++) {
            if (_arr[i].hasOwnProperty('cc')) {
                var oTablero = buscarTablero(_arr[i].cc.id);
                if (oTablero == null) {
                    throw err;
                } else {
                    oTablero.setValue(_arr[i]);
                }
                oTablero.execute();
            }
        };
    } catch (err) {
        if (isDebugging) {
            showError('procesarTablero', err);
        };
    }
};

/*recibe una cadena con el codigo de encuentro y el codigo de solicitud ej: 2375-111,,, */
function actualizarTablero(value) {
    try {
        /*tiene que haber una llamada al ws verificando si existen cambios para que se actualice*/
        var obj = new Object();
        obj.url = tableroUrlWS + pathDatosUrl;
        obj.pars = value; // recibe un cadena de ids
        var ajaxConexion = new ajaxData(obj);
        ajaxConexion.conectar();
    } catch (err) {
        if (isDebugging) {
            showError('actualizarTablero', err);
        };
    }
};

/*actualiza el tiempo de los tableros*/
function actualizarTiempo() {
    try {
        for (var i = 0; i < tableros.length; i++) {
            tableros[i].actualizarReloj();
        }
    } catch (err) {
        if (isDebugging) {
            showError('actualizarTiempo', err);
        };
    }
}

var iniciarTableros = exports.iniciarTableros = function iniciarTableros(tablerosParam) {
    try {
        tableros = tablerosParam;
        var _cadena = new Array();
        for (var i = 0; i < tableros.length; i++) {
            _cadena.push(tableros[i]._value.cc.id + "-" + tableros[i]._value.cc.valor);
        }
        _cadena = Array.from(new Set(_cadena));
        //console.log(_cadena.toString())
        actualizarTablero(_cadena.toString());
        //a partir de aca, una vez que se actualiza por primera vez el tablero
        // setear un intervalo de tiempo para un metodo que actualice el tiempo en los tableros.
        setInterval(actualizarTiempo, 1000);
    } catch (err) {
        if (isDebugging) {
            showError('iniciarTableros', err);
        };
    }
};

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var agregarTableroBasket = exports.agregarTableroBasket = function agregarTableroBasket(idPartido, codigoSolicitud) {

    var objTablero = new tableroBasket({ cc: { id: idPartido, valor: codigoSolicitud } });

    return objTablero;
};

/* objeto Tablero Basket */
var tableroBasket = function tableroBasket(value, isActive) {
    this._value = value;
    this._estaActivo = isActive || true;
    this._cambioEncuentro = false;
    this._cambioIncidencias = false;
    this._cambioExtras = false;
    this._cambioFormaciones = false;
    this._tieneTiempo = true;

    /* TAG A ACTUALIZAR */
    if (this._value.cc.hasOwnProperty('tipoTablero')) {
        this.TAG_RESULTADOS = this._value.cc.tipoTablero + "resultado";
        this.TAG_INCIDENCIA = this._value.cc.tipoTablero + "i";
        this.TAG_ESTADO = this._value.cc.tipoTablero + "estado";
        this.TAG_PERIODO = this._value.cc.tipoTablero + "periodo";
        this.TAG_TIEMPO = this._value.cc.tipoTablero + "tiempo";
        this.TAG_RESUMEN = this._value.cc.tipoTablero + "resumen";
    } else {
        this.TAG_RESULTADOS = "resultado";
        this.TAG_INCIDENCIA = "i";
        this.TAG_ESTADO = "estado";
        this.TAG_PERIODO = "periodo";
        this.TAG_TIEMPO = "tiempo";
        this.TAG_RESUMEN = "resumen";
    }

    /* ******************** */

    this.setValue = function (valorActualizado) {
        try {
            if (valorActualizado.hasOwnProperty('cc')) {
                this._value.cc = valorActualizado.cc;
            };
            if (valorActualizado.hasOwnProperty('encuentro')) {
                this._value.encuentro = valorActualizado.encuentro;this._cambioEncuentro = true;
            } else {
                this._cambioEncuentro = false;
            };
            if (valorActualizado.hasOwnProperty('ins')) {
                this._value.ins = valorActualizado.ins;this._cambioIncidencias = true;
            } else {
                this._cambioIncidencias = false;
            };
            if (valorActualizado.hasOwnProperty('fors')) {
                this._value.fors = valorActualizado.fors;this._cambioFormaciones = true;
            } else {
                this._cambioFormaciones = false;
            };
            if (valorActualizado.hasOwnProperty('extras')) {
                this._value.tablero = valorActualizado.extras;this._cambioExtras = true;
            } else {
                this._cambioExtras = false;
            };
        } catch (err) {
            if (isDebugging) {
                showError('tableroBasket.setValue', err);
            };
        }
    };
    this.cambiarActivo = function (isActive) {
        try {
            this._estaActivo = isActive;
        } catch (err) {
            if (isDebugging) {
                showError('tableroBasket.estaActivo', err);
            };
        }
    };
    this.tieneTiempo = function () {
        return this._tieneTiempo;
    };

    this.estaActivo = function () {
        return this._estaActivo;
    };

    this.actualizarReloj = function () {};

    this.actualizarResultado = function () {
        try {
            var local, visitante;
            if (this._value.encuentro.local.id != undefined && this._value.encuentro.visitante.id) {
                this.actualizarResultado90Minutos();
            }
        } catch (err) {
            if (isDebugging) {
                showError('tableroBasket.actualizarResultado', err);
            };
        }
    };

    this.actualizarResultado90Minutos = function () {
        var local = $("#" + this.TAG_RESULTADOS + this._value.encuentro.local.id);
        var visitante = $("#" + this.TAG_RESULTADOS + this._value.encuentro.visitante.id);

        if (local.length && visitante.length) {
            if (this._value.encuentro.estado == "1") {
                local.html("-");
                visitante.html("-");
            } else {
                local.html(this._value.encuentro.local.puntosTotales);
                visitante.html(this._value.encuentro.visitante.puntosTotales);

                if (this._value.encuentro.local.puntosTotales == "" || this._value.encuentro.local.puntosTotales == "NaN") {
                    local.html("0");
                }

                if (this._value.encuentro.visitante.puntosTotales == "" || this._value.encuentro.visitante.puntosTotales == "NaN") {
                    visitante.html("0");
                }
            }
        }
    };

    this.actualizarEstado = function () {
        try {
            var estado;
            if (this._value.encuentro.estado != undefined) {
                estado = $("#" + this.TAG_ESTADO + this._value.cc.id);
                if (this._value.encuentro.estado != '2') {
                    estado.show();
                    $("#" + this.TAG_PERIODO + this._value.cc.id).hide();
                }
                if (estado.length) {
                    switch (this._value.encuentro.estado) {
                        case "1":
                            estado.html(this.ESTADO_SIN_COMIENZO);
                            break;
                        case "2":
                            estado.html(this.ESTADO_EN_JUEGO);
                            break;
                        case "3":
                            estado.html(this.ESTADO_FINALIZADO);
                            this._estaActivo = false;
                            break;
                        case "4":
                            estado.html(this.ESTADO_SUSPENDIDO);
                            break;
                        case "5":
                            estado.html(this.ESTADO_ENTRETIEMPO);
                            break;
                    }
                }
            }
        } catch (err) {
            if (isDebugging) {
                showError('tableroBasket.actualizarEstado', err);
            };
        }
    };
    this.actualizarPeriodo = function () {
        try {
            if (this._value.encuentro.tiempo != undefined) {
                var oPeriodo = $("#" + this.TAG_PERIODO + this._value.cc.id);
                if (oPeriodo.length) {
                    if (this._value.encuentro.estado == "2") {
                        oPeriodo.html("");
                        switch (this._value.encuentro.tiempo) {
                            case "8":
                                oPeriodo.html(this.TIEMPO_UNICO);
                                break;
                            case "17":
                                oPeriodo.html(this.PRIMER_CUARTO);
                                break;
                            case "18":
                                oPeriodo.html(this.SEGUNDO_CUARTO);
                                break;
                            case "19":
                                oPeriodo.html(this.TERCER_CUARTO);
                                break;
                            case "20":
                                oPeriodo.html(this.CUARTO_CUARTO);
                                break;
                            case "21":
                                oPeriodo.html(this.TIEMPO_SUPLEMENTARIO);
                                break;
                        }
                        $("#" + this.TAG_ESTADO + this._value.cc.id).hide();
                    } else {
                        switch (this._value.encuentro.estado) {
                            case "1":
                                oPeriodo.html(this.ESTADO_SIN_COMIENZO);
                                break;
                            case "3":
                                oPeriodo.html(this.ESTADO_FINALIZADO);
                                break;
                            case "4":
                                oPeriodo.html(this.ESTADO_SUSPENDIDO);
                                break;
                            case "5":
                                oPeriodo.html(this.ESTADO_ENTRETIEMPO);
                                break;
                        }
                    }
                }
            }
        } catch (err) {
            if (isDebugging) {
                showError('tableroBasket.actualizarPeriodo', err);
            };
        }
    };

    this.actualizarIncidencia = function () {
        try {
            if (this._value.ins[0].inc.id != undefined) {
                var oIncidencia = $("#" + this.TAG_INCIDENCIA + this._value.cc.id);
                if (oIncidencia.length) {
                    var clase = "";
                    switch (this._value.ins[0].inc.tp.toLowerCase()) {
                        case "amarilla":
                            clase = "amarilla";
                            break;
                        case "roja":
                            clase = "roja";
                            break;
                        case "gol":
                            clase = "gol";
                            break;
                        case "cambio":
                            clase = "cambio";
                            break;
                        case "lesion":
                            clase = "lesion";
                        default:
                            clase = "fallo";
                            break;
                    }
                    oTextoIncidencia = $("#textoIncidencia", oIncidencia);
                    oTextoIncidencia.html(this._value.ins[0].inc.cm);
                    oIncidencia.addClass(clase).slideDown('slow').delay(7000).hide('fast', function () {
                        $(this).removeClass(clase);
                    });
                }
            }
        } catch (err) {
            if (isDebugging) {
                showError('tableroBasket.actualizarIncidencia', err);
            };
        }
    };

    this.isTypeOf = function (value) {
        var _isTypeOf = false;
        if (value == "tableroBasket") _isTypeOf = !_isTypeOf;
        return _isTypeOf;
    };

    this.actualizarExtras = function () {
        var marquesina;
        try {
            if (this._value.tablero.mq.texto != undefined && this._value.tablero.mq.texto != '' && this._value.tablero.mq.texto != null) {
                $("#marquesina" + this._value.cc.id).html("");
                $("#marquesina" + this._value.cc.id).append(this._value.tablero.mq.texto);
            }
        } catch (err) {
            if (isDebugging) {
                showError('tableroFutbol.actualizarEstado', err);
            };
        }
    };
    this.PRIMER_TIEMPO = "1er tiempo";
    this.SEGUNDO_TIEMPO = "2do tiempo";
    this.PRIMER_TIEMPO_SUPLEMENTARIO = "1er Supl.";
    this.SEGUNDO_TIEMPO_SUPLEMENTARIO = "2do Supl.";
    this.ESTADO_SIN_COMIENZO = "Sin comienzo";
    this.ESTADO_EN_JUEGO = "En juego";
    this.ESTADO_FINALIZADO = "Finalizado";
    this.ESTADO_SUSPENDIDO = "Suspendido";
    this.ESTADO_ENTRETIEMPO = "Entretiempo";

    this.TIEMPO_UNICO = "En Juego";
    this.PRIMER_CUARTO = "1er. Cuarto";
    this.SEGUNDO_CUARTO = "2do. Cuarto";
    this.TERCER_CUARTO = "3er. Cuarto";
    this.CUARTO_CUARTO = "4to. Cuarto";
    this.TIEMPO_SUPLEMENTARIO = "Suplementario";

    // implementa diferente para cada tipo de tablero: tennis, futbol
    this.execute = function () {
        try {
            if (this._cambioEncuentro) {
                this.actualizarEstado();
                this.actualizarPeriodo();
                this.actualizarResultado();
                this.actualizarExtras();
            }
            this.actualizarIncidencia();
        } catch (err) {
            if (isDebugging) {
                showError('tableroBasket.execute', err);
            };
        }
    };
};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

/* objeto Tablero Futbol */
var tableroFutbol = function tableroFutbol(value, isActive) {
    var isDebugging = false;
    //    console.log(value);
    //    console.log(isActive);

    this._value = value;
    this._estaActivo = isActive || true;
    this._cambioEncuentro = false;
    this._cambioIncidencias = false;
    this._cambioExtras = false;
    this._cambioFormaciones = false;
    this._tieneTiempo = true;

    /* TAG A ACTUALIZAR */
    if (this._value.cc.hasOwnProperty('tipoTablero')) {
        this.TAG_RESULTADOS = this._value.cc.tipoTablero + "resultado";
        this.TAG_RESULTADOS_PENALES = this._value.cc.tipoTablero + "penales";
        this.TAG_INCIDENCIA = this._value.cc.tipoTablero + "i";
        this.TAG_ESTADO = this._value.cc.tipoTablero + "estado";
        this.TAG_PERIODO = this._value.cc.tipoTablero + "periodo";
        this.TAG_TIEMPO = this._value.cc.tipoTablero + "tiempo";
        this.TAG_TIEMPO_MINUTOS = this._value.cc.tipoTablero + "minutos";
        this.TAG_RESUMEN = this._value.cc.tipoTablero + "resumen";
        this.TAG_BARRATIEMPO = this._value.cc.tipoTablero + "barraTiempo";
        this.TAG_GOLEADORESLOCAL = this._value.cc.tipoTablero + "goleadoresLocal";
        this.TAG_GOLEADORESVISITANTE = this._value.cc.tipoTablero + "goleadoresVisitante";
    } else {
        this.TAG_RESULTADOS = "resultado";
        this.TAG_RESULTADOS_PENALES = "penales";
        this.TAG_INCIDENCIA = "i";
        this.TAG_ESTADO = "estado";
        this.TAG_PERIODO = "periodo";
        this.TAG_TIEMPO = "tiempo";
        this.TAG_TIEMPO_MINUTOS = "minutos";
        this.TAG_RESUMEN = "resumen";
        this.TAG_BARRATIEMPO = "barraTiempo";
        this.TAG_GOLEADORESLOCAL = "goleadoresLocal";
        this.TAG_GOLEADORESVISITANTE = "goleadoresVisitante";
    }

    /* ******************** */

    this.setValue = function (valorActualizado) {
        try {
            if (valorActualizado.hasOwnProperty('cc')) {
                this._value.cc = valorActualizado.cc;
            };
            if (valorActualizado.hasOwnProperty('encuentro')) {
                this._value.encuentro = valorActualizado.encuentro;this._cambioEncuentro = true;
            } else {
                this._cambioEncuentro = false;
            };
            if (valorActualizado.hasOwnProperty('ins')) {
                this._value.ins = valorActualizado.ins;this._cambioIncidencias = true;
            } else {
                this._cambioIncidencias = false;
            };
            if (valorActualizado.hasOwnProperty('fors')) {
                this._value.fors = valorActualizado.fors;this._cambioFormaciones = true;
            } else {
                this._cambioFormaciones = false;
            };
            if (valorActualizado.hasOwnProperty('extras')) {
                this._value.tablero = valorActualizado.extras;this._cambioExtras = true;
            } else {
                this._cambioExtras = false;
            };
        } catch (err) {
            if (isDebugging) {
                showError('tableroFutbol.setValue', err);
            };
        }
    };
    this.cambiarActivo = function (isActive) {
        try {
            this._estaActivo = isActive;
        } catch (err) {
            if (isDebugging) {
                showError('tableroFutbol.estaActivo', err);
            };
        }
    };
    this.tieneTiempo = function () {
        return this._tieneTiempo;
    };

    this.estaActivo = function () {
        return this._estaActivo;
    };

    this.actualizarResultado = function () {
        try {
            var local, visitante;
            if (this._value.encuentro.local.id != undefined && this._value.encuentro.visitante.id) {

                this.actualizarResultado90Minutos();
                if (this._value.encuentro.local.golesPenal != "" && this._value.encuentro.visitante.golesPenal != "" || this._value.encuentro.tiempo == "22") {
                    this.actualizarResultadoPenales();
                }
            }
        } catch (err) {
            if (isDebugging) {
                showError('tableroFutbol.actualizarResultado', err);
            };
        }
    };

    this.actualizarResultado90Minutos = function () {
        var local = $("#" + this.TAG_RESULTADOS + this._value.encuentro.local.id);
        var visitante = $("#" + this.TAG_RESULTADOS + this._value.encuentro.visitante.id);

        if (local.length && visitante.length) {
            if (this._value.encuentro.estado == "1") {
                local.html("-");
                visitante.html("-");
            } else {
                local.html(this._value.encuentro.local.goles);
                visitante.html(this._value.encuentro.visitante.goles);

                if (this._value.encuentro.local.goles == "" || this._value.encuentro.local.goles == "NaN") {
                    local.html("0");
                }

                if (this._value.encuentro.visitante.goles == "" || this._value.encuentro.visitante.goles == "NaN") {
                    visitante.html("0");
                }
            }
        }
    };

    this.actualizarResultadoPenales = function () {

        var golesPenalLocal = this._value.encuentro.local.golesPenal == undefined ? 0 : this._value.encuentro.local.golesPenal;
        var golesPenalVisitante = this._value.encuentro.visitante.golesPenal == undefined ? 0 : this._value.encuentro.visitante.golesPenal;
        if (golesPenalLocal > 0 || golesPenalVisitante > 0) {
            var local = $("#" + this.TAG_RESULTADOS_PENALES + this._value.encuentro.local.id);
            var visitante = $("#" + this.TAG_RESULTADOS_PENALES + this._value.encuentro.visitante.id);

            if (local.length && visitante.length) {
                //var classpadre = local.closest("ul").attr("class");
                //if (!classpadre.indexOf("penales") >= 0) {
                //    local.closest("ul").addClass("penales");
                //    visitante.closest("ul").addClass("penales");
                //}
            } else {
                $('div.equipo.local ul li').append('<span id="' + this.TAG_RESULTADOS_PENALES + this._value.encuentro.local.id + '">');
                $('div.equipo.visitante ul li').append('<span id="' + this.TAG_RESULTADOS_PENALES + this._value.encuentro.visitante.id + '">');
                local = $("#" + this.TAG_RESULTADOS_PENALES + this._value.encuentro.local.id);
                visitante = $("#" + this.TAG_RESULTADOS_PENALES + this._value.encuentro.visitante.id);
            }
            //local.closest("ul").addClass("penales");
            //visitante.closest("ul").addClass("penales");

            local.closest("[data-penales]").addClass("penales");

            this.actualizarGolesPenal(local, golesPenalLocal);
            this.actualizarGolesPenal(visitante, golesPenalVisitante);
        }
    };

    this.actualizarGolesPenal = function (obj, goles) {
        $(obj).html("P" + goles);
        //        if ($("#resultadoPenales", obj).length) {
        //            $(obj).removeClass("hidePenales");
        //            if ($("#e" + this._value.encuentro.id).length) {
        //                if (!($("#e" + this._value.encuentro.id).attr("class").indexOf("conPenales") > 0)) {
        //                    $("#e" + this._value.encuentro.id).addClass("conPenales");
        //                }
        //            }
        //            $("#resultadoPenales", obj).html(goles);
        //        }
    };

    this.actualizarEstado = function () {

        try {
            var estado, minutosTiempo;
            if (this._value.encuentro.estado != undefined) {
                estado = $("#" + this.TAG_ESTADO + this._value.cc.id);
                if (this._value.encuentro.estado != '2') {
                    estado.show();
                    $("#" + this.TAG_PERIODO + this._value.cc.id).hide();
                }
                if (estado.length) {
                    switch (this._value.encuentro.estado) {
                        case "1":
                            estado.html(this.ESTADO_SIN_COMIENZO);
                            break;
                        case "2":
                            estado.html(this.ESTADO_EN_JUEGO);
                            break;
                        case "3":
                            estado.html(this.ESTADO_FINALIZADO);
                            this._estaActivo = false;
                            break;
                        case "4":
                            estado.html(this.ESTADO_SUSPENDIDO);
                            break;
                        case "5":
                            estado.html(this.ESTADO_ENTRETIEMPO);
                            break;
                    }
                }
            }
        } catch (err) {
            if (isDebugging) {
                showError('tableroFutbol.actualizarEstado', err);
            };
        }
    };
    this.actualizarPeriodo = function () {
        try {
            if (this._value.encuentro.tiempo != undefined) {
                var oPeriodo = $("#" + this.TAG_PERIODO + this._value.cc.id);
                if (oPeriodo.length) {
                    if (this._value.encuentro.estado == "2") {
                        oPeriodo.html("");
                        oPeriodo.show();
                        switch (this._value.encuentro.tiempo) {
                            case "1":
                                oPeriodo.html(this.PRIMER_TIEMPO);
                                break;
                            case "2":
                                oPeriodo.html(this.SEGUNDO_TIEMPO);
                                break;
                            case "3":
                                oPeriodo.html(this.ESTADO_ENTRETIEMPO);
                                break;
                            case "21":
                                oPeriodo.html(this.PRIMER_TIEMPO_SUPLEMENTARIO);
                                break;
                            case "23":
                                oPeriodo.html(this.SEGUNDO_TIEMPO_SUPLEMENTARIO);
                                break;
                            case "22":
                                oPeriodo.html(this.PENALES);
                                break;
                        }
                        $("#" + this.TAG_ESTADO + this._value.cc.id).hide();
                    } else {
                        switch (this._value.encuentro.estado) {
                            case "1":
                                //oPeriodo.html(this.ESTADO_SIN_COMIENZO);
                                break;
                            case "3":
                                var oTiempo = $("#" + this.TAG_TIEMPO + this._value.cc.id);
                                var oTiempoMin = $("#" + this.TAG_TIEMPO_MINUTOS + this._value.cc.id);

                                if (oPeriodo.length) {
                                    oPeriodo.html('&nbsp;');
                                }
                                if (oTiempoMin.length) {
                                    oTiempoMin.html('&nbsp;');
                                }
                                //                                oPeriodo.html("");
                                this._estaActivo = false;
                                break;
                            case "4":
                                oPeriodo.html(this.ESTADO_SUSPENDIDO);
                                break;
                            case "5":
                                //oPeriodo.html(this.ESTADO_ENTRETIEMPO);
                                break;
                        }
                    }
                }
            }
        } catch (err) {
            if (isDebugging) {
                showError('tableroFutbol.actualizarPeriodo', err);
            };
        }
    };

    this.actualizarIncidencia = function () {
        try {

            if (this._value.ins[0].inc.id != undefined) {
                var oIncidencia = $("#" + this.TAG_INCIDENCIA + this._value.cc.id);
                if (oIncidencia.length) {
                    var clase = "";
                    switch (this._value.ins[0].inc.tp.toLowerCase()) {
                        case "amarilla":
                            clase = "amarilla";
                            break;
                        case "roja":
                            clase = "roja";
                            break;
                        case "gol":
                            clase = "gol";
                            break;
                        case "cambio":
                            clase = "cambio";
                            break;
                        case "lesion":
                            clase = "lesion";
                        default:
                            clase = "fallo";
                            break;
                    }
                    oTextoIncidencia = $("#textoIncidencia", oIncidencia);
                    oTextoIncidencia.html(this._value.ins[0].inc.cm);
                    oIncidencia.addClass(clase).slideDown('slow').delay(7000).hide('fast', function () {
                        $(this).removeClass(clase);
                    });
                }
            }
        } catch (err) {
            if (isDebugging) {
                showError('tableroFutbol.actualizarIncidencia', err);
            };
        }
    };

    this.isTypeOf = function (value) {
        var _isTypeOf = false;
        if (value == "tableroFutbol") _isTypeOf = !_isTypeOf;
        return _isTypeOf;
    };
    this.PRIMER_TIEMPO = "1er tiempo";
    this.SEGUNDO_TIEMPO = "2do tiempo";
    this.PRIMER_TIEMPO_SUPLEMENTARIO = "1er Supl.";
    this.SEGUNDO_TIEMPO_SUPLEMENTARIO = "2do Supl.";
    this.PENALES = "Penales";
    this.ESTADO_SIN_COMIENZO = "Sin comienzo";
    this.ESTADO_EN_JUEGO = "En juego";
    this.ESTADO_FINALIZADO = "Finalizado";
    this.ESTADO_SUSPENDIDO = "Suspendido";
    this.ESTADO_ENTRETIEMPO = "Entretiempo";

    this.calcularDelta = function () {
        var horaPC = new Date();
        var toReturn = 0;

        //if (fechaServidor != null) {
        //    toReturn = (horaPC - fechaServidor) / 1000;
        //}
        return toReturn;
    };

    this.tiempoTranscurrido = function (horaInicio) {
        var elReloj = new Date();
        var deltaTiempo = this.calcularDelta();
        if (horaInicio != null) {
            // Armo el dia con la horacomienzo
            var relojComienzo = new Date(elReloj.getFullYear(), elReloj.getMonth(), elReloj.getDate(), Number(horaInicio.substr(0, 2)), Number(horaInicio.substr(3, 2)), 0);
            if (elReloj > relojComienzo) {
                var miliSegundos = elReloj - deltaTiempo - relojComienzo;
                var Hora = Math.floor(miliSegundos / 3600000); // Horas
                var Minuto = Math.floor(miliSegundos / 60000) - Hora * 60; // Minutos
                var Segundo = Math.floor(miliSegundos / 1000) - Minuto * 60 - Hora * 3600; // Segundos

                if (Hora != 0 && Hora > 0) Hora += ":";else Hora = "";

                if (typeof Segundo == "undefined") Segundo = SegundoAnt;else var SegundoAnt = Segundo;

                if (typeof Minuto == "undefined") Minuto = MinutoAnt;else var MinutoAnt = Minuto;

                if (Minuto < 10) Minuto = "0" + Minuto.toString();

                if (Segundo < 10) Segundo = "0" + Segundo.toString();
                return Minuto + ":" + Segundo;
            } else {
                return "";
            }
        } else {
            return "";
        }
    };

    this.actualizarGoleadores = function () {
        var goleadoresLocal,
            goleadoresVisitante,
            bufferGoleadoresLocales = "",
            bufferGoleadoresVisitantes = "";
        try {
            goleadoresLocal = $("#" + this.TAG_GOLEADORESLOCAL + this._value.encuentro.local.id);
            goleadoresVisitante = $("#" + this.TAG_GOLEADORESVISITANTE + this._value.encuentro.visitante.id);

            if (goleadoresLocal.length && this._value.encuentro.local.golesDetalle.length) {

                for (var x = 0; x < this._value.encuentro.local.golesDetalle.length; x++) {
                    bufferGoleadoresLocales += "<li>" + this._value.encuentro.local.golesDetalle[x].nombre + " <time>" + this._value.encuentro.local.golesDetalle[x].minuto + "' </time><i> / </i></li>";
                }
                goleadoresLocal.html(bufferGoleadoresLocales);
            }

            if (goleadoresVisitante.length && this._value.encuentro.visitante.golesDetalle.length) {

                for (var x = 0; x < this._value.encuentro.visitante.golesDetalle.length; x++) {
                    bufferGoleadoresVisitantes += "<li>" + this._value.encuentro.visitante.golesDetalle[x].nombre + "<time> " + this._value.encuentro.visitante.golesDetalle[x].minuto + "' </time><i> / </i></li>";
                }
                goleadoresVisitante.html(bufferGoleadoresVisitantes);
            }
        } catch (err) {
            if (isDebugging) {
                showError('tableroFutbol.renderReloj', err);
            };
        }
    };

    this.actualizarReloj = function () {
        this.renderReloj();
    };

    this.renderReloj = function () {
        var oTiempo, oTiempo_min;
        var minutosTiempo, progresoTiempo;
        try {

            oTiempo = $("#" + this.TAG_TIEMPO + this._value.cc.id);
            oTiempo_min = $("#" + this.TAG_TIEMPO_MINUTOS + this._value.cc.id);
            //oTiempo_nom = $("#" + this.TAG_TIEMPO + "nom" + this._value.cc.id);
            if (oTiempo.length) {
                minutosTiempo = $("#" + this.TAG_BARRATIEMPO + this._value.cc.id);
                if (this._value.encuentro.estado == "2" && this._value.encuentro.tiempo != "5") {
                    oTiempo.css("display", "inline");
                    oTiempo_min.css("display", "inline");
                    progresoTiempo = this.tiempoTranscurrido(this._value.encuentro.inicio_tiempo);
                    oTiempo_min.html(progresoTiempo);

                    if (this._value.encuentro.tiempo != undefined) {

                        switch (this._value.encuentro.tiempo) {
                            case "1":
                            case "2":
                                minutosTiempo.attr("max", "45");
                                break;
                            case "21":
                            case "23":
                                minutosTiempo.attr("max", "15");
                                break;
                        }

                        minutosTiempo.val(progresoTiempo.split(":")[0]);
                    }
                } else {
                    if (this._value.encuentro.estado != "2") {
                        if (oTiempo_min.length) {
                            oTiempo_min.html(" ");
                            minutosTiempo.attr("max", "45");
                            switch (this._value.encuentro.estado) {
                                case "1": //SIN COMIENZO                                                                          
                                case "5":
                                    //ENTRE TIEMPO                                        
                                    minutosTiempo.val("0");
                                    break;
                                case "4": //SUSPENDIDO
                                case "3":
                                    //FINALIZADO                                        
                                    minutosTiempo.val(minutosTiempo.attr("max"));
                                    break;
                            }
                        }
                        if (oTiempo_nom.length) {
                            oTiempo_nom.html(" ");
                        }
                    }
                    this._tieneTiempo = false;
                }
            } else {
                this._tieneTiempo = false;
            }
            //oTiempo = null;
        } catch (err) {
            if (isDebugging) {
                showError('tableroFutbol.renderReloj', err);
            };
            this._tieneTiempo = false;
        }
    };

    this.actualizarExtras = function () {
        var marquesina;
        try {
            if (this._value.tablero.mq.texto != undefined && this._value.tablero.mq.texto != '' && this._value.tablero.mq.texto != null) {
                $("#marquesina" + this._value.cc.id).html("");
                $("#marquesina" + this._value.cc.id).append(this._value.tablero.mq.texto);
            }
        } catch (err) {
            if (isDebugging) {
                showError('tableroFutbol.actualizarEstado', err);
            };
        }
    };

    // implementa diferente para cada tipo de tablero: tennis, futbol
    this.execute = function () {
        try {
            if (this._cambioEncuentro) {
                this.actualizarEstado();
                this.actualizarPeriodo();
                this.actualizarResultado();
                this.actualizarReloj();
                this.actualizarGoleadores();
                this.actualizarExtras();
            }
            this.actualizarIncidencia();
        } catch (err) {
            if (isDebugging) {
                showError('tableroFutbol.execute', err);
            };
        }
    };
};

var agregarTableroFutbol = exports.agregarTableroFutbol = function agregarTableroFutbol(idPartido, codigoSolicitud) {
    //if (tableros != null) {
    var objTablero = new tableroFutbol({ cc: { id: idPartido, valor: codigoSolicitud } });
    //}
    return objTablero;
};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

/* objeto Tablero Rugby */
var tableroRugby = function tableroRugby(value, isActive) {
    var isDebugging = false;
    //    console.log(value);
    //    console.log(isActive);

    this._value = value;
    this._estaActivo = isActive || true;
    this._cambioEncuentro = false;
    this._cambioIncidencias = false;
    this._cambioExtras = false;
    this._cambioFormaciones = false;
    this._tieneTiempo = true;

    /* TAG A ACTUALIZAR */
    if (this._value.cc.hasOwnProperty('tipoTablero')) {
        this.TAG_RESULTADOS = this._value.cc.tipoTablero + "resultado";
        this.TAG_RESULTADOS_PENALES = this._value.cc.tipoTablero + "penales";
        this.TAG_INCIDENCIA = this._value.cc.tipoTablero + "i";
        this.TAG_ESTADO = this._value.cc.tipoTablero + "estado";
        this.TAG_PERIODO = this._value.cc.tipoTablero + "periodo";
        this.TAG_TIEMPO = this._value.cc.tipoTablero + "tiempo";
        this.TAG_TIEMPO_MINUTOS = this._value.cc.tipoTablero + "minutos";
        this.TAG_RESUMEN = this._value.cc.tipoTablero + "resumen";
        this.TAG_BARRATIEMPO = this._value.cc.tipoTablero + "barraTiempo";
        this.TAG_GOLEADORESLOCAL = this._value.cc.tipoTablero + "goleadoresLocal";
        this.TAG_GOLEADORESVISITANTE = this._value.cc.tipoTablero + "goleadoresVisitante";
    } else {
        this.TAG_RESULTADOS = "resultado";
        this.TAG_RESULTADOS_PENALES = "penales";
        this.TAG_INCIDENCIA = "i";
        this.TAG_ESTADO = "estado";
        this.TAG_PERIODO = "periodo";
        this.TAG_TIEMPO = "tiempo";
        this.TAG_TIEMPO_MINUTOS = "minutos";
        this.TAG_RESUMEN = "resumen";
        this.TAG_BARRATIEMPO = "barraTiempo";
        this.TAG_GOLEADORESLOCAL = "goleadoresLocal";
        this.TAG_GOLEADORESVISITANTE = "goleadoresVisitante";
    }

    /* ******************** */

    this.setValue = function (valorActualizado) {
        try {
            if (valorActualizado.hasOwnProperty('cc')) {
                this._value.cc = valorActualizado.cc;
            };
            if (valorActualizado.hasOwnProperty('encuentro')) {
                this._value.encuentro = valorActualizado.encuentro;this._cambioEncuentro = true;
            } else {
                this._cambioEncuentro = false;
            };
            if (valorActualizado.hasOwnProperty('ins')) {
                this._value.ins = valorActualizado.ins;this._cambioIncidencias = true;
            } else {
                this._cambioIncidencias = false;
            };
            if (valorActualizado.hasOwnProperty('fors')) {
                this._value.fors = valorActualizado.fors;this._cambioFormaciones = true;
            } else {
                this._cambioFormaciones = false;
            };
            if (valorActualizado.hasOwnProperty('extras')) {
                this._value.tablero = valorActualizado.extras;this._cambioExtras = true;
            } else {
                this._cambioExtras = false;
            };
        } catch (err) {
            if (isDebugging) {
                showError('tableroRugby.setValue', err);
            };
        }
    };
    this.cambiarActivo = function (isActive) {
        try {
            this._estaActivo = isActive;
        } catch (err) {
            if (isDebugging) {
                showError('tableroRugby.estaActivo', err);
            };
        }
    };
    this.tieneTiempo = function () {
        return this._tieneTiempo;
    };

    this.estaActivo = function () {
        return this._estaActivo;
    };

    this.actualizarResultado = function () {
        try {
            var local, visitante;
            if (this._value.encuentro.local.id != undefined && this._value.encuentro.visitante.id) {

                this.actualizarResultado90Minutos();
                if (this._value.encuentro.local.golesPenal != "" && this._value.encuentro.visitante.golesPenal != "" || this._value.encuentro.tiempo == "22") {
                    this.actualizarResultadoPenales();
                }
            }
        } catch (err) {
            if (isDebugging) {
                showError('tableroRugby.actualizarResultado', err);
            };
        }
    };

    this.actualizarResultado90Minutos = function () {
        var local = $("#" + this.TAG_RESULTADOS + this._value.encuentro.local.id);
        var visitante = $("#" + this.TAG_RESULTADOS + this._value.encuentro.visitante.id);

        if (local.length && visitante.length) {
            if (this._value.encuentro.estado == "1") {
                local.html("-");
                visitante.html("-");
            } else {
                local.html(this._value.encuentro.local.goles);
                visitante.html(this._value.encuentro.visitante.goles);

                if (this._value.encuentro.local.goles == "" || this._value.encuentro.local.goles == "NaN") {
                    local.html("0");
                }

                if (this._value.encuentro.visitante.goles == "" || this._value.encuentro.visitante.goles == "NaN") {
                    visitante.html("0");
                }
            }
        }
    };

    this.actualizarResultadoPenales = function () {

        var golesPenalLocal = this._value.encuentro.local.golesPenal == undefined ? 0 : this._value.encuentro.local.golesPenal;
        var golesPenalVisitante = this._value.encuentro.visitante.golesPenal == undefined ? 0 : this._value.encuentro.visitante.golesPenal;
        if (golesPenalLocal > 0 || golesPenalVisitante > 0) {
            var local = $("#" + this.TAG_RESULTADOS_PENALES + this._value.encuentro.local.id);
            var visitante = $("#" + this.TAG_RESULTADOS_PENALES + this._value.encuentro.visitante.id);

            if (local.length && visitante.length) {
                //var classpadre = local.closest("ul").attr("class");
                //if (!classpadre.indexOf("penales") >= 0) {
                //    local.closest("ul").addClass("penales");
                //    visitante.closest("ul").addClass("penales");
                //}
            } else {
                $('div.equipo.local ul li').append('<span id="' + this.TAG_RESULTADOS_PENALES + this._value.encuentro.local.id + '">');
                $('div.equipo.visitante ul li').append('<span id="' + this.TAG_RESULTADOS_PENALES + this._value.encuentro.visitante.id + '">');
                local = $("#" + this.TAG_RESULTADOS_PENALES + this._value.encuentro.local.id);
                visitante = $("#" + this.TAG_RESULTADOS_PENALES + this._value.encuentro.visitante.id);
            }
            //local.closest("ul").addClass("penales");
            //visitante.closest("ul").addClass("penales");

            local.closest("section").addClass("penales");

            this.actualizarGolesPenal(local, golesPenalLocal);
            this.actualizarGolesPenal(visitante, golesPenalVisitante);
        }
    };

    this.actualizarGolesPenal = function (obj, goles) {
        $(obj).html(goles);
        //        if ($("#resultadoPenales", obj).length) {
        //            $(obj).removeClass("hidePenales");
        //            if ($("#e" + this._value.encuentro.id).length) {
        //                if (!($("#e" + this._value.encuentro.id).attr("class").indexOf("conPenales") > 0)) {
        //                    $("#e" + this._value.encuentro.id).addClass("conPenales");
        //                }
        //            }
        //            $("#resultadoPenales", obj).html(goles);
        //        }
    };

    this.actualizarEstado = function () {

        try {
            var estado;
            if (this._value.encuentro.estado != undefined) {
                estado = $("#" + this.TAG_ESTADO + this._value.cc.id);
                if (this._value.encuentro.estado != '2') {
                    estado.show();
                    $("#" + this.TAG_PERIODO + this._value.cc.id).hide();
                }
                if (estado.length) {
                    switch (this._value.encuentro.estado) {
                        case "1":
                            estado.html(this.ESTADO_SIN_COMIENZO);
                            break;
                        case "2":
                            estado.html(this.ESTADO_EN_JUEGO);
                            break;
                        case "3":
                            estado.html(this.ESTADO_FINALIZADO);
                            this._estaActivo = false;
                            break;
                        case "4":
                            estado.html(this.ESTADO_SUSPENDIDO);
                            break;
                        case "5":
                            estado.html(this.ESTADO_ENTRETIEMPO);
                            break;
                    }
                }
            }
        } catch (err) {
            if (isDebugging) {
                showError('tableroRugby.actualizarEstado', err);
            };
        }
    };
    this.actualizarPeriodo = function () {
        try {
            if (this._value.encuentro.tiempo != undefined) {
                var oPeriodo = $("#" + this.TAG_PERIODO + this._value.cc.id);
                if (oPeriodo.length) {
                    if (this._value.encuentro.estado == "2") {
                        oPeriodo.html("");
                        oPeriodo.show();
                        switch (this._value.encuentro.tiempo) {
                            case "1":
                                oPeriodo.html(this.PRIMER_TIEMPO);
                                break;
                            case "2":
                                oPeriodo.html(this.SEGUNDO_TIEMPO);
                                break;
                            case "3":
                                oPeriodo.html(this.ESTADO_ENTRETIEMPO);
                                break;
                            case "21":
                                oPeriodo.html(this.PRIMER_TIEMPO_SUPLEMENTARIO);
                                break;
                            case "23":
                                oPeriodo.html(this.SEGUNDO_TIEMPO_SUPLEMENTARIO);
                                break;
                            case "22":
                                oPeriodo.html(this.PENALES);
                                break;
                        }
                        $("#" + this.TAG_ESTADO + this._value.cc.id).hide();
                    } else {
                        switch (this._value.encuentro.estado) {
                            case "1":
                                //oPeriodo.html(this.ESTADO_SIN_COMIENZO);
                                break;
                            case "3":
                                var oTiempo = $("#" + this.TAG_TIEMPO + this._value.cc.id);
                                var oTiempoMin = $("#" + this.TAG_TIEMPO_MINUTOS + this._value.cc.id);

                                if (oPeriodo.length) {
                                    oPeriodo.html('&nbsp;');
                                }
                                if (oTiempoMin.length) {
                                    oTiempoMin.html('&nbsp;');
                                }
                                //                                oPeriodo.html("");
                                this._estaActivo = false;
                                break;
                            case "4":
                                oPeriodo.html(this.ESTADO_SUSPENDIDO);
                                break;
                            case "5":
                                //oPeriodo.html(this.ESTADO_ENTRETIEMPO);
                                break;
                        }
                    }
                }
            }
        } catch (err) {
            if (isDebugging) {
                showError('tableroRugby.actualizarPeriodo', err);
            };
        }
    };

    this.actualizarIncidencia = function () {
        try {

            if (this._value.ins[0].inc.id != undefined) {
                var oIncidencia = $("#" + this.TAG_INCIDENCIA + this._value.cc.id);
                if (oIncidencia.length) {
                    var clase = "";
                    switch (this._value.ins[0].inc.tp.toLowerCase()) {
                        case "amarilla":
                            clase = "amarilla";
                            break;
                        case "roja":
                            clase = "roja";
                            break;
                        case "gol":
                            clase = "gol";
                            break;
                        case "cambio":
                            clase = "cambio";
                            break;
                        case "lesion":
                            clase = "lesion";
                        default:
                            clase = "fallo";
                            break;
                    }
                    oTextoIncidencia = $("#textoIncidencia", oIncidencia);
                    oTextoIncidencia.html(this._value.ins[0].inc.cm);
                    oIncidencia.addClass(clase).slideDown('slow').delay(7000).hide('fast', function () {
                        $(this).removeClass(clase);
                    });
                }
            }
        } catch (err) {
            if (isDebugging) {
                showError('tableroRugby.actualizarIncidencia', err);
            };
        }
    };

    this.isTypeOf = function (value) {
        var _isTypeOf = false;
        if (value == "tableroRugby") _isTypeOf = !_isTypeOf;
        return _isTypeOf;
    };
    this.PRIMER_TIEMPO = "1er tiempo";
    this.SEGUNDO_TIEMPO = "2do tiempo";
    this.PRIMER_TIEMPO_SUPLEMENTARIO = "1er Supl.";
    this.SEGUNDO_TIEMPO_SUPLEMENTARIO = "2do Supl.";
    this.PENALES = "Penales";
    this.ESTADO_SIN_COMIENZO = "Sin comienzo";
    this.ESTADO_EN_JUEGO = "En juego";
    this.ESTADO_FINALIZADO = "Finalizado";
    this.ESTADO_SUSPENDIDO = "Suspendido";
    this.ESTADO_ENTRETIEMPO = "Entretiempo";

    this.calcularDelta = function () {
        var horaPC = new Date();
        var toReturn = 0;

        //if (fechaServidor != null) {
        //    toReturn = (horaPC - fechaServidor) / 1000;
        //}
        return toReturn;
    };

    this.tiempoTranscurrido = function (horaInicio) {
        var elReloj = new Date();
        var deltaTiempo = this.calcularDelta();
        if (horaInicio != null) {
            // Armo el dia con la horacomienzo
            var relojComienzo = new Date(elReloj.getFullYear(), elReloj.getMonth(), elReloj.getDate(), Number(horaInicio.substr(0, 2)), Number(horaInicio.substr(3, 2)), 0);
            if (elReloj > relojComienzo) {
                var miliSegundos = elReloj - deltaTiempo - relojComienzo;
                var Hora = Math.floor(miliSegundos / 3600000); // Horas
                var Minuto = Math.floor(miliSegundos / 60000) - Hora * 60; // Minutos
                var Segundo = Math.floor(miliSegundos / 1000) - Minuto * 60 - Hora * 3600; // Segundos

                if (Hora != 0 && Hora > 0) Hora += ":";else Hora = "";

                if (typeof Segundo == "undefined") Segundo = SegundoAnt;else var SegundoAnt = Segundo;

                if (typeof Minuto == "undefined") Minuto = MinutoAnt;else var MinutoAnt = Minuto;

                if (Minuto < 10) Minuto = "0" + Minuto.toString();

                if (Segundo < 10) Segundo = "0" + Segundo.toString();
                return Minuto + ":" + Segundo;
            } else {
                return "";
            }
        } else {
            return "";
        }
    };

    this.actualizarGoleadores = function () {
        var goleadoresLocal, goleadoresVisitante;
        try {
            goleadoresLocal = $("#" + this.TAG_GOLEADORESLOCAL + this._value.encuentro.local.id);
            goleadoresVisitante = $("#" + this.TAG_GOLEADORESVISITANTE + this._value.encuentro.visitante.id);

            if (goleadoresLocal.length && this._value.encuentro.local.golesDetalle.length) {

                for (var x = 0; x < this._value.encuentro.local.golesDetalle.length; x++) {
                    goleadoresLocal.append('<li>' + this._value.encuentro.local.golesDetalle[x].nombre + '<time>' + this._value.encuentro.local.golesDetalle[x].minuto + '</time>' + '</li>');
                }
            }

            if (goleadoresVisitante.length && this._value.encuentro.visitante.golesDetalle.length) {

                for (var x = 0; x < this._value.encuentro.visitante.golesDetalle.length; x++) {
                    goleadoresVisitante.append('<li>' + this._value.encuentro.visitante.golesDetalle[x].nombre + '<time>' + this._value.encuentro.visitante.golesDetalle[x].minuto + '</time>' + '</li>');
                }
            }
        } catch (err) {
            if (isDebugging) {
                showError('tableroRugby.renderReloj', err);
            };
        }
    };

    this.actualizarReloj = function () {
        this.renderReloj();
    };

    this.renderReloj = function () {
        var oTiempo, oTiempo_min;
        var minutosTiempo, progresoTiempo;
        try {

            oTiempo = $("#" + this.TAG_TIEMPO + this._value.cc.id);
            oTiempo_min = $("#" + this.TAG_TIEMPO_MINUTOS + this._value.cc.id);
            //oTiempo_nom = $("#" + this.TAG_TIEMPO + "nom" + this._value.cc.id);
            if (oTiempo.length) {
                minutosTiempo = $("#" + this.TAG_BARRATIEMPO + this._value.cc.id);
                if (this._value.encuentro.estado == "2" && this._value.encuentro.tiempo != "5") {
                    oTiempo.css("display", "inline");
                    oTiempo_min.css("display", "inline");
                    progresoTiempo = this.tiempoTranscurrido(this._value.encuentro.inicio_tiempo);
                    oTiempo_min.html(progresoTiempo);

                    if (this._value.encuentro.tiempo != undefined) {

                        switch (this._value.encuentro.tiempo) {
                            case "1":
                            case "2":
                                minutosTiempo.attr("max", "45");
                                break;
                            case "21":
                            case "23":
                                minutosTiempo.attr("max", "15");
                                break;
                        }

                        minutosTiempo.val(progresoTiempo.split(":")[0]);
                    }
                } else {
                    if (this._value.encuentro.estado != "2") {
                        if (oTiempo_min.length) {
                            oTiempo_min.html(" ");
                            minutosTiempo.attr("max", "45");
                            switch (this._value.encuentro.estado) {
                                case "1": //SIN COMIENZO                                                                          
                                case "5":
                                    //ENTRE TIEMPO                                        
                                    minutosTiempo.val("0");
                                    break;
                                case "4": //SUSPENDIDO
                                case "3":
                                    //FINALIZADO                                        
                                    minutosTiempo.val(minutosTiempo.attr("max"));
                                    break;
                            }
                        }
                        if (oTiempo_nom.length) {
                            oTiempo_nom.html(" ");
                        }
                    }
                    this._tieneTiempo = false;
                }
            } else {
                this._tieneTiempo = false;
            }
            //oTiempo = null;
        } catch (err) {
            if (isDebugging) {
                showError('tableroRugby.renderReloj', err);
            };
            this._tieneTiempo = false;
        }
    };

    this.actualizarExtras = function () {
        var marquesina;
        try {
            if (this._value.tablero.mq.texto != undefined && this._value.tablero.mq.texto != '' && this._value.tablero.mq.texto != null) {
                $("#marquesina" + this._value.cc.id).html("");
                $("#marquesina" + this._value.cc.id).append(this._value.tablero.mq.texto);
            }
        } catch (err) {
            if (isDebugging) {
                showError('tableroRugby.actualizarEstado', err);
            };
        }
    };

    // implementa diferente para cada tipo de tablero: tennis, futbol
    this.execute = function () {
        try {
            if (this._cambioEncuentro) {
                this.actualizarEstado();
                this.actualizarPeriodo();
                this.actualizarResultado();
                this.actualizarReloj();
                this.actualizarGoleadores();
                this.actualizarExtras();
            }
            this.actualizarIncidencia();
        } catch (err) {
            if (isDebugging) {
                showError('tableroRugby.execute', err);
            };
        }
    };
};

var agregarTableroRugby = exports.agregarTableroRugby = function agregarTableroRugby(idPartido, codigoSolicitud) {
    //if (tableros != null) {
    var objTablero = new tableroRugby({ cc: { id: idPartido, valor: codigoSolicitud } });
    //}
    return objTablero;
};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* objeto Tablero Tenis */
var tableroTenis = function tableroTenis(value, isActive) {
    var isDebugging = false;
    this._value = value;
    this._estaActivo = isActive || true;
    this._cambioEncuentro = false;
    this._cambioIncidencias = false;
    this._cambioExtras = false;
    this._cambioFormaciones = false;
    this._cantidadSet = 0;
    this._tieneTiempo = true;
    this.URL_bandera = "http://canchallena.lanacion.com.ar/_ui/desktop/imgs/layout/iconos/banderas";

    /* TAG A ACTUALIZAR */
    if (this._value.cc.hasOwnProperty('tipoTablero')) {
        this.tipoTablero = this._value.cc.tipoTablero;
    } else {
        this.tipoTablero = "";
    }
    this.TAG_RESULTADOS = this.tipoTablero + "resultado";
    this.TAG_INCIDENCIA = this.tipoTablero + "i";
    this.TAG_ESTADO = this.tipoTablero + "st";
    this.TAG_PERIODO = this.tipoTablero + "p";
    this.TAG_TIEMPO = this.tipoTablero + "t";
    this.TAG_GAMECAST = this.tipoTablero + "gamec";
    this.TAG_SAQUE = this.tipoTablero + "saque";
    this.TAG_EQUIPO = this.tipoTablero + "eq";
    this.TAG_BANDERA = this.tipoTablero + "img";
    this.TAG_PUNTOS = "puntos";

    /* ******************** */

    this.setValue = function (valorActualizado) {
        try {
            if (valorActualizado.hasOwnProperty('cc')) {
                this._value.cc = valorActualizado.cc;
            };
            if (valorActualizado.hasOwnProperty('encuentro')) {
                this._value.encuentro = valorActualizado.encuentro;this._cambioEncuentro = true;
            } else {
                this._cambioEncuentro = false;
            };
            if (valorActualizado.hasOwnProperty('ins')) {
                this._value.ins = valorActualizado.ins;this._cambioIncidencias = true;
            } else {
                this._cambioIncidencias = false;
            };
            if (valorActualizado.hasOwnProperty('fors')) {
                this._value.fors = valorActualizado.fors;this._cambioFormaciones = true;
            } else {
                this._cambioFormaciones = false;
            };
            if (valorActualizado.hasOwnProperty('extras')) {
                this._value.extras = valorActualizado.extras;this._cambioExtras = true;
            } else {
                this._cambioExtras = false;
            };
        } catch (err) {
            if (isDebugging) {
                showError('tableroTenis.setValue', err);
            };
        }
    };
    this.cambiarActivo = function (isActive) {
        try {
            this._estaActivo = isActive;
        } catch (err) {
            if (isDebugging) {
                showError('tableroTenis.estaActivo', err);
            };
        }
    };
    this.tieneTiempo = function () {
        return this._tieneTiempo;
    };
    this.estaActivo = function () {
        return this._estaActivo;
    };

    this.actualizarIncidencias = function () {
        try {
            var oIncidencia = jQuery("#" + this.TAG_INCIDENCIA + this._value.cc.id)[0];
            if (oIncidencia != undefined && this._value.ins[0].inc.cm != undefined) {
                for (var i = 0; i < this._value.ins.length; i++) {
                    oIncidencia.innerHTML = this._value.ins[0].inc.mm + "' " + this._value.ins[0].inc.cm;
                }
            }
        } catch (err) {
            if (isDebugging) {
                showError('tableroTenis.actualizarIncidencias', err);
            };
        }
    };
    this.actualizarGamecast = function () {
        try {
            var oGamecast = jQuery("#" + this.TAG_GAMECAST + this._value.cc.id)[0];
            if (oGamecast != undefined && this._value.encuentro.linkeable != undefined) {
                if (this._value.encuentro.linkeable == "1") {
                    oGamecast.style.display = "block";
                } else {
                    oGamecast.style.display = "none";
                }
            }
        } catch (err) {
            if (isDebugging) {
                showError('tableroFutbol.actualizarGamecast', err);
            };
        }
    };

    this.actualizarBanderas = function () {
        try {
            local = $("#" + this.TAG_BANDERA + this._value.encuentro.local.id);
            visitante = $("#" + this.TAG_BANDERA + this._value.encuentro.visitante.id);
            if (local != undefined) {
                if (this._value.encuentro.local.pais != "") {
                    local.attr("src", this.URL_bandera + "/18x14/paises/" + this._value.encuentro.local.pais + ".gif");
                }
            }
            if (visitante != undefined) {
                if (this._value.encuentro.visitante.pais != "") {
                    visitante.attr("src", this.URL_bandera + "/18x14/paises/" + this._value.encuentro.visitante.pais + ".gif");
                }
            }
        } catch (err) {
            if (isDebugging) {
                showError('tableroFutbol.actualizarResultado', err);
            };
        }
    };

    this.actualizarSets = function () {
        try {
            for (var i = 0; i < this._value.encuentro.local.tantos.length; i++) {
                if (this._value.encuentro.local.tantos[i].id == "5") this._cantidadSet += 1;
            }
        } catch (err) {
            if (isDebugging) {
                showError('tableroTenis.actualizarSets', err);
            };
        }
    };

    this.actualizarResultado = function () {
        try {
            //this.actualizarBanderas();
            var local, visitante;
            if (this._value.encuentro.local.id != undefined && this._value.encuentro.visitante.id) {
                //SET TOTALES
                local = $("#" + this.TAG_RESULTADOS + this._value.encuentro.local.id + "_0");
                visitante = $("#" + this.TAG_RESULTADOS + this._value.encuentro.visitante.id + "_0");

                if (local != undefined && visitante != undefined) {
                    local.html(this._value.encuentro.local.sets);
                    visitante.html(this._value.encuentro.visitante.sets);
                }
                for (var i = 0; i < this._value.encuentro.local.tantos.length; i++) {
                    switch (this._value.encuentro.local.tantos[i].id) {
                        case "5":
                            // RESALTA GANADOR SETS
                            local = $("#" + this.TAG_RESULTADOS + this._value.encuentro.local.id + "_" + this._value.encuentro.local.tantos[i].orden);
                            visitante = $("#" + this.TAG_RESULTADOS + this._value.encuentro.visitante.id + "_" + this._value.encuentro.local.tantos[i].orden);
                            if (this._value.encuentro.local.tantos[i].valor >= 6 || this._value.encuentro.visitante.tantos[i].valor >= 6) {
                                if (this._value.encuentro.local.tantos[i].valor > this._value.encuentro.visitante.tantos[i].valor) {
                                    local.addClass("won");
                                    visitante.removeClass("won");
                                }
                                if (this._value.encuentro.local.tantos[i].valor < this._value.encuentro.visitante.tantos[i].valor) {
                                    local.removeClass("won");
                                    visitante.addClass("won");
                                }
                            }
                            //SETS
                            local = $("#" + this.TAG_RESULTADOS + this._value.encuentro.local.id + "_" + this._value.encuentro.local.tantos[i].orden);
                            if (local.length) {
                                local.html(this._value.encuentro.local.tantos[i].valor);
                            }
                            break;
                        case "6":
                            //Break  
                            local = $("#" + this.TAG_RESULTADOS + this._value.encuentro.local.id + "_" + this._value.encuentro.local.tantos[i].orden);
                            if (local.length) {
                                local.append("<span>" + this._value.encuentro.local.tantos[i].valor + "</span>");
                            }
                            break;
                        default:
                            break;
                    }
                }

                for (var i = 0; i < this._value.encuentro.visitante.tantos.length; i++) {
                    switch (this._value.encuentro.visitante.tantos[i].id) {
                        case "5":
                            //SETS               
                            visitante = $("#" + this.TAG_RESULTADOS + this._value.encuentro.visitante.id + "_" + this._value.encuentro.visitante.tantos[i].orden);
                            if (visitante.length) {
                                visitante.html(this._value.encuentro.visitante.tantos[i].valor);
                            }
                            break;
                        case "6":
                            //Break
                            visitante = $("#" + this.TAG_RESULTADOS + this._value.encuentro.visitante.id + "_" + this._value.encuentro.visitante.tantos[i].orden);
                            if (visitante.length) {
                                visitante.append("<span>" + this._value.encuentro.visitante.tantos[i].valor + "</span>");
                            }
                            break;
                        default:
                            break;
                    }
                }

                if (this._value.encuentro.estado == "3") {
                    this._estaActivo = false;
                } else {
                    this.actualizarPuntos(this._value.encuentro.local, this._value.encuentro);
                    this.actualizarPuntos(this._value.encuentro.visitante, this._value.encuentro);
                }
            }
        } catch (err) {
            if (isDebugging) {
                showError('tableroTenis.actualizarResultado', err);
            };
        }
    };

    this.actualizarPuntos = function (jugador, encuentro) {
        //objJugador = $("#" + this.TAG_RESULTADOS + jugador.id + "_" + this.TAG_PUNTOS);
        //objSaque = $(".tablero.tenis" + this.TAG_SAQUE + jugador.id);
        var objSaque = $('.tablero.tenis[data-id="' + encuentro.id + '"] [data-equipoId="' + jugador.id + '"]');
        if (encuentro.estado === "2") {
            if (jugador.saque === '1' || jugador.saque === 'S') {
                objSaque.addClass('saque');
            } else {
                objSaque.removeClass('saque');
            }
        } else {
            //  objJugador.html(jugador.sets);
        }
    };

    this.actualizarEstado = function () {
        try {
            var estado;
            if (this._value.encuentro.estado != undefined) {
                estado = $("." + this.TAG_ESTADO + this._value.cc.id);
                if (estado.length) {
                    switch (this._value.encuentro.estado) {
                        case "1":
                            estado.html(this.ESTADO_SIN_COMIENZO);
                            break;
                        case "2":
                            estado.html(this.ESTADO_EN_JUEGO);
                            break;
                        case "3":
                            estado.html(this.ESTADO_FINALIZADO);
                            break;
                        case "4":
                            estado.html(this.ESTADO_SUSPENDIDO);
                            break;
                        case "5":
                            estado.html(this.ESTADO_ENTRETIEMPO);
                            break;
                    }
                }
            }
        } catch (err) {
            if (isDebugging) {
                showError('tableroTenis.actualizarPeriodo', err);
            };
        }
    };
    this.actualizarPeriodo = function () {
        try {
            if (this._value.encuentro.tiempo != undefined) {
                var oPeriodo = $("#" + this.TAG_PERIODO + this._value.cc.id);
                if (oPeriodo.length) {
                    if (this._value.encuentro.estado == "2") {
                        if (oPeriodo != undefined) {
                            oPeriodo.html("");
                            switch (this._value.encuentro.tiempo) {
                                case "1":
                                    oPeriodo.html(this.PRIMER_TIEMPO);
                                    break;
                                case "2":
                                    oPeriodo.html(this.SEGUNDO_TIEMPO);
                                    break;
                                case "3":
                                    oPeriodo.html(this.PRIMER_TIEMPO_SUPLEMENTARIO);
                                    break;
                                case "4":
                                    oPeriodo.html(this.SEGUNDO_TIEMPO_SUPLEMENTARIO);
                                    break;
                                case "5":
                                    oPeriodo.html(this.PENALES);
                                    break;
                            }
                        }
                    } else {
                        oPeriodo.html("");
                    }
                }
            }
        } catch (err) {
            if (isDebugging) {
                showError('tableroTenis.actualizarEstado', err);
            };
        }
    };
    this.isTypeOf = function (value) {
        var _isTypeOf = false;
        if (value == "tableroTenis") _isTypeOf = !_isTypeOf;
        return _isTypeOf;
    };
    this.PRIMER_TIEMPO = "1er tiempo";
    this.SEGUNDO_TIEMPO = "2do tiempo";
    this.PRIMER_TIEMPO_SUPLEMENTARIO = "1er Supl.";
    this.SEGUNDO_TIEMPO_SUPLEMENTARIO = "2do Supl.";
    this.PENALES = "Penales";
    this.ESTADO_SIN_COMIENZO = "Sin comienzo";
    this.ESTADO_EN_JUEGO = "En juego";
    this.ESTADO_FINALIZADO = "Finalizado";
    this.ESTADO_SUSPENDIDO = "Suspendido";
    this.ESTADO_ENTRETIEMPO = "Entretiempo";

    this.calcularDelta = function () {
        var horaPC = new Date();
        var toReturn = 0;

        if (fechaServidor != null) {
            toReturn = (horaPC - fechaServidor) / 1000;
        }
        return toReturn;
    };

    this.tiempoTranscurrido = function (horaInicio) {
        var elReloj = new Date();
        var deltaTiempo = this.calcularDelta();

        if (horaInicio != null) {
            // Armo el dia con la horacomienzo	
            var relojComienzo = new Date(elReloj.getFullYear(), elReloj.getMonth(), elReloj.getDate(), Number(horaInicio.substr(0, 2)), Number(horaInicio.substr(3, 2)), 0);
            if (elReloj > relojComienzo) {
                var miliSegundos = elReloj - deltaTiempo - relojComienzo;
                var Hora = Math.floor(miliSegundos / 3600000); // Horas
                var Minuto = Math.floor(miliSegundos / 60000) - Hora * 60; // Minutos
                var Segundo = Math.floor(miliSegundos / 1000) - Minuto * 60 - Hora * 3600; // Segundos

                if (Hora != 0 && Hora > 0) Hora += ":";else Hora = "";

                if (typeof Segundo == "undefined") Segundo = SegundoAnt;else var SegundoAnt = Segundo;

                if (typeof Minuto == "undefined") Minuto = MinutoAnt;else var MinutoAnt = Minuto;

                if (Minuto < 10) Minuto = "0" + Minuto.toString();

                if (Segundo < 10) Segundo = "0" + Segundo.toString();

                return Minuto + ":" + Segundo;
            } else {
                return "";
            }
        } else {
            return "";
        }
    };
    this.actualizarReloj = function () {
        this.renderReloj();
    };

    this.renderReloj = function () {
        var oTiempo;
        try {
            oTiempo = $("#" + this.TAG_TIEMPO + this._value.cc.id);

            if (oTiempo.length) {
                if (this._value.encuentro.estado == "2") {
                    oTiempo.css("display", "inline");
                    oTiempo.html(this.tiempoTranscurrido(this._value.encuentro.inicio_tiempo));
                } else {
                    oTiempo.html("");
                }
            }
            oTiempo = null;
        } catch (err) {
            if (isDebugging) {
                showError('tableroTenis.renderReloj', err);
            };
            this._tieneTiempo = false;
        }
    };

    // implementa diferente para cada tipo de tablero: tennis, futbol
    this.execute = function () {
        try {
            if (this._cambioEncuentro) {
                if (this._cantidadSet == 0) this.actualizarSets();
                this.actualizarEstado();
                this.actualizarPeriodo();
                this.actualizarResultado();
                this.actualizarGamecast();
            }
            if (this._cambioIncidencias) {
                this.actualizarIncidencias();
            }
        } catch (err) {
            if (isDebugging) {
                showError('tableroTenis.execute', err);
            };
        }
    };
};

var agregarTableroTenis = exports.agregarTableroTenis = function agregarTableroTenis(idPartido, codigoSolicitud) {
    //if (tableros != null) {
    var objTablero = new tableroTenis({ cc: { id: idPartido, valor: codigoSolicitud } });
    //}
    return objTablero;
};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPromoClubLnEnHome = undefined;

var _ajax = __webpack_require__(1);

var _bucket = __webpack_require__(2);

var BucketTools = _interopRequireWildcard(_bucket);

var _utilities = __webpack_require__(3);

var Utilities = _interopRequireWildcard(_utilities);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var bucketClubLn = window.config.Statics.BucketClubLnUrl.replace("dp-", "");
var urlPromoClubLn = window.config.Statics.ApiContenidoUrlRoot + window.config.Statics.ApiPromoClubLnUrl;

var renderPromoClubLnEnHome = function renderPromoClubLnEnHome(data) {
    var container = document.getElementById("promoClubLnEnHome");
    if (container) {
        var notas = data;

        if (notas == null) return;

        var cantidadNotas = notas.length;
        if (cantidadNotas == 0) return;

        var indexRandom1 = Utilities.getRandomInteger(0, cantidadNotas - 1);
        var indexRandom2 = Utilities.getRandomInteger(0, cantidadNotas - 1);
        var exitwhile = 0;
        while (indexRandom1 == indexRandom2 && exitwhile < 300) {
            indexRandom2 = Utilities.getRandomInteger(0, cantidadNotas - 1);
        }

        var notaGrande = notas[indexRandom1];
        var notaChica = notas[indexRandom2];

        var promoPromoClubLnHtml = "<div class=\"techo-2 floatFix\">\n                                        <a href=\"https://club.lanacion.com.ar\" target=\"_blank\">Club <b>La Naci\xF3n</b></a>\n                                    </div>\n                                    <article class=\"destacada foto floatFix\">";

        var benefitGrande = notaGrande.benefits[0];
        var benefitChica = notaChica.benefits[0];

        var imageHTML = "";
        var imageUrl = "";
        var imageUrlChica = "";

        if (notaGrande.imagenDestacar !== null && notaGrande.imagenDestacar !== 0) {
            var objDestacado = notaGrande.images.find(function (img) {
                return img.id == notaGrande.imagenDestacar;
            });
            if (objDestacado != undefined) {
                imageUrl = BucketTools.urlBucketClubLn(bucketClubLn, objDestacado.id, "220", "", objDestacado.extension);
            }
        }

        if (imageUrl == "" && benefitGrande.images != null && benefitGrande.images.length > 0) {
            imageUrl = BucketTools.urlBucketClubLn(bucketClubLn, benefitGrande.images[0].id, "220", "", benefitGrande.images[0].extension);
        }

        imageHTML = "<a href=\"" + notaGrande.link + "\" target=\"_blank\"><img src=\"" + imageUrl + "\" alt=\"" + benefitGrande.description + "\" /></a><span></span><div>";

        promoPromoClubLnHtml += imageHTML;

        promoPromoClubLnHtml += "<label><a href=\"" + notaGrande.link + "\" target=\"_blank\">" + benefitGrande.benefitTypeName + "</a></label>\n                                        <p><a href=\"" + notaGrande.link + "\" target=\"_blank\">" + notaGrande.name + "</a></p>\n                                    </div>\n                                </article>";
        //Chica
        promoPromoClubLnHtml += "<article class=\"noticia foto floatFix\">";

        if (notaChica.imagenDestacar !== null && notaChica.imagenDestacar !== 0) {
            var objDestacadoChica = notaChica.images.find(function (img) {
                return img.id == notaChica.imagenDestacar;
            });
            if (objDestacadoChica != undefined) {
                imageUrlChica = BucketTools.urlBucketClubLn(bucketClubLn, objDestacadoChica.id, "80", "", objDestacadoChica.extension);
            }
        }

        if (imageUrlChica == "" && benefitChica.images != null && benefitChica.images.length > 0) {
            imageUrlChica = BucketTools.urlBucketClubLn(bucketClubLn, benefitChica.images[0].id, "80", "", benefitChica.images[0].extension);
        }

        promoPromoClubLnHtml += "<a href=\"" + notaChica.link + "\" target=\"_blank\"><img src=\"" + imageUrlChica + "\" alt=\"" + benefitChica.description + "\" /></a>\n                                    <div>\n                                        <label><a href=\"" + notaChica.link + "\" target=\"_blank\">" + benefitChica.benefitTypeName + "</a></label>\n                                        <p><a href=\"" + notaChica.link + "\" target=\"_blank\">" + notaChica.name + "</a></p>\n                                    </div>\n                                    <div class=\"links\">\n                                        <a href=\"http://especiales.lanacion.com.ar/experiencias/newsletter/newsletter-online-combo2.html?cv=671&fc=568&utm_source=sitio_ln&utm_medium=Autopromo&utm_campaign=boton_caja_dinamica_sitio_ln\" target=\"_blank\">Ped\xED tu tarjeta </a> | <a href=\"https://www.lanacion.com.ar/club-la-nacion-t48832\" target=\"_blank\"> Propuestas Club LA NACION</a>\n                                    </div>\n                                </article>";

        container.innerHTML = promoPromoClubLnHtml;
    }
};

var getPromoClubLnEnHome = exports.getPromoClubLnEnHome = function getPromoClubLnEnHome() {
    if (document.getElementById("promoClubLnEnHome")) {
        (0, _ajax.get)(urlPromoClubLn).then(function (rs) {
            return JSON.parse(rs);
        }).then(renderPromoClubLnEnHome);
    }
};

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


$(document).ready(function () {

    $('#cabezal').removeClass('no-btn');

    scroll();

    // Oculta header cuando el usuario scrollea hacia abajo y lo muestra cuando scrollea hacia arriba
    var didScroll = void 0;
    var lastScrollTop = 0;
    var delta = 5;
    var navbarHeight = $('header').outerHeight();

    $(window).scroll(function (event) {
        didScroll = true;

        //Banner sticky lateral
        if ($('.tercera .banner.caja:not(:empty)').length) {
            var altura = $('.tercera .banner.caja #sticky_ad').height();
            if (altura >= 1200) $('.tercera .banner.caja').addClass('alto');
        }
    });

    setInterval(function () {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);

    function hasScrolled() {
        var st = $(window).scrollTop();

        if (st > 60) {
            $('header').removeClass('nav-up');

            //bomba
            if ($('body.bomba').length) {
                $('header').removeClass('transparente');
            }

            //banner tercera
            if ($('header').hasClass('nav-down')) {
                $('.contenidos #mosaico .tercera #sticky').addClass('onTop');
            } else {
                $('.contenidos #mosaico .tercera #sticky').removeClass('onTop');
            }

            //titulo deportes
            if ($('.contenidos.deportes').length) {

                var titulo = $('.techo-1 h3 a')[0].textContent;
                var labelTitulo_fijo = document.querySelector('.titulo-fijo');
                if (labelTitulo_fijo) {
                    labelTitulo_fijo.innerHTML = titulo;
                }
            }

            //titulo indices
            if ($('main.indices').length) {

                var titulo = $('.encabezado > h1')[0].textContent;
                var labelTitulo_fijo = document.querySelector('.titulo-fijo');
                if (labelTitulo_fijo) {
                    labelTitulo_fijo.innerHTML = titulo;
                }
            }
        } else {
            $('header').addClass('nav-up');
            $('header').removeClass('nav-down');
            $('.banner-mobile.sticky2').removeClass('up');
            $('header').removeClass('acu-fijo');

            if ($('body.bomba').length) {
                $('header').addClass('transparente');
            }

            if ($('header.nav-up.nav-down').length) {
                $('header').removeClass('nav-down');
            }
            if ($('.anticipo').length) {
                $('#sticky').css('margin-bottom', '0');
            }
        }

        // Make sure they scroll more than delta
        if (Math.abs(lastScrollTop - st) <= delta) return;

        // If they scrolled down and are past the navbar, add class .nav-up.
        // This is necessary so you never see what is "behind" the navbar.
        if (st > lastScrollTop && st > navbarHeight) {
            // Scroll Down
            $('header').removeClass('nav-up').removeClass('nav-down');
        } else {
            // Scroll down
            if (st + $(window).height() < $(document).height()) {
                $('header').removeClass('nav-down').addClass('nav-down');
            }
        }
        if ($('header.nav-up.nav-down').length) {
            $('header').removeClass('nav-down');
        }
        if (st > 180) {

            //indices
            if ($('main.indices').length) {
                $('header').addClass('acu-fijo');
                $('header').removeClass('home');
            }

            if ($('header').hasClass('nav-down')) {
                $('.banner-mobile.sticky2').removeClass('up');
            } else {
                $('.banner-mobile.sticky2').addClass('up');
            }

            //deportes
            if ($('main.deportes').length) {
                if ($('header').hasClass('nav-down')) {
                    $('.banner-mobile.sticky2').addClass('up');
                    $('.banner-mobile.sticky2').css('top', '52px');
                    $('.scroll-links').slideDown();
                } else {
                    $('.banner-mobile.sticky2').addClass('up');
                    $('.banner-mobile.sticky2').css('top', '0px');
                    $('.scroll-links').slideUp();
                }
            }
        }

        lastScrollTop = st;
    }

    //ESTO ES EL MISMO QUE EST� EN COMMON, PERO CON EL HTML PLANO EL OTRO NO FUNCIONA, cuando lo tomen ustedes funcionar� con el common
    menu();
    menuBusqueda();
    modal();
    climaDesplegable();
    bombaGaleria();
    //if ($('.galeria').length) {
    //    sliderArticle(); //TODO: esto solo se usa para HTMLs de integracion 
    //}

    function menu() {

        //Apertura del menú
        $(".icon-menu-desktop").click(function (event) {
            if ($('header').hasClass('desplegado')) {
                $('.icon-menu-desktop').html('MEN&Uacute');
                $('header').removeClass('desplegado-busqueda');
                $('header').removeClass('desplegado');
            } else {
                $('header').addClass('desplegado');
                $('.icon-menu-desktop').html('CERRAR');
            }

            if ($('header').hasClass('desplegado-busqueda') && $('.icon-menu-desktop').html('CERRAR')) {
                $('.icon-menu-desktop').html('MEN&Uacute');
                $('header').removeClass('desplegado-busqueda');
                $('header').removeClass('desplegado');
            }

            if ($(window).width() <= 768) {
                if ($('body').hasClass('sinScroll')) {
                    $('body').removeClass('sinScroll');
                } else {
                    $('body').addClass('sinScroll');
                }
            }
        });

        //Cierre del menú

        $('html').click(function (e) {
            if (e.target.id != 'header' && $(e.target).parents('header').length == 0) {
                if ($('header').hasClass('desplegado')) {
                    $('.icon-menu-desktop').html('MEN&Uacute');
                    $('header').removeClass('desplegado-busqueda');
                    $('header').removeClass('desplegado');
                } else {}
            }
        });
    }

    function menuBusqueda() {
        $('.busqueda input').focus(function () {
            $('header').addClass('desplegado');
            $('.icon-menu-desktop').html('CERRAR');
        });
    }

    function modal() {
        var modal = $('#modalImagen');
        var ampliar = $('.icon-ampliar');
        //Abre Modal
        ampliar.click(function () {
            var sliderContainer = $(this).parent('#sliderContainer');
            if (sliderContainer.length) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = sliderContainer.find('ul li img')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var img = _step.value;

                        img.src = BucketTools.changeSizeWithFullPath(img.src, 'h1080');
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                ;
                $(this).parent().parent().addClass('elementoModal');
            } else {
                $(this).parent().find("img").attr("src", BucketTools.changeSizeWithFullPath($(this).parent().find("img").attr("src"), 'h1080'));
                $(this).parent().addClass('elementoModal');
            }

            if ($("body").hasClass('modal-on')) {
                exitFullScreen(elem);
                setTimeout(function () {
                    modal.fadeOut();
                    $('body').removeClass('modal-on');
                    $('.galeria').removeClass('elementoModal');
                    $('figure').removeClass('elementoModal');
                }, 300);

                var elem = document.body; // Make the body go full screen.
            } else {
                modal.fadeIn();
                $('body').addClass('modal-on');
                setTimeout(function () {
                    var elem = document.body; // Make the body go full screen.
                    requestFullScreen(elem);
                }, 300);
            }
        });
    }

    function climaDesplegable() {
        $(".clima h2").click(function (event) {
            $('body').addClass('climaOn');

            $('.climaDesplegable select').each(function () {
                var $this = $(this),
                    numberOfOptions = $(this).children('option').length;

                $this.addClass('select-hidden');
                $this.wrap('<div class="select"></div>');
                $this.after('<div class="select-styled"></div>');

                var $styledSelect = $this.next('div.select-styled');
                $styledSelect.text($this.children('option').eq(0).text());

                var $list = $('<ul />', {
                    'class': 'select-options'
                }).insertAfter($styledSelect);

                for (var i = 0; i < numberOfOptions; i++) {
                    $('<li />', {
                        text: $this.children('option').eq(i).text(),
                        rel: $this.children('option').eq(i).val()
                    }).appendTo($list);
                }

                var $listItems = $list.children('li');

                $styledSelect.click(function (e) {
                    e.stopPropagation();
                    $('div.select-styled.active').not(this).each(function () {
                        $(this).removeClass('active').next('ul.select-options').hide();
                    });
                    $(this).toggleClass('active').next('ul.select-options').toggle();
                });

                $listItems.click(function (e) {
                    e.stopPropagation();
                    $styledSelect.text($(this).text()).removeClass('active');
                    $this.val($(this).attr('rel'));
                    $list.hide();
                    //console.log($this.val());
                });

                $(document).click(function () {
                    $styledSelect.removeClass('active');
                    $list.hide();
                });
            });
        });

        $(".climaDesplegable .cerrar").click(function (event) {
            $('body').removeClass('climaOn');
        });
    }

    function bombaGaleria() {
        if ($('body.bomba .galeria').length) {
            $('main.contenidos').addClass('galeria-fix');
        }
    }
});

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var sliderArticle = exports.sliderArticle = function sliderArticle() {
    if ($("#sliderContainer ul li").length > 1) {

        //Crea la navegacion // VER ESTO QUE NO PEGA LO QUE CREA    
        var nav = function nav() {
            for (var i = 0; i < slides; i++) {
                $('.navegacion').append('<span data-slide="slide' + i + '" class="slide-' + i + '"></span>');
            }
        };

        // Activa las flechas


        var flechas = function flechas() {
            if (pos != 1) {
                $('.galeria .prev').addClass('activo');
                $('.galeria .prev').removeClass('primero');
            } else {
                $('.galeria .prev').removeClass('activo');
                $('.galeria .prev').addClass('primero');
            }
            if (pos != slides) {
                $('.galeria .next').addClass('activo');
                $('.galeria .next').removeClass('ultimo');
            } else {
                $('.galeria .next').removeClass('activo');
                $('.galeria .next').addClass('ultimo');
            }
        };

        //Activa la slide seleccionada


        var slideActiva = function slideActiva() {
            $('#sliderContainer ul li').removeClass('activo');
            $('#sliderContainer ul li').addClass('off');
            $('#sliderContainer ul li').removeClass('previo');
            $('#sliderContainer ul li').eq(pos - 2).addClass('previo');
            $('#sliderContainer ul li').eq(pos).removeClass('previo');
            $('#sliderContainer ul li').eq(pos - 1).toggleClass('off activo');
            if (pos == 1) {
                $('#sliderContainer ul li').removeClass('previo');
            }
        };

        //Toma el texto de cada imagen y lo replica


        var epigrafe = function epigrafe() {
            var epigrafe = $('#sliderContainer ul li.activo img').attr('alt');
            $('#epigrafe').html(epigrafe);
        };

        // Crea el total y el actual numero de slides


        var total = function total() {
            var total = pos + ' de ' + slides;
            $('#total').html(total);
        };
        //Pregunta si es la primera


        var moveLeft = function moveLeft() {
            reloadSrc();
            if (pos == 1) {
                pos = slides;
            } else {
                pos = pos - 1;
            }
            slideActiva();
            total();
            flechas();
        };

        //Pregunta si es la ultima
        var moveRight = function moveRight() {
            reloadSrc();
            if (pos == slides) {
                pos = 1;
            } else {
                pos = pos + 1;
            }
            slideActiva();
            total();
            flechas();
        };

        /*stopea el video que se esta reproduciendo y si tiene autoplay se lo quita*/
        var reloadSrc = function reloadSrc() {
            if ($('#sliderContainer ul li.activo iframe').length) {
                var strReload = $('#sliderContainer ul li.activo iframe').attr('src');
                var strReloadNew = strReload.replace('autoplay=1', 'autoplay=0');
                $('#sliderContainer ul li.activo iframe').attr('src', strReloadNew);
            }
        };

        /*agrega autoplay al video que esta en el elemento visible*/
        var addAutoplay = function addAutoplay() {
            if ($('#sliderContainer ul li.activo iframe').length) {
                var str = $('#sliderContainer ul li.activo iframe').attr('src');
                var strNew = str.replace('autoplay=0', 'autoplay=1');
                $('#sliderContainer ul li.activo iframe').attr('src', strNew);
            }
        };

        var botonActivo = function botonActivo() {
            $('.navegacion span').removeClass('activo');
            $('.navegacion span').eq(pos - 1).addClass('activo');
        };

        var timeOut;
        //Cuento la cantidad de slides
        var slides = $("#sliderContainer ul li").length;
        //Creo la navegacion
        nav();
        //Activo la primera
        var pos = 1;
        $('.navegacion span').eq(pos - 1).addClass('activo');

        //Altura flechas
        var alturaContenedor = $('#sliderContainer').height();

        // Funciones a realizar cuando inicia
        slideActiva();
        total();
        epigrafe();
        flechas();;;;;

        ;

        /*los botones ejecutan las funciones anteriores*/
        $(".prev").click(function () {
            moveLeft();
            botonActivo();
            addAutoplay();
            total();
            epigrafe();
            flechas();
        });

        $(".next").click(function () {
            moveRight();
            botonActivo();
            addAutoplay();
            total();
            epigrafe();
            flechas();
        });

        //Activa el slide segun la posicion del menu
        $(".navegacion span").click(function () {
            reloadSrc();
            pos = $(this).attr("data-slide");
            pos = parseInt(pos);
            botonActivo();
            slideActiva();
            addAutoplay();
            total();
            epigrafe();
            flechas();
        });
    }
};

/***/ }),
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initIframePym = undefined;

var _pymV1Min = __webpack_require__(48);

var _pymV1Min2 = _interopRequireDefault(_pymV1Min);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.pym = _pymV1Min2.default;

var initIframePym = exports.initIframePym = function initIframePym() {

    $("iframe.pym").each(function (i, nodo) {
        var id = $(nodo).data('id') || 'pymnro' + i,
            url = $(nodo).attr('src') || $(nodo).data('src'),
            opts = /*$(nodo).data('opts') || HAY QUE PARSEAR JSON*/{};

        if (!!url) {
            $(nodo).after('<div id="' + id + '"></div>');
            $(nodo).remove();

            var mypym = new _pymV1Min2.default.Parent(id, url, opts);
            mypym.onMessage('pymEspecialesLoaded', function (status) {
                if (status === 'ready') mypym.sendMessage('setShareUrl', document.URL);
            });
        }
    });
};

/***/ }),
/* 66 */,
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// @ts-check

/**
 * Request - Generic method
 * @param {string} method
 * @param {string} url
 * @param {any} params
 * @param {any} headers
 * @return {Promise<string>}
 */
var ajax = exports.ajax = function ajax(method, url, params) {
  var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return new Promise(function (resolve, reject) {
    var request = new XMLHttpRequest();

    request.open(method, url, true);
    if (headers) {
      var names = Object.keys(headers);
      names.forEach(function (name) {
        var value = headers[name];

        request.setRequestHeader(name, value);
      });
    }

    request.onload = function () {
      if (request.status >= 200 && request.status < 400) {
        var resp = request.responseText;
        resolve(resp);
      } else {
        reject();
      }
    };
    request.onerror = function () {
      return reject();
    };
    request.send(JSON.stringify(params));
  });
};

/**
 * Request - Post
 * @param {string} method
 * @param {string} url
 * @param {any} params
 * @param {any} headers
 * @return {Promise<string>}
 */
var post = exports.post = function post(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return ajax('POST', url, params, headers);
};

/**
 * Request - Get
 * @param {string} method
 * @param {string} url
 * @param {any} params
 * @param {any} headers
 * @return {Promise<string>}
 */
var get = exports.get = function get(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return ajax('GET', url, params, headers);
};

exports.default = { get: get, post: post };

/***/ }),
/* 68 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _app = __webpack_require__(16);

var app = _interopRequireWildcard(_app);

__webpack_require__(68);

var _video = __webpack_require__(45);

var Video = _interopRequireWildcard(_video);

var _login = __webpack_require__(9);

var Login = _interopRequireWildcard(_login);

var _logout = __webpack_require__(7);

var Logout = _interopRequireWildcard(_logout);

__webpack_require__(55);

var _slideArticleHome = __webpack_require__(56);

var Galeria = _interopRequireWildcard(_slideArticleHome);

var _masLeidas = __webpack_require__(103);

var Ranking = _interopRequireWildcard(_masLeidas);

var _lazyLoad = __webpack_require__(39);

var LazyLoad = _interopRequireWildcard(_lazyLoad);

var _loQueSigo = __webpack_require__(23);

var LoQueSigo = _interopRequireWildcard(_loQueSigo);

var _ultimasNoticias = __webpack_require__(104);

var UltimasNoticias = _interopRequireWildcard(_ultimasNoticias);

var _beneficioClubLn = __webpack_require__(54);

var BeneficioClubLn = _interopRequireWildcard(_beneficioClubLn);

var _tableros = __webpack_require__(49);

var Tablero = _interopRequireWildcard(_tableros);

var _tableroTenis = __webpack_require__(53);

var TableroTenis = _interopRequireWildcard(_tableroTenis);

var _tableroFutbol = __webpack_require__(51);

var TableroFutbol = _interopRequireWildcard(_tableroFutbol);

var _tableroRugby = __webpack_require__(52);

var TableroRugby = _interopRequireWildcard(_tableroRugby);

var _tableroBasket = __webpack_require__(50);

var TableroBasquet = _interopRequireWildcard(_tableroBasket);

var _functions = __webpack_require__(12);

var Functions = _interopRequireWildcard(_functions);

var _personalizacion = __webpack_require__(10);

var Personalizacion = _interopRequireWildcard(_personalizacion);

var _utilities = __webpack_require__(3);

var Utilities = _interopRequireWildcard(_utilities);

var _CustomDimension = __webpack_require__(34);

var CustomDimension = _interopRequireWildcard(_CustomDimension);

var _MetricsEvents = __webpack_require__(42);

var MetricsEvents = _interopRequireWildcard(_MetricsEvents);

var _pymFunction = __webpack_require__(65);

var Pym = _interopRequireWildcard(_pymFunction);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var FirstQuarter = false;
var SecondQuarter = false;
var ThirdQuarter = false;
var FourthQuarter = false;

var guardarClima = function guardarClima() {
    if (document.querySelector("#btnClimaHome")) {
        var btnClick = document.querySelector("#btnClimaHome");
        btnClick.addEventListener("click", function () {

            var ciudadClima = document.querySelector("#ciudadClima");
            var selectCiudad = document.querySelector("#ciudades");
            var currentOpt = selectCiudad.options[selectCiudad.selectedIndex];

            ciudadClima.textContent = currentOpt.text;

            $.ajax({
                dataType: "jsonp",
                cache: true,
                url: window.config.Statics.ContenidosUrlRoot + "/json/pronostico/index-ciudadRef=" + currentOpt.value,
                jsonpCallback: "Pronostico",
                success: function success(json) {}
            });
        });
    }
};

var initClima = function initClima() {
    var ciudadClima = document.querySelector("#ciudadClima");

    if (ciudadClima != null) {
        var selectCiudad = document.querySelector("#ciudades");
        selectCiudad.selectedIndex = 8;
        var currentOpt = selectCiudad.options[selectCiudad.selectedIndex];

        ciudadClima.textContent = currentOpt.text;

        $.ajax({
            dataType: "jsonp",
            cache: true,
            url: window.config.Statics.ContenidosUrlRoot + "/json/pronostico/index-ciudadRef=ARCF0009",
            jsonpCallback: "Pronostico",
            success: function success(json) {}
        });
    }
};

window.pronosticoCallbackJSON = function (value) {
    var tempeClima = document.querySelector("#temperaturaClima");

    var ciudadClima = document.querySelector("#ciudadClima");
    var selectCiudad = document.querySelector("#ciudades");
    var currentOpt = selectCiudad.options[selectCiudad.selectedIndex];

    var ciudadData = value.ciudades.find(function (i) {
        return i.ciudad.codigo === currentOpt.value;
    });

    tempeClima.textContent = ciudadData.ciudad.temperatura.concat("° ", ciudadData.ciudad.icono_descripcion);
    var imagenClima = document.querySelector("#imageClima");

    var idImagenClima = ciudadData.ciudad.icono_id.trim();
    var classClima = "clima-";

    imagenClima.classList.add(classClima.concat(idImagenClima));
};

var getTableros = function getTableros() {
    var tablero = document.body.querySelectorAll(".tablero");

    if (tablero.length > 0) {

        var tableros = [];

        var tFutbol = document.body.querySelectorAll("div.tablero.futbol");
        var tTenis = document.body.querySelectorAll("section.tablero.tenis");
        var tRugby = document.body.querySelectorAll("div.tablero.rugby");
        var tbasquet = document.body.querySelectorAll("div.tablero.basquet");

        if (tFutbol != null) {
            for (var i = 0; i < tFutbol.length; i++) {
                tableros.push(TableroFutbol.agregarTableroFutbol(tFutbol[i].getAttribute("data-id"), '1101'));
            }
        }
        if (tTenis != null) {
            for (var j = 0; j < tTenis.length; j++) {
                tableros.push(TableroTenis.agregarTableroTenis(tTenis[j].getAttribute("data-id"), '1000'));
            }
        }
        if (tRugby != null) {
            for (var _j = 0; _j < tRugby.length; _j++) {
                tableros.push(TableroRugby.agregarTableroRugby(tRugby[_j].getAttribute("data-id"), '1101'));
            }
        }
        if (tbasquet != null) {
            for (var _j2 = 0; _j2 < tbasquet.length; _j2++) {
                tableros.push(TableroBasquet.agregarTableroBasket(tbasquet[_j2].getAttribute("data-id"), '1101'));
            }
        }

        Tablero.iniciarTableros(tableros);
        Tablero.verificarCambiosCodigoControl();
        setInterval(Tablero.verificarCambiosCodigoControl, 15000);
    }
};

var LinksFooter = function LinksFooter() {
    if (document.querySelector("#pie-facebook")) {
        document.querySelector("#pie-facebook").addEventListener("click", function () {
            window.open("https://www.facebook.com/lanacion", "_blank");
        });
    }

    if (document.querySelector("#pie-twitter")) document.querySelector("#pie-twitter").addEventListener("click", function () {
        window.open("https://twitter.com/LANACION", "_blank");
    });

    if (document.querySelector("#pie-instagram")) document.querySelector("#pie-instagram").addEventListener("click", function () {
        window.open("https://www.instagram.com/lanacioncom/", "_blank");
    });

    if (document.querySelector("#pie-rss")) document.querySelector("#pie-rss").addEventListener("click", function () {
        window.open("http://servicios.lanacion.com.ar/herramientas/rss/ayuda", "_blank");
    });

    if (document.querySelector("#pie-apple")) document.querySelector("#pie-apple").addEventListener("click", function () {
        window.open("https://www.google.com.ar/url?sa=t&rct=j&q=&esrc=s&source=web&cd=1&cad=rja&uact=8&ved=0ahUKEwjsqvOLkr7XAhUDjpAKHZyiBigQFgglMAA&url=https%3A%2F%2Fitunes.apple.com%2Far%2Fapp%2Fla-nacion%2Fid410689702%3Fmt%3D8&usg=AOvVaw3LqfU_ag8u27BMNAtmRxqN", "_blank");
    });

    if (document.querySelector("#pie-android")) document.querySelector("#pie-android").addEventListener("click", function () {
        window.open("https://play.google.com/store/apps/details?id=app.lanacion.activity&hl=es_419", "_blank");
    });
};

var eventMetrics = function eventMetrics() {

    window.onscroll = function () {
        if (FirstQuarter === true && SecondQuarter === true && ThirdQuarter === true && FourthQuarter === true) {
            return true;
        }
        var scrollTop = $(window).scrollTop();
        var docHeight = $(document).height();
        var winHeight = $(window).height();
        var scrollPercent = scrollTop / (docHeight - winHeight);
        var scrollPercentRounded = Math.round(scrollPercent * 100);
        if (scrollPercentRounded > 25 && FirstQuarter === false) {
            FirstQuarter = true;
            if (window.dataLayer !== undefined) {
                dataLayer.push({ 'event': 'trackScroll', 'quartile': '25' });
            }
        }
        if (scrollPercentRounded > 50 && SecondQuarter === false) {
            SecondQuarter = true;
            if (window.dataLayer !== undefined) {
                dataLayer.push({ 'event': 'trackScroll', 'quartile': '50' });
            }
        }
        if (scrollPercentRounded > 75 && ThirdQuarter === false) {
            ThirdQuarter = true;
            if (window.dataLayer !== undefined) {
                dataLayer.push({ 'event': 'trackScroll', 'quartile': '75' });
            }
        }
        if (scrollPercentRounded === 100 && FourthQuarter === false) {
            FourthQuarter = true;
            if (window.dataLayer !== undefined) {
                dataLayer.push({ 'event': 'trackScroll', 'quartile': '100' });
            }
        }
    };
};

var cxense = function cxense() {
    var script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    script.innerHTML = "\n    var cX = cX || {}; cX.callQueue = cX.callQueue || [];\n    cX.callQueue.push(['setSiteId', '1135050122432099686']);\n    cX.callQueue.push(['sendPageViewEvent']);\n    (function(d,s,e,t){e = d.createElement(s); e.type='text/java'+s;e.async='async';\n        e.src='http'+('https:'===location.protocol?'s://s':'://')+'cdn.cxense.com/cx.js';\n        t=d.getElementsByTagName(s)[0];t.parentNode.insertBefore(e,t);})(document,'script');\n    ";
    document.body.appendChild(script);
};

var initialize = function initialize() {
    //Banners.loadBanners(window.LN.tipoPaginaBanner);
    Login.Initialize();
    Logout.Initialize();
    UltimasNoticias.getUltimasNoticias();
    Personalizacion.initPreferencias("home");
    Personalizacion.seguirDejarSeguir(document.querySelectorAll("button.seguir"));
    Video.initialize();
    Galeria.sliderArticle();
    Ranking.getHomeRanking();
    BeneficioClubLn.getPromoClubLnEnHome();
    LazyLoad.implementLazyLoadImage();
    initClima();
    getTableros();
    guardarClima();
    Functions.buscador();
    Functions.bannerHeaderLogo();
    LinksFooter();
    cxense();
    eventMetrics();
    Pym.initIframePym();
    Utilities.metaRefresh(300000, "home");
    CustomDimension.MakeCustomDimension();
};

//app.on(Events.APP_START, Functions.functions);
window.app = app;
app.start().then(initialize);

/***/ }),
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getHomeRanking = undefined;

var _ajax = __webpack_require__(1);

var _bucket = __webpack_require__(2);

var BucketTools = _interopRequireWildcard(_bucket);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var sitioId = window.config.Sitio.Id;
var urlApiRoot = window.config.Statics.ApiContenidoUrlRoot;
var urlRankingSitio = urlApiRoot + window.config.Statics.ApiRankingSitioUrl;
var bucket = window.config.Statics.BucketUrl;

var getHomeRanking = exports.getHomeRanking = function getHomeRanking() {
    (0, _ajax.get)(urlRankingSitio + sitioId).then(function (rs) {
        return renderHomeRanking(JSON.parse(rs));
    });
};

var renderHomeRanking = function renderHomeRanking(data) {
    var notas = data.items.slice(0, 5);
    var articleMasLeidas = document.querySelector("#masLeidasSitio.mas-leidas");
    var imgUrl = void 0;

    var html = "<div class=\"techo-2 floatFix\">\n                    <span class=\"titulo-destacado\" >\n                        lo m\xE1s visto <b>ahora</b>\n                    </span>\n                </div>";
    var toi = 401;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = notas[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var nota = _step.value;

            var toiPos = "toi".concat(toi.toString());
            var img = "";
            if (nota.imagenes instanceof Array && nota.imagenes.length > 0 && nota.imagenes[0].src != null && nota.imagenes[0].src != "") {
                imgUrl = "" + BucketTools.urlBucketBalance(bucket, nota.imagenes[0].src, "70");
                img = "<img src=\"" + imgUrl + "\"/>";
            }
            html += "<article class=\"noticia foto floatFix\" data-id=\"" + nota.id + "\" data-notaid=\"" + nota.id + "\" data-source=\"ranking\" data-pos=\"" + toiPos + "\">\n                    <a class=\"figure\" href=\"/" + nota.url + "\">\n                        " + img + "\n                    </a>    \n                    <h2>\n                        <a href=\"/" + nota.url + "\">\n                            " + nota.titulo + "\n                        </a>\n                    </h2>   \n                </article>";
            toi++;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    articleMasLeidas.innerHTML = html;
};

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getUltimasNoticias = undefined;

var _ajax = __webpack_require__(67);

var _ajax2 = _interopRequireDefault(_ajax);

var _bucket = __webpack_require__(2);

var BucketTools = _interopRequireWildcard(_bucket);

var _utilities = __webpack_require__(3);

var Utilities = _interopRequireWildcard(_utilities);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var urlUltimasNoticias = window.config.Statics.ApiContenidoUrlRoot + window.config.Statics.ApiUltimasNoticias;
var bucket = window.config.Statics.BucketUrl;

var getUltimasNoticias = exports.getUltimasNoticias = function getUltimasNoticias() {
    _ajax2.default.get(urlUltimasNoticias + "&h=1").then(function (rs) {
        return renderUltimasNotas(JSON.parse(rs));
    });
};

var renderUltimasNotas = function renderUltimasNotas(notas) {

    if (notas != null && notas.items != null && notas.items.length > 0) {
        var cssClass = "s noticia foto tema floatFix";
        //cssClass = notas.css === "" ? cssClass.replace("foto","") : cssClass;
        var arrayIdsNotas = [];
        var notasRender = notas.items;
        if (notasRender.length > 0 && notasRender.length > 6) {
            notasRender = notasRender.slice(0, 6);
        }

        //<!-- Últimas Noticias -->
        var html = "<div class=\"techo-2 floatFix\">\n                        <a href=\"/ultimas-noticias\">\n                            <b>\xDAltimas noticias</b>\n                        </a>\n                    </div>\n                    <div>";
        var toi = 501;

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = notasRender[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var nota = _step.value;

                //Array utilizado para hacer el filtro de notas repetidas con Preferencias.
                arrayIdsNotas.push(nota.id);

                var hora = nota.fechaActualizacion.split(":")[0].substr(nota.fechaActualizacion.split(":")[0].length - 2, 2) + ":" + nota.fechaActualizacion.split(":")[1]; //nota.fechaActualizacion.substr(9, 5);
                var tag = void 0;
                var tagHtml = "";
                var tags = nota.tags;

                if (tags && tags.length > 0) {
                    tag = tags[0];
                    tagHtml = "<h3><a href=\"" + Utilities.formatoUrlAcuTag(tag.valor, tag.id) + "\">" + tag.valor + "</a></h3>";
                }
                var imageUrl = " ";
                if (nota.imagenes instanceof Array && nota.imagenes.length > 0 && nota.imagenes[0].src != null && nota.imagenes[0].src != "") {
                    imageUrl = "<img src=\"" + BucketTools.urlBucketBalance(bucket, nota.imagenes[0].src, "", 130) + "\"/>";
                }
                var toiPos = "toi".concat(toi.toString());
                html += "<article class=\"" + cssClass + "\" data-id=\"" + nota.id + "\" data-notaid=\"" + nota.id + "\" data-source=\"ultimas\" data-pos=\"" + toiPos + "\">\n                    <div class=\"hora\">\n                        " + hora + "\n                    </div>\n                    <a class=\"figure\" href=\"/" + nota.url + "\">\n                        " + imageUrl + "\n                    </a>\n                    <div>\n                        <h2>\n                            <a href=\"/" + nota.url + "\">\n                                " + nota.titulo + "\n                            </a>\n                        </h2>\n                        " + tagHtml + "\n                    </div>\n                </article>";
                toi++;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        localStorage.setItem("notasUltimasNoticias", arrayIdsNotas);

        html += "<div class=\"botones\">\n                <a href=\"/ultimas-noticias\">VER M\xC1S \xDALTIMAS NOTICIAS</a>\n             </div>\n             </div>";
        document.querySelector("section #ultimas-noticias").insertAdjacentHTML("afterbegin", html);
    }
};

/***/ }),
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(79);


/***/ })
],[117]);


// WEBPACK FOOTER //
// js/home.59767d7.min.js